/* global app */
/*
 * views/commonViewHelper.js
 * helper functions used by all views
 */
define('app/views/commonViewHelper',[
    'app/views/defaultAnalytics/rooms',
    'app/views/defaultAnalytics/dining',
    'app/views/defaultAnalytics/golf',
    'app/views/defaultAnalytics/retail',
    'app/views/defaultAnalytics/ski',
    'app/views/defaultAnalytics/spa',
    'app/views/defaultAnalytics/cart',
    'hbs!app/views/templates/spaServiceListPartialSpaItem',
    'hbs!app/views/templates/skiLiftTicketPartialSkiItem',
    'hbs!app/views/templates/cancellationModal',
    'app/views/templates/helpers/RSDateToString',
    'app/views/templates/helpers/stripChars',
    'app/views/templates/helpers/equalGt',
    'app/views/templates/helpers/nl2br',
    'lib/leaflet',
    'lib/simplePagination',
    'DataTable',
    'Customization',
    'enquire',
    'moment',
    'lib/event',
    'hbs!app/views/templates/navbar',
    'Handlebars',
    'app/views/templates/helpers/xmlEscape',
    'app/views/templates/helpers/urlEscape',
    'app/views/templates/helpers/escapeJSString',
    'underscore', 'jquery', 'lib/axios', 'jqueryui', 'jqueryuidatepicker', 'bootstrap', 'jquery_validate', 'date', 'jquerymask', 'moment_tz',
],
    function (
        roomsAnalytics,
        diningAnalytics,
        golfAnalytics,
        retailAnalytics,
        skiAnalytics,
        spaAnalytics,
        cartAnalytics,
        spaServiceListPartialSpaItemTpl,
        skiLiftTicketPartialSkiItemTpl,
        cancellationModalTpl,
        rsDateToString,
        stripChars,
        equalGt,
        nl2br,
        L,
        pagination,
        DataTable,
        Customization,
        enquire,
        moment,
        Event,
        navbarTpl,
        Handlebars,
        xmlEscape,
        urlEscape,
        escapeJSString,     
        _, $, axios) {

        app.analytics = {
            rooms: roomsAnalytics,
            dining: diningAnalytics,
            golf: golfAnalytics,
            retail: retailAnalytics,
            ski: skiAnalytics,
            spa: spaAnalytics,
            cart: cartAnalytics
        }

        if(Customization.spaBooking.serviceSelection.MapConfig.externalConfig){
            axios.get(Customization.rsapiUrl + "/api/getMapConfig")
            .then(function(res){
                var layouts = res.data;
                _.forEach(layouts, function(layout){
                    Customization.spaBooking.serviceSelection.map[layout.mapName] = layout;
                })
            })
            .catch(function(err){
                console.error(err);
            })
        }

        var addOneMinute = function addOneMinute(timestr) {
            timestr = 1 + +timestr
            if (timestr % 100 == 60) {
                timestr += 40
            }
            timestr = "" + timestr
            while (timestr.length < 4) {
                timestr = "0" + timestr
            }
            return timestr
        }
            , validEmail = function (email) {
                return /^[^@"(),:;<>\/\[\\\]|`]+@[a-z0-9-]+(\.?[a-z0-9-])*\.[a-z0-9]{2,}$/i.test(email)
            }
            , attachError = function (group, message) {
                var label = $(group).addClass('invalid').find('.control-label')
                label.find('span.required').remove()
                message && label.append('<span class="required"> ' + message + '</span>')
            }
            , loadCustomerAddressIntoForm = function loadCustomerAddressIntoForm() {
                return app.models.userModel.getData('fetchCustomerProfile', {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID
                })
                    .then(function (r_fcp) {
                        var customer = $.firstOrOnly(r_fcp.Customer)
                        if (customer) {
                            $('#cartCCFName').val(customer.Name && customer.Name.FirstName).parents('.control-group').addClass('filled')
                            $('#cartCCLName').val(customer.Name && customer.Name.LastName).parents('.control-group').addClass('filled')
                            $('#cartCCname').val(customer.Name && (customer.Name.FirstName + ' ' + customer.Name.LastName)).parents('.control-group').addClass('filled')
                            var otherAddress = _.find(customer.Address, function (address) {
                                return address.type == "OTHER"
                            }) || {}
                            var selectedCountry = false;
                            if (otherAddress && otherAddress.Address1) {
                                $('#cartCCaddress').val(otherAddress.Address1)
                                $('#cartCCaddress2').val(otherAddress.Address2)
                                $('#cartCCcity').val(otherAddress.City)
                                $('#cartCCstate').val(otherAddress.StateProv)
                                $('#cartCCzip').val(otherAddress.PostCode)
                                selectedCountry = _.find(app.localization.countryList, function (x) { return x.name == otherAddress.Country })
                                otherAddress.country = selectedCountry && selectedCountry.code || otherAddress.Country;
                                $('#cartCCcountry').val(otherAddress.country)
                                customer.otherAddress = otherAddress
                            } else {
                                var homeAddress = _.find(customer.Address, function (address) {
                                    return address.type == "HOME"
                                }) || {}
                                if (homeAddress) {
                                    $('#cartCCaddress').val(homeAddress.Address1)
                                    $('#cartCCaddress2').val(homeAddress.Address2)
                                    $('#cartCCcity').val(homeAddress.City)
                                    $('#cartCCstate').val(homeAddress.StateProv)
                                    $('#cartCCzip').val(homeAddress.PostCode)
                                    selectedCountry = _.find(app.localization.countryList, function (x) { return x.name == homeAddress.Country })
                                    homeAddress.country = selectedCountry && selectedCountry.code || homeAddress.Country;
                                    $('#cartCCcountry').val(homeAddress.country)
                                    customer.homeAddress = homeAddress
                                }
                            }
                        }
                        return customer
                    })
            }
            , formatCmsBookingWindows = function(arr) {
                _.each(arr, function(el){
                    _.each(Object.keys(el), function(key){
                        if(el[key] === null || key == '__v' || key == '_id' || key == 'clientid'){
                            delete el[key];
                        }
                    })
                })
                return arr;
            }
            , getBookingWindow = function (module, itemObj) {
                var cmsBookingWindows = [];
                var allBookingWindows = [];
                // Get booking windows from client api
                if(app.customization.cmsBookingWindowEnabled){
                    $.ajax({
                        dataType: "json",
                        url: app.customization.cmsBookingWindowEndPoint,
                        async: false
                      }).done(function(response){
                          if(response.Status.code = 200 && response.Result.length){
                            // Format returned booking windows from api
                            cmsBookingWindows = formatCmsBookingWindows(response.Result);
                          } else{
                            console.log('no booking windows returned from api');
                          }
                      }).fail(function(){
                        console.log('booking windows call failed');
                      })
                }

                allBookingWindows = cmsBookingWindows.concat(app.customization.bookingWindows);

                var myBookingWindow = []
                _.each(allBookingWindows, function (bookingWindow) {
                    if (bookingWindow.module == module) {
                        myBookingWindow.push(_.keys(bookingWindow));
                    }
                })

                criteriaTypeList = _.without(_.unique(_.flatten(myBookingWindow)), 'module', 'bookingWindow') // an array of strings

                var combos = function (arr, stack, memo) {
                    if (arr.length == 0) {
                        memo.push(stack)
                    } else {
                        var stackTrue = _.extend({}, stack)
                        var stackFalse = _.extend({}, stack)
                        stackTrue[arr[0]] = true;
                        stackFalse[arr[0]] = false;
                        combos(arr.slice(1), stackTrue, memo)
                        combos(arr.slice(1), stackFalse, memo)
                    }
                    return memo
                }
                var criteriaCombos = combos(criteriaTypeList, {}, [])

                var returnValue = _.find(allBookingWindows, function (bookingWindow) {
                    return bookingWindow.module == module && (
                        criteriaCombos.length <= 1 || _.find(criteriaCombos, function (criteriaCombo) {
                            return _.all(criteriaCombo, function (isRequired, criteriaName) {
                                return isRequired
                                    ? (typeof bookingWindow[criteriaName] != 'undefined'
                                        && bookingWindow[criteriaName] !== null
                                        && (
                                            typeof bookingWindow[criteriaName].exec == 'function'
                                                ? bookingWindow[criteriaName].exec(itemObj[criteriaName])
                                                : bookingWindow[criteriaName] == itemObj[criteriaName]
                                        )
                                    )
                                    : (typeof bookingWindow[criteriaName] == 'undefined'
                                        || bookingWindow[criteriaName] === null
                                    )
                            })
                        })
                    )
                })
                return returnValue && returnValue.bookingWindow || app.customization.defaultBookingWindow
            }
        $.extend($.datepicker, {
            _doKeyDown: function (event) {
                var inst = $.datepicker._getInst(event.target);
                var handled = true;
                var isRTL = inst.dpDiv.is('.ui-datepicker-rtl');
                inst._keyEvent = true;
                if ($.datepicker._datepickerShowing)
                    switch (event.keyCode) {
                        case 9: $.datepicker._hideDatepicker();
                            handled = false;
                            break; // hide on tab out
                        case 13: var sel = $('td.' + $.datepicker._dayOverClass + ':not(.' +
                            $.datepicker._currentClass + ')', inst.dpDiv);
                            if ($.datepicker._get(inst, 'customOnSelect')) { return }
                            if (sel[0])
                                $.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
                            var onSelect = $.datepicker._get(inst, 'onSelect');
                            if (onSelect) {
                                var dateStr = $.datepicker._formatDate(inst);

                                // trigger custom callback
                                onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
                            }
                            else
                                $.datepicker._hideDatepicker();
                            return false; // don't submit the form
                            break; // select the value on enter
                        case 27: $.datepicker._hideDatepicker();
                            break; // hide on escape
                        case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                            -$.datepicker._get(inst, 'stepBigMonths') :
                            -$.datepicker._get(inst, 'stepMonths')), 'M');
                            break; // previous month/year on page up/+ ctrl
                        case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                            +$.datepicker._get(inst, 'stepBigMonths') :
                            +$.datepicker._get(inst, 'stepMonths')), 'M');
                            break; // next month/year on page down/+ ctrl
                        case 35: if (event.ctrlKey || event.metaKey) $.datepicker._clearDate(event.target);
                            handled = event.ctrlKey || event.metaKey;
                            break; // clear on ctrl or command +end
                        case 36: if (event.ctrlKey || event.metaKey) $.datepicker._gotoToday(event.target);
                            handled = event.ctrlKey || event.metaKey;
                            break; // current on ctrl or command +home
                        case 37: // if (event.ctrlKey || event.metaKey)
                            $.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), 'D');
                            handled = true; // event.ctrlKey || event.metaKey;
                            // -1 day on ctrl or command +left
                            if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                                -$.datepicker._get(inst, 'stepBigMonths') :
                                -$.datepicker._get(inst, 'stepMonths')), 'M');
                            // next month/year on alt +left on Mac
                            break;
                        case 38: // if (event.ctrlKey || event.metaKey)
                            $.datepicker._adjustDate(event.target, -7, 'D');
                            handled = true; // event.ctrlKey || event.metaKey;
                            break; // -1 week on ctrl or command +up
                        case 39: // if (event.ctrlKey || event.metaKey)
                            $.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), 'D');
                            handled = true; // event.ctrlKey || event.metaKey;
                            // +1 day on ctrl or command +right
                            if (event.originalEvent.altKey) $.datepicker._adjustDate(event.target, (event.ctrlKey ?
                                +$.datepicker._get(inst, 'stepBigMonths') :
                                +$.datepicker._get(inst, 'stepMonths')), 'M');
                            // next month/year on alt +right
                            break;
                        case 40: // if (event.ctrlKey || event.metaKey)
                            $.datepicker._adjustDate(event.target, +7, 'D');
                            handled = true; // event.ctrlKey || event.metaKey;
                            break; // +1 week on ctrl or command +down
                        default: handled = false;
                    }
                else if (event.keyCode == 36 && event.ctrlKey) // display the date picker on ctrl+home
                    $.datepicker._showDatepicker(this);
                else {
                    handled = false;
                }
                if (handled) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        });
        $.extend($.expr[':'], {
            focusable: function (el, index, selector) {
                return $(el).is('a, button, :input, [tabindex]');
            }
        });
        app.commonViewHelper = {
            getBookingWindow: getBookingWindow,
            prepFolioTimedOut: function () {
                $('#folioTimedOut').modal('show');
                $('#restart').click(function (obj) {
                    obj.preventDefault();
                    app.dispatcher.redirect('');
                    window.location.reload(false);
                });
                $('#folioTimedOut').on('hidden', function () {
                    app.dispatcher.redirect('');
                    window.location.reload(false);
                })
                if(app.customization.googleAuth.showGoogleYolo){
                    $('#credential_picker_container').remove();
                    $('#credential_picker_iframe').remove();
                }
            },
            fetchFromCache: function (modelName, soapCall, params) {
                return ( !app.models[modelName].dataModel[soapCall].data
                    ? app.models[modelName].getData(soapCall, params)
                    : app.models[modelName].dataModel[soapCall].data[
                        app.models[modelName].makeStandardName(app.models[modelName].dataModel[soapCall],params)
                    ]
                )
            },
            triggerAfterView: function(event, cb) {
                app.views.splashView.event.events.data('events')[event][0].syncTriggerAfter = function() {
                    cb.apply(this, arguments);
                }
            },
            triggerBeforeView: function(event, cb) {
              app.views.splashView.event.events.data('events')[event][0].syncTriggerBefore = function() {
                  cb.apply(this, arguments);
              }
            },
            analyticsInit: function (event, args) {
                //the reason why we're using this pattern and not triggerbefore/after is because we cannot keep this uniform when we get to spa module and triggerbefore/after is not available on the templates in a clean way and for hard to reach areas
                //this will find the right function to call for the analytics event based on the view name or the template/function name in spa
                var analytics = _.find(app.analytics, function (analytics) {
                    return analytics && analytics[event]
                });

                if (analytics && app.customization.googleAnalytics) {
                    return analytics[event].apply(this, args);
                } else {
                    // do nothing
                    return;
                }
            },
            prepPMSSpecialSerivceForm: function (specialServices) {
                $('.addSpecialServiceButton').bind('click', function (obj) {
                    var folioid = $(this).attr('data-for'),
                        dateHref = '';
                    $(obj.target).button('loading');
                    if ($(this).attr('data-charged') == '1') {
                        dateHref = $(this).parents('.specialService').find('select.specialServicesDates').val();
                    }
                    this.href += dateHref;
                  
                });
                if(app.customization.googleAnalytics){
                    $('#categoryTabs > li > a').click(function (e) {
                        e.preventDefault();
                        var category = $(this).attr('data-cat');
                        app.commonViewHelper.analyticsInit('specialServiceCatClick', [specialServices, category]);
                    })
    
                    $('.accordion-heading > a').click(function (e) {
                        e.preventDefault();
                        var itemId = $(this).attr('data-itemid');
                        app.commonViewHelper.analyticsInit('specialServiceItemClick', [specialServices, itemId]);
                    });
                }
                $('.specialService.collapse').on('shown', function (obj) {
                    if ($(obj.target).data('collapse')) {
                        $(obj.target).collapse('reset');
                    }

                });
            },

            updateNavBar: function (serviceType, language, folioBalance) {
                if(window.document.documentMode) $('body').addClass('isIE');          
                var copyrightText = $(".footer-copyright .navbar-text")[0].innerHTML
                if (copyrightText.length < 11) {
                    var yearDigits = new Date().getFullYear();
                    $(".footer-copyright .navbar-text").append(yearDigits);
                }
                
                $('#progressIndicator').modal('hide');
                $('div.popover').remove();
                $('.modal-backdrop').remove();
                if (!serviceType) {
                    $('#navbarServiceTypeList').hide();
                    $('.navbar .nav').removeClass('serviceType')
                } else {
                    $('#navbarServiceTypeList').show();
                    $('.navbar .nav').addClass('serviceType')
                    $('#navbarServiceTypeList li.serviceType').removeClass('active');
                    $('#navbarServiceTypeList li.serviceType.' + serviceType.id).addClass('active')
                    $('#navbarServiceTypeList a.dropdown-toggle span.name').text(serviceType.name);
                    $('#navbarServiceTypeList a.dropdown-toggle i').replaceWith('<i class="icon-' + serviceType.icon + ' icon-white"></i>');
                }
                var items, balance = undefined;
                //update cart total to reflect it on navbar
                var folioSetFolioBalance =    app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId})

                if ((app.data.pmsBookingFuture && app.data.pmsBookingFuture.length > 0)
                    || (app.data.spaBookingFuture && app.data.spaBookingFuture.length > 0)
                    || (app.data.golfBookingFuture && app.data.golfBookingFuture.length > 0)
                    || (folioBalance && +folioBalance.FolioItems > 0 || folioSetFolioBalance && folioSetFolioBalance  != "0.00"  )
                    || app.customization.spaBooking.showContinueShoppingButton
                    && folioBalance.FolioBalance) { //always show cart options/total if true
                  
                    balance = Number(folioSetFolioBalance)|| Number(folioBalance.FolioBalance);
                    $('#navbarCartControl').removeClass('hidden').addClass('active');
                    $('#navbarCartControl .orderTotal').html(app.localization.general.currencyPrefix + (+balance).toFixed(2) + app.localization.general.currencyPostfix);
                    $('#navbarServiceTypeList').removeClass('active');
                    $('.navbar .nav').addClass('bookingSummary')
                } else {
                    $('.navbar .nav').removeClass('bookingSummary')
                    $('#navbarCartControl').addClass('hidden').removeClass('active');
                    $('#navbarServiceTypeList').addClass('active');
                }
                $('#navbarLanguageList li.language').removeClass('active');
                $('#navbarLanguageList li.language.' + app.language).addClass('active');
                $('#navbarLanguageList a.dropdown-toggle span.name').text(app.localization.general.language); //(app.data.languageMap[language]);
                    $('#navbarLanguageList li.language a').on('click',function(){

                app.data.previousHref = window.location.href
            })
                if (app.data.userLoggedIn) {
                    $('#navbarLoginControl a .name').html(app.localization.general.login.greeting + xmlEscape(app.data.FirstName));
                    $('#navbarLoginControl .bookingHistory').removeClass('hidden');
                    $('#navbarLoginControl #loginForm').addClass('hidden');
                    $('#navbarLoginControl #logoutForm').removeClass('hidden');
                    // In Vue application when you logged in profile dropdown is not working 
                    // cause of getting double clicked even click once so for only spa vue app we're preventing double click
                    $('#navbarLoginControl').removeClass('open');
                    $('#navbarLoginControl > a[href="#/profile"]').attr('data-toggle', 'dropdown');
                    var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                    if(checkSpaVueApp > -1){
                        $('#navbarLoginControl > a[href="#/profile"]').off('click');
                    }
                    // remove all 3rd party sign in buttons
                    $('[id="fb-root"]').remove();
                    $('[id="apple-root"]').remove();
                    $('[id="gSignInWrapper"]').remove();
                    $('#logoutButton').click(function (obj) {
                        if (+balance == 0) {
                            if (!window.confirm(app.localization.general.login.logoutWarning)) {
                                obj.preventDefault();
                            }
                        }
                    })
                    if (app.data.folioLoginHasPassword == "N" || app.data.RestrictedFolio) {
                        $('#logoutForm li:first-child').hide();
                    }
                    $('.navbar-login-option').remove();
                    $('.login-options').remove();
                    $('#thirdPartyLogins').remove();
                    $('#thirdPartyAuthDine').remove();
                    if(app.datal('thirdPartyAuth')){
                        $('a[href="#/profile/change"]').remove();
                    }
                } else {
                    $('#navbarLoginControl > a .name').html(app.localization.general.login.loginButtonLabel);
                    $('#navbarLoginControl .bookingHistory').addClass('hidden');
                    $('#navbarLoginControl #loginForm').removeClass('hidden');
                    $('#navbarLoginControl #logoutForm').addClass('hidden');
                    $('.nav .logoutButton').addClass('hidden');
                    $('#navbarLoginControl > a').removeAttr('data-toggle');
                    $('#navbarLoginControl > a').click(function (e) {
                        if (!$(e.target).parents('.nav-collapse').hasClass('in')) {
                            e.preventDefault();
                            $('#navbarLoginControl').toggleClass('open').popover('hide');
                        }
                        $(document).mouseup(function (e) {
                            var container = $('#loginForm');
                            if (!container.is(e.target) && container.has(e.target).length === 0) {
                                $('#navbarLoginControl').removeClass('open');
                            }
                        });
                    });
                    $('#navbarLoginControl form').submit(function (e) {
                        e.preventDefault();
                        $(e.target).validate();
                        if ($(e.target).valid()) {
                            app.dispatcher.updateURL('profile', 'login', [], true);
                            app.dispatcher.dispatch('profile', 'authenticate', [encodeURIComponent($('#loginEmail').val()), encodeURIComponent($('#loginPassword').val())])
                            $('#navbarLoginControl').removeClass('open');
                        }
                    });
                    if (!app.customization.login.alternativeLogin) {
                        $('.login-options').addClass('disabled');
                    } else {
                        $('#header .span4.message').addClass('split-screen')
                    }

                    if (app.customization.showLoginPromptFlyout && app.data.inittime.clone().add(10).seconds() > Date.now() && $('body > .loginPromptFlyout').length == 0) {
                        var nlc = $('#navbarLoginControl');
                        nlc.popover({
                            trigger: 'manual',
                            placement: 'bottom loginPromptFlyout',
                            offsetX: -5,
                            delay: { show: 750, hide: 300 },
                            title: '<a class="close" onclick="app.customization.showLoginPromptFlyout = false; $(\'body > .loginPromptFlyout\').remove(); return false" href="#">&times;</a>'
                                + app.localization.general.login.promptFlyoutTitle,
                            content: app.localization.general.login.promptFlyoutText
                        })
                        $('body').data('loginFlyout', nlc.data('popover'))
                        setTimeout(function () {
                            $('body').data('loginFlyout').show()
                            setTimeout(function () {
                                $('body').data('loginFlyout').hide()
                                app.customization.showLoginPromptFlyout = false;
                            }, 10000);
                        }, 500);

                    }
                    // Facebook Authentication
                    if(app.customization.facebookAuth.showFacebookButton){
                        app.commonViewHelper.handleFacebookAuth();
                    }
                    // Apple Authentication
                    if(app.customization.appleAuth.showAppleButton){
                        app.commonViewHelper.handleAppleAuth();
                    }
                    // Google Authentication
                    if(app.customization.googleAuth.showGoogleButton){
                        app.commonViewHelper.handleGoogleAuth();
                    }

                }
                $('.alert-hide').on('click', function (obj) {
                    if ($(this).hasClass('dont-hide-alerts')) {
                        $(this).removeClass('dont-hide-alerts');
                    } else {
                        $('.alert:not(.alert-error, .alert-uptime, .alert-no-autoclose)').alert('close');
                    }
                })
                $('.error-hide').on('click', function (obj) {
                    $('.alert-error').alert('close');
                })
                $.validator.messages = app.localization.general.err.jquery_validate;
                $('#nav a.skip-main').on('click', function (e) {
                    e.preventDefault();
                    var a = $('#main .focus-first'),
                        b = $('#main #content :focusable:first');
                    // focus the specifically designated focus-first element, or just the first focusable one found
                    (a.length ? a : b).first().focus()
                })
            },

            updateBreadcrumbs: function (breadCrumbs) {
                $('#breadcrumbs').html($('#breadCrumbTpl').rendthaner({
                    'breadCrumbs': breadCrumbs
                }));
            },
            handleServiceClick: function (spaLocations) {
                $('.spaLocationListTpl .location-button').on('click', function (e) {
                    e.preventDefault();
                    var selectedLocationId = $(this).data('location')
                    var isOnLocationScreen = true
                    app.commonViewHelper.browserCheckAndRedirect(spaLocations,selectedLocationId,isOnLocationScreen)
                })
            },
            handleServiceClickOnEventPage: function (spaLocations) {
                $('.spaClassCalendarTpl .crossTypeLink').on('click', function (e) {
                    e.preventDefault();
                    var selectedLocationId = $(this).data('location')
                    var isOnLocationScreen = false
                    app.commonViewHelper.browserCheckAndRedirect(spaLocations,selectedLocationId,isOnLocationScreen)
                })
            },
            handleServiceClickOnClassPage: function (spaLocations) {
                $('.spaClassListTpl .crossTypeLink').on('click', function (e) {
                  e.preventDefault()
                    var selectedLocationId = $(this).data('location')
                    var isOnLocationScreen = false
                    app.commonViewHelper.browserCheckAndRedirect(spaLocations,selectedLocationId,isOnLocationScreen)
                })
            },
            handleSessionTimeOut: function(){  
                app.data.lastUserActiveTime = app.data.lastUserActiveTime || moment().toDate() 
                var now = moment(new Date()) 
                userActiveTime = moment(app.data.lastUserActiveTime),
                idleTime = moment.duration(now.diff(userActiveTime)).minutes(); 
                maxIdleTimeBeforeWarning  = +app.customization.defaultSessionTimeout -  +app.customization.warnFolioTimeoutMinutes
                if(idleTime < maxIdleTimeBeforeWarning ) 
                    app.models.systemModel.getData('folioBalance',{})
            },
            browserCheckAndRedirect: function(locations,selectedLocationId,isOnLocationScreen){
                var isIE = (navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)
                    isIE = (navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)
                    var spaLocations = [].concat(locations)
                    _.each(spaLocations, function (loc) {
                        if (selectedLocationId && loc.LocationId == selectedLocationId) {
                            if (loc.showPackagesButton) {
                                app.dispatcher.redirect('spaBooking', 'package', [
                                    'Location' + loc.LocationId 
                                ])
                            } else app.dispatcher.redirect('spaBooking', 'service', [
                                'Location' + loc.LocationId 
                            ])
                        }
                })
            },
            //below function is used for old spa class/service ui
            checkEligibilityByAge:function(program, userDob, CustomerName, CustomerId,canEditGroupMember) {
                var valid = true,
                requireUserToEnterDate = false
                var errorElement = '<div class="age-restriction-class-error-message" id="age-restriction-' + CustomerId + '">',
                localStrings = app.localization.spaBooking.ageRestriction

                if (app.data.userLoggedIn) {
                    var age = moment().diff(userDob, 'years', false);
                    var isAgeNotValid = ((program.MinAge && age < program.MinAge) || (program.MaxAge && age > program.MaxAge))
                    if ((program.MinAge || program.MaxAge)) {
                        (isAgeNotValid || !userDob && canEditGroupMember == "N") ? valid = false: ''
                        if (isAgeNotValid) {
                            errorElement += '<p >' + CustomerName + ' '+localStrings.classRequiredTextTwoOldUI+'  - ' + ' '+localStrings.ageRestriction+' ( ' + (program.MinAge ? ' '+localStrings.min+':' + program.MinAge : '') + ' ' + (program.MaxAge ? ' ' +localStrings.max+':'+ program.MaxAge : '') + ')</p>'
                        }
                        requireUserToEnterDate = !!!userDob
                    }
                    if (!userDob && canEditGroupMember == "N") {
                        errorElement += '<p>'+localStrings.cannotEditUserDobTextOneOldUI +' '+ CustomerName + ' '+localStrings.cannotEditUserDobTextTwo +'  </p>'
                    }
                } else {
                    if ((program.MinAge || program.MaxAge)) {
                        valid = false;
                    errorElement += '<p>'+localStrings.loginToVerifyTwoOldUI+'</p>'
                    }
                }
                errorElement += '</div>'

                return obj = {
                    isValid: valid,
                    errorElement: errorElement,
                    requireUserToEnterDate:requireUserToEnterDate
                }
            },
            runAgeRestrictionMechanism: function(payload){
                result = app.commonViewHelper.checkEligibilityByAge(payload.service, payload.selectedGuestDob, payload.CustomerName, payload.CustomerId, payload.canEditGroupMember)

                //TOGGLE "CHECK AVAILABILITY BUTTON AND BOOK BUTTON"
                $(payload.self).find('.spaServiceButton').toggleClass('disable_spaEventButton', !result.isValid || result.requireUserToEnterDate)
                $(payload.self).find('.bookButton').toggleClass('disable_spaEventButton', !result.isValid || result.requireUserToEnterDate)
            
                if (!result.isValid)  $(app.data.userLoggedIn? payload.guestSelectionDOM:payload.self.find('.accordion-inner')).prepend(result.errorElement) //render error message
                   
                //show date picker if birthdate is required and user is allowed to edit.Or user previously added dob using datepicker.
                if (!!payload.addedByDatePicker || result.requireUserToEnterDate && payload.canEditGroupMember != "N") {
                    //   requireUserToEnterDate
                    $(payload.guestSelectionDOM).prepend('  <span class="old-service-datepicker"><p class="datepicker-warning">'+app.localization.spaBooking.packageBooking.ageRestriction.requireDOBMessage+'</p><p class="age-validation-error-event"></p> <input type = "text" id = "datepicker-' + payload.CustomerId + '"  placeholder="MM/DD/YYYY"></span>')

                    //handling the date selection and its validity
                   // $(document).ready(function () {
                        // var errorDOM = $(".age-validation-error-event")
                        // $('#datepicker-' + payload.CustomerId).on('input', function (val) {
                        //     var date = $(this).val()
                        //     var isDateValid = isDate(date)
                        //     date ? errorDOM.html(isDateValid ? '' : 'not a valid date') : ''

                        //     function isDate(value) {
                        //         return moment(value, 'MM/DD/YYYY', true).isValid()
                        //     }
                        // })
                       // $(function () {
                            $('#datepicker-' + payload.CustomerId).datepicker({
                                onSelect: function (e) {
                                   // errorDOM.html('') // incase user entered the dob and was in wrong format. Selecting from date picker is always in correct format
                                    $('.age-restriction-class-error-message').remove()
                                    handleClick(payload.service, e, payload.CustomerName, payload.CustomerId)
                                },
                                defaultDate: moment(payload.selectedGuestDob).format('MM/DD/YYYY') || ''
                            })
                            if(payload.selectedGuestDob) {
                                $('.datepicker-warning').html(app.localization.spaBooking.ageRestriction.yourDOB)
                                 $("#datepicker-" + payload.CustomerId).val(moment(payload.selectedGuestDob).format('MM/DD/YYYY'))}
                       // })

                        function handleClick(program, dob, cname, cid) {
                            var param = {
                                "Customer.CustomerId": app.data.CustomerId,
                                "Customer.CustomerGUID": app.data.CustomerGUID,
                                "Customer.DateOfBirth": moment(dob).format('YYYY-MM-DD')
                            }
                            !!cid && cid != app.data.CustomerId ? param["Customer.CustomerToChange"] = cid : ''
                            $.when(app.models.systemModel.getData('updateCustomerProfile', param))
                                .then(function (r_cc) {
                                    var result = app.commonViewHelper.checkEligibilityByAge(program, dob, cname, cid)
                                    //remove error message to avoid dublicate
                                    $('.datepicker-warning').html('')
                                    $('option:selected', $('.serviceRecipient')).data('birthdate', dob)
                                    app.data.loggedInUserProfile? app.data.loggedInUserProfile.DateOfBirth = dob:''
                                   // $('option:selected', $('.serviceRecipient')).data('addedByDatePicker', true)
                                   //keep track of customers who added their dob using a datepicker
                                   var datePickedCustomerList = app.data.datePickedCustomerList|| {}
                                   datePickedCustomerList[cid] = dob
                                   app.datal('datePickedCustomerList',datePickedCustomerList)
                                    //keep track of customers who added their dob using a datepicker
                                    
                                    if (!result.isValid)  $('.datepicker-warning').html(result.errorElement)

                                    //TOGGLE "CHECK AVAILABILITY BUTTON AND BOOK BUTTON"
                                    $('.spaServiceButton').toggleClass('disable_spaEventButton', !result.isValid)
                                    $('.bookButton').toggleClass('disable_spaEventButton', !result.isValid)
                                })
                                .fail(function (err) {
                                    $('.datepicker-warning').html('<p class="age-restriction-class-error-message">'+app.localization.spaBooking.packageBooking.errors.failedToUpdateDOB +'</p>')
                                })
                        }
                  //  })

                }
            },
            showMessages: function () {
                if (app.data.messages) {
                    var unusedmessages = [],
                        showedAMessage = false;
                    for (var message; message = app.data.messages.shift();) {
                        message.id = +Date.now();
                        if (!this.showMessage(message)) {
                            unusedmessages.push(message);
                        } else {
                            showedAMessage = true;
                        }
                    }
                    $.merge(app.data.messages, unusedmessages);
                    if ($('#alerts')[0] && showedAMessage) {
                        $('html, body').animate({
                            scrollTop: $('#alerts').offset().top < $('#nav .navbar').height() ? 0 : $('#alerts').offset().top - $('#nav .navbar').height()
                        }, 300);
                    }
                    $('.alert').fadeIn('slow');
                }
            },

            DisplayError: function (result, msg) {
                result == true ? $('#eventModal #waitlist-error').html(xmlEscape(msg)).removeClass("alert-error").addClass("alert success_message") : $('#eventModal #waitlist-error').html(xmlEscape(msg)).removeClass("success_message").addClass("alert alert-error ")


            },

            showMessage: function (message) {
                if (message.type == 'alert') {
                    var msg = '<div id="alert-' + message.id + '" class="alert hide ' + (message['class']) + '"><a class="close" data-dismiss="alert" role="button" aria-labelledby="alert-head-' + message.id + '" aria-describedby="alert-body-' + message.id + '" href="#">×</a>';
                    message.title && (msg += '<h4 id="alert-head-' + message.id + '">' + message.title + '</h4>');
                    message.message && (msg += '<p id="alert-body-' + message.id + '">' + message.message + '</p>');
                    message.actions && _.each(message.actions, function (action) {
                        msg += '<p>' + action.text + '<a data-loading="' + action.loading + '" class="spaAlternateButton btn btn-small btn-primary" href="' + action.url + '">' + action.label + '</a></p>';
                    })
                    message.footer && (msg += '<p>' + message.footer + '</p>');
                    msg += '</div>';
                    $('#alerts').append(msg);
                } else if (message.type == 'spaAlternateService') {
                    var msg = $('<div id="alert-' + message.id + '" class="alert hide "><a class="close" data-dismiss="alert" role="button" aria-labelledby="alert-head-' + message.id + '" aria-describedby="alert-body-' + message.id + '" href="#">×</a></div>');
                    msg.append('<h4 id="alert-head-' + message.id + '">' + (message.title || app.localization.spaBooking.multipleAppointments.title) + '</h4>');
                    msg.append('<p id="alert-body-' + message.id + '">' + (message.message || app.localization.spaBooking.multipleAppointments.instructions) + '</p>');
                    var tbl = $('<table class="spaAlternateService"></table>');
                    message.actions && _.each(message.actions, function (action) {

                        tbl.append('<tr><td><p>' + app.rs.DateToString(action.text, "dddd, MMMM d, yyyy") + app.localization.spaBooking.serviceSelection.at + app.rs.DateToString(action.text, "h:mm tt") + '</p></td><td><a data-loading="' + (action.loading || app.localization.general.progressIndicatorMessage) + '" class="spaAlternateButton btn btn-small btn-primary" href="' + action.url + '">' + (action.label || app.localization.spaBooking.confirmation.makeBookingButtonLabel) + '</a></td></tr>');
                    })
                    msg.append(tbl);

                    $('#alerts').append(msg);
                } else if (message.type == 'spaConflictingBookings') {
                    var msg = $('<div id="alert-' + message.id + '" class="alert hide"><a class="close" data-dismiss="alert" role="button" aria-labelledby="alert-head-' + message.id + '" aria-describedby="alert-body-' + message.id + '" href="#">×</a></div>');
                    msg.append('<h4 id="alert-head-' + message.id + '">' + (message.title || app.localization.spaBooking.confirmation.err.conflictingBookingsRemoveTitle) + '</h4>');
                    msg.append('<p id="alert-body-' + message.id + '">' + (message.message || app.localization.spaBooking.confirmation.err.conflictingBookingsRemoveExisting) + '</p>');
                    message.actions && _.each(message.actions, function (action) {
                        var locationName = $.firstOrOnly(message.locations[action.text.Location]) ? " - " + $.firstOrOnly(message.locations[action.text.Location]).LocationName : "";
                        msg.append('<p>' + app.rs.DateToString(action.text.StartTime, "dddd, MMMM d, yyyy  h:mm tt") + ' - ' + action.text.ItemName + locationName + '</p>');
                    });
                    msg.append('<p>' + (message.message || app.localization.spaBooking.confirmation.err.conflictingBookingsRemoveMessage) + '</p>');
                    msg.append('<p><a class="btn btn-small" href="#/summary">' + Localization.bookingSummary.cartName + '</a></p>');

                    //                msg.append('<p>' + message.finally.text.StartDateTime + ' - ' + message.finally.text.ItemName + '</p>');
                    //                msg.append('<a data-loading="' + (message.finally.loading || app.localization.general.progressIndicatorMessage) + '" class="spaConflictingButton btn btn-small btn-primary" href="' + message.finally.url + '">' + (message.finally.label || app.localization.spaBooking.confirmation.makeBookingButtonLabel) + '</a>');
                    $('#alerts').append(msg);
                } else if (message.type == 'modal-alert') {
                    var msg = '<div id="alert-' + message.id + '" class="alert hide ' + (message['class']) + '"><a class="close" data-dismiss="alert" role="button" aria-labelledby="alert-head-' + message.id + '" aria-describedby="alert-body-' + message.id + '" href="#">×</a>';
                    message.title && (msg += '<h4 id="alert-head-' + message.id + '">' + message.title + '</h4>');
                    message.message && (msg += '<p id="alert-body-' + message.id + '">' + message.message + '</p>');
                    message.actions && _.each(message.actions, function (action) {
                        msg += '<p>' + action.text + '<a data-loading="' + action.loading + '" class="spaAlternateButton btn btn-small btn-primary" href="' + action.url + '">' + action.label + '</a></p>';
                    })
                    message.footer && (msg += '<p>' + message.footer + '</p>');
                    msg += '</div>';
                    $('#golfer-alerts').append(msg);
                } else {
                    return false;
                }
                return true;
            },
            
            prepSpaForm: function (location, itemId, date, time, staffGenderOrId, templateData,category) {

                var lastItemId = itemId;
                var updateBookButton = function (newItemId) {
                    lastItemId = newItemId || lastItemId;
                    $('#spaServiceForm').validate({
                        rules: {
                            spaServiceStaff: {
                                required: function (e) {
                                    return location.ForceGenderSelect == "Y";
                                }
                            }
                        }
                    });
                    if ($('#spaServiceForm').valid()) {
                        $('.spaServiceButton').addClass(app.customization.spaBooking.alwaysQueryPrice ? '' : 'btn-primary').removeClass('disabled').removeAttr('title');
                    } else {
                        $('.spaServiceButton').removeClass('btn-primary').addClass('disabled').attr('title', 'Please pick a service date first.');
                    }
                    var url = app.dispatcher.updateURL('spaBooking', 'service', [
                        'Location' + location.LocationId + '|' + encodeURIComponent(lastItemId),
                        encodeURIComponent($('#spaServiceDate').val()),
                        encodeURIComponent($('#spaServiceTime').val()),
                        encodeURIComponent(($('#spaRecipientGender' + lastItemId).length ? ($('#spaServiceStaff').val() || $('#spaRecipientGender').val() || "") : $('#spaServiceStaff').val()) || ""),
                        encodeURIComponent($('#serviceRecipient').val() || "")
                    ], true);
                    $('.loginPrompt a').attr('href', '#/profile/login/next' + url)
                }
                var resetAvailabilities = function (that) {
                    var availabilities = $('.spaAvailability').remove()
                        , reqtime = _.min(availabilities, function (x) { return $(x).data('reqtime') })
                        , spaItemElement = $(that).parents('.spaItem')
                    reqtime = addOneMinute($(reqtime).data('reqtime'))
                    var firstTimeOption = _.find(spaItemElement.find('.spaServiceTime option'), function (x) {
                        return x.value == reqtime
                    })
                    if (firstTimeOption) {
                        $('.spaServiceTime').val(firstTimeOption.value)
                        spaItemElement.find('.spaServiceTime').change()
                    }
                    $('.hasAvailabilities').removeClass('hasAvailabilities')
                    spaItemElement.find('.spaServiceButton').button('reset').css('display', 'inline-block')
                    spaItemElement.find('.alert.notAvailable').alert('close')
                    availabilities = undefined
                }
                var spaDateChange = _.debounce(function () {
                    if ($('#spaServiceDate').val() != this.value) {
                        resetAvailabilities(this)
                    }
                    $('.spaServiceDate').val(this.value);
                    $('.alt-spaServiceDate').val($.datepicker.formatDate(Localization.spaBooking.dateFormat[0], $.datepicker.parseDate('yy-mm-dd', this.value)));
                    updateBookButton.call(this);
                    var dayofweek = $.datepicker.formatDate('DD', $.datepicker.parseDate('yy-mm-dd', this.value));
                    var startTime = !!location[dayofweek + 'Start'] && location[dayofweek + 'Start'].substr(10, 4) || "";
                    var endTime = !!location[dayofweek + 'End'] && location[dayofweek + 'End'].substr(10, 4) || "";
                    var opentime = ''
                    $('.spaServiceTimeSelect')
                        .html('')
                        // .data('opentime',startTime)
                        .data('closetime', endTime)
                    var time = $('#spaServiceTime').val();
                    var bookingWindow = getBookingWindow('Spa', _.find(_.flatten(_.pluck(templateData.categories, 'value')), function (item) { return item.SpaItemId == lastItemId }) || { Location: location.Location })
                    var minTime = moment.tz(this.value + ' ' + startTime, "YYYY-MM-DD HHmm", bookingWindow.timeZone),
                        maxTime = moment.tz(this.value + ' ' + endTime, "YYYY-MM-DD HHmm", bookingWindow.timeZone),
                        setTime = $('#spaServiceTime').val();
                    // moment.tz( bookingWindow.timeZone ).format('YYYY-mm-dd hhmm')
                    // var bookingWindowEndInLocationTZ = false;
                    // if (moment.tz(this.value, bookingWindow.timeZone).format('YYYY-MM-DD') == moment.tz(bookingWindow.timeZone).format('YYYY-MM-DD')) {
                    // bookingWindowEndInLocationTZ = moment.tz(this.value+'235959', bookingWindow.timeZone)
                    // bookingWindowEndInLocationTZ = Date.parseExact(bookingWindowEndInLocationTZ,"HHmm")
                    // if (minTime < bookingWindowEndInLocationTZ) {
                    //     minTime = bookingWindowEndInLocationTZ // rounded up to the nearest appointmentIntervalTime
                    // }
                    // }
                    var endOffsetMinTime = minTime.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endOffsetMinTime.add(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endOffsetMinTime[unit](num)
                        })
                    }
                    var startOffsetMinTime = moment('2000-01-01')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startOffsetMinTime = minTime.clone()
                        startOffsetMinTime.add(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startOffsetMinTime[unit](num)
                        })
                    }
                    for (var endOffsetOutputDate = endOffsetMinTime, startOffsetOutputDate = startOffsetMinTime, outputDate = minTime;
                        outputDate < maxTime;
                        (!_.isEmpty(bookingWindow.endSet) && (bookingWindow.endSet.hours || bookingWindow.endSet.hour)) || endOffsetOutputDate.add({ minutes: app.customization.spaBooking.appointmentIntervalTime }),
                        (!_.isEmpty(bookingWindow.startSet) && (bookingWindow.startSet.hours || bookingWindow.startSet.hour)) || startOffsetOutputDate.add({ minutes: app.customization.spaBooking.appointmentIntervalTime }),
                        outputDate.add({ minutes: app.customization.spaBooking.appointmentIntervalTime })) {
                        var now = moment.tz(bookingWindow.timeZone)
                        if (now < endOffsetOutputDate && now >= startOffsetOutputDate) {
                            opentime = opentime || outputDate.format('HHmm')
                            $('.spaServiceTimeSelect').append('<option value="' + outputDate.format('HHmm') + '"' + ((time == outputDate.format('HHmm')) && ' selected="selected"') + '>' + outputDate.format('h:mm a') + '</option>');
                        }
                    }
                    if ($('.spaServiceTimeSelect option').length == 0) {
                        // todo display message
                    }
                    $('.spaServiceTimeSelect')
                        .data('opentime', opentime)
                    if (setTime < opentime) {
                        $('#spaServiceTime').val(opentime);
                    }
                    if (setTime > maxTime.format('HHmm')) {
                        $('#spaServiceTime').val(maxTime.toString('HHmm'));
                    }
                }, 150);
                var spaTimeChange = _.debounce(function () {
                    var newtime = $(this).val();
                    $('.spaServiceTime').val(newtime);
                    updateBookButton.call(this);
                }, 150);
                var spaRecipientGenderChange = _.debounce(function (obj) {
                    if ($('#spaRecipientGender').val() != this.value) {
                        resetAvailabilities(this)
                    }
                    var thisValue = $(this).val();
                    if (thisValue === null) return;
                    $('.spaRecipientGender').val(thisValue);
                    if (this.tagName != "INPUT") {
                        thisValue && (app.data.staffGenderOrId = thisValue);
                        var recipientGender = $(this).parents('.spaItem').find('.spaRecipientGender').val()
                        var serviceStaff = $(this).parents('.spaItem').find('.spaServiceStaff').val()
                        app.data.staffGenderOrId = recipientGender ? (serviceStaff || thisValue) : thisValue
                        if (thisValue != '') { this[0].value == "" && $(this[0]).remove(); }
                        app.dispatcher.dispatch('spaBooking', 'serviceStaffList', [this.id.substr(18), false]);
                    }
                    updateBookButton.call(this);
                }, 150);
                var spaServiceStaffChange = _.debounce(function (obj) {
                    if ($('#spaServiceStaff').val() != this.value) {
                        resetAvailabilities(this)
                    }
                    var thisValue = $(this).val();
                    if (thisValue === null) return;
                    $('.spaServiceStaff').val(thisValue);
                    if (this.tagName != "INPUT") {
                        var recipientGender = $(this).parents('.spaItem').find('.spaRecipientGender').val()
                        app.data.staffGenderOrId = recipientGender ? (thisValue || recipientGender) : thisValue
                        // this[0].value == "" && $(this[0]).remove();
                        app.dispatcher.dispatch('spaBooking', 'serviceStaffList', [this.id.substr(15), false, 'spaServiceStaff', thisValue]);
                    }
                    if (thisValue != "") {
                        $('.spaServiceStaff option[value=]').remove()
                    }
                    updateBookButton.call(this);
                }, 150);
                var serviceRecipientChange = _.debounce(function (obj) {
                   var itemId = ($(this).attr('id')).split('-')
                    var serviceItemDOM = $('#spaItem'+itemId[1])
                
                    //AGE RESTRICTION LOGIC FOR OLD SPA UI -----START-----
                   //clear any error message or date picker 
                   serviceItemDOM.find('.old-service-datepicker').remove()
                   serviceItemDOM.find('.age-restriction-class-error-message').remove()
                    var guestSelectionDOM = serviceItemDOM.find('.serviceRecipientGroup') //used to append error messages
                    
                    if (!$('option:selected', this).is('#newMemberOption')) {
                      //  var selectedGuestDob = $('option:selected').data('birthdate'),
                           var canEditGroupMember = $('option:selected', this).data('canedit'),
                            CustomerId = $(this).val(),
                            service = app.data.selectedService,
                            addedByDatePicker = (app.data.datePickedCustomerList || {})[CustomerId]
                            CustomerName = $('option:selected', this).data('name'),
                            selectedGuestDob =( $('option:selected',this).data('birthdate') )||addedByDatePicker || ''

                        var payload = {
                            selectedGuestDob: selectedGuestDob,
                            canEditGroupMember: canEditGroupMember,
                            CustomerId: CustomerId,
                            service: service,
                            addedByDatePicker: addedByDatePicker,
                            CustomerName: CustomerName,
                            self: serviceItemDOM,
                            guestSelectionDOM: guestSelectionDOM

                        }
                        app.commonViewHelper.runAgeRestrictionMechanism(payload)
                        //AGE RESTRICTION LOGCI FOR OLD SPA UI -----END-----
                    }
                   // selectedService
                    if ($(this).val() == "addMember") {
                        $('.newMember').removeClass('hide')
                        if (app.customization.spaBooking.useFullPageAddGroupMember) {
                            app.data.loginNextURL = ['spaBooking', 'service', [
                                'Location' + location.LocationId + '|' + encodeURIComponent(lastItemId),
                                encodeURIComponent($('#spaServiceDate').val()),
                                encodeURIComponent($('#spaServiceTime').val()),
                                encodeURIComponent(($('#spaRecipientGender' + lastItemId).length ? ($('#spaServiceStaff').val() || $('#spaRecipientGender').val() || "") : $('#spaServiceStaff').val()) || ""),
                                encodeURIComponent($('#serviceRecipient').val() || "")
                            ]]
                            app.dispatcher.redirect('profile', 'addmember', []);
                            return;
                        }
                    } else {
                        $('.newMember').addClass('hide')
                        var thisValue = $(this).val();
                        $('.serviceRecipient').val(thisValue);
                        updateBookButton.call(this);
                    }
                }, 150);
                templateData.showDateList = false;
                if (!app.data.overridePMSRestriction && templateData.dateList && templateData.dateList.length > 0) {
                    templateData.showDateList = true;
                    if (!_.any(templateData.dateList, function (x) { return x.machine == date })) {
                        date = templateData.dateList[0].machine;
                    }
                }
                var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location))
                var now = moment.tz(bookingWindow.timeZone);
                var endMinTime = now.clone()
                if (!_.isEmpty(bookingWindow.endOffset)) {
                    endMinTime.subtract(bookingWindow.endOffset)
                }
                if (!_.isEmpty(bookingWindow.endSet)) {
                    _.each(bookingWindow.endSet, function (num, unit) {
                        endMinTime[unit](num)
                    })
                }

                $('.spaServiceDate, #alt-spaServiceDate' + itemId).val(app.customization.spaBooking.forceSpaDate && app.customization.spaBooking.forceSpaDate.substr(0, 10) || date || endMinTime.format('YYYY-MM-DD'));
                $('#spaServiceDate').change(spaDateChange);
                $('.spaServiceTime').val(time);
                $('#spaServiceTime').change(spaTimeChange);
                $('#spaRecipientGender').change(spaRecipientGenderChange);
                $('.spaRecipientGender').val(staffGenderOrId)
                $('#spaServiceStaff').change(spaServiceStaffChange);
                $('.spaServiceStaff').val(staffGenderOrId)
                $('.serviceRecipient').val(templateData.guestName)
                $('.spaAlternateButton').on('click', function (obj) {
                    $(obj.target).button('loading');
                    $('#progressIndicator').modal('show');
                })
                var attachSpaEventHandlers = function (spaItemElement, itemId, itemData) {
                    var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location, itemData))
                    spaItemElement.data('bookingWindow', bookingWindow)
                    var now = moment.tz(bookingWindow.timeZone);
                    var endMinTime = now.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endMinTime.subtract(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endMinTime[unit](num)
                        })
                    }
                    var startMaxTime = now.clone().add(2, 'years')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startMaxTime = now.clone()
                        startMaxTime.subtract(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startMaxTime[unit](num)
                        })
                    }

                    spaItemElement.find('#alt-spaServiceDate' + itemId).datepicker({
                        minDate: endMinTime.toDate(),
                        maxDate: startMaxTime.toDate(),
                        numberOfMonths: 2,
                        dateFormat: app.localization.spaBooking.dateFormat[0],
                        defaultDate: Date.parse($('#alt-spaServiceDate' + itemId).val(),'yyyy-MM-dd'),
                        altField: '#spaServiceDate' + itemId,
                        altFormat: "yy-mm-dd",
                        onSelect: function(){ spaItemElement.find('.spaServiceDate').trigger('change') }
                    }).datepicker('setDate', Date.parse($('.spaServiceDate').val(), 'yyyy-MM-dd'));
                    // spaItemElement.find('.required').change(function(e){
                    // updateBookButton.call(this,itemId);
                    // })
                    spaItemElement.find('.spaServiceDate').change(spaDateChange);
                    if (templateData.showDateList && app.data.pmsPropertyIdsInCart.length < 1) {
                        // if (app.data.RestrictedFolio) {
                        //     spaItemElement.find('.spaServiceDateContainer').popover({
                        //         trigger: 'hover',
                        //         placement: 'in left',
                        //         offsetY: 10,
                        //         delay: { show: 250, hide: 300 },
                        //         title: app.localization.spaBooking.pmsbeforespa.restrictedDateSelectorAcknowledgePromptTitle,
                        //         content: app.localization.spaBooking.pmsbeforespa.restrictedDateSelectorAcknowledgePromptText.replace('a href="#/profile"', 'a onclick="app.data.overridePMSRestriction = true;" href="#/spaBooking/service/' + spaItemElement.attr('id').substr(7) + '"')
                        //     });
                        // } else {
                        //     spaItemElement.find('.spaServiceDateContainer').popover({
                        //         trigger: 'hover',
                        //         placement: 'in left',
                        //         offsetY: 10,
                        //         delay: { show: 250, hide: 300 },
                        //         title: app.localization.spaBooking.pmsbeforespa.dateSelectorAcknowledgePromptTitle,
                        //         content: app.localization.spaBooking.pmsbeforespa.dateSelectorAcknowledgePromptText.replace('a href="#/summary/setOverride"', 'a onclick="app.data.overridePMSRestriction = true;" href="#/spaBooking/service/' + spaItemElement.attr('id').substr(7) + '"')
                        //     });
                        // }
                    }
                    spaItemElement.find('.spaServiceTime').change(spaTimeChange);
                    $('#spaServiceDate').change();
                    $('#spaServiceTime').change();
                    spaItemElement.find('.itemStaffPref').on('show', function () {
                        app.dispatcher.dispatch('spaBooking', 'serviceStaffList', [this.id.substr(13), location.AllowStaff == "N"]);
                    });
                    if (itemData.ItemImage) {
                        spaItemElement.find('.itemImage img')
                            .on('error', function () {
                                spaItemElement.find('.itemImage').remove()
                                spaItemElement.find('.itemDesc').removeClass('span6').addClass('span9')
                            })
                            .attr('src', itemData.ItemImage)
                    } else {
                        spaItemElement.find('.itemImage').remove()
                        spaItemElement.find('.itemDesc').removeClass('span6').addClass('span9')
                    }
                    spaItemElement.find('.itemprice').on('click', '.bookButton', function () {
                        $(this).attr(src)
                    })
                    if(app.customization.spaBooking.showContinueShoppingButton){
                        $(".itemPrice").addClass( "itemAvailCont" );
                        $(".itemDesc").addClass( "itemDescCont" );
                    }
                    spaItemElement.find('.spaServiceButton').on('click', function (obj) {
                        if (location.ForceGenderSelect == 'Y' && !$('#spaServiceForm').valid()) {
                            obj.preventDefault();
                            return
                        }
                        var itemId = $(this).parents('.spaItem').attr('id') && $(this).parents('.spaItem').attr('id').substr(7) || ""
                        updateBookButton.call(this, itemId);
                        if (app.customization.spaBooking.alwaysQueryPrice) {
                            obj.preventDefault();
                            var date = $('#spaServiceDate').val()
                                , time = $('#spaServiceTime').val()
                                , staffGenderOrId = ($('#spaRecipientGender' + itemId).length ? $('#spaServiceStaff').val() || $('#spaRecipientGender').val() : $('#spaServiceStaff').val()) || ""
                                , guestName = $('#serviceRecipient').val() || ""
                            $(obj.target)
                                .button('loading')
                                .data('lookahead', app.customization.spaBooking.availabilityQueryLookaheadDays)
                                .data('startDate', date)
                                .data('startTime', time)
                            app.dispatcher.dispatch('spaBooking', 'serviceItem', [itemId, date, time, staffGenderOrId, guestName]);
                            $('.alert.notAvailable').alert('close')
                        } else {
                            $(obj.target).button('loading');
                            $('#progressIndicator').modal('show');
                            obj.target.orighref = obj.target.orighref || obj.target.href
                            obj.target.href = obj.target.orighref + '/' + $('#spaServiceDate').val() + '/' + $('#spaServiceTime').val();
                            var spaItem = $(obj.target).parents('.spaItem'),
                                recipientGender = spaItem.find('.spaRecipientGender').val(),
                                staffGender = spaItem.find('.spaServiceStaff').val();
                            obj.target.href += '/';
                            if (staffGender) {
                                obj.target.href += staffGender;
                            } else if (recipientGender) {
                                obj.target.href += recipientGender;
                            }
                            obj.target.href += '/' + encodeURIComponent($('#serviceRecipient').val())
                        }

                    });
                    //$('#categories .nav-tabs li:first-child').addClass('active');
                    //$('#categories .tab-content div.tab-pane:first-child').addClass('active');
                    //$('#categories .tab-content div.accordion-group:first-child div.accordion-body').addClass('in')
                    
                    var value_spaServiceStaff = $('#spaServiceStaff').val()
                        , value_spaRecipientGender = $('#spaRecipientGender').val()
                    spaItemElement.find('.spaServiceStaff').change(spaServiceStaffChange);
                    app.dispatcher.dispatch('spaBooking', 'serviceStaffList', [itemId, false, 'spaServiceStaff', value_spaServiceStaff]);

                    if (templateData.showBookForGroupMember) {
                        spaItemElement.find('.serviceRecipientGroup').removeClass('hide')
                    }
                    // $('#spaServiceStaff').change();
                    spaItemElement.find('.spaRecipientGender').change(spaRecipientGenderChange);
                    spaItemElement.find('.spaRecipientGender').val(value_spaRecipientGender).change();
                    // $('#spaRecipientGender').change();
                    spaItemElement.find('.spaItemHasStaff').click(function (obj) {
                        app.dispatcher.dispatch('spaBooking', 'serviceStaffList', [obj.target.hash.substr(8)]);
                    })
                    spaItemElement.find('.itemStaffPref').on('show', function (obj) {
                        $(obj.target).parents('.spaItem').find('.moreOptionsButton').hide();
                    });
                    spaItemElement.find('.itemStaffPref').on('shown', function (obj) {
                        if ($(obj.target).parents('.spaItem').data('collapse')) {
                            $(obj.target).parents('.spaItem').collapse('reset');
                        }
                    });
                    spaItemElement.find('.serviceRecipient .me').click(function (obj) {
                        $(obj.target).parents('.spaItem').find('.someoneInput').addClass('hidden');
                        $('.someoneInputField').removeClass('required');
                        updateBookButton.call(this);
                        if ($(obj.target).parents('.spaItem').data('collapse')) {
                            $(obj.target).parents('.spaItem').collapse('reset');
                        }
                    });
                    spaItemElement.find('.serviceRecipient .someone').click(function (obj) {
                        $(obj.target).parents('.spaItem').find('.someoneInput').removeClass('hidden');
                        $('.someoneInputField').addClass('required');
                        updateBookButton.call(this);
                        if ($(obj.target).parents('.spaItem').data('collapse')) {
                            $(obj.target).parents('.spaItem').collapse('reset');
                        }
                    });
                    spaItemElement.find('.serviceRecipientGroup .serviceRecipient').change(serviceRecipientChange);
                    spaItemElement.find('.serviceRecipientGroup .newMemberAdd').on('click', function (obj) {
                        obj.preventDefault();
                        updateBookButton.call(this);
                        $('#progressIndicator').modal('show');
                        app.data.loginNextURL = ['spaBooking', 'service', [
                            'Location' + location.LocationId + '|' + encodeURIComponent(lastItemId),
                            encodeURIComponent($('#spaServiceDate').val()),
                            encodeURIComponent($('#spaServiceTime').val()),
                            encodeURIComponent($('#spaRecipientGender').val() || $('#spaServiceStaff').val() || ""),
                            encodeURIComponent($('#serviceRecipient').val() || "")
                        ]]
                        app.dispatcher.dispatch('profile', 'quickspamembercreatesubmit', [
                            "", // encodeURIComponent($('#userEmail1').val()),
                            "", // encodeURIComponent($('#userPassword1').val()),
                            "", // encodeURIComponent($('#userGender').val()),
                            "", // encodeURIComponent($('#userSalutation').val()),
                            encodeURIComponent($(this).parents('.newMember').find('.newMemberFirstName').val()),
                            encodeURIComponent($(this).parents('.newMember').find('.newMemberLastName').val()),
                            // $('#userMainPhoneH').hasClass('active') ? "H" :
                            //     $('#userMainPhoneW').hasClass('active') ? "W" :
                            //         $('#userMainPhoneO').hasClass('active') ? "O" : "",
                            "",
                            "", // encodeURIComponent($('#userHomePhone').val()),
                            "", // encodeURIComponent($('#userWorkPhone').val()),
                            "", // encodeURIComponent($('#userWorkExt').val()),
                            "", // encodeURIComponent($('#userOtherPhone').val()),
                            "", // encodeURIComponent($('#userMobilePhone').val()),
                            templateData.user.Address[0].Address1 || "", // encodeURIComponent($('#userHomeAddress1').val()),
                            templateData.user.Address[0].Address2 || "", // encodeURIComponent($('#userHomeAddress2').val()),
                            templateData.user.Address[0].City || "", // encodeURIComponent($('#userHomeCity').val()),
                            templateData.user.Address[0].StateProv || "", // encodeURIComponent($('#userHomeProvince').val()),
                            templateData.user.Address[0].Country || "", // encodeURIComponent($('#userHomeCountry').val()),
                            templateData.user.Address[0].PostCode || "", // encodeURIComponent($('#userHomePostalCode').val()),
                            "", // encodeURIComponent($('#userOtherAddress1').val()),
                            "", // encodeURIComponent($('#userOtherAddress2').val()),
                            "", // encodeURIComponent($('#userOtherCity').val()),
                            "", // encodeURIComponent($('#userOtherProvince').val()),
                            "", // encodeURIComponent($('#userOtherCountry').val()),
                            "", // encodeURIComponent($('#userOtherPostalCode').val()),
                            "1", // $('#newsletter').prop('checked') ? "1" : "0",
                            "1", // $('#mailmarketing').prop('checked') ? "1" : "0",
                            "1", // $('#phonemarketing').prop('checked') ? "1" : "0",
                            "1", // $('#smsmarketing').prop('checked') ? "1" : "0",
                            { "English": "en-us", "French": "fr-ca", "Spanish": "es-sp", "Chinese": "zh-cn", "": "en-us" }[templateData.user.Language],
                            // $('#userLanguageen-us').hasClass('active') ? "en-us" :
                            //     $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                            //         $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                            //             $('#userLanguagees-sp').hasClass('active') ? "es-sp" : ""
                            //club below 4 of them
                            '',
                            '',
                            '',
                            '',
                            '', //$('#userSkiSize').val()||'',
                            '', //$('#userSkiBootSize').val()||'',
                            '',
                            '',
                            '', //$('#userSnowboardSize').val()||'',
                            '', //$('#userSnowboardBootSize').val()||'',
                            '', //$('#userDinNumber').val()||'',
                            '', //$('#userAge').val()||'',
                            '', //$('#userWeight').val()||'',
                            '', //$('#userHeight').val()||'',
                            '', //$('#userDOB').val()||'',
                            '' //$('#userCustomerId').val()
                        ]);
                    })
                };
                $('.spaItem').on('shown', function (obj) {
                    var itemId = $(this).attr('id').substr(7),
                        spaItemCollapse = $("#spaItem" + itemId),
                        spaItemGenderControlName = spaItemCollapse.find('.spaRecipientGender').length ? 'spaRecipientGender' : 'spaServiceStaff',
                        spaItemGenderControl = spaItemCollapse.find('.' + spaItemGenderControlName);

                    if (spaItemGenderControl.hasClass('hasData') && !spaItemGenderControl.val()) {
                        $('.' + spaItemGenderControlName).val('').change();
                    }
                    spaItemCollapse.data('collapse') && spaItemCollapse.collapse('reset');
                    app.customization.googleAnalytics && _gaq.push(['_trackPageview', '#/spaBooking/service/' + itemId]);
                }).on('show', function (obj) {
                    $(this).show()
                }).on('hidden', function (obj) {
                    $(this).hide()
                });
                $('.spaItemToggle').on('click', function (obj) {
                  
                    var itemId = $(this).attr('id').substr(13),
                        spaItemCollapse = $("#spaItem" + itemId),
                        itemData = false;
                    _.each(templateData.categories, function (v, k, l) {
                        itemData = itemData || _.find(v.value, function (x) {
                            return x.SpaItemId == itemId;
                        })
                    });
                  

   
                     obj.preventDefault();
                    if (!app.customization.spaBooking.autoExpandResults && spaItemCollapse.hasClass('empty')) {
                        spaItemCollapse.html(spaServiceListPartialSpaItemTpl($.extend({}, itemData, templateData)));
                        spaItemCollapse.data('collapse') && spaItemCollapse.collapse('reset');
                        spaItemCollapse.removeClass('empty');
                        attachSpaEventHandlers(spaItemCollapse, itemId, itemData);

                        //set placeholder date spa

                        if(sessionStorage.getItem('phWid-' + app.data.WebFolioId)){
                            var phDate = JSON.parse(sessionStorage.getItem('phWid-' + app.data.WebFolioId));
                            if($($('input.datepicker')[0]).datepicker('option', 'dateFormat').toLocaleLowerCase()[0] == 'd'){
                            $('.datepicker').datepicker("setDate", new Date(phDate.year + ',' + phDate.month + "," + phDate.day));
                            $('#spaServiceDate').attr('value', new Date(phDate.year + ',' + phDate.month + "," + phDate.day).toISOString().slice(0,10));
                            }else{
                                $('.datepicker').datepicker("setDate", new Date(phDate.year,phDate.altMonth,phDate.day));
                                $('#spaServiceDate').attr('value', new Date(phDate.year,phDate.altMonth,phDate.day).toISOString().slice(0,10));
                            }
                        }
                    }
                    app.data.selectedService = itemData
                    updateBookButton.call(this, itemId);
                    //run age restriction login on mount -start-
                    $('.old-service-datepicker').remove()
                    $('.age-restriction-class-error-message').remove()
                    var serviceItemDOM = $('#spaItem'+app.data.selectedService.SpaItemId)
                    if(!$(serviceItemDOM).hasClass('in')){
                        var guestDropDown = serviceItemDOM.find('.serviceRecipient') 
                        var guestSelectionDOM = serviceItemDOM.find('.serviceRecipientGroup')
                        var selectedGuest = $('option:selected', guestDropDown).val()
                        
                        $('.newMember').toggleClass('hide',selectedGuest != "addMember")

                        var payload = {
                            canEditGroupMember: $('option:selected', guestDropDown).data('canedit'),
                            CustomerId:$(guestDropDown).val(),
                            service:itemData,
                            addedByDatePicker:(app.data.datePickedCustomerList||{})[$(guestDropDown).val()],
                            CustomerName:$('option:selected', guestDropDown).data('name'),
                            self:serviceItemDOM,
                            guestSelectionDOM:guestSelectionDOM
                        } 
                        payload.selectedGuestDob = ($('option:selected',guestDropDown).data('birthdate')) || payload.addedByDatePicker || ''
                        app.commonViewHelper.runAgeRestrictionMechanism(payload)
                    }
                    //run age restriction login on mount -end-
                }).on('keydown', function (e) {
                    switch (e.keyCode) {
                        case 37: e.preventDefault(); // left to focus header
                            $('#categoryTabs a[href="#' + $(this).parents('.tab-pane').attr('id') + '"]').focus()
                            break;
                        case 38: e.preventDefault(); // up to focus previous spa item toggle
                            $(this).parents('.accordion-group').prev().find('.spaItemToggle').focus()
                            break;
                        case 39: e.preventDefault(); // right to expand collapse
                            $(e.target).click();
                            break;
                        case 40: e.preventDefault(); // down to focus next spa item toggle
                            $(this).parents('.accordion-group').next().find('.spaItemToggle').focus()
                            break;
                    }
                });
                $('#categoryTabs a').click(function (obj) {
                    obj.preventDefault();
       

                    $('.spaItemToggle').each(function(){
                        var itemId = $(this).attr('href').substr(8)
                         if (!$(this).hasClass('collapsed')) {
                             $('#spaItem'+itemId).removeClass('in')
                             $('#spaItem'+itemId).css('display','none')
                             $('#spaItem'+itemId).css('height',"0px")
                         }
                    });
                     
                    $('#categoryTabs a').attr('aria-selected', 'false');
                    $(this).tab('show').attr('aria-selected', 'true');
                    if ($($(this).attr('href')).hasClass('active')) {
                        $($(this).attr('href')).find(':focusable:first').focus();
                    }
                    //$(this.hash).has('div.accordion-group div.accordion-body.in').length || $(this.hash).find('div.accordion-group:first-child div.accordion-body').addClass('in');
                }).on('shown', function (e) {
                    $($(e.target).attr('href')).find(":focusable:first").focus();
                }).on('keydown', function (e) {
                    switch (e.keyCode) {
                        case 39: e.preventDefault(); // right to focus tab pane
                            $(e.target).click();
                            break;
                        case 38: e.preventDefault(); // up to focus previous category heading
                            $(this).parents('li').prev().find('a').focus()
                            break;
                        case 40: e.preventDefault(); // down to focus next category heading
                            $(this).parents('li').next().find('a').focus()
                            break;
                    }
                }).first().addClass('focus-first')
                $('.crossTypeLink').on('click', function (obj) {
                   // console.log("1222","hello")
                    this.href += '/' + $('#spaServiceDate').val()
                })

                if (!!app.customization.spaBooking.autoExpandResults) {

                    _.each(templateData.categories, function (v, k, l) {
                        _.each(v.value, function (spaItem) {
                            var itemId = spaItem.SpaItemId
                                , spaItemCollapse = $("#spaItem" + itemId)
                            spaItemCollapse.html(spaServiceListPartialSpaItemTpl($.extend({}, spaItem, templateData)));
                            spaItemCollapse.removeClass('empty').addClass('in');
                            attachSpaEventHandlers(spaItemCollapse, itemId, spaItem);

                        })
                    });
                    $(".spaItemToggle").removeAttr('data-parent').removeAttr('data-toggle')
                    if (!!itemId) {
                        $('html, body').animate({
                            scrollTop: ($("#spaItem" + itemId).offset().top - window.document.body.scrollTop < $(window).height() * .6)
                                ? $("#spaItem" + itemId).offset().top - $(window).height() * .5
                                : 0
                        }, 300);
                    } else {
                        $('#categoryTabs a:first').click()
                    }
                } else if (!!itemId) {
                        $('#spaItemToggle' + itemId).addClass('dont-hide-alerts').click();
                }
               
              
              
            },
            
            handleClubDirectory: function(accountId, memberList){
                var modal = $('.content-clubGuestDirectory .clubGuestDirectory')
                modal.append('<div class="row"></div>')
                modal.find('.row').append('<div class="backtoAccount-parent-div"><a class="backtoAccount">'+Localization.club.goBackToAccount+'</a></div>')
                handlebackclick(modal, accountId)
                createDirectoryTable(modal)
                initializeData(memberList)              
                
                function createDirectoryTable(modal){
                    var theads = Localization.general.club.TableHeaders
                    var table= '<table id="guestDirectory" class="table table-striped table-bordered" cellspacing="0" width="100%"> <thead> <tr> </tr> </thead> </table>'
                    modal.find('.row').append(table)
                    theads.forEach(function(thead){
                        modal.find('#guestDirectory  tr').append('<th>'+thead+'</th>')
                    }) 
                }
               function initializeData(memberList){
                    $(document).ready(function() {
                    $('#guestDirectory').DataTable( {
                            data:memberList,
                            "columns": [
                                { "data": "name" },
                                { "data": "address" },
                                { "data": "phone" },
                                { "data": "email" },
                                { "data": "VIPLevel" },
                                { "data": "Gender" } ,
                                { "data": "Birthdate" } ,
                                {"data":'GolfPlayerType'}
                            ],
                            "createdRow": function (row, data, rowIndex) {
                                // Per-cell function to do whatever needed with cells
                                $.each($('td', row), function (colIndex) {
                                    // For example, adding data-* attributes to the cell
                                     $(this).attr('data-label', Object.keys(data)[colIndex]);
                                });
                            }
                        });
                    
                    }); 
                }
                function handlebackclick(modal,accountId){
                    modal.find('.backtoAccount').on('click', function (e) {
                        e.preventDefault()
                        app.dispatcher.redirect('membership', 'account', accountId);
                    })
                }             
            },
            paginateClubStatements: function (accountResponse){
                var items = $('.accordion-group');
                var numItems = items.length;
                var perPage = typeof Customization.club.memberStatementMonthsQuantity == 'number' && Customization.club.memberStatementMonthsQuantity >= 3 ? Math.abs(parseInt(Customization.club.memberStatementMonthsQuantity)): Customization.club.memberStatementMonthsQuantity = 3;
                items.slice(perPage).hide();
                if(Customization.club.memberStatementsPagination){
                    $('#pagination-container').pagination({
                        items: numItems,
                        itemsOnPage: perPage,
                        prevText: "&laquo;",
                        nextText: "&raquo;",
                        hrefTextPrefix:'',
                        onPageClick: function (pageNumber,e) {
                            e.preventDefault();
                            var showFrom = perPage * (pageNumber - 1);
                            var showTo = showFrom + perPage;
                            items.hide().slice(showFrom, showTo).show();
                            app.datal("clubPagination",pageNumber)
                        },
                        onInit:function(){
                            var currentPage = app.datal("clubPagination") == null || app.datal("clubPagination") > Math.ceil(numItems/perPage)  ? 1 : app.datal("clubPagination");
                            $('#pagination-container ul li a[href='+ currentPage +']').click();
                        }
                    })
                } else {
                    items.insertAfter('#statementTitleWraper');
                }              
            },
            populateReturnStatementText: function() {
               var accountId = app.dispatcher.currentRoute[2] 
               var returnStatementText = '<p id="returnStatement" >'+Localization.club.returnStatement+'</p>';
               if(window.location.href.indexOf('membership') != -1){
                   $('#content').append(returnStatementText);
                   $('#content #returnStatement span').click(function(){
                    app.dispatcher.dispatch('membership','account',[accountId]);
                   })
                } else if(app.data.clubBookingInCart){
                    $('#content').append(returnStatementText);
                    $('#content #returnStatement span').click(function(){
                    app.dispatcher.dispatch('membership');
                    })
                }
            },
            updateSpaItemAvailability: function (params) {
                var spaItemElement = $('#spaItem' + params.itemId)
                    , bookingWindow = spaItemElement.data('bookingWindow')
                    , buttonElement = spaItemElement.find('.spaServiceButton')
                    , availabilityElement = $(Customization.spaBooking.showContinueShoppingButton ? app.localization.spaBooking.serviceSelection.availabilityRowBookContinue : app.localization.spaBooking.serviceSelection.availabilityRow)
                    , availabilityMaxTime = ""
                    , lookahead = +buttonElement.data('lookahead')
                    , startDate = params.date // buttonElement.data('startDate')
                    , startTime = addOneMinute(params.time) // buttonElement.data('startTime')
                    , openTime = spaItemElement.find('.spaServiceTimeSelect').data('opentime')
                    , closeTime = spaItemElement.find('.spaServiceTimeSelect').data('closetime')
                    , duration = buttonElement.data('duration')
                    , maxtime = ''

                spaItemElement.addClass('hasAvailabilities')
                
                var currentTimeInLocationTZ = false;
                if (moment.tz(startDate, bookingWindow.timeZone).format('YYYY-MM-DD') == moment.tz(bookingWindow.timeZone).format('YYYY-MM-DD')) {
                    currentTimeInLocationTZ = moment.tz(bookingWindow.timeZone).format('HHmm')
                    // currentTimeInLocationTZ = Date.parseExact(currentTimeInLocationTZ,"HHmm")
                    // if (minTime < currentTimeInLocationTZ) {
                    //     minTime = currentTimeInLocationTZ // rounded up to the nearest appointmentIntervalTime
                    // }
                    if (params.spaAvailability && params.spaAvailability.SpaAvailability) {
                        params.spaAvailability.SpaAvailability = _.filter(params.spaAvailability.SpaAvailability, function (availability) {
                            return availability.StartTime.substr(10, 4) >= currentTimeInLocationTZ
                        })
                    }
                }

                if (params.spaAvailability && params.spaAvailability.SpaAvailability) {
                    buttonElement.button('reset')
                    _.each(params.spaAvailability.SpaAvailability, function (availability) {
                        var conflict = false
                            , endTime = Date.parseExact(availability.StartTime, 'yyyy-MM-ddHHmmss').add(duration).minutes().toString('yyyy-MM-ddHHmmss')
                        _.each(app.data.spaBookings, function (spaBooking) {
                            if (spaBooking.SpaFolioItem.BookStartTime <= endTime
                                && availability.StartTime <= spaBooking.SpaFolioItem.BookEndTime) {
                                conflict = true
                            }
                        })
                        availabilityMaxTime = availabilityMaxTime < availability.StartTime ? availability.StartTime : availabilityMaxTime
                        if (conflict) return
                        spaItemElement.find('.spaAvailability[data-time=' + availability.StartTime + ']').remove()
                        var newElement = availabilityElement.clone()
                            , staffName = _.find(params.spaStaffList.SpaStaff, function (x) { return x.SpaStaffId == availability.SpaStaffId })
                        staffName = staffName && staffName.SpaStaffName || ''
                        newElement.attr('data-time', availability.StartTime)
                        newElement.attr('data-reqtime', params.time)
                        newElement.find('.staff').text(staffName)
                        newElement.find('.time').text(Date.parseExact(availability.StartTime.substr(10, 4), "HHmm").toString(app.localization.CultureInfo.formatPatterns.shortTime))
                        newElement.find('.price').text(app.localization.general.currencyPrefix + (+availability.Price).toFixed(2) + app.localization.general.currencyPostfix)
                        newElement.find('.bookButton').on('click', function (e) {
                            e.preventDefault()
                            $(this).text(Localization.spaBooking.serviceSelection.loading)
                            // part of #10942 fix - updating customerId adfter it has already been selected
                             var customerId = $('#serviceRecipient-'+params.itemId).val()
                            params.guestName = customerId
                            app.dispatcher.dispatch('spaBooking', 'book', [params.itemId, availability.StartTime.substr(0, 10), availability.StartTime.substr(10, 4), availability.SpaStaffId, params.guestName, params.staffGenderOrId, 0, $('#spaGuestRequest' + params.itemId).val()]);
                        })
                        newElement.find('.bookButtonResume').on('click', function (e) {
                            e.preventDefault()
                            $(this).text(Localization.spaBooking.serviceSelection.loading)
                            app.data.NoSummary = true; //allow control of when booking summary is loaded via spa controller (continue booking)
                            // part of #10942 fix - updating customerId adfter it has already been selected
                            var customerId = $('#serviceRecipient-'+params.itemId).val()
                            params.guestName = customerId
                            app.dispatcher.dispatch('spaBooking', 'book', [params.itemId, availability.StartTime.substr(0, 10), availability.StartTime.substr(10, 4), availability.SpaStaffId, params.guestName, params.staffGenderOrId, 0, $('#spaGuestRequest' + params.itemId).val()]);
                        })
                        spaItemElement.find('.spaServiceButton').after(newElement)
                    })
                    // if params.spaAvailability.SpaAvailability.length<5 make note that there are no more today
                    maxTime = getMaxTime()
                } else {
                    // we got nothing
                    maxTime = getMaxTime()
                    if (startTime > maxTime && getMinReqTime() < openTime) {
                        maxTime = closeTime
                    } else if (lookahead > 0) {
                        if (startTime > openTime) {
                            startTime = openTime
                            // skip query if we have result with reqtime == opentime
                        } else {
                            buttonElement.data('lookahead', lookahead = lookahead - 1)
                            startDate = Date.parseExact(startDate, "yyyy-MM-dd").add(1).day().toString('yyyy-MM-dd')
                        }
                        app.dispatcher.dispatch('spaBooking', 'serviceItem', [params.itemId, startDate, startTime, params.staffGenderOrId, params.guestName]);
                        return
                    } else {
                        buttonElement.button('reset')
                        spaItemElement.find('.spaServiceButton').after(
                            '<div class="alert fade in error notAvailable"><a class="close" data-dismiss="alert" href="#">×</a><p>'
                            + (app.customization.spaBooking.availabilityQueryLookaheadDays ? app.localization.spaBooking.serviceSelection.notAvailableDates : app.localization.spaBooking.serviceSelection.notAvailable)
                            + (app.customization.spaBooking.availabilityQueryLookaheadDays
                                ? '</p><a class="btn" href="#">' + app.localization.spaBooking.serviceSelection.checkNextDay + '</a></div>'
                                : '</p></div>')
                        )
                        app.customization.spaBooking.availabilityQueryLookaheadDays && spaItemElement.find('.spaServiceButton').css('display', 'none')
                        spaItemElement.find('.alert.notAvailable .date').text(Date.parseExact(params.date, "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .fromdate').text(Date.parseExact(buttonElement.data('startDate') || params.date, "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .time').text(Date.parseExact(addOneMinute(params.time), "HHmm").toString(app.localization.CultureInfo.formatPatterns.shortTime))
                        spaItemElement.find('.alert.notAvailable .staffOrGender').html(
                            params.staffGenderOrId == "M" ? app.localization.spaBooking.serviceSelection.notAvailableGenderMale :
                                params.staffGenderOrId == "F" ? app.localization.spaBooking.serviceSelection.notAvailableGenderFemale :
                                    !!params.staffGenderOrId ? app.localization.spaBooking.serviceSelection.notAvailableStaff : ""
                        )
                        spaItemElement.find('.alert.notAvailable a.btn').on('click', function (obj) {
                            obj.preventDefault()
                            spaItemElement.find('.spaServiceDate').val(Date.parseExact(startDate, "yyyy-MM-dd").add(1).day().toString('yyyy-MM-dd')).change()
                            setTimeout(function () { spaItemElement.find('.spaServiceButton').trigger('click') }, 200)
                        })
                        if (!!params.staffGenderOrId && params.staffGenderOrId != "M" && params.staffGenderOrId != "F") {
                            var staffName = _.find(spaItemElement.find('.spaServiceStaff option'), function (x) { return x.value == params.staffGenderOrId })
                            staffName && spaItemElement.find('.alert.notAvailable .staffName').text(staffName.text)
                        }
                        app.customization.spaBooking.availabilityQueryLookaheadDays || setTimeout(function () {
                            spaItemElement.find('.alert.notAvailable').alert('close')
                        }, 4500)
                    }

                }
                function getMaxTime() {
                    var maxTime = ''
                    spaItemElement.find('.spaAvailability').each(function (i, item) {
                        var time = $(item).data('time')
                        maxTime = maxTime < time ? time : maxTime
                    })
                    return maxTime.substr(10, 4)
                }
                function getMinReqTime() {
                    var minTime = params.time
                    spaItemElement.find('.spaAvailability').each(function (i, item) {
                        var time = $(item).data('reqtime')
                        minTime = minTime > time ? time : minTime
                    })
                    return minTime
                }
                spaItemElement.find('.spaServiceButton').after(
                    _.sortBy(spaItemElement.find('.spaAvailability'), function (item) {
                        var time = $(item).data('time')
                        return time
                    })
                )
                if (true || !!availabilityMaxTime) {
                    if (!!buttonElement.data('startDate') && params.date != buttonElement.data('startDate')) {
                        $('.spaServiceDate').val(params.date).change()
                        spaItemElement.find('.spaServiceButton').after(
                            '<div class="alert fade in alert-info notAvailable"><a class="close" data-dismiss="alert" href="#">×</a><p>'
                            + (app.localization.spaBooking.serviceSelection.foundOnDate)
                            + '</p></div>'
                        )
                        spaItemElement.find('.alert.notAvailable .date').text(Date.parseExact(params.date, "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .fromdate').text(Date.parseExact(buttonElement.data('startDate'), "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .time').text(Date.parseExact(addOneMinute(params.time), "HHmm").toString(app.localization.CultureInfo.formatPatterns.shortTime))
                        spaItemElement.find('.alert.notAvailable .staffOrGender').html(
                            params.staffGenderOrId == "M" ? app.localization.spaBooking.serviceSelection.notAvailableGenderMale :
                                params.staffGenderOrId == "F" ? app.localization.spaBooking.serviceSelection.notAvailableGenderFemale :
                                    !!params.staffGenderOrId ? app.localization.spaBooking.serviceSelection.notAvailableStaff : ""
                        )
                        if (!!params.staffGenderOrId && params.staffGenderOrId != "M" && params.staffGenderOrId != "F") {
                            var staffName = _.find(spaItemElement.find('.spaServiceStaff option'), function (x) { return x.value == params.staffGenderOrId })
                            staffName && spaItemElement.find('.alert.notAvailable .staffName').text(staffName.text)
                        }
                    } else {
                        buttonElement.text(Localization.spaBooking.serviceSelection.showMoreTimes)
                    }
                    var nextTimeOption = _.find(spaItemElement.find('.spaServiceTime option'), function (x) {
                        return x.value > maxTime
                    })
                    if (nextTimeOption) {
                        setTimeout(function () { spaItemElement.find('.spaServiceTime').val(nextTimeOption.value).change() }, 200)
                    } else {
                        spaItemElement.find('.spaServiceButton')
                            .after(
                                '<div class="alert fade in alert-info notAvailable noFurther"><a class="close" data-dismiss="alert" href="#">×</a><p>'
                                + (app.localization.spaBooking.serviceSelection.noFurtherAvailabilities)
                                + '</p><a class="btn" href="#">' + app.localization.spaBooking.serviceSelection.checkNextDay + '</a></div>'
                            )
                        app.customization.spaBooking.availabilityQueryLookaheadDays && spaItemElement.find('.spaServiceButton').css('display', 'none')
                        spaItemElement.find('.alert.notAvailable .date').text(Date.parseExact(params.date, "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .fromdate').text(Date.parseExact(buttonElement.data('startDate'), "yyyy-MM-dd").toString(app.localization.CultureInfo.formatPatterns.mediumDate))
                        spaItemElement.find('.alert.notAvailable .time').text(Date.parseExact(addOneMinute(params.time), "HHmm").toString(app.localization.CultureInfo.formatPatterns.shortTime))
                        spaItemElement.find('.alert.notAvailable .staffOrGender').html(
                            params.staffGenderOrId == "M" ? app.localization.spaBooking.serviceSelection.notAvailableGenderMale :
                                params.staffGenderOrId == "F" ? app.localization.spaBooking.serviceSelection.notAvailableGenderFemale :
                                    !!params.staffGenderOrId ? app.localization.spaBooking.serviceSelection.notAvailableStaff : ""
                        )
                        spaItemElement.find('.alert.notAvailable a.btn').on('click', function (obj) {
                            obj.preventDefault()
                            spaItemElement.find('.spaServiceDate').val(Date.parseExact(startDate, "yyyy-MM-dd").add(1).day().toString('yyyy-MM-dd')).change()
                            setTimeout(function () { spaItemElement.find('.spaServiceButton').trigger('click') }, 200)
                        })

                        if (!!params.staffGenderOrId && params.staffGenderOrId != "M" && params.staffGenderOrId != "F") {
                            var staffName = _.find(spaItemElement.find('.spaServiceStaff option'), function (x) { return x.value == params.staffGenderOrId })
                            staffName && spaItemElement.find('.alert.notAvailable .staffName').text(staffName.text)
                        }
                        // setTimeout(function(){
                        //     spaItemElement.find('.alert.noFurther').alert('close')
                        // },4500)
                    }
                }
                availabilityElement.remove()
        
            },
            handleSkiLoopPerUserProfile: function (lastUpdatedCustomerId, redirectToSummary, missingAuthFields) {
                var userFound = _.find(app.data.GuestsWithSkiInCart, function (guestDetails) {
                    //clear the missing fields for the user we just updated profile. It is guaranteed that all the required ski fields were updated
                   if( lastUpdatedCustomerId && guestDetails.CustomerId == lastUpdatedCustomerId){
                        guestDetails.missingSkiFields = []
                    }
                    return guestDetails.missingSkiFields && !_.isEmpty(guestDetails.missingSkiFields)
                })
                //This time we need a user that has all the fields filled in --start
                var userRequiredToPreview = _.find(app.data.GuestsWithSkiInCart, function (guestDetails) {
                    var visitedRentalProfile = JSON.parse(window.localStorage.getItem('visitedRentalProfile')) || {};
                    var userLastUpdatedDate = visitedRentalProfile && visitedRentalProfile[guestDetails.CustomerId],
                        yourDate = userLastUpdatedDate ? moment(userLastUpdatedDate).valueOf() : '',
                        daysDifference = moment().diff(moment(yourDate), 'days',true);
                        forceProfileReviewConfig = app.customization.skiBooking.forceCompletedGuestProfileReview
                    if (forceProfileReviewConfig && ((!userLastUpdatedDate && guestDetails.CustomerId)|| (daysDifference && daysDifference >=1))) {
                        visitedRentalProfile[guestDetails.CustomerId|| app.data.CustomerId] = Date.now()
                        visitedRentalProfile = JSON.stringify(visitedRentalProfile);
                        window.localStorage.setItem("visitedRentalProfile",visitedRentalProfile);
                        return true
                    }
                    return false
                }),
                mustReviewProfile = false
                //This time we need a user that has all the fields filled in - end

                if (userFound) { //means found a user with ski fields missing
                    var guestName = getGuestName(userFound)
                    var errorMessage = getErrorMessage(userFound,guestName,true)
                    setErrorMessage(errorMessage)
                    redirectToRentalProfile(userFound)

                } else if (!!userRequiredToPreview) { //depending on the config, If a user has all the required fields, user will always be directed to confirm ski details once per day
                    //The yourDate time is less than 1 days from now
                    var guestName = getGuestName(userRequiredToPreview),
                        errorMessage = getErrorMessage('', guestName, false)
                    setErrorMessage(errorMessage)
                    redirectToRentalProfile(userRequiredToPreview)
                    mustReviewProfile = true
                } else if (redirectToSummary) app.dispatcher.redirect('summary', [])
                
                function getGuestName(profile){
                    return profile.Name.FirstName + ' ' + profile.Name.LastName
                }
                function redirectToRentalProfile(profile){
                    app.dispatcher.redirect('profile', 'detailsredirectfromsummary', [profile.CustomerId == app.data.CustomerId ? '' : profile.CustomerId]);
                }
                function setErrorMessage(errorMessage){
                    app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-error',
                        actions: [],
                        title: errorMessage,
                        message: ''
                    }); 
                }
                
                function getErrorMessage(profile, guestName, isMissingMandatorySkiField) {
                    var errorMessage = ''
                    if (isMissingMandatorySkiField) {
                        errorMessage = app.localization.general.err.missingSkiFieldsPre + '<strong> ' + guestName + '</strong> ' + app.localization.general.err.missingSkiFieldsPost + ' '
                        // this comes from app.customization.auth.requiredFieldsBeforeCheckout
                        _.each(missingAuthFields, function (field, index) {
                            errorMessage = errorMessage + (index > 0 ? ', ' : ' ') + '<strong>' + field.name + '</strong>'
                        })
                        _.each(profile.missingSkiFields, function (x, i) {
                            errorMessage = errorMessage + (i > 0 ? ', ' : ' ') + '<strong>' + x.name + '</strong>'
                        })
                    } else {
                        errorMessage = 'Please review the following information for the  ' + '<strong> ' + guestName + '</strong> ' + ''
                    }
                    return errorMessage
                }
                return userFound || mustReviewProfile
            },
            prepSkiForm: function (location, itemId, date, templateData,group) {
         
                var skiDateChange = _.debounce(function () {
                    app.data.stopReset = true;
                    $('#skiServiceDate').val(this.value);
                    app.customization.skiBooking.queryAdvanceDays || $('#progressIndicator').modal('show');
                    app.dispatcher[app.customization.skiBooking.queryAdvanceDays ? 'updateURL' : 'redirect']('ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent(this.value), encodeURIComponent($('#skiRecipients').val()) || ''], !!app.customization.skiBooking.queryAdvanceDays);
                }, 150);
                var skiRecipientsChange = _.debounce(function (obj) {
                    if (isNaN($(this).val())) {
                        $(this).parents('.control-group').find('.newMember').removeClass('hide')
                        if (app.customization.skiBooking.useFullPageAddGroupMember) {
                            app.data.loginNextURL = ['ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent($('#skiServiceDate').val()), encodeURIComponent($('#skiRecipients').val()) || '']];
                            app.dispatcher.redirect('profile', 'addmember', []);
                        }
                    } else {
                        $(this).parents('.control-group').find('.newMember').addClass('hide')
                        $(this).parents('.packageItems').find('.newMember').addClass('hide')
                        var thisValue = $(this).val();

                       
                        if (!$(this).hasClass('skiPkgRecipients')) {
                            $('.skiRecipients').val(thisValue);
                        }
                        if (!app.customization.skiBooking.queryAdvanceDays && !$(this).hasClass('skiPkgRecipients')) {
                            app.dispatcher.redirect('ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent($('#skiServiceDate').val()), encodeURIComponent(this.value) || ''], true);
                        }
                    }
                }, 150);

                var newMemberAddHandler = function newMemberAddHandler(obj) {
                    obj.preventDefault();
                    var skiItem = $(obj.target).parents('.skiItem')
                    var skiUniqueId = ($(obj.target).attr('id')).split('newMemberAdd')[1]
                    var newMemberForm = skiItem.find('#newMember'+skiUniqueId)
                  
                    var firstname = newMemberForm.find('.newMemberFirstName').val()
                    var lastname = newMemberForm.find('.newMemberLastName').val()
                    if(firstname.length<=0 || lastname.length <=0){
                       $(newMemberForm).find('.error').remove()
                        var error = "<p class='error'>"+app.localization.ski.err.requiredField+"</p>"
                        $(error).insertAfter($(newMemberForm).find('h4'))
                        return
                    }
                    app.data.WTPNumber = [];
                    skiItem.find('.wptNumber input').each(function () {
                        app.data.WTPNumber.push($(this).val());

                    })
                    app.data.skiTicketCustId = [];
                    skiItem.find('select.skiPkgRecipients').each(function () {
                        app.data.skiTicketCustId.push($(this).val());
                    })
                    $('#progressIndicator').modal('show');
                    app.data.loginNextURL = ['ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent($('#skiServiceDate').val()), '']]
                    app.dispatcher.dispatch('profile', 'quickmembercreatesubmit', [
                        "", // encodeURIComponent($('#userEmail1').val()),
                        "", // encodeURIComponent($('#userPassword1').val()),
                        "", // encodeURIComponent($('#userGender').val()),
                        "", // encodeURIComponent($('#userSalutation').val()),
                        encodeURIComponent($(this).parents('.newMember').find('.newMemberFirstName').val()),
                        encodeURIComponent($(this).parents('.newMember').find('.newMemberLastName').val()),
                        // $('#userMainPhoneH').hasClass('active') ? "H" :
                        //     $('#userMainPhoneW').hasClass('active') ? "W" :
                        //         $('#userMainPhoneO').hasClass('active') ? "O" : "",
                        "",
                        "", // encodeURIComponent($('#userHomePhone').val()),
                        "", // encodeURIComponent($('#userWorkPhone').val()),
                        "", // encodeURIComponent($('#userWorkExt').val()),
                        "", // encodeURIComponent($('#userOtherPhone').val()),
                        "", // encodeURIComponent($('#userMobilePhone').val()),
                        templateData.user.Address[0].Address1 || "", // encodeURIComponent($('#userHomeAddress1').val()),
                        templateData.user.Address[0].Address2 || "", // encodeURIComponent($('#userHomeAddress2').val()),
                        templateData.user.Address[0].City || "", // encodeURIComponent($('#userHomeCity').val()),
                        templateData.user.Address[0].StateProv || "", // encodeURIComponent($('#userHomeProvince').val()),
                        templateData.user.Address[0].Country || "", // encodeURIComponent($('#userHomeCountry').val()),
                        templateData.user.Address[0].PostCode || "", // encodeURIComponent($('#userHomePostalCode').val()),
                        "", // encodeURIComponent($('#userOtherAddress1').val()),
                        "", // encodeURIComponent($('#userOtherAddress2').val()),
                        "", // encodeURIComponent($('#userOtherCity').val()),
                        "", // encodeURIComponent($('#userOtherProvince').val()),
                        "", // encodeURIComponent($('#userOtherCountry').val()),
                        "", // encodeURIComponent($('#userOtherPostalCode').val()),
                        "1", // $('#newsletter').prop('checked') ? "1" : "0",
                        "1", // $('#mailmarketing').prop('checked') ? "1" : "0",
                        "1", // $('#phonemarketing').prop('checked') ? "1" : "0",
                        "1", // $('#smsmarketing').prop('checked') ? "1" : "0",
                        { "English": "en-us", "French": "fr-ca", "Spanish": "es-sp", "Chinese": "zh-cn", "": "en-us" }[templateData.user.Language],
                        // $('#userLanguageen-us').hasClass('active') ? "en-us" :
                        //     $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                        //         $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                        //             $('#userLanguagees-sp').hasClass('active') ? "es-sp" : ""
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);
                }
                $('.newMemberAdd').on('click', newMemberAddHandler);

                templateData.showDateList = false;
                if (!app.data.overridePMSRestriction && templateData.dateList && templateData.dateList.length > 0) {
                    templateData.showDateList = true;
                    if (!_.any(templateData.dateList, function (x) { return x.machine == date })) {
                        date = templateData.dateList[0].machine;
                    }
                }

                var bookingWindow = getBookingWindow('Ski', _.extend({ Location: location.LocationId }, location))
                var now = moment.tz(bookingWindow.timeZone);
                var endMinTime = now.clone();
                var startDateToUse;
                var endDateToUse;

                if (!_.isEmpty(bookingWindow.endOffset)) {
                    endMinTime.subtract(bookingWindow.endOffset)
                }
                if (!_.isEmpty(bookingWindow.endSet)) {
                    _.each(bookingWindow.endSet, function (num, unit) {
                        endMinTime[unit](num)
                    })
                }
                var startMaxTime = now.clone().add(2, 'years')
                if (!_.isEmpty(bookingWindow.startOffset)) {
                    startMaxTime = now.clone()
                    startMaxTime.subtract(bookingWindow.startOffset)
                }
                if (!_.isEmpty(bookingWindow.startSet)) {
                    _.each(bookingWindow.startSet, function (num, unit) {
                        startMaxTime[unit](num)
                    })
                }
                startDateToUse=endMinTime
                endDateToUse=startMaxTime
                if(app.data.RestrictedFolio){
                    if(app.data.datesForRestrictedFolio) {
                        var restrictedDates = app.data.datesForRestrictedFolio;
                        var calendarEndTime = moment(startMaxTime)
                        var calenderStartTime = moment(endMinTime)
                        var folioStartDate = moment(restrictedDates[0].machine,'YYYY-MM-DD');
                        var folioEndDate = moment(restrictedDates[restrictedDates.length-1].machine,'YYYY-MM-DD');
                         startDateToUse =  folioStartDate.isSameOrAfter(calenderStartTime) ? folioStartDate : calenderStartTime;
                         endDateToUse = folioEndDate.isSameOrBefore(calendarEndTime) ? folioEndDate : calendarEndTime;
                      
                    }
                  }
                  var dateList = (location.PMSRoomMandatory == "Y" ? (!!app.data.pmsDateList ? (app.data.pmsDateList[location.PropertyId] || []) : []) : []);
                  if(dateList.length > 0){
                  
                    startDateToUse= moment(dateList[0].machine, 'YYYY-MM-DD')
                    endDateToUse=  moment(dateList[dateList.length-1].machine, 'YYYY-MM-DD')
                  }
                $('.skiDate, #alt-skiDate')
                    .val(
                        app.customization.skiBooking.forceSkiDate && app.customization.skiBooking.forceSkiDate.substr(0, 10)
                        || date
                        || endMinTime.format('YYYY-MM-DD')
                        // Date.today().add(  app.customization.skiBooking.allowBookingToday ? 0 : 1  ).days().toString('yyyy-MM-dd')
                    );
                $('#alt-skiDate')
                    .datepicker({
                        minDate: startDateToUse.toDate(),
                        maxDate: endDateToUse.toDate(),
                        numberOfMonths: 2,
                        dateFormat: app.localization.ski.dateFormat[0],
                        defaultDate: Date.parse($('#alt-skiDate').val(),'yyyy-MM-dd'),
                        altField: "#skiDate",
                        altFormat: "yy-mm-dd",
                        onSelect: function(){ $('#skiDate').trigger('change') }
                    })
                    .datepicker('setDate', Date.parse($('#alt-skiDate').val(),'yyyy-MM-dd'))
                    
                $('#skiDate')
                    .change(skiDateChange);
                $('select.skiRecipients').change(skiRecipientsChange);
                $('select.skiPkgRecipients').change(skiRecipientsChange);

                //Ski placeholder date
                //stopReset there to address issue with date reverting on selection of ski date
                function setSkiPhd() {
                    if(sessionStorage.getItem('phWid-' + app.data.WebFolioId) && (!app.data.stopReset || Customization.skiBooking.queryAdvanceDays)){
                        var phDate = JSON.parse(sessionStorage.getItem('phWid-' + app.data.WebFolioId));
                        if($($('.hasDatepicker')[0]).datepicker('option', 'dateFormat').toLocaleLowerCase()[0] == 'd'){
                            $('.hasDatepicker').datepicker("setDate", new Date(phDate.year + ',' + phDate.month + "," + phDate.day))
                        }else{
                            $('.hasDatepicker').datepicker("setDate", new Date(phDate.year,phDate.altMonth,phDate.day));
                        }
                        app.data.stopReset = false;
                    }
                }

                if(!Customization.skiBooking.queryAdvanceDays){
                    setSkiPhd();
                }

                var attachSkiEventHandlers = function attachSkiEventHandlers(skiItemElement, itemData) {
                   
                    var selectedDate = moment($('#skiServiceDate').val());
                    var bookingWindow = getBookingWindow('Ski', _.extend({ Location: location.LocationId }, location, itemData))
                    var now = moment.tz(bookingWindow.timeZone);
                    var endMinTime = selectedDate.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endMinTime.add(bookingWindow.endOffset)
                    }
                
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endMinTime[unit](num)
                        })
                    }
                    var startMaxTime = moment('2000-01-01')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startMaxTime = selectedDate.clone()
                        startMaxTime.add(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startMaxTime[unit](num)
                        })
                    }
                    if (moment(now).isBetween(moment(startMaxTime), moment(endMinTime))) {
                        skiItemElement.find('.mustPickDifferentDay').remove();
                    } else {
                        skiItemElement.find('.skiServiceButton').remove();
                    }

                    var startMaxTime = now.clone().add(2, 'years')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startMaxTime = now.clone()
                        startMaxTime.subtract(bookingWindow.startOffset)
                    }
        
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startMaxTime[unit](num)
                        })
                    }
                    if(itemData.AbsoluteTicketEndDate &&itemData.EndDate){
                        var absoluteDate = moment(itemData.AbsoluteTicketEndDate,'YYYY-MM-DDHHmmss')
                        var endDate  = moment(itemData.EndDate, 'YYYY-MM-DDHHmmss')
                        if(absoluteDate.isBefore(endDate)){
                            startMaxTime = absoluteDate
                        } else  startMaxTime = endDate   
                    }
                    else{
                        startMaxTime = (itemData.AbsoluteTicketEndDate &&  moment(itemData.AbsoluteTicketEndDate,'YYYY-MM-DDHHmmss'))|| (itemData.EndDate && moment(itemData.EndDate, 'YYYY-MM-DDHHmmss')) || startMaxTime
                    }
                    
                    var dpOpts = {
                        minDate: startDateToUse.toDate(),
                        maxDate: startMaxTime.toDate(),
                        numberOfMonths: 2,
                        // dateFormat: "yy-mm-dd",
                        dateFormat: app.localization.ski.dateFormat[0],
                        // defaultDate: $('#skiServiceDate').val()
                        defaultDate: Date.parse($('#alt-skiDate' + itemData.SkiItemId).val(),'yyyy-MM-dd'),
                        altField: "#skiDate" + itemData.SkiItemId,
                        altFormat: "yy-mm-dd",
                        onSelect: function(){ $('#skiDate' + itemData.SkiItemId).trigger('change') }
                    }
                    if (app.customization.skiBooking.queryAdvanceDays) {
                        if(itemData.StartDate){
                            var skiStartDate = moment(itemData.StartDate,'YYYY-MM-DDHHmmss')
                            dpOpts.defaultDate = skiStartDate.toDate()
                            if(skiStartDate.isAfter(startDateToUse)){
                                dpOpts.minDate = skiStartDate.toDate()
                            }
                        }
                        dpOpts.beforeShowDay = function (theDate) {
                            return [
                                itemData['Avail' + ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][theDate.getDay()]] == 'Y',
                                '',
                                ''
                            ]
                        }
                        while (itemData['Avail' + ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dpOpts.minDate.getDay()]] != 'Y') {
                            dpOpts.minDate.add(1).days();
                            if (dpOpts.minDate.valueOf() > dpOpts.maxDate.valueOf()) {
                                skiItemElement.find('.datepicker').replaceWith($('<p class="noDates">').text(app.localization.ski.err.noDates));
                                skiItemElement.find('.skiServiceButton').remove();
                                break;
                            }
                        }
                    }
                    skiItemElement.find('#alt-skiDate' + itemData.SkiItemId)
                    .datepicker(dpOpts).datepicker('setDate',dpOpts.defaultDate)
                    $('#skiDate' + itemData.SkiItemId).change(skiDateChange);
                    var activeDate = Date.parse($('#skiServiceDate').val());
                    if (activeDate.valueOf() > dpOpts.maxDate.valueOf()) {
                        $('.skiDate').val(dpOpts.maxDate.toString('yyyy-MM-dd'))
                    }
                    if (activeDate.valueOf() < dpOpts.minDate.valueOf()) {
                        $('.skiDate').val(dpOpts.minDate.toString('yyyy-MM-dd'))
                    }
                    $('#skiServiceDate').change();

                    skiItemElement.find('.skiServiceButton').on('click', function (obj) {
                        var clickedBtn = $(obj.target);
                        $(obj.target).button('loading');
                        $('#progressIndicator').modal('show');
                        var itemId = $(obj.target).attr('data-ski-item-id');
                        obj.target.orighref = obj.target.orighref || obj.target.href
                        obj.target.hash = "#/ski/purchase/" + $(obj.target).attr('data-ski-item-id') + "/" + moment($('#alt-skiDate'+itemId+'.hasDatepicker').datepicker("getDate")).format("YYYY-MM-DD") + "/" + $('.skiRecipients').val();
                        obj.target.hash += '/';
                        if ($('#wptNumber' + $(obj.target).attr('data-ski-item-id')).val()) {
                            obj.target.hash += encodeURIComponent($('#wptNumber' + $(obj.target).attr('data-ski-item-id')).val())
                        }
                        obj.target.hash += '/';
                        var guestNote = skiItemElement.find('#skiGustNote').val()
                        if(!!guestNote){
                            obj.target.hash +=  encodeURIComponent(guestNote)
                           
                        }
                        obj.target.hash += '/';
                        if (itemData.PackageItems) {
                            var customerIdArray = []
                            var WTPNoArray = []
                            var pkgItemIdArray = []
                            var pkgItemGuestNotesArray = []

                            $(itemData.PackageItems.PackageItem).each(function () {
                                customerIdArray.push(clickedBtn.parents('.skiItem').find('#skiPkgRecipients' + this.SkiItemId + '-' + this.SkiPackageItemId).val()) //Select guest that has been selected
                                WTPNoArray.push(clickedBtn.parents('.skiItem').find('#wptNumber' + this.SkiItemId + '-' + this.SkiPackageItemId).val())//Select guest that has been selected
                                pkgItemIdArray.push(this.SkiPackageItemId);

                                //Adding guest notes for the individual ski item
                                pkgItemGuestNotesArray.push(clickedBtn.parents('.skiItem').find('#skiGustNote' + this.SkiItemId + '-' + this.SkiPackageItemId).val()) 
                            })
                            obj.target.hash += WTPNoArray.join('|') + "/" + customerIdArray.join('|') + "/" + pkgItemIdArray.join('|')+ "/" + pkgItemGuestNotesArray.join('|')
                        }
                        
                    });
                    skiItemElement.find('.skiRecipients').val($('#skiRecipients').val()).change(skiRecipientsChange).change();
                    skiItemElement.find('.skiPkgRecipients').val($('#skiPkgRecipients').val()).change(skiRecipientsChange);
                    skiItemElement.find('.newMemberAdd').on('click', newMemberAddHandler);
                    var bookingWindow = getBookingWindow('Ski', _.extend({ Location: location.LocationId }, location))
                    var now = moment.tz(bookingWindow.timeZone);
                    var endMinTime = now.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endMinTime.subtract(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endMinTime[unit](num)
                        })
                    }
                    var startMaxTime = now.clone().add(2, 'years')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startMaxTime = now.clone()
                        startMaxTime.subtract(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startMaxTime[unit](num)
                        })
                    }
                    if (app.data.WTPNumber) {
                        skiItemElement.find(".wptNumber input").each(function (i) {
                            $(this).val(app.data.WTPNumber[i]);
                        });
                        delete app.data.WTPNumber;
                    }
                    if (app.data.skiTicketCustId) {
                        skiItemElement.find("select.skiPkgRecipients").each(function (i) {
                            if (app.data.skiTicketCustId[i] == app.localization.general.login.addGroupMember) {
                                $(this).val($('#skiRecipient').val());
                            } else {
                                $(this).val(app.data.skiTicketCustId[i]);
                            }

                        });
                        delete app.data.skiTicketCustId;
                    }
                };
                $('.skiItem').on('shown', function (obj) {
                    var itemId = $(this).attr('id').substr(7),
                        skiItemCollapse = $("#skiItem" + itemId),
                        url = '#/ski/liftTickets/Location' + location.LocationId + '|' + itemId;
                    skiItemCollapse.data('collapse') && skiItemCollapse.collapse('reset');
                    app.customization.googleAnalytics && _gaq.push(['_trackPageview', url]);

                });
                $('.skiItemToggle').on('click', function (obj) {
                    var itemId = $(this).attr('id').substr(13),
                        skiItemCollapse = $("#skiItem" + itemId),
                        itemData = false;
                    _.each(templateData.categories, function (category) {
                        _.each(category.items, function (v, k, l) {
                            itemData = itemData || _.find(v.tickets, function (x) {
                                if (x.SkiItemId == itemId) {
                                    x._itemType = category.category
                                    return true;
                                } else return false;
                            })
                        })
                    });
                    
                    
                    // if (skiItemCollapse.attr('style') && skiItemCollapse.attr('style').indexOf('height: 0px')>=0) {
                    //     skiItemCollapse.attr('style', skiItemCollapse.attr('style').replace(/height: 0px/,'') ).addClass('in');
                    // }
                    $('#skiItemSelected').val(itemId);
                    app.dispatcher.updateURL('ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent($('#skiServiceDate').val()), encodeURIComponent($('#skiRecipients').val()) || ''], true);
                    if (skiItemCollapse.hasClass('empty')) {
                        skiItemCollapse.html(skiLiftTicketPartialSkiItemTpl($.extend({}, itemData, templateData)));
                        skiItemCollapse.data('collapse') && skiItemCollapse.collapse('reset');
                        skiItemCollapse.removeClass('empty');
                        attachSkiEventHandlers(skiItemCollapse, itemData);

                        if(Customization.skiBooking.queryAdvanceDays){
                            setSkiPhd();
                            app.dispatcher.updateURL('ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent(moment($('.hasDatepicker').datepicker("getDate")).format("YYYY-MM-DD")), encodeURIComponent($('#skiRecipients').val()) || ''], true);
                        }
                    }
                    //make calendar icon clickable
                    $('.add-on').on('click',function(){
                            $('#alt-skiDate'+itemId).trigger('focus')
                    })
                    app.commonViewHelper.analyticsInit('requestSkiLiftTicketSelectionItemClick', [templateData.categories, itemId]);
                });
                $('#categoryTabs a').click(function (obj) {
                    obj.preventDefault();
                    $(this).tab('show');
                    var categoryElem = $(this.hash + ' div.accordion-group div.accordion-body.in');
                    if (categoryElem.length == 0) {
                        categoryElem = $(this.hash + ' div.accordion-group:first-child div.accordion-body');
                    }
                    if (categoryElem.length > 0) {
                        var itemId = categoryElem.attr('id').substr(7);
                        $('#skiItemSelected').val(itemId);
                        app.dispatcher.updateURL('ski', 'liftTickets', ['Location' + location.LocationId + '|' + encodeURIComponent($('#skiItemSelected').val()), encodeURIComponent($('#skiServiceDate').val()), encodeURIComponent($('#skiRecipients').val()) || ''], true);
                        if (categoryElem.length == 1 && !categoryElem.hasClass('in') && app.customization.skiBooking.autoExpandFirstItem) {
                           $('#skiItemToggle' + itemId).click();
                        }
                    //view item list
                    var catName = $(this).attr('data-cat')
                    app.commonViewHelper.analyticsInit('requestSkiLiftTicketSelectionCatClick', [templateData.categories, catName]);
                    }
                    //$(this.hash).has('div.accordion-group div.accordion-body.in').length || $(this.hash).find('div.accordion-group:first-child div.accordion-body').addClass('in');

                    var accordionBodyId = $(this).attr('href');
                    $(accordionBodyId+' a').first().focus();
                  
                })
                !!itemId && _.debounce(function () {
                    $('#skiItemToggle' + itemId).addClass('dont-hide-alerts').click();
                }, 200)()

            },

            prepPMSInputForm: function (venue, arrivalDate, departureDate, dayGuest) {
                var validateOnChange = function () {
                    $('#pmsDatesForm').validate({
                        errorPlacement: function (error, element) {
                            element.parent().append(error)
                        }
                    });


                    if ($('#pmsDatesForm').valid()) {
                        $('#pmsFormSubmit').addClass('btn-primary').removeClass('disabled');
                    } else {
                        $('#pmsFormSubmit').addClass('btn-primary').addClass('disabled');
                    }
                }
                var bookDateOffset = app.customization.roomsBooking.allowBookingToday ? 0 : 1;

                $('#pmsDatesForm .required').change(validateOnChange);
                $('#alt-pmsArrivalDate').val(arrivalDate ? arrivalDate.toString(Localization.roomReservation.dateFormat2[1]) : Date.today().add(bookDateOffset).days().toString(Localization.roomReservation.dateFormat2[1]));
                $('#pmsArrivalDate').val(arrivalDate ? arrivalDate.toString('yyyy-MM-dd') : Date.today().add(bookDateOffset).days().toString('yyyy-MM-dd'));
                if (!!dayGuest) {
                    $('#alt-pmsArrivalDate').addClass('datepicker').datepicker({
                        minDate: bookDateOffset,
                        maxDate: "+2Y",
                        numberOfMonths: 2,
                        dateFormat: Localization.roomReservation.dateFormat2[0],
                        defaultDate: $('alt-#pmsArrivalDate').val(),
                        altField: '#pmsArrivalDate',
                        altFormat: "yy-mm-dd",
                    });
                    $('label[for=pmsArrivalDate].add-on').html('<i class="icon-calendar"></i>');
                } else {
                    $('#pmsDepartureDate, #alt-pmsDepartureDate').val(departureDate ? departureDate.toString('yyyy-MM-dd') : (arrivalDate ? arrivalDate.toString('yyyy-MM-dd') : Date.today().add(bookDateOffset).days().toString('yyyy-MM-dd'))).datepicker('option', { 'defaultDate': "+" + (bookDateOffset + 1) + "d", "minDate": "+" + (bookDateOffset + 1) + "d" });
                    var datecontrols = ["#pmsDepartureDate", "#pmsArrivalDate"];
                    var depth = { count: 0 };
                    //console.log('docwidth at load',$(document).width());
                    $('#pmsDatesCalendar').data('venue', venue);
                    if (!jQuery.datepicker.__adjustDate) {
                        jQuery.datepicker.__adjustDate = jQuery.datepicker._adjustDate;
                    }
                    // Debounce added for preventing duplicate calls when user multi-clicks on the datepicker next button
                    // Since changing whole logic is cumbursome at this point, this is the best solution
                    jQuery.datepicker._adjustDate = _.debounce(function (a, b, c) {
                        jQuery.datepicker.__adjustDate(a, b, c);
                        if ($("#pmsDatesCalendar").length) {
                            app.commonViewHelper.updateRateCalendarData(venue);
                        }
                    }, 1000);
                    if (!jQuery.datepicker.__updateDatepicker) {
                        jQuery.datepicker.__updateDatepicker = jQuery.datepicker._updateDatepicker;
                    }
                    jQuery.datepicker._updateDatepicker = function (a) {
                        jQuery.datepicker.__updateDatepicker.call(this, a);
                        if ($("#pmsDatesCalendar").length) {
                            if (depth.count++ < 5) {
                                app.commonViewHelper.updateRateCalendar(false, venue);
                            }
                            depth.count--;
                        }

                    }

                    function setupCalendar() {
                        var pmsDateCalendar = $("#pmsDatesCalendar")
                        pmsDateCalendar.html('').removeClass('hasDatepicker').data('datepicker', null).datepicker({
                            defaultDate: (arrivalDate || Date.today().add(bookDateOffset).days()).toString('yyyy-MM-dd'), //"+" + bookDateOffset + "d",
                            changeMonth: false,
                            numberOfMonths: window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 1 : 2,
                            dateFormat: "yy-mm-dd",
                            minDate: "+" + bookDateOffset + "d",
                            maxDate: "+2Y",
                            altField: "#pmsArrivalDate",
                            dayNames: app.localization.CultureInfo.dayNames,
                            dayNamesMin: app.localization.CultureInfo.shortestDayNames,
                            dayNamesShort: app.localization.CultureInfo.abbreviatedDayNames,
                            monthNamesShort: app.localization.CultureInfo.abbreviatedMonthNames,
                            monthNames: app.localization.CultureInfo.monthNames,
                            customOnSelect: true,
                            onSelect: function (selectedDate) {
                                if (!!$("#pmsArrivalDate").val()) {
                                    $('#alt-pmsArrivalDate').val(moment($('#pmsArrivalDate').val()).format(app.localization.roomReservation.dateFormat));
                                }
                                if (!!$("#pmsDepartureDate").val()) {
                                    $('#alt-pmsDepartureDate').val(moment($('#pmsDepartureDate').val()).format(app.localization.roomReservation.dateFormat));
                                }
                                console.log('onselect', selectedDate)
                                var altField = _.first(_.without(datecontrols, jQuery.datepicker._optionDatepicker(this, 'altField')));
                                $(datecontrols).each(function (x) {
                                    if (this == altField) {
                                        $("label[for=" + this.substr(1) + "].add-on").removeClass('hidden')
                                    } else {
                                        $("label[for=" + this.substr(1) + "].add-on").addClass('hidden')
                                    }
                                });
                                var inst = jQuery.datepicker._getInst(this);
                                inst.settings.altField = altField;
                                if (altField == "#pmsArrivalDate") {
                                    var dateDiff = Date.parse($("#pmsDepartureDate").val()).compareTo(Date.parse($("#pmsArrivalDate").val()));
                                    if (dateDiff < 0) {
                                        var a = $("#pmsDepartureDate").val(),
                                            b = $("#pmsArrivalDate").val();
                                        inst.input.val(b);
                                        $("#pmsDepartureDate").val(b);
                                        $("#pmsArrivalDate").val(a);//.focus();
                                        $("#alt-pmsArrivalDate").val(moment(a).format(app.localization.roomReservation.dateFormat));
                                        $("#alt-pmsDepartureDate").val(moment(b).format(app.localization.roomReservation.dateFormat));
                                    } else if (dateDiff == 0) {
                                        //                                     var a = Date.parse($("#pmsDepartureDate").val()).add(1).day().toString('yyyy-MM-dd');
                                        //                                     $("#pmsDepartureDate").val(a);
                                        //                                     inst.input.val(a);
                                        //$("#pmsArrivalDate").focus();
                                    } else {
                                        //$("#pmsArrivalDate").focus();
                                    }
                                    $('#pmsDatesCalendar').data('popOverTouchButtonText', app.localization.roomReservation.calendar.selectArrivalDateButton);
                                    $('.datepickernextstep').text(app.localization.roomReservation.calendar.clickContinueToProceed);
                                    inst.rangeEnd = inst.input.val();
                                    inst.rangeStart = $("#pmsArrivalDate").val();
                                    /*var rangeEnd = Date.parse(inst.rangeEnd),
                                        rangeStart = Date.parse(inst.rangeStart);*/
                                    inst.currentDay = inst.selectedDay = $("#pmsArrivalDate").val().substr(8);
                                    inst.currentMonth = inst.selectedMonth = $("#pmsArrivalDate").val().substr(5, 2) - 1;
                                    inst.input.val($("#pmsArrivalDate").val());
                                } else {
                                    $("#pmsDepartureDate").val('');//.focus();
                                    $("#alt-pmsDepartureDate").val('');
                                    inst.rangeStart = inst.rangeEnd = null;
                                    $('#pmsDatesCalendar').data('popOverTouchButtonText', app.localization.roomReservation.calendar.selectDepartureDateButton);
                                    $('.datepickernextstep').text(app.localization.roomReservation.calendar.selectDepartureDateOnCalendar);
                                }
                                var datePart = selectedDate.split('-')
                                setTimeout(function () {
                                    $('#pmsDatesCalendar .ui-datepicker-calendar td[data-day=' + datePart[2] + '][data-month=' + (datePart[1] - 1) + '][data-year=' + datePart[0] + '] a').focus()
                                }, 50)
                                //console.log('selectedDate',selectedDate,this,altField,$(altField));
                                // app.commonViewHelper.updateRateCalendar(true,venue);
                                if (!!app.commonViewHelper.pmsCalendarAfterSelect && typeof app.commonViewHelper.pmsCalendarAfterSelect == 'function') {
                                    app.commonViewHelper.pmsCalendarAfterSelect(altField, inst)
                                }
                                $('div.popover').remove();
                            },
                            onChangeMonthYear: function (year, month, inst) {
                                //console.log('onChangeMonthYear', year, month, inst);
                                $("#pmsDatesCalendar td .ui-state-default").append('<span class="small">&nbsp;</span>');
                            },
                            xbeforeShowDay: function (date) {
                                //console.log('beforeShowDat', date, this);
                                //$("#pmsDatesCalendar td .ui-state-default").append('<span class="small">&nbsp;</span>');
                                var asdf = date.toString("yyyy/M/d").split('/');
                                return (
                                    app.data.pmsDatesCalendar
                                    && app.data.pmsDatesCalendar[venue]
                                    && app.data.pmsDatesCalendar[venue][asdf[1] + '/' + asdf[0]]
                                    && app.data.pmsDatesCalendar[venue][asdf[1] + '/' + asdf[0]][asdf[2]] == undefined
                                ) ? [false, '']
                                    : [true, ''];
                            }
                        })

                        function setTabIndexOfJqueryCalendar() {
                            $('#pmsDatesCalendar .ui-datepicker td:not(.ui-state-disabled) .ui-state-default').attr('tabindex',-1);
                            $('#pmsDatesCalendar .ui-datepicker td:not(.ui-state-disabled) .ui-state-default').first().attr('tabindex',0).addClass('focus-first');
                        }

                        setTabIndexOfJqueryCalendar();

                        pmsDateCalendar.on('keydown', function (event) {
                            var inst = $.datepicker._getInst(event.currentTarget);
                            var handled = true;
                            var isRTL = inst.dpDiv.is('.ui-datepicker-rtl');
                            inst._keyEvent = true;
                            var focusedCellData = $(document.activeElement).parent().data()
                            switch (event.keyCode) {
                                case 13: var sel = $('td.' + $.datepicker._dayOverClass + ':not(.' +
                                    $.datepicker._currentClass + ')', inst.dpDiv);
                                    if (sel[0]) {
                                        $.datepicker._selectDay(event.currentTarget, inst.selectedMonth, inst.selectedYear, sel[0]);
                                        event.stopPropagation();
                                    }
                                    setTabIndexOfJqueryCalendar();
                                    $('#pmsDatesCalendar .ui-datepicker td:not(.ui-state-disabled) .ui-state-default').first().focus();
                                    return false; // don't submit the form
                                    break; // select the value on enter
                                case 33: $.datepicker._adjustDate(event.currentTarget, (event.ctrlKey ?
                                    -$.datepicker._get(inst, 'stepBigMonths') :
                                    -$.datepicker._get(inst, 'stepMonths')), 'M');
                                    break; // previous month/year on page up/+ ctrl
                                case 34: $.datepicker._adjustDate(event.currentTarget, (event.ctrlKey ?
                                    +$.datepicker._get(inst, 'stepBigMonths') :
                                    +$.datepicker._get(inst, 'stepMonths')), 'M');
                                    break; // next month/year on page down/+ ctrl
                                case 35: if (event.ctrlKey || event.metaKey) $.datepicker._clearDate(event.currentTarget);
                                    handled = event.ctrlKey || event.metaKey;
                                    break; // clear on ctrl or command +end
                                case 36: if (event.ctrlKey || event.metaKey) $.datepicker._gotoToday(event.currentTarget);
                                    handled = event.ctrlKey || event.metaKey;
                                    break; // current on ctrl or command +home
                                case 37: // if (event.ctrlKey || event.metaKey)
                                    $.datepicker._adjustDate(event.currentTarget, (isRTL ? +1 : -1), 'D');
                                    handled = true; // event.ctrlKey || event.metaKey;
                                    // -1 day on ctrl or command +left
                                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.currentTarget, (event.ctrlKey ?
                                        -$.datepicker._get(inst, 'stepBigMonths') :
                                        -$.datepicker._get(inst, 'stepMonths')), 'M');
                                    // next month/year on alt +left on Mac
                                    setTabIndexOfJqueryCalendar();
                                    $('.focus-first').focus();
                                    break;
                                case 38: // if (event.ctrlKey || event.metaKey)
                                    $.datepicker._adjustDate(event.currentTarget, -7, 'D');
                                    setTabIndexOfJqueryCalendar();
                                    $('.focus-first').focus(); 
                                    handled = true; // event.ctrlKey || event.metaKey;
                                    break; // -1 week on ctrl or command +up
                                case 39: // if (event.ctrlKey || event.metaKey)
                                    $.datepicker._adjustDate(event.currentTarget, (isRTL ? -1 : +1), 'D');
                                    handled = true; // event.ctrlKey || event.metaKey;
                                    // +1 day on ctrl or command +right
                                    if (event.originalEvent.altKey) $.datepicker._adjustDate(event.currentTarget, (event.ctrlKey ?
                                        +$.datepicker._get(inst, 'stepBigMonths') :
                                        +$.datepicker._get(inst, 'stepMonths')), 'M');
                                    setTabIndexOfJqueryCalendar();
                                    $('.focus-first').focus();
                                    // next month/year on alt +right
                                    break;
                                case 40: // if (event.ctrlKey || event.metaKey)
                                    $.datepicker._adjustDate(event.currentTarget, +7, 'D');
                                    handled = true; // event.ctrlKey || event.metaKey;
                                    setTabIndexOfJqueryCalendar();
                                    $('.focus-first').focus();
                                    break; // +1 week on ctrl or command +down
                                default: handled = false;
                            }
                            if (handled) {
                                if (focusedCellData) {
                                    $('#pmsDatesCalendar .ui-datepicker-calendar td[data-day=' + focusedCellData.day + '][data-month=' + focusedCellData.month + '][data-year=' + focusedCellData.year + '] a').focus()
                                }
                                event.preventDefault();
                                event.stopPropagation();
                            }
                        });
                        pmsDateCalendar.find('.ui-datepicker-prev,.ui-datepicker-next').attr('tabindex=0')

                    }

                    setupCalendar();
                    app.commonViewHelper.updateRateCalendar(true, venue);
                    if (!!app.data.windowResizeHandler) {
                        $(window).unbind('resize', app.data.windowResizeHandler);
                    }
                    var lastWindowSize = null;
                    app.data.windowResizeHandler = _.debounce(function () {
                        if ($("#pmsDatesCalendar").length) {
                            var currentWindowSize = $(document).width();
                            if (currentWindowSize != lastWindowSize) {
                                lastWindowSize = currentWindowSize;
                                setupCalendar();
                                app.commonViewHelper.updateRateCalendar(true, venue);
                            }
                        } else {
                            $(window).unbind('resize', app.data.windowResizeHandler)
                        }
                    }, 500);
                    $(window).bind('resize', app.data.windowResizeHandler);
                    $('#pmsDatesCalendar').data('popOverTouchButtonText', app.localization.roomReservation.calendar.selectArrivalDateButton);
                    $('#pmsDatesCalendar').removeAttr('style');
                    $("#pmsDepartureDate, #alt-pmsDepartureDate").bind('click', function () {
                        var inst = jQuery.datepicker._getInst($('#pmsDatesCalendar')[0]);
                        inst.settings.altField = "#pmsDepartureDate";
                        inst.rangeStart = null;
                        var date = Date.parse($("#pmsArrivalDate").val()),
                            year = date.toString('yyyy'),
                            month = +date.toString('M') - 1,
                            day = date.toString('d');
                        //inst.rangeEnd = null;
                        $('#pmsDatesCalendar .ui-datepicker-inline td .ui-state-default').removeClass('ui-state-active ui-state-selected');
                        $('#pmsDatesCalendar .ui-datepicker-inline td[data-year=' + year + '][data-month=' + month + '][data-day=' + day + '] a').addClass('ui-state-active');
                        $('#pmsDatesCalendar').data('popOverTouchButtonText', app.localization.roomReservation.calendar.selectArrivalDateButton);
                        $('.datepickernextstep').text(app.localization.roomReservation.calendar.selectDepartureDateOnCalendar);
                        $("label[for=pmsDepartureDate].add-on").removeClass('hidden')
                        $("label[for=pmsArrivalDate].add-on").addClass('hidden')
                        app.commonViewHelper.updateRateCalendar(true, venue);
                    });
                    $("#pmsArrivalDate, #alt-pmsArrivalDate").bind('click', function () {
                        var inst = jQuery.datepicker._getInst($('#pmsDatesCalendar')[0]);
                        inst.settings.altField = "#pmsArrivalDate";
                        inst.rangeStart = null;
                        inst.rangeEnd = null;
                        $('#pmsDatesCalendar .ui-datepicker-inline td .ui-state-default').removeClass('ui-state-active ui-state-selected');
                        $('#pmsDatesCalendar').data('popOverTouchButtonText', app.localization.roomReservation.calendar.selectDepartureDateButton);
                        $('.datepickernextstep').text(app.localization.roomReservation.calendar.selectArrivalDateOnCalendar);
                        $("label[for=pmsArrivalDate].add-on").removeClass('hidden')
                        $("label[for=pmsDepartureDate].add-on").addClass('hidden')
                        $("#pmsDatesCalendar").datepicker("setDate",$("#pmsDatesCalendar").datepicker("getDate"));
                        app.commonViewHelper.updateRateCalendar(true, venue);
                    });

                }
                /*            $('#pmsArrivalDate,#pmsDepartureDate').change(function(e) {
                 var arrivalDate = Date.parse($('#pmsArrivalDate').val()),
                 departureDate = Date.parse($('#pmsDepartureDate').val());
                 if (e.target.id == "pmsArrivalDate" && arrivalDate.add(1).days() > departureDate) {
                 $('#pmsDepartureDate').val( arrivalDate.add(1).days().toString('yyyy-MM-dd') )
                 }
                 if (e.target.id == "pmsDepartureDate" && arrivalDate > departureDate.add(1).days() ) {
                 $('#pmsArrivalDate').val( departureDate.subtract(1).days().toString('yyyy-MM-dd') )
                 }
                 });*/
                $('#showMore').click(function (obj) {
                    obj.preventDefault();
                    $('#more').removeClass('hidden');
                    $('#showMore').remove();
                })
                $('#pmsFormSubmit').on('click', function (obj) {
                    $('#pmsDatesForm').validate({
                        errorPlacement: function (error, element) {
                            element.parent().append(error)
                        }
                    });
                    if ($('#pmsDatesForm').valid()) {
                        $(obj.target).button('loading');
                        obj.target.href += "/" + Date.parse($('#pmsArrivalDate').val()).toString('yyyy-MM-dd000000')
                            + "/" + (dayGuest
                                ? Date.parse($('#pmsArrivalDate').val()).add(1).days().toString('yyyy-MM-dd000000')
                                : Date.parse($('#pmsDepartureDate').val()).toString('yyyy-MM-dd000000')
                            )
                            + "/" + ($('#pmsNumAdults').val() || "")
                            + "/" + ($('#pmsNumYouth').val() || "")
                            + "/" + ($('#pmsNumChildren').val() || "")
                            + "/" + ($('#pmsNumJrChildren').val() || "")
                            + "/" + ($('#pmsPromoCode').val() || "");
                    } else {
                        return false;
                    }

                });
            },

            prepPMSRateForm: function () {
                $('.btn-primary').on('click', function (obj) {
                    $(obj.target).button('loading');
                });
            },

            updateDayRoomTypeData: function (rateType, roomTypes) {
                if (!!roomTypes && roomTypes.length) {
                    var count = roomTypes.length,
                        prices = {},
                        pricelist = [];
                    _.each(roomTypes, function (x) {
                        var theprice = app.customization.roomsBooking.suppressDailyRate ? +x.TotalStayRate : +x.AverageRate;
                        prices[theprice] = x;
                        pricelist.push(theprice);
                    })
                    pricelist = _.uniq(_.sortBy(pricelist, function (v, k) {
                        return v;
                    }), true);

                    // roomTypes = _.reduce([1, 2, 3], function(memo, num){ return memo + num; }, 0);
                    var fromTxt = pricelist.length > 1 ? app.localization.roomReservation.roomTypeSelection.roomTypeFromLabel : "",
                        atag = $('a[href=#collapse' + stripChars(rateType) + ']');
                    atag.find('span.pull-right').remove();
                    var spantag = $('<span class="pull-right btn btn-mini disabled btn-info"></span>');
                    spantag.text(fromTxt
                        + app.localization.general.currencyPrefix
                        + (app.customization.roomsBooking.suppressDailyRate ? +prices[pricelist[0]].TotalStayRate : +prices[pricelist[0]].AverageRate).toFixed(2)
                        + app.localization.general.currencyPostfix
                        + (app.customization.roomsBooking.suppressDailyRate
                            ? app.localization.roomReservation.roomTypeSelection.roomTypeTotalRateLabel
                            : app.localization.roomReservation.roomTypeSelection.roomTypeRateLabel));
                    atag.append(spantag);
                    if (count == 1) {
                        $('#collapse' + rateType + ' a.btn-primary').attr('href', '#/roomsBooking/roomtype/' + encodeURIComponent(rateType) + '/' + encodeURIComponent(roomTypes[0].PMSRoomType.PMSRoomTypeId) + '/1');
                    }
                }
            },

            updateRateCalendar: function (request, venue) {
                if ($("#pmsDatesCalendar").length == 0) {
                    return;
                }
                console.log('updateRateCalendar', request, venue);
                var _time = new Date()
                $(".ui-datepicker-inline,.datepicker-legend").css('width', ($(document).width() < 395 ? '100%' : window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? '25em' : '50em'));
                var dpgf = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group-first',
                    dpg = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group',
                    origmonth = _.indexOf(app.localization.CultureInfo.monthNames, $("#pmsDatesCalendar ." + dpgf + " .ui-datepicker-month:first").text()) + 1,
                    inst = jQuery.datepicker._getInst($("#pmsDatesCalendar")[0]),
                    rangeStart = inst.rangeStart ? Date.parse(inst.rangeStart) : null,
                    rangeEnd = inst.rangeEnd ? Date.parse(inst.rangeEnd) : null,
                    isSelectingEnd = !$("label[for=pmsDepartureDate]").hasClass('hidden'),
                    selectedStart = Date.parseExact($("#pmsArrivalDate").val(), "yyyy-MM-dd"),
                    selectedMonthYear = selectedStart && (selectedStart.getMonth() + 1) + "/" + selectedStart.getFullYear(),
                    selectedDay = selectedStart && selectedStart.getDate(),
                    selectedEnd = Date.parseExact($("#pmsDepartureDate").val(), "yyyy-MM-dd"),
                    selectedEndMonthYear = selectedEnd && (selectedEnd.getMonth() + 1) + "/" + selectedEnd.getFullYear(),
                    selectedEndDay = selectedEnd && selectedEnd.getDate(),
                    waitForRoomTypeData = false
                limit = 62;
                // console.log('isSelectingEnd',isSelectingEnd,'selectedStart',selectedStart,rangeStart,rangeEnd);
                if (!!app.data.pmsDatesCalendar
                    && !!app.data.pmsDatesCalendar[venue]
                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]) {
                    while (limit > 0
                        && (!!app.data.pmsDatesCalendar
                            && !!app.data.pmsDatesCalendar[venue]
                            && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                            && !app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay])
                        || (
                            !!app.data.pmsDatesCalendar
                            && !!app.data.pmsDatesCalendar[venue]
                            && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                            && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                            && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate
                            && (
                                (app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate.availMonSun != "YYYYYYY"
                                    && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate.availMonSun[(selectedStart.getDay() + 6) % 7] == "N")
                                || app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate.stopArrivals == "Y"
                            )
                        )
                    ) {
                        selectedStart.add(1).day()
                        selectedMonthYear = selectedStart && (selectedStart.getMonth() + 1) + "/" + selectedStart.getFullYear(),
                            selectedDay = selectedStart && selectedStart.getDate(),
                            limit--;
                    }
                    var stop = false
                    while (selectedEnd
                        && limit > 0
                        && (
                            selectedStart >= selectedEnd
                            || (
                                !!app.data.pmsDatesCalendar
                                && !!app.data.pmsDatesCalendar[venue]
                                && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].MinLOS >= 2
                                && selectedEnd.between(
                                    selectedStart.clone().add(1).days(),
                                    selectedStart.clone().add(+app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].MinLOS - 1).days()
                                )
                            )
                        ) || (
                            !!app.data.pmsDatesCalendar
                            && !!app.data.pmsDatesCalendar[venue]
                            && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear]
                            && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay]
                            && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay].bestRate
                            && app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay].bestRate.stopDepartures == 'Y'
                        )
                    ) {
                        selectedEnd.add(1).day()
                        selectedEndMonthYear = selectedEnd && (selectedEnd.getMonth() + 1) + "/" + selectedEnd.getFullYear(),
                            selectedEndDay = selectedEnd && selectedEnd.getDate(),
                            rangeStart = selectedStart.clone()
                        rangeEnd = selectedEnd.clone()
                        inst.rangeStart = rangeStart.toString("yyyy-MM-dd")
                        inst.rangeEnd = rangeEnd.toString("yyyy-MM-dd")
                        if ((!!app.data.pmsDatesCalendar
                            && !!app.data.pmsDatesCalendar[venue]
                            && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear]
                            && !app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay]
                        )
                            || (
                                !!app.data.pmsDatesCalendar
                                && !!app.data.pmsDatesCalendar[venue]
                                && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear]
                                && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay]
                                && app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay].bestRate
                                && app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay].bestRate.availMonSun != "YYYYYYY"
                                && app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay].bestRate.availMonSun[(selectedStart.getDay() + 6) % 7] == "N"
                            )) {
                            stop = stop || limit - 1 // _.max([limit,stop])
                            console.log('selectedEnd,limit,stop', selectedEnd, limit, stop)
                        }
                        limit = (stop >= limit) ? 0 : limit - 1
                    }
                    if (limit == 0) {
                        $("#pmsDepartureDate").val("")
                        inst.rangeEnd = ""
                        rangeEnd = null
                    } else {
                        if (!!app.data.pmsDatesCalendar
                            && !!app.data.pmsDatesCalendar[venue]
                            && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                            && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                            && $("#pmsArrivalDate").val() != selectedStart.toString("yyyy-MM-dd")) {
                            var prevSelectedStart = Date.parseExact($("#pmsArrivalDate").val(), "yyyy-MM-dd")
                            $("#pmsArrivalDate").val(selectedStart.toString("yyyy-MM-dd"))
                            $("#pmsDatesCalendar").datepicker("setDate", selectedStart.toString("yyyy-MM-dd"));
                            $('#alt-pmsArrivalDate').val(moment($('#pmsArrivalDate').val()).format(app.localization.roomReservation.dateFormat));
                        }
                        if (!!selectedEndDay
                            && !!app.data.pmsDatesCalendar
                            // && !!app.data.pmsDatesCalendar[venue]
                            // && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear]
                            // && !!app.data.pmsDatesCalendar[venue][selectedEndMonthYear][selectedEndDay]
                            && $("#pmsDepartureDate").val() != selectedEnd.toString("yyyy-MM-dd")) {
                            $("#pmsDepartureDate").val(selectedEnd.toString("yyyy-MM-dd"))
                            $('#alt-pmsArrivalDate').val(moment($('#pmsArrivalDate').val()).format(app.localization.roomReservation.dateFormat));
                            $('#alt-pmsDepartureDate').val(moment($('#pmsDepartureDate').val()).format(app.localization.roomReservation.dateFormat));
                        }
                    }
                }
                var month = _.indexOf(app.localization.CultureInfo.monthNames, $("#pmsDatesCalendar ." + dpgf + " .ui-datepicker-month:first").text()) + 1,
                    year = +$("#pmsDatesCalendar ." + dpgf + " .ui-datepicker-year:first").text()
                if (origmonth != month) {
                    request = true
                }
                $("#pmsDatesCalendar ." + dpg).each(function (i) {
                    var monthyeardate = Date.parseExact(month.toString() + '/' + year.toString(), "M/yyyy").add(i).months(),
                        monthyear = monthyeardate.toString("M/yyyy");
                    if (!!venue && !!app.data.pmsDatesCalendar && !!app.data.pmsDatesCalendar[venue] && !!app.data.pmsDatesCalendar[venue][monthyear]) {
                        var that = this;
                        $(this).find("td").blur();
                        $(this).find("td .ui-state-default span.small").remove();
                        $(this).find("td .ui-state-default").each(function (j) {
                            var day = $(this).text(),
                                monthyeardatecopy = monthyeardate.clone(),
                                theDay = monthyeardatecopy.add(+day - 1).days(),
                                today = Date.today().add(app.customization.roomsBooking.allowBookingToday ? 0 : 1).days()
                            if (rangeStart !== null) {
                                if (theDay > rangeStart && theDay <= rangeEnd) {
                                    $(this).addClass(theDay.compareTo(rangeEnd) == 0 ? 'ui-state-active' : 'ui-state-selected');
                                }
                                if (theDay == rangeStart && theDay <= rangeEnd) {
                                    $(this).addClass('ui-state-active');
                                }
                            }

                            if (app.data.pmsDatesCalendar[venue][monthyear][day] == undefined
                                || (
                                    app.data.pmsDatesCalendar[venue][monthyear][day].bestRate
                                    && app.data.pmsDatesCalendar[venue][monthyear][day].bestRate.availMonSun != "YYYYYYY"
                                    && app.data.pmsDatesCalendar[venue][monthyear][day].bestRate.availMonSun[(theDay.getDay() + 6) % 7] == "N"
                                )
                            ) {
                                if (!app.customization.roomsBooking.suppressCalendarRate) {
                                    $(this).append('<span class="small">' + (theDay >= today ? app.localization.roomReservation.calendar.notAvailable : '&nbsp;') + '</span>');
                                }
                                if (theDay >= today) {
                                    if (rangeEnd ? theDay.compareTo(rangeEnd) != 0 : true) {
                                        $(this).addClass('ui-datepicker-unselectable ui-state-disabled').removeClass('ui-state-active');
                                    }
                                }
                            } else {
                                var bestRate = app.data.pmsDatesCalendar[venue][monthyear][day].bestRate,
                                    rate = (+bestRate.MinRate).toFixed(app.customization.roomsBooking.calendarRateDecimals),
                                    roomType = stripChars(bestRate.PMSRoomType),
                                    totalrooms = bestRate.totalrooms,
                                    level = stripChars(bestRate.NumRoomLeft);
                                if (totalrooms <= app.customization.roomsBooking.lowAvailabilityThreshold) {
                                    $(this).addClass('ui-state-low');
                                }
                                if (!!app.data.pmsDatesCalendar[venue][monthyear][day]
                                    && +app.data.pmsDatesCalendar[venue][monthyear][day].MinLOS >= 2
                                    && !isSelectingEnd) {
                                    $(this).addClass('min-los').attr('data-min-los', app.data.pmsDatesCalendar[venue][monthyear][day].MinLOS);
                                }
                                app.customization.roomsBooking.suppressCalendarRate ||
                                    $(this).append('<span class="small level' + level + ' room' + roomType + '">' + app.localization.general.currencyPrefix + rate + app.localization.general.currencyPostfix + '</span>');
                            }
                            var stopDepart = false
                            if (isSelectingEnd && selectedStart &&
                                (
                                    (!!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                        && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                        && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].lastCheckOutDate
                                        && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].lastCheckOutDate < theDay
                                    )
                                    ||
                                    (!!app.data.pmsDatesCalendar[venue][monthyear]
                                        && !!app.data.pmsDatesCalendar[venue][monthyear][day]
                                        && !!app.data.pmsDatesCalendar[venue][monthyear][day].bestRate
                                        && app.data.pmsDatesCalendar[venue][monthyear][day].bestRate.stopDepartures == "Y"
                                        && (stopDepart = true)
                                    )
                                )
                            ) {
                                if (!$(this).parent('td').hasClass('ui-datepicker-unselectable')) {
                                    $(this).parent('td').addClass('ui-datepicker-unselectable ui-state-disabled rangeLock' + (stopDepart ? ' stop-departures' : ''))
                                } else {
                                    $(this).addClass('ui-datepicker-unselectable ui-state-disabled' + (stopDepart ? ' stop-departures' : '')).parent('td').addClass('rangeLock')
                                }
                            } else if (isSelectingEnd && selectedStart
                                && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].firstCheckOutDate
                                && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].firstCheckOutDate >= theDay) {
                                if (!$(this).parent('td').hasClass('ui-datepicker-unselectable')) {
                                    $(this).parent('td').addClass('ui-datepicker-unselectable ui-state-disabled rangeLock')
                                } else {
                                    $(this).parent('td').addClass('rangeLock')
                                }
                            } else {
                                if (isSelectingEnd && selectedStart
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].lastCheckOutDate
                                    && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].lastCheckOutDate.compareTo(theDay) == 0) {
                            
                                    $(this).removeClass('ui-datepicker-unselectable ui-state-disabled').parent('td').addClass('rangeLock').removeClass('ui-datepicker-unselectable ui-state-disabled');
                                } else if (app.data.pmsDatesCalendar[venue][monthyear][day] == undefined
                                    || (app.data.pmsDatesCalendar[venue][monthyear][day].bestRate
                                        && app.data.pmsDatesCalendar[venue][monthyear][day].bestRate.availMonSun != "YYYYYYY"
                                        && app.data.pmsDatesCalendar[venue][monthyear][day].bestRate.availMonSun[(theDay.getDay() + 6) % 7] == "N")
                                ) {
                                    $(this).parent('td').addClass('ui-datepicker-unselectable')
                                }

                                if (isSelectingEnd && theDay.compareTo(selectedStart) == -1
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                    && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate
                                    && app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].bestRate.stopDepartures == "Y"
                                ) {
                                    if (!$(this).hasClass('ui-state-active')) {
                                        $(this).parent('td').addClass('ui-state-disabled')
                                    }
                                    $(this).parent('td').addClass('ui-datepicker-unselectable stop-departures rangeLock')
                                } else if (isSelectingEnd || theDay.compareTo(selectedStart) == -1) {
                                    if (
                                        !!app.data.pmsDatesCalendar[venue][selectedMonthYear]
                                        && !!app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay]
                                        && +app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].MinLOS >= 2
                                        && theDay.between(selectedStart.clone().add(1).days(), selectedStart.clone().add(+app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].MinLOS - 1).days())
                                    ) {
                                        $(this).parent('td').addClass('rangeLock min-los').attr('data-range-min-los', app.data.pmsDatesCalendar[venue][selectedMonthYear][selectedDay].MinLOS)
                                        if (!$(this).parent('td').hasClass('ui-datepicker-unselectable')) {
                                            $(this).parent('td').addClass('ui-datepicker-unselectable ui-state-disabled')
                                        }
                                    }
                                } else if ((!isSelectingEnd || theDay.compareTo(selectedStart) == -1)) {
                                    if (!!bestRate && bestRate.stopArrivals == 'Y') {
                                        if (!$(this).hasClass('ui-state-active')) {
                                            $(this).parent('td').addClass('ui-state-disabled')
                                        }
                                        $(this).parent('td').addClass('ui-datepicker-unselectable stop-arrivals')
                                    } else if (isSelectingEnd
                                        && app.data.pmsDatesCalendar[venue][monthyear]
                                        && app.data.pmsDatesCalendar[venue][monthyear][day]
                                        && app.data.pmsDatesCalendar[venue][monthyear][day].MinLOS >= 2
                                        && selectedStart.between(theDay.clone().add(1).days(), theDay.clone().add(+app.data.pmsDatesCalendar[venue][monthyear][day].MinLOS - 1).days())) {
                                        $(this).parent('td').addClass('rangeLock min-los').attr('data-range-min-los', app.data.pmsDatesCalendar[venue][monthyear][day].MinLOS)
                                        $(this).parent('td').addClass('ui-datepicker-unselectable ui-state-disabled')
                                    }
                                } else if ($(this).parent('td').hasClass('rangeLock')) {
                                    $(this).parent('td').removeClass('ui-datepicker-unselectable ui-state-disabled rangeLock min-los')
                                } else {
                                    $(this).parent('td').removeClass('rangeLock min-los')
                                }
                            }
                        });

                    } else {
                        waitForRoomTypeData = true;
                        if (request === true) {
                            app.commonViewHelper.updateRateCalendarData(venue, monthyear);
                        }
                        $(this).find("td .ui-state-default span.small").remove();
                        app.customization.roomsBooking.suppressCalendarRate ||
                            $(this).find("td .ui-state-default").removeClass('ui-state-low ui-datepicker-unselectable ui-state-disabled').append('<span class="small">...</span>');
                    }
                });
                console.log('paint calendar', new Date().getTime() - _time.getTime())
                // the magic value null for request means that we were called from the controller for roomTypeData, which got us some
                // data. the other values that could be received are either false (which is called from __updateDatepicker in
                // commonViewHelper) or true (which means we will only be issuing the updateRateCalendarData request which in turn
                // populates the list of room types that need to be fetched by roomTypeData.
                // maybe we only need to ever dispatch this if request===null, but that would be to assume no call after the initial
                // updateRateCalendarData call will be for more than one month, and possibly we'd call roomtypedata too soon, before
                // knowing the list of room types returned in the next month to see whether there's a new one we need to fetch.
                app.data.beenBackFromDispatcherRateCalendar = app.data.beenBackFromDispatcherRateCalendar || (request === null);
                !waitForRoomTypeData && app.data.beenBackFromDispatcherRateCalendar && app.dispatcher.dispatch('roomsBooking', 'roomtypedata', []);
            },
            // TODO: identify return from controller vs a call in commonviewhelper, and then only dispatch roomtypedata when its come back at least once from controller.
            updateRateCalendarData: function (venue, monthyear) {
                var dpgf = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group-first',
                    dpg = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group';
                if (!!monthyear) {
                    app.dispatcher.dispatch('roomsBooking', 'ratecalendar', monthyear.split('/'));
                } else {
                    var month = _.indexOf(app.localization.CultureInfo.monthNames, $("#pmsDatesCalendar ." + dpgf + " .ui-datepicker-month").text()) + 1,
                        year = +$("#pmsDatesCalendar ." + dpgf + " .ui-datepicker-year").text(),
                        waitForRoomTypeData = false;
                    $("#pmsDatesCalendar ." + dpg).each(function (i) {
                        var monthyear = Date.parseExact(month.toString() + '/' + year.toString(), "M/yyyy").add(i).months().toString("M/yyyy");
                        if (!!app.data.pmsDatesCalendar && !!app.data.pmsDatesCalendar[venue] && !!app.data.pmsDatesCalendar[venue][monthyear]) {
                        } else {
                            waitForRoomTypeData = true;
                            app.dispatcher.dispatch('roomsBooking', 'ratecalendar', monthyear.split('/'));
                        }
                    });
                    !waitForRoomTypeData && app.dispatcher.dispatch('roomsBooking', 'roomtypedata', []);
                }
            },

            roomTypeDataReady: function () {
                app.data.roomTypeDataReadyClick ? (app.data.roomTypeDataReadyClick++) : (app.data.roomTypeDataReadyClick = 1);
                var dpgf = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group-first',
                    dpg = window.matchMedia(app.customization.roomsBooking.calendarMediaQuery).matches ? 'ui-datepicker-inline' : 'ui-datepicker-group',
                    roomTypeDataReadyClick = app.data.roomTypeDataReadyClick,
                    lastCheckOutDateList = [],
                    firstCheckOutDateList = [],
                    noGoodCheckOutDate = null;
                //try {console.log('roomTypeDataReady', app.data.pmsDatesCalendar['Lodge']['10/2012'][1].Date, app.data.pmsRoomTypeData['DRES']['Venue']);} catch(e){}
                $('#pmsDatesCalendar .' + dpg + ' td').each(function (x, elem) {
                    if (roomTypeDataReadyClick != app.data.roomTypeDataReadyClick) { console.log('over click', roomTypeDataReadyClick, app.data.roomTypeDataReadyClick); return; }
                    var venue = $('#pmsDatesCalendar').data('venue'),
                        month = +$(elem).attr('data-month'),
                        year = +$(elem).attr('data-year'),
                        monthyear = (month + 1) + '/' + year,
                        day = $(elem).attr('data-day'),
                        touch = false;
                    //console.log('hover',x,monthyear,day,elem, venue);
                    if (month !== NaN && year !== NaN && day !== undefined) {
                        if (!!app.data.pmsDatesCalendar && !!app.data.pmsDatesCalendar[venue] && !!app.data.pmsDatesCalendar[venue][monthyear] && !!app.data.pmsDatesCalendar[venue][monthyear][day]) {
                            lastCheckOutDateList.push(app.data.pmsDatesCalendar[venue][monthyear][day]);
                            if (noGoodCheckOutDate) {
                                app.data.pmsDatesCalendar[venue][monthyear][day].firstCheckOutDate = noGoodCheckOutDate;
                            }
                        } else {
                            $(lastCheckOutDateList).each(function (i, d) {
                                d.lastCheckOutDate = new Date(year, month, day);
                            })
                            lastCheckOutDateList = [];
                            noGoodCheckOutDate = new Date(year, month, day);
                        }
                    }
                    if (!app.customization.roomsBooking.suppressCalendarPopover && month !== NaN && year !== NaN && !!app.data.pmsDatesCalendar && !!app.data.pmsDatesCalendar[venue] && !!app.data.pmsDatesCalendar[venue][monthyear] && !!app.data.pmsRoomTypeData) {

                        touch && $(elem).unbind('click').bind('click', function (e) {
                            $(elem).addClass('ui-state-hover');
                            return false;
                        });
                        if (!!app.data.pmsDatesCalendar[venue][monthyear][day] && !!app.data.pmsDatesCalendar[venue][monthyear][day].bestRate) {

                            var bestRate = app.data.pmsDatesCalendar[venue][monthyear][day].bestRate,
                                roomDetails = app.data.pmsRoomTypeData[bestRate.PMSRoomType];
                            $(elem).data('popover', undefined).popover({
                                trigger: 'hover',
                                onEnter: function () {
                                    (roomTypeDataReadyClick + 1 < app.data.roomTypeDataReadyClick) && this.$tip && this.$tip.remove() //&& console.log('snip!');
                                    touch && this.$element[0].scrollIntoView(true);
                                },
                                beforeEnter: function () {
                                    var minLosElement = this.$element.find('a.min-los')
                                    if (minLosElement.length) {
                                        if (!this.options._content_added_minlos) {
                                            this.options.content += "\n\n" + app.localization.roomReservation.calendar.minLOSRestriction(minLosElement.attr('data-min-los') || "")
                                            this.options._content_added_minlos = true
                                        }
                                    }
                                    minLosElement = this.$element.hasClass('min-los') && this.$element.hasClass('rangeLock')
                                    if (minLosElement) {
                                        if (!this.options._content_added_minlos) {
                                            this.options.content += "\n\n" + app.localization.roomReservation.calendar.minLOSRestriction(this.$element.attr('data-range-min-los') || "")
                                            this.options._content_added_minlos = true
                                        }
                                    }
                                    var stopDeparturesElement = this.$element.hasClass('stop-departures')
                                    if (stopDeparturesElement) {
                                        if (!this.options._content_added_stopdepart) {
                                            this.options.content += "\n\n" + app.localization.roomReservation.calendar.stopDepartures
                                            this.options._content_added_stopdepart = true
                                        }
                                    }
                                    return (!touch || !this.$element.hasClass('ui-datepicker-unselectable'))
                                },
                                placement: touch ? 'in bottom' : 'bottom',
                                delay: { show: 500, hide: 100 },
                                title: (bestRate.totalrooms <= app.customization.roomsBooking.lowAvailabilityThreshold
                                    ? (app.customization.roomsBooking.suppressCalendarRate
                                        ? app.localization.roomReservation.calendar.limitedAvailability
                                        : app.localization.roomReservation.calendar.limitedAvailabilityFrom)
                                    : (app.customization.roomsBooking.suppressCalendarRate
                                        ? app.localization.roomReservation.calendar.roomsAvailable
                                        : app.localization.roomReservation.calendar.roomsAvailableFrom))
                                    + (app.customization.roomsBooking.suppressCalendarRate ? '' : bestRate.MinRate)
                                    + (touch ? '<a class="close" onclick="$(this).parents(\'div.popover\').remove(); return false" href="#">&times;</a>' : ''),
                                content: (roomDetails
                                    ? '<div class="pmsRoomDesc month' + month + ' year' + year + ' day' + day + ' clearfix"><img style="padding-left:1em" src="' + roomDetails.PMSRoomTypeImage + '" align="right" width="100">' + roomDetails.PMSRoomTypeDesc + '<br><br><span class="small">' + (roomDetails.PMSRoomTypeCustDesc || '') + '</span>' + (touch
                                        ? '<a href="#" onclick="javascript:$(\'label[for=pmsDepartureDate].add-on.hidden,label[for=pmsArrivalDate].add-on.hidden\').map(function(){$(this.htmlFor==\'pmsArrivalDate\'?\'pmsDepartureDate\':\'pmsArrivalDate\').val(\'' + year + '-' + (1 + month) + '-' + day + '\')}); $(\'#pmsDatesCalendar td[data-month=' + month + '][data-year=' + year + '][data-day=' + day + ']\').map(function(){$.datepicker._selectDay(\'#pmsDatesCalendar\', ' + month + ', ' + year + ', this);}); return false;" class="popOverTouchButton hasimg btn btn-primary btn-large">' + $('#pmsDatesCalendar').data('popOverTouchButtonText') + '</a>'
                                        : '') + '</div>'
                                    : app.localization.roomReservation.calendar.noDescriptionAvailable)
                                    + ($(elem).hasClass('stop-arrivals')
                                        ? "\n\n" + app.localization.roomReservation.calendar.noRoomsAvailableNoAction
                                        : "")

                                //'$(\'label[for=pmsDepartureDate].add-on.hidden,label[for=pmsArrivalDate].add-on.hidden\').map(function(){$(this.htmlFor==\'pmsArrivalDate\'?\'pmsDepartureDate\':\'pmsArrivalDate\').val(\''+year+'-'+(1+month)+'-'+day+'\')})'
                            });
                            //$(elem).popover('show');
                            //console.log('deets!!', bestRate.PMSRoomType, roomDetails, app.data.pmsRoomTypeData);
                        } else {
                            $(elem).data('popover', undefined).popover({
                                trigger: 'hover',
                                onEnter: function () {
                                    (roomTypeDataReadyClick != app.data.roomTypeDataReadyClick) && this.$tip.remove();
                                    touch && this.$element[0].scrollIntoView(true);
                                },
                                beforeEnter: function () {
                                    var minLosElement = this.$element.hasClass('min-los')
                                    if (minLosElement) {
                                        if (!this.options._content_added_minlos) {
                                            this.options.content += "\n\n" + app.localization.roomReservation.calendar.minLOSRestriction(this.$element.attr('data-range-min-los') || "")
                                            this.options._content_added_minlos = true
                                        }
                                    }
                                    return (!touch || !this.$element.hasClass('ui-datepicker-unselectable'))
                                },
                                placement: touch ? 'in bottom' : 'bottom',
                                delay: { show: 500, hide: 100 },
                                title: app.localization.roomReservation.calendar.noRoomsAvailable,
                                content: ($(elem).hasClass('rangeLock')
                                    ? app.localization.roomReservation.calendar.noRoomsAvailableAction
                                    + (touch ? '<div class="pmsRoomDesc"><a href="#" onclick="javascript:$(\'label[for=pmsDepartureDate].add-on.hidden,label[for=pmsArrivalDate].add-on.hidden\').map(function(){$(this.htmlFor==\'pmsArrivalDate\'?\'pmsDepartureDate\':\'pmsArrivalDate\').val(\'' + year + '-' + (1 + month) + '-' + day + '\')}); $(\'#pmsDatesCalendar td[data-month=' + month + '][data-year=' + year + '][data-day=' + day + ']\').map(function(){$.datepicker._selectDay(\'#pmsDatesCalendar\', ' + month + ', ' + year + ', this);}); return false;" class="popOverTouchButton hasimg btn btn-primary btn-large">' + $('#pmsDatesCalendar').data('popOverTouchButtonText') + '</a></div>' : "")
                                    : app.localization.roomReservation.calendar.noRoomsAvailableNoAction
                                )
                            });
          
                        }

                    } 
                });
            },
            handlePaymentPageDOM: function(folioid,module){
                $('.total-display .payNowBtn').on('click', function (obj) {
                    var amount = $('.partial-payment-balance-input').val()
                    if(module !="PMS" && (!amount || +amount <= 0)) {
                        $('.partial-payment-balance-error').html(app.localization.general.postPayment.enterValidAmount)
                        return
                    }
                    $('.partial-payment-balance-error').html('')
                    app.commonViewHelper.handlePayment(folioid,module,amount);
                })
            },
            handlePayment: function(folioid,module,amount){
                    $.when(
                        app.models.userModel.getData('postPayment', {
                            FolioId: folioid,
                            App: module,
                            Amount: amount,
                            SessionId: app.data.SessionId,
                            WebFolioId: app.data.WebFolioId
                        }))
                    .then(function (result) {
                        if(module == "CLUB"){
                           return $.when(app.models.systemModel.getData('folioBalance', {}))
                            .done(function (r_fb) {
                                app.datal("clubBookingInCart",true) //to prevent bo
                                app.dispatcher.dispatch('summary','checkout')
                                return;
                            })
                        } 
                        app.dispatcher.dispatch('summary','checkout')
                        console.log('pay skipped');
                    })
                    .fail(function(err){
                        console.log(err.Result.ErrorId == 804)
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: module == "CLUB" ? (err.Result.Text + ' '+ (err.Result.ErrorId == 804 ?  app.localization.general.postPayment.removeFromSummary: '')):app.localization.club.paymentActionFailed,
                            message: module == "ClUB" ?(err.Result && app.localization.club.err[r.Result.ErrorId] || ''): ''   
                        });
              
                        module == "CLUB" ? app.dispatcher.dispatch('membership', 'account', [folioid]):  app.commonViewHelper.showMessages();
                    }).always(function(){
                        $('#progressIndicator').modal('hide')
                    }) 
            },
            prepPMSConfirmForm: function () {
                $('#pmsFormSubmit').on('click', function (obj) {
                    $(obj.target).button('loading');
                    $('#progressIndicator').modal('show');
                });
            },
            prepSpaClassConfirmForm: function () {
                $('#pmsFormSubmit').on('click', function (obj) {
                    $(obj.target).button('loading');
                    $('#progressIndicator').modal('show');
                });
            },
            prepGolfConfirmForm: function () {
                $('.popover .close').click(function (o) {
                    o.preventDefault();
                    $(o.target).parents('.popover').hide();
                })
            },
            updatedTeeTimes: function (location, course, numberOfPlayers, startDate, groupCode) {
                $('#golfTeeInfoSubmit').addClass('disabled');

                $('.teetimeContainer').off('keydown').on('keydown', function(e){
                    if(e.keyCode == 13) {
                        $('.bookGolfTime').attr('tabindex', 0);
                        $(this).next().find('.bookGolfTime').first().focus();
                    }
                }).off('focus').on('focus', function(e){
                    $('.bookGolfTime').attr('tabindex', -1);
                })

                $('.bookGolfTime').click(function (obj) {
                    obj.stopPropagation();
                    $(obj.target).after($('<span class="loading"></span>').text(app.localization.spaBooking.serviceSelection.loading))
                });
                $('.groupCodeApply').on('click', function (obj) {
                    obj.preventDefault();
                    var inputGroupCode = $(this).parents('.groupCodeContainer').find('.groupCode').val();
                    var teeTime = $(this).attr('id') || '';
                    if (inputGroupCode) {
                        app.dispatcher.replace('golfBooking', 'location', [location.LocationId, course, startDate, '', '', numberOfPlayers, '', inputGroupCode, teeTime])
                    }
                })
            },
            prepGolfForm: function (location, selectedStartTime, course, stop, startDate) {
                var vm = this;
                selectedStartTime = selectedStartTime || "";
                var arret = stop;

                var objExtend = _.extend(location, { CourseId: course });
                var bookingWindow = getBookingWindow('Golf', _.extend({ Location: location.LocationId }, location, objExtend))
                var now = moment.tz(bookingWindow.timeZone);
                var endMinTime = now.clone()
                if (!_.isEmpty(bookingWindow.endOffset)) {
                    endMinTime.subtract(bookingWindow.endOffset) // because endOffset is negative, so subtract to add.
                }
                if (!_.isEmpty(bookingWindow.endSet)) {
                    _.each(bookingWindow.endSet, function (num, unit) {
                        endMinTime[unit](num)
                    })
                }
                var startMaxTime = now.clone().add(2, 'years')
                if (!_.isEmpty(bookingWindow.startOffset)) {
                    startMaxTime = now.clone()
                    startMaxTime.subtract(bookingWindow.startOffset)
                }
                if (!_.isEmpty(bookingWindow.startSet)) {
                    _.each(bookingWindow.startSet, function (num, unit) {
                        startMaxTime[unit](num)
                    })
                }

                $('#alt-golfTeeDate').datepicker({
                    minDate: endMinTime.toDate(),
                    maxDate: startMaxTime.toDate(),
                    numberOfMonths: 2,
                    dateFormat: app.localization.golf.dateFormat[0],
                    defaultDate: endMinTime.toDate(),
                    altField: '#golfTeeDate',
                    altFormat: "yy-mm-dd",
                    onSelect: function(){ $('#golfTeeDate').trigger('change').trigger('change') }
                }).datepicker('setDate', Date.parse($('#alt-golfTeeDate').val(), 'yyyy-MM-dd'));

                //Golf placeholder date

                if(sessionStorage.getItem('phWid-' + app.data.WebFolioId) && !startDate){
                    var phDate = JSON.parse(sessionStorage.getItem('phWid-' + app.data.WebFolioId));
                    if($($('.datepicker')[0]).datepicker('option', 'dateFormat').toLocaleLowerCase()[0] == "d"){
                        $('.datepicker').datepicker("setDate", new Date(phDate.year + ',' + phDate.month + "," + phDate.day));
                    }else{
                        $('.datepicker').datepicker("setDate", new Date(phDate.year,phDate.altMonth,phDate.day));
                    }
                }

                var updateGolfButton = function () {
                    $('#golfTeeInfo').validate();
                    if ($('#golfTeeInfo').valid()) {
                        $('#golfTeeInfoSubmit').removeClass('disabled').removeAttr('title').attr('href', window.location.hash + '/');
                    } else {
                        $('#golfTeeInfoSubmit').addClass('disabled').attr('title', app.localization.golf.error.date);
                    }
                }

                var golfTeeInfoSubmit = function golfTeeInfoSubmit(obj) {
                    if ($('#golfTeeInfo').valid()) {
                        if (app.customization.golfBooking.showTeeSheet) {
                            app.dispatcher.redirect('golfBooking', 'location', [location.LocationId, course, Date.parse($('#golfTeeDate').val()).toString('yyyy-MM-dd')])
                        } else {
                            obj.target.orighref = obj.target.orighref || obj.target.href;
                            obj.target.href = obj.target.orighref
                                + "/" + Date.parse($('#golfTeeDate').val()).toString('yyyy-MM-dd')
                                + "/" + $('#golfTeeTime').val() + '00'
                                + "/" + endDTime + '00'
                                + "/" + $('#golfTeePlayers').val()
                                + "/"
                                + "/" + $('#groupCode').val()
                            if ($('#golfTeeInfoSubmit').hasClass('disabled')) {
                                $('#progressIndicator').modal('hide');
                            }

                            var numberOfPlayers = $('#golfTeePlayers').val();
                            var startDate = Date.parse($('#golfTeeDate').val()).toString('yyyy-MM-dd');
                            var startTime = $('#golfTeeTime').val() + '00';
                            var endTime = endDTime + '00';
                            var groupCode = $('#groupCode').val();

                            app.dispatcher.dispatch('golfBooking','teetime', [startDate, startTime, endTime, numberOfPlayers, groupCode]);
                        }
                    } else {
                        return false;
                    }
                }

                var endDTime;
                var golfDateChange = function () {
                    updateGolfButton();

                    var time = $('#golfTeeTime').val();
                    var teedate = $.datepicker.parseDate('yy-mm-dd', $('#golfTeeDate').val());
                    var teedatestr = $.datepicker.formatDate('yyyy-mm-dd', teedate);
                    var todaystr = $.datepicker.formatDate('yyyy-mm-dd', new Date());
                    var sameday = teedatestr == todaystr;
                    var dayofweek = $.datepicker.formatDate('DD', teedate);
                    var startTime = !!location[dayofweek + 'Open'] && location[dayofweek + 'Open'].substr(10, 4);
                    var endTime = !!location[dayofweek + 'Close'] && location[dayofweek + 'Close'].substr(10, 4);
                    endDTime = endTime;
                    $('#golfTeeTime').html('');

                    var minTime = moment.tz(this.value + ' ' + startTime, "YYYY-MM-DD HHmm", bookingWindow.timeZone),
                        maxTime = moment.tz(this.value + ' ' + endTime, "YYYY-MM-DD HHmm", bookingWindow.timeZone);

                    var endOffsetMinTime = minTime.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endOffsetMinTime.add(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endOffsetMinTime[unit](num)
                        })
                    }
                    var startOffsetMinTime = moment('2000-01-01')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startOffsetMinTime = minTime.clone()
                        startOffsetMinTime.add(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startOffsetMinTime[unit](num)
                        })
                    }

                    if (app.customization.golfBooking.showTeeSheet) {
                        if (arret) {
                            arret = false
                        } else {
                            setTimeout(function () { $('#golfTeeInfoSubmit').trigger('click') }, 1)
                        }
                    } else {
                        var selectedDateString = moment(teedate).format('YYYY-MM-DD');
                        var numberOfPlayers = $('#golfTeePlayers').val();
                        var groupCode = $('#groupCode').val();
                        var golfTeeParameters = {
                            'Players': numberOfPlayers,
                            'StartDateTime': selectedDateString+startTime,
                            'EndDateTime': selectedDateString+endTime,
                            'Version':'2',
                            Date: selectedDateString,
                            GroupCode: groupCode
                        };
                        if (app.data.userLoggedIn) {
                            golfTeeParameters.CustomerId = app.data.CustomerId
                            golfTeeParameters.CustomerGUID = app.data.CustomerGUID
                        }
                        $('#progressIndicator').modal('show')
                        app.commonViewHelper.fetchFilteredGolfTeeSheet(golfTeeParameters).done( function(r_gt) {
                            $('#golfTeeTime').empty();
                            ((r_gt.TeeTimes || {}).TeeTime || []).forEach(function(tt){
                                var outputDate = moment(tt.DateTime, 'YYYY-MM-DDHHmmss');
                                $('#golfTeeTime').append('<option value="' + outputDate.format('HHmm') + '"' + ((selectedStartTime.substr(0, 4) == outputDate.format('HHmm')) && ' selected="selected"') + '>' + outputDate.format('h:mm A') + '</option>');
                            });
                            $('#golfTeeInfoSubmit').click();
                        }).always(function(){
                            $('#progressIndicator').modal('hide');
                        });
                    }
                };

                $('#golfTeeDate').change(golfDateChange);
                $('#golfTeeTime').change(updateGolfButton);
                $('#golfTeePlayers').change(updateGolfButton);
                $('#groupCode').on('input', updateGolfButton);
                $('#golfTeeDate, #alt-golfTeeDate').val($('#golfTeeDate').val() || endMinTime.format('YYYY-MM-DD'));
                $('#alt-golfTeeDate').datepicker('setDate', Date.parse($('#alt-golfTeeDate').val(), 'yyyy-MM-dd'));
                $('#golfTeeDate').change();
                $('#golfTeeInfoSubmit').on('click', golfTeeInfoSubmit);
            },
            prepBookTeeTimeButtons: function(courseId, groupCode){
               
                    $('.btn.names, .btn.roster, .btn.bookGolfTime').each(function(){
                        var rates = $(this).parent().parent().find('.bookGolfRates').text();
                        var numberOfPlayers = $(this).data('num-of-players');
                        var itemId = $(this).data('rateid');
                        var price = $(this).data('price');
                        var time = $(this).data('time');
                        var displayTime = $(this).data('display-time');
                        var maxSlots = $(this).data('slots-avail');
                        var guestNotes = JSON.stringify({});
                        var locationId = app.dispatcher.currentRoute[2]

                        $(this).click(function(e){
                            if(app.customization.golfBooking.enableGolferNamesModal || (app.customization.golfBooking.enableGolfMemberRoster && !app.data.userLoggedIn)){
                                e.preventDefault();
                                app.dispatcher.dispatch('golfBooking', 'showGolferModal',[courseId, time, maxSlots, itemId, groupCode, price, rates, displayTime] );
                            } else if(app.customization.golfBooking.enableGolfMemberRoster){
                                e.preventDefault();
                                $('#progressIndicator').modal('show');
                                app.dispatcher.dispatch('golfBooking', 'teetime', app.data.golfTeeSheetArgs.includes(time) ? app.data.golfTeeSheetArgs : app.data.golfTeeSheetArgs.slice(0,6).concat(1, locationId, courseId, time, maxSlots, displayTime) )
                            } else {
                                //all other cases except this, we can allow default behavior of this button, in legacy versions of bookGolfTime btn we allow redirect to confirm page
                                if(!app.customization.golfBooking.showTeeSheetAvailabilitiesAsGridOfButtons){
                                    e.preventDefault();
                                    app.dispatcher.dispatch('golfBooking', 'confirm',[courseId, time, numberOfPlayers, itemId, groupCode,price, guestNotes] );
                                }
                            };
                        });
                    });
            },
            // Save Group members information and fetch memberdirectory in app.data context
            saveGrpMembersAndDirectoryInfo: function(cb, skipFetchingDirectory) {
                //still ambiguous about putting this logic in init controller, placing this here isntead
                if(app.data.userLoggedIn){
                    var fetchParams = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID,
                    }

                    function fetchClubDirectory(groupMembers) {
                        $.when(app.models.clubModel.getData('fetchAccounts', fetchParams)).always(function (userAccounts) {
                            // if call successful
                            if(userAccounts && userAccounts.Account){
                                var userAccountsArr = userAccounts.Account;
                                var acctWithDirectoryAccess = _.find(userAccountsArr, function (acct) {
                                    //any acct with where memberdirectory is not D (disabled) - option in location setup club > admin > location > member directory
                                    return acct.MemberDirectory !== 'D';
                                });
                                
                                var clubDirectoryLocal = app.data.clubDirectory;
                                var hasClubDirectorySaved = clubDirectoryLocal && clubDirectoryLocal.Members && clubDirectoryLocal.Members.length
                                if(hasClubDirectorySaved){
                                    cb(groupMembers, clubDirectoryLocal);
                                } else {
                                    if (acctWithDirectoryAccess && acctWithDirectoryAccess.AccountId) {
                                        var fetchMembersParams = {
                                            CustomerId: app.data.CustomerId,
                                            CustomerGUID: app.data.CustomerGUID,
                                            AccountId: acctWithDirectoryAccess.AccountId
                                        };
                                        $.when(app.models.clubModel.getData('FetchClubDirectoryRequest', fetchMembersParams)).always(function (clubDirectory) {
                                            if(clubDirectory && clubDirectory.Members && clubDirectory.Members.length){
                                                // assuming member with directory access is the same as the one that is logged in
                                                var filteredClubDirectoryWithPrimaryAcctRemoved = clubDirectory ? _.filter(clubDirectory.Members[0].Member, function (member) {
                                                    // Book same player restriction for members
                                                    return member.MemberBookingId !== acctWithDirectoryAccess.MemberBookingId ;
                                                }) : null;

                                                app.data.clubDirectory = filteredClubDirectoryWithPrimaryAcctRemoved;
                                                cb(groupMembers, filteredClubDirectoryWithPrimaryAcctRemoved);
                                            } else {
                                                cb(groupMembers);
                                            }
                                        });
                                    } else {
                                        //has no accounts with club directory access
                                        cb(groupMembers);
                                    }
                                }
                            } else {
                                cb(groupMembers)
                            }
                        });
                    }
                    if(!app.data.groupMembers || !app.data.groupMembers.GroupMember ){
                        $.when(app.models.userModel.getData('fetchGroupMembers', fetchParams)).always(function (groupMembers) {
                            if(!app.data.cartData || !app.data.folioBookings){
                                $.when(app.models.systemModel.getData('folioBookings', {})).always(function(folioBookings){
                                    if(groupMembers && groupMembers.GroupMember){
                                        app.data.groupMembers = groupMembers
                                    }
                                    if(folioBookings){
                                        app.data.folioBookings = folioBookings;
                                    }
                                    if(app.customization.features.clubBooking && !skipFetchingDirectory){
                                        fetchClubDirectory(app.data.groupMembers);
                                        return;
                                    } else {
                                        cb(app.data.groupMembers);
                                        return;
                                    }
                                })
                            } else {
                                if(groupMembers && groupMembers.GroupMember){
                                    app.data.groupMembers = groupMembers
                                }
                                if(app.customization.features.clubBooking){
                                    fetchClubDirectory(app.data.groupMembers);
                                    return;
                                } else {
                                    cb(app.data.groupMembers);
                                    return;
                                }
                            }
                        });
                    } else {
                        var groupMembers = app.data.groupMembers;
                        if(!app.data.cartData || !app.data.folioBookings){
                            $.when(app.models.systemModel.getData('folioBookings', {})).always(function(folioBookings){
                                app.datal('cartData', folioBookings);
                                if(groupMembers && groupMembers.GroupMember){
                                    app.data.groupMembers = groupMembers
                                }
                                if(folioBookings){
                                    app.data.folioBookings = folioBookings;
                                }
                                if(app.customization.features.clubBooking){
                                    fetchClubDirectory(app.data.groupMembers);
                                    return;
                                } else {
                                    cb(app.data.groupMembers);
                                    return;
                                }
                            })
                        } else {
                            if(groupMembers && groupMembers.GroupMember){
                                app.data.groupMembers = groupMembers
                            }
                            if(app.customization.features.clubBooking){
                                fetchClubDirectory(app.data.groupMembers);
                                return;
                            } else {
                                cb(app.data.groupMembers);
                                return;
                            }
                        }
                        
                    }

                    
                    
                }
            },
            // show/hide loader on golfer form
            renderGolferFormLoader: function (show) {
                if(show){
                    $('#golferInformationModal').find('.golf-loader-container').removeClass('hide');
                } else {
                    $('#golferInformationModal').find('.golf-loader-container').addClass('hide');
                }
            },
            prepGolferInformationForm: function (courseId, dateTime, maxSlots, itemId, groupCode, price, golfRates, locationId, tempFlags) {
                //Golf player names modal stuff
                // Displays golfer information modal and dispateches to summary on confirm/submit
                $('#golferInformationModal').modal();
                if(tempFlags.enableGolferNamesModal){
                    var selectedItemId = itemId;
                    var $radios = $('input:radio[name=rate]');
                    var names = {};
                    

                    //selected rate checked by default
                    if($radios.is(':checked') === false) {
                        $radios.filter('[value='+itemId+']').prop('checked', true);
                    } 
                    var selectedCourse = app.models.golfModel.getSelectedItem('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})
                                
                    var allowSamePlayerBooking = selectedCourse && selectedCourse.RestrictSamePlayer && selectedCourse.RestrictSamePlayer === 'N';

                    // we can allow users to book only one slot if the course restricts same player
                    if(!allowSamePlayerBooking){
                        maxSlots = 1;
                    }

                    for(var i = 1; i<= maxSlots; i++) {
                        $('#golferInformationModal').find('#playerName' + i).removeAttr('disabled').attr('value', '')
                    } 
                    var realNumberOfPlayers = 0;
                    // disable continue button when number of players is 0 (initially)
                    $('#golferInformationModal').find('.continueBtn').attr('disabled', 'disabled').addClass('disabled');

                    // prepopulate the main account owner for first player name
                    if(app.data.FirstName && app.data.LastName){
                        $('#golferInformationModal').find('#playerName1').val(app.data.FirstName + ' ' + app.data.LastName).addClass('has-value');
                        realNumberOfPlayers = 1; 
                        $('#golferInformationModal').find('.continueBtn').removeAttr('disabled').removeClass('disabled');
                    }
             

                    

                    $('#golferInformationModal').find('input[id*="playerName"]').on('change textInput input', function(e){
                       
                        if($(this).val() !== ''){
                            $(this).addClass('has-value');
                        } else {
                            $(this).removeClass('has-value');
                        }

                        realNumberOfPlayers = $('#golferInformationModal').find('input[id*="playerName"].has-value').length;

                        // disable continue button when number of players is 0
                        if(realNumberOfPlayers === 0) {
                            $('#golferInformationModal').find('.continueBtn').attr('disabled', 'disabled').addClass('disabled');
                        } else {
                            $('#golferInformationModal').find('.continueBtn').removeAttr('disabled').removeClass('disabled');
                        }   
                    });  
                    
                    $('#golferInformationModal .continueBtn').on('click', function (e) {
                        if(!app.customization.enableGolfModalGeneralNote){
                            $('#golferInformationModal').find('input').each(function(){ 
                                if(this.name && this.name !== 'rate') {
                                    names[this.name] = $(this).val();
                                } else if(this.name === 'rate' && $(this).is(':checked')) {
                                    selectedItemId = $(this).val();
                                }
                            });
                        }

                        var note = JSON.stringify(names);
                        var ratesArr = JSON.parse(golfRates);
                        var selectedItem = _.find(ratesArr, function(rate){
                            return rate.ItemId === selectedItemId;
                        })


                        app.dispatcher.dispatch('golfBooking','confirm', [courseId, dateTime, realNumberOfPlayers, selectedItemId, groupCode, selectedItem.Price, note] );
                        

                        $('#golferInformationModal').remove();
                        $('#progressIndicator').modal('show');               
                    })

                    $('#golferInformationForm').submit(function (e) {
                        e.preventDefault()
                        $('#golferInformationModal .continueBtn').click();
                    });
                } else if(tempFlags.enableGolfMemberRoster){
                    // Preselect members (if primary member has enough rounds)
                 
                    var customerId= app.data.CustomerId 
                    var customerGUID= app.data.CustomerGUID

                    var selectedCourse = app.models.golfModel.getSelectedItem('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})
                    var allowSamePlayerBooking = selectedCourse && selectedCourse.RestrictSamePlayer && selectedCourse.RestrictSamePlayer === 'N';
                    var hasTimeRestriction = selectedCourse && selectedCourse.RestrictDuration && selectedCourse.RestrictDuration === 'Y';
                    var timeRestrictionDuration = selectedCourse && selectedCourse.PlayDuration ? selectedCourse.PlayDuration : 0;
                    var currentTeeTimeInfo = app.data.teeTimes.CourseId === courseId ? _.filter(app.data.teeTimes.TeeTime, function(teeTime){
                                                return teeTime.DateTime === dateTime;
                                            }): null;

                    // append error message to member container near rates
                    function appendErrorMessageToMemberContainer(memberContainer, message){
                        if(!memberContainer.find('.golf-rates .error-message p').length){
                            memberContainer.find('.golf-rates').append('<div class="error-message"><p>'+message+'</p></div>')
                        }
                    }
                    
                    // remove error message from member container near rates
                    function removeErrorMessageFromMemberContainer(memberContainer){
                        memberContainer.find('.golf-rates .error-message').remove();
                    }

                    // fetch and display rates per player
                    function fetchAndDisplayRatesPerPlayer(memberContainerParent, golfRateParameters, primaryUserParams, dateTime){
                        // {
                        //     'CustomerId':app.data.CustomerId,
                        //     'CourseId':courseId,
                        //     'Date':dateTime.slice(0,-6),
                        //     'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt"),
                        //     'Version': 2,
                        //     'GolfPlayerId': memberId,
                        //     'GolfPlayerType': customerPlayerType,
                        // }
                        // For each item in items, append a radio button
                        var golfRatesDiv = memberContainerParent.find('.golf-rates');
                        var memberNumber = golfRatesDiv.data('member');
                        // Clear existing rates
                        golfRatesDiv.empty();
                        // Add rates label
                        if(!memberContainerParent.find('.golf-rates .rates-label').length){
                            memberContainerParent.find('.golf-rates').prepend('<label class="rates-label">'+ app.localization.golf.modal.selectRateType +'</label>')
                        }
                        // show loader
                        app.commonViewHelper.renderGolferFormLoader(true);
                        $.when (app.models.golfModel.getData('golfRates', golfRateParameters)).done( function(r_gr) {
                            // check data-vip-level attribute on member container to see if the user group member 
                            var checkUserGroupMember = !primaryUserParams && !$(memberContainerParent).find('.accordion-toggle').data('memberbookingid') ? true : false;
                            var primaryUserVIPLevel = app.data.membershipDetails && app.data.membershipDetails.VIPLevels;
                            var primaryUserMemberIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds;

                            var bookingDate = dateTime && dateTime.substring(0,10) || '';
                            var bookingTime = dateTime && dateTime.substring(10) || '';
                            if(primaryUserParams || checkUserGroupMember){
                                app.commonViewHelper.eval_ttb({module:"golfBooking", locationId: app.models.golfModel.getSelectedValue('golfLocations'), courseId: golfRateParameters.CourseId, vipLevel: primaryUserVIPLevel, membershipId:primaryUserMemberIds, date:bookingDate, time:bookingTime });
                            } 
                            // this dynamic rest effect will filter rates by given sub category
                            if (app.commonViewHelper.active_ttb_effects.golfFilterRatesBySubCat) {
                                var golfFilterRatesBySubCatRes = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.golfFilterRatesBySubCat);
                              
                                if (golfFilterRatesBySubCatRes.isActive) {
                                  // filter rates by sub category
                                  var filteredRates = _.filter($.wrapArray(r_gr.GolfRates.GolfRate), function (rate) {
                                    var shouldFilter = true;
                                    for (var i = 0; i < golfFilterRatesBySubCatRes.value.length; i++) {
                                      if (rate.ItemSubcategory.indexOf(golfFilterRatesBySubCatRes.value[i]) !== -1) {
                                        shouldFilter = false;
                                        break;
                                      }
                                    }
                                    return shouldFilter;
                                  });
                                  r_gr.GolfRates.GolfRate = filteredRates;
                              
                                  if (!filteredRates || (filteredRates && filteredRates.length === 0)) {
                                    appendErrorMessageToMemberContainer(memberContainerParent, app.localization.golf.modal.noRatesErr);
                                    app.commonViewHelper.renderGolferFormLoader(false);
                                    return;
                                  }
                                }
                            }
                            // this dynamic rest effect will keep rates by given sub category
                            if (app.commonViewHelper.active_ttb_effects.golfKeepRatesBySubCat) {
                                var golfKeepRatesBySubCatRes = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.golfKeepRatesBySubCat);
                              
                                if (golfKeepRatesBySubCatRes.isActive) {
                                  // filter rates by sub category
                                  var filteredRates = _.filter($.wrapArray(r_gr.GolfRates.GolfRate), function (rate) {
                                    for (var i = 0; i < golfKeepRatesBySubCatRes.value.length; i++) {
                                      if (rate.ItemSubcategory.indexOf(golfKeepRatesBySubCatRes.value[i]) !== -1) {
                                        return true;
                                      }
                                    }
                                    return false;
                                  });
                                  r_gr.GolfRates.GolfRate = filteredRates;
                              
                                  if (!filteredRates || (filteredRates && filteredRates.length === 0)) {
                                    appendErrorMessageToMemberContainer(memberContainerParent, app.localization.golf.modal.noRatesErr);
                                    app.commonViewHelper.renderGolferFormLoader(false);
                                    return;
                                  }
                                }
                            }
                            if(r_gr.PlayerOverLimit === 'N'){
                                //if member is selected and the privacy mode is on
                                if(app.customization.golfBooking.memberPrivacyMode && golfRateParameters.GolfPlayerId){
                                    
                                    var cheapestRate = _.min($.wrapArray(r_gr.GolfRates.GolfRate), function(rate){
                                        return parseFloat(rate.Price);
                                    });

                                    if(!memberContainerParent.find('.golf-rates #r'+ memberNumber + cheapestRate.ItemId+'').length){
                                        memberContainerParent.find('.golf-rates').append('<div class="form-check"><input class="form-check-input" type="radio" name="golfRate'+memberNumber+'" id="r'+memberNumber + cheapestRate.ItemId+'" value='+cheapestRate.ItemId+' checked="checked"/><label class="form-check-label" for="r'+memberNumber + cheapestRate.ItemId+'"> '+ app.localization.golf.modal.memberRate +' </label></div>')
                                    }
                                } else {
                                    $.each($.wrapArray(r_gr.GolfRates.GolfRate), function (i, item) {
                                        if(!memberContainerParent.find('.golf-rates #r'+memberNumber + item.ItemId+'').length){
                                            memberContainerParent.find('.golf-rates').append('<div class="form-check"><input class="form-check-input" type="radio" name="golfRate'+memberNumber+'" id="r'+memberNumber + item.ItemId+'" value='+item.ItemId+' /><label class="form-check-label" for="r'+memberNumber + item.ItemId+'"> <span>'+ item.ItemName +'</span><span>'+app.localization.general.currencyPrefix+ item.Price + app.localization.general.currencyPostfix +'</span> </label></div>')
                                        }
                                    })
                                }
                            } else {
                                appendErrorMessageToMemberContainer(memberContainerParent, app.localization.golf.modal.limitErr);
                            }
                            app.commonViewHelper.renderGolferFormLoader(false);
                        }).fail( function(r_gr) {
                            app.commonViewHelper.renderGolferFormLoader(false);
                            appendErrorMessageToMemberContainer(memberContainerParent, r_gr.Result.Text);
                            if(!memberContainerParent.find('.golf-rates .error-message p').length){
                                memberContainerParent.find('.golf-rates').append('<div class="error-message"><p>'+r_gr.Result.Text+'</p></div>')
                            }
                        });
                    };

                    //checks if all the selected accordions have a member selected and have a rate selected
                    function golferFormIsValid(){
                        var isValid = true;

                        $('.member-container').each(function () {
                            var memberContainerParent = $(this);
                            var memberBtn = memberContainerParent.find('.accordion-heading a');
                            var memberBtnCustomerId = memberBtn.attr('data-customerid');
                            var golfRatesDiv = memberContainerParent.find('.golf-rates')
                            var memberNumber = golfRatesDiv.data('member');
                            var selectedRate = golfRatesDiv.find('input[name="golfRate'+memberNumber+'"]:checked').val();

                            // check if selected customers do not have a rate selected
                            if(memberBtnCustomerId && !selectedRate){
                                isValid = false;
                                appendErrorMessageToMemberContainer(memberContainerParent, app.localization.golf.modal.selectRate);
                            } else {
                                removeErrorMessageFromMemberContainer(memberContainerParent);
                            }
                        });

                        return isValid;
                    };

                    //show hidden members from all member containers
                    function showMembersByCustomerID(customerID){
                        //show hidden members from other member containers
                        $('.member-container').each(function () {
                                $(this).find('.member-btn[data-customerid="'+customerID+'"]').show().removeAttr('data-force-hide');
                        });
                    }

                    // hide members from all member containers
                    function hideMembersByCustomerID(customerID, memberBookingID){
                        //show hidden members from other member containers
                        $('.member-container').each(function () {
                            if(customerID){
                                $(this).find('.member-btn[data-customerid="'+customerID+'"]').hide().attr('data-force-hide', 'y');
                            }
                            if(memberBookingID){
                                $(this).find('.member-btn[data-memberbookingid="'+memberBookingID+'"]').hide().attr('data-force-hide', 'y');
                            }
                        });
                    }

                    // force close accordion after setting props
                    // override bootstrap default behaviour
                    function forceCloseAccordion(accordionHeading, firstName, lastName, customerId){
                        if((firstName || lastName) && customerId){
                            accordionHeading.addClass('collapsed').removeClass('active-member').html(firstName+' '+lastName).attr('data-customerid', customerId).attr('clicked', 'n');
                            accordionHeading.find('.remove-player').removeClass('hide');
                        } else {
                            accordionHeading.addClass('collapsed').removeClass('active-member').html('Choose Player').removeAttr('data-customerid').attr('clicked', 'n');
                            accordionHeading.find('.remove-player').addClass('hide');
                        }
                        accordionHeading.parent().next().removeClass('in').css({height: '0px',display:'none'});
                    }
                   
                   

                    // customer has tee time booked
                    function customerHasTeeTimeBookedForCourse(dateTime, customerId, courseId){
                        return _.find(app.data.golfBookings || [], function(booking){
                            return booking.BookingTime=== dateTime && booking.CourseId === courseId && _.find($.wrapArray(booking.GolfPlayer), function(player){
                                return player.CustomerId === customerId;
                            });
                        });
                    }
                    
                    function hasTeeTimeInCart(dateTime, courseId, customerId){
                        var cartData = app.data.cartData
                        if(cartData && cartData.rawData && cartData.rawData.WebFolioItem){
                            var webFolioItems = $.wrapArray(cartData.rawData.WebFolioItem)
                            return _.find(webFolioItems || [], function(booking){ 
                                return booking.DisplayStartTime === dateTime && booking.CourseId === courseId && booking.CustomerId === customerId;
                             });
                        } else {
                            return null;
                        }
                    }

                    if(customerId && customerGUID){
                        var skipPrimaryPreselection = false
                        // hide users based on same duration restriction
                        if(hasTimeRestriction){
                            // hide players with overlapping tee times
                            // check cart
                            var cartData = app.data.cartData
                            if(cartData && cartData.rawData && cartData.rawData.WebFolioItem){
                                var webFolioItems = $.wrapArray(cartData.rawData.WebFolioItem)
                                _.each(webFolioItems, function(booking){
                                    var bookeTeeTime = moment(booking.DisplayStartTime, 'YYYY-MM-DDHHmmss');
                                    var currentTeeTime = moment(dateTime, 'YYYY-MM-DDHHmmss');
                                    var durationInMinutes = moment.duration(currentTeeTime.diff(bookeTeeTime)).asMinutes();
                                    if(Math.abs(durationInMinutes) <= parseInt(timeRestrictionDuration) && booking.CourseId === courseId){
                                        //hide this player
                                        if(booking.CustomerId === customerId){
                                            skipPrimaryPreselection = true;
                                        }
                                        hideMembersByCustomerID(booking.CustomerId);
                                    }
                                });
                            }
                            // check future bookings
                            if(app.data.golfBookings){
                                _.each(app.data.golfBookings, function(booking){
                                    var bookeTeeTime = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss');
                                    var currentTeeTime = moment(dateTime, 'YYYY-MM-DDHHmmss');
                                    var isBookedTeeTimeToday = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss').isSame(currentTeeTime, 'day');
                                    var isBookedTeeTimeInFuture = moment(booking.BookingTime, 'YYYY-MM-DDHHmmss').isAfter(currentTeeTime, 'day');
                                    if(isBookedTeeTimeToday || isBookedTeeTimeInFuture){
                                        var durationInMinutes = moment.duration(currentTeeTime.diff(bookeTeeTime)).asMinutes();
                                        if(Math.abs(durationInMinutes) <= parseInt(timeRestrictionDuration) && booking.CourseId === courseId){
                                            _.each($.wrapArray(booking.GolfPlayer), function(player){
                                                // hide all players from tee times
                                                if(player.CustomerId === customerId){
                                                    skipPrimaryPreselection = true;
                                                }
                                                hideMembersByCustomerID(player.CustomerId);
                                            });
                                        }
                                    }
                                });
                            }
                        }
                        // pre select primary member if no same player restriction on the course for the same tee time
                        // Primary user pre selection logic
                        function preSelectMembersPrevReservations(){
                            var bookedTeeTimes = _.find(app.data.golfBookings || [], function(booking){
                                return booking.BookingTime=== dateTime && booking.CourseId === courseId;
                            });
    
                            if(bookedTeeTimes && bookedTeeTimes.GolfPlayer){
                                var golfPlayers = $.wrapArray(bookedTeeTimes.GolfPlayer)
                                
    
                                if(golfPlayers.length){
                                    _.each(golfPlayers, function(player){
                                        var playerPosition = player.Position
                                        var firstName = player.FirstName;
                                        var lastName = player.LastName;
                                        if(firstName || lastName){
                                            // preselect this accordion and disable it
                                            $('#member'+(playerPosition)).parent().addClass('disabled')
                                            $('#member'+(playerPosition)).addClass('disabled booked')
                                            $('#member'+(playerPosition)).find('.accordion-heading a').addClass('disabled').html(firstName+' '+lastName)
                                        }
                                    });
                                } else {
                                    // the golfbookings are being reset using info from teetimes if available
                                    if(currentTeeTimeInfo && currentTeeTimeInfo.length){
                                        var teeTimeInfo = currentTeeTimeInfo[0];
                                        for (var playerNumber = 1; playerNumber <= 4; playerNumber++) {
                                                var firstName = teeTimeInfo['P'+playerNumber+'FirstName'];
                                                var lastName = teeTimeInfo['P'+playerNumber+'LastName'];
    
                                                if(firstName || lastName){
                                                    // preselect this accordion and disable it
                                                    $('#member'+(playerNumber)).parent().addClass('disabled')
                                                    $('#member'+(playerNumber)).addClass('disabled booked')
                                                    $('#member'+(playerNumber)).find('.accordion-heading a').addClass('disabled').html(firstName+' '+lastName)
                                                }
                                        }
                                    }
                                }
                            } else {
                                if(currentTeeTimeInfo && currentTeeTimeInfo.length){
                                    var teeTimeInfo = currentTeeTimeInfo[0];
                                    for (var playerNumber = 1; playerNumber <= 4; playerNumber++) {
                                            var firstName = teeTimeInfo['P'+playerNumber+'FirstName'];
                                            var lastName = teeTimeInfo['P'+playerNumber+'LastName'];

                                            if(firstName || lastName){
                                                // preselect this accordion and disable it
                                                $('#member'+(playerNumber)).parent().addClass('disabled')
                                                $('#member'+(playerNumber)).addClass('disabled booked')
                                                $('#member'+(playerNumber)).find('.accordion-heading a').addClass('disabled').html(firstName+' '+lastName)
                                            }
                                    }
                                }
                            }
                        };
                        if(!app.data.golfBookings || !app.data.golfBookings.length){
                            app.commonViewHelper.renderGolferFormLoader(true)
                            app.controllers.initController.initGuestItinerary('fetchCustomerGolfBookings').always(function(){
                                app.commonViewHelper.renderGolferFormLoader(false)
                                preSelectMembersPrevReservations()
                            });
                        } else {
                            preSelectMembersPrevReservations()
                        }
                        if(!skipPrimaryPreselection){
                            if((!customerHasTeeTimeBookedForCourse(dateTime, customerId, courseId) && !hasTeeTimeInCart(dateTime, courseId, customerId)) || (allowSamePlayerBooking)){
                                var profileParams = {
                                    CustomerId: app.data.CustomerId,
                                    CustomerGUID: app.data.CustomerGUID
                                }
                                $.when(app.models.userModel.getData('fetchCustomerProfile', profileParams )).done(function (customerProfile) {
                                    var customer = customerProfile.Customer[0];
                                    var customerID = customer.CustomerId;
                                    var customerVipLevel = customer.VIPLevel;
                                    var customerPlayerType = customer.GolfSettings.GolfPlayerType;
                                    var name = customer.Name.FirstName + ' ' + customer.Name.LastName;
                                    var firstUnBookedPosition = $('.accordion:not(.booked)').first();
                                    var accordionGrpParent = firstUnBookedPosition.find('.accordion-group');
                                    var accordionHeading = accordionGrpParent.find('.accordion-heading a');
                                    var thisMemberContainerParent = firstUnBookedPosition.parent();
                                    
                                    if(customer){
                                        var primaryUser = '<button href="#" class="member-btn primary-user" data-customerid="'+customerID+'" data-vip-level="'+customerVipLevel+'" data-player-type="'+customerPlayerType+'">'+name+'</button>';
            
                                        // if new member button is not already in the list append
                                        $('.member-container').each(function () {
                                            var memberContainerParent = $(this);
                                            // if member is not already in the list append
                                            if(!memberContainerParent.find('.member-btn[data-customerid="'+customerID+'"]').length){
                                                memberContainerParent.find('.golf-members-list.group-members').prepend(primaryUser)
                                            }
                                            
                                        });
                                        //preselect member
                                        accordionHeading.html(name).attr('data-customerid', customerID).attr('data-vip-level', customerVipLevel)
                                        // Close the accordion and set attributes
                                        forceCloseAccordion(accordionHeading, customer.Name.FirstName, customer.Name.LastName, customer.CustomerId);
                                        
                                        // show remove button
                                        firstUnBookedPosition.find('.remove-player').removeClass('hide');
                                        fetchAndDisplayRatesPerPlayer(thisMemberContainerParent, {
                                            'CustomerId':customerID,
                                            'CourseId':courseId,
                                            'Date':dateTime.slice(0,-6),
                                            'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt"),
                                            'Version': 2,
                                            'GolfPlayerType': customerPlayerType,
                                        }, {
                                            locationId: locationId,
                                            courseId: courseId,
                                            vipLevel: customerVipLevel,
                                        }, dateTime);
                                        handleMemberBtnClick();
                                        // hide the new member from other member containers
                                        if(!allowSamePlayerBooking){
                                            hideMembersByCustomerID(customerID);
                                        }
                                    }
                                }).fail(function(){
                                    // TODO: fail case
                                })
                            }
                        }
                        

                        // Add new members click event
                        $('.newMemberAdd').on('click', function (e) {
                            e.preventDefault();
                         
                            
                            //writing it this way for es5 compatibility
                            var thisMemberContainerParent = $(this).parents('.member-container');
                            var newMemberAddDiv = $(this).parent().parent();
                            var firstNameDiv = newMemberAddDiv.find('.newMemberFirstName');
                            var lastNameDiv = $(this).parent().find('.newMemberLastName');
                            var firstName = firstNameDiv.val();
                            var lastName = lastNameDiv.val();
                            if(!firstName){
                                firstNameDiv.addClass('error');
                                firstNameDiv.parent().after('<span class="error-message">'+ app.localization.golf.modal.firstNameErr +'</span>');
                            } else {
                                firstNameDiv.removeClass('error');
                                firstNameDiv.parent().parent().find('.error-message').remove();
                            }
                            if(!lastName){
                                lastNameDiv.addClass('error');
                                lastNameDiv.parent().after('<span class="error-message">'+ app.localization.golf.modal.lastNameErr +'</span>');
                            } else {
                                lastNameDiv.removeClass('error');
                                lastNameDiv.parent().parent().find('.error-message').remove();
                            }

                            var createGroupMemberParams = {
                                CustomerId: customerId,
                                CustomerGUID: customerGUID,
                            }
                            // writing it this way for es5 compatibility
                            createGroupMemberParams["NewGroupMember.Name.FirstName"] = firstName;
                            createGroupMemberParams["NewGroupMember.Name.LastName"] = lastName;

                            if(firstName && lastName){
                                // close this accordion
                                $(this).parents('.accordion-group').find('.accordion-heading a').click();
                                app.commonViewHelper.renderGolferFormLoader(true)
                                $.when(app.models.systemModel.getData('createGroupMember', createGroupMemberParams))
                                .done(function (createGroupMemberResponse) {

                                    // add the new member to the list as member-btn for member-container
                                    //fetch group members and find the newly created group member
                                    $.when(app.models.userModel.getData('fetchGroupMembers', {
                                        CustomerId: customerId,
                                        CustomerGUID: customerGUID,
                                    } )).always(function (groupMembers) {
                                        var groupMembersList = groupMembers.GroupMember;
                                        var groupMemberCustomerId = createGroupMemberResponse.NewGroupMemberCustomerId;

                                        // find the new member with groupMemberCustomerId
                                        var memberObj = _.find(groupMembersList, function (member) {
                                             return member.CustomerId == groupMemberCustomerId;
                                        });
    
                                        if(memberObj){
                                            var newMember = '<button href="#" class="member-btn" data-customerid="'+memberObj.CustomerId+'" data-vip-level="'+memberObj.VIPLevel+'" data-player-type="'+memberObj.GolfSettings.GolfPlayerType+'">'+memberObj.Name.FirstName+' '+memberObj.Name.LastName+'</button>';
    
                                            // if new member button is not already in the list append
                                            $('.member-container').each(function () {
                                                var memberContainerParent = $(this);
                                                var accordionGrpParent = thisMemberContainerParent.find('.accordion-group');
                                                var accordionHeading = accordionGrpParent.find('.accordion-heading a');
                                                
                                                // if member is not already in the list append
                                                if(!memberContainerParent.find('.member-btn[data-customerid="'+memberObj.CustomerId+'"]').length){
                                                    memberContainerParent.find('.golf-members-list.group-members').append(newMember)
                                                }
                                                
                                                //preselect member
                                                // Close the accordion and set attributes
                                                forceCloseAccordion(accordionHeading, memberObj.Name.FirstName, memberObj.Name.LastName, memberObj.CustomerId);

                                                fetchAndDisplayRatesPerPlayer(thisMemberContainerParent, {
                                                    'CustomerId':memberObj.CustomerId,
                                                    'CourseId':courseId,
                                                    'Date':dateTime.slice(0,-6),
                                                    'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt"),
                                                    'Version': 2,
                                                    'GolfPlayerType': memberObj.GolfSettings.GolfPlayerType
                                                },{}, dateTime);
                                            });
                                            // hide the new member from other member containers
                                            if(!allowSamePlayerBooking){
                                                hideMembersByCustomerID(customerID);
                                            }
                                        }
                                        app.commonViewHelper.renderGolferFormLoader(false)
                                    })
                                    
                                }).fail(function (createGroupMemberResponse) {
                                    if(!$(this).find('.error-message p').length){
                                        $(this).append('<div class="error-message"><p>'+createGroupMemberResponse.Result.Text+'</p></div>')
                                    }
                                });
                            }
                        })
                        
                        // logic to keep only one accordion open
                        $('#golferInformationModal .accordion-heading > a').each(function () {
                            var thisAccordionHeading = $(this);
                            // if not clicked yet
                            thisAccordionHeading.click(function (e) {
                                e.preventDefault();
                                if(thisAccordionHeading.attr('clicked') == 'y'){
                                    thisAccordionHeading.addClass('collapsed').removeClass('active-member').attr('clicked', 'n');
                                } else {
                                     // collapse all other accordions with class active and remove class active
                                     thisAccordionHeading.parents('#golferInformationModal').find('.active-member').each(function () {
                                        if($(this).hasClass('active-member')){
                                            // collapse the accordion
                                            $(this).addClass('collapsed').removeClass('active-member').attr('clicked', 'n');
                                            $(this).parent().next().removeClass('in').css({height: '0px',display:'none'});
                                        }
                                    });
                                    thisAccordionHeading.addClass('active-member').attr('clicked', 'y');
                                   
                                }
                            })
                        })
                        //only this is a function becuase we're reusing it
                        handleMemberBtnClick(); //when there's no preselection
                        function handleMemberBtnClick(){
                            // member button click event
                            $('.member-btn').click(function (e) {
                                e.preventDefault();
                                var customerID = $(this).data('customerid') 
                                var memberId = $(this).data('memberbookingid');
                                var customerVipLevel = $(this).data('vip-level');
                                var customerPlayerType = $(this).data('player-type');
                                var name = $(this).html();
                                var accordionGrpParent = $(this).parents('.accordion-group');
                                var memberContainerParent = $(this).parents('.member-container');
                                
                                // if guest pre selected show in all other member containers before changing the pre selected guest
                                var preSelectedGuestID = accordionGrpParent.find('.accordion-heading a').attr('data-customerid');
                                    if(preSelectedGuestID !== customerID){
                                        showMembersByCustomerID(preSelectedGuestID);
                                    }
    
                                // Close the accordion after selecting a member
                                if(memberId){
                                    accordionGrpParent.find('.accordion-heading a').html(name).removeAttr('data-customerid').attr('data-memberbookingid', memberId).attr('data-vip-level', customerVipLevel).click();
                                } else {
                                    accordionGrpParent.find('.accordion-heading a').html(name).attr('data-customerid', customerID).attr('data-vip-level', customerVipLevel).click();
                                }
                                // hide this member from all other member containers
                                if(!allowSamePlayerBooking){
                                    hideMembersByCustomerID(customerID, memberId);
                                }
                                memberContainerParent.find('.remove-player').removeClass('hide');
                                var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                                app.commonViewHelper.eval_ttb({module:"golfBooking", locationId:locationId, courseId:courseId, date:dateTime, vipLevel:customerVipLevel, membershipId:membershipIds });
    
                                var golfTeeParameters = memberId ? {
                                    'CustomerId':app.data.CustomerId,
                                    'CourseId':courseId,
                                    'Date':dateTime.slice(0,-6),
                                    'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt"),
                                    'Version': 2,
                                    'GolfPlayerId': memberId,
                                    'GolfPlayerType': customerPlayerType,
                                } : {
                                    'CustomerId':customerID,
                                    'CourseId':courseId,
                                    'Date':dateTime.slice(0,-6),
                                    'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt"),
                                    'Version': 2,
                                    'GolfPlayerType': customerPlayerType,
                                }

                                
                                fetchAndDisplayRatesPerPlayer(memberContainerParent, golfTeeParameters, {}, dateTime);
                            })    
                        }
                        
                        // collate all memmbers into an object and trigger the booking when clicking select
                        $('#golferInformationModal button.continueBtn').click(function (e) {
                            e.preventDefault();
                            // validate form
                            if(golferFormIsValid()){
                                // collate all members into an object
                                var golfers = [];
                                $('.member-container').each(function () {
                                    var memberContainerParent = $(this);
                                    var memberBtn = memberContainerParent.find('.accordion-heading a');
                                    var memberBtnCustomerId = memberBtn.attr('data-customerid');
                                    var memberBookingId = memberBtn.attr('data-memberbookingid');
                                    var golfRatesDiv = memberContainerParent.find('.golf-rates');
                                    var memberNumber = golfRatesDiv.data('member');
                                    var selectedRate = golfRatesDiv.find('input[name="golfRate'+memberNumber+'"]:checked').val();
                                    
                                    if((memberBtnCustomerId || memberBookingId) && selectedRate){
                                        golfers.push({rate:selectedRate, customerId:memberBtnCustomerId, memberBookingId:memberBookingId, memberNumber: memberNumber});
                                    }
                                });
                                // trigger the booking
                                var golfBookingRequest = {
                                    'TeeTime': dateTime,
                                    'CourseId': courseId,
                                    'Players': golfers.length,
                                    'CustomerId': app.data.CustomerId,
                                    'LocationId': locationId,
                                };

                                _.each(golfers, function(golfer){
                                    golfBookingRequest['P'+golfer.memberNumber+'CustomerId'] = golfer.customerId || golfer.memberBookingId;
                                    golfBookingRequest['P'+golfer.memberNumber+'ItemId'] = golfer.rate;
                                });

                                // show loader
                                app.commonViewHelper.renderGolferFormLoader(true); 
                                $.when ( app.models.golfModel.getData('bookMemberRosterTeeTime', golfBookingRequest) )
                                .done( function(r_gb) {
                                    if (r_gb.GolfBookingId != undefined) {
                                        app.data.messages.push({ type:'modal-alert', 'class':'alert-success', actions: [],
                                            title:app.localization.golf.successfullBookingMessage,
                                            message:Localization.spaBooking.confirmation.customerCustomTextFooter
                                        });
                                        app.dispatcher.replace('summary','show',[]);
                                    } else {
                                            app.data.messages.push({ type:'modal-alert', 'class':'alert-error', actions: [],
                                            title:app.localization.golf.error.noBooking,
                                            message:(r_gb && r_gb.Result) ? "("+r_gb.Result.Text+")" : ""
                                        });
                                    }
                                    app.commonViewHelper.renderGolferFormLoader(false);  
                                    app.commonViewHelper.showMessages();
                                })
                                .fail( function( r_gt) {
                                    var message = app.localization.golf.error.noBooking;
                                    
                                    if (r_gt && r_gt.Result && r_gt.Result.ErrorId && app.localization.golf.error[r_gt.Result.ErrorId]) {
                                        message = app.localization.golf.error[r_gt.Result.ErrorId]
                                    }

                                    app.data.messages.push({ type:'modal-alert', 'class':'alert-error', actions: [],
                                        title:message
                                    });

                                    app.commonViewHelper.renderGolferFormLoader(false);  
                                    app.commonViewHelper.showMessages();
                                });
                            }
                        });
                    }

                    // add event listener to the remove-member buttons in each member-container
                    $('.remove-player').each(function () {
                        var removeMemberBtn = $(this);
                        removeMemberBtn.click(function (e) {
                            e.preventDefault();
                            var memberContainerParent = removeMemberBtn.parents('.member-container');
                            var memberBtn = memberContainerParent.find('.accordion-heading a');
                            var customerID = memberBtn.data('customerid');
                            //remove all atrributes from member button
                            memberBtn.removeAttr('data-customerid');
                            memberBtn.removeAttr('data-vip-level');
                            memberBtn.removeAttr('data-player-type');
                            memberBtn.text('Choose Player');

                            var golfRatesDiv = memberContainerParent.find('.golf-rates')
                            // remove everything inside golfRatesDiv
                            golfRatesDiv.empty();
                        
                            //show hidden members from other member containers
                            showMembersByCustomerID(customerID);

                            removeMemberBtn.addClass('hide');
                        });
                    });

                    // Member search
                    $('.member-search').each(function () {
                        var memberSearch = $(this);
                        memberSearch.on('keyup', function (e) {
                            var searchVal = $(this).val();
                            var memberBtns = $(this).parent().next().find('.member-btn')
                            memberBtns.each(function () {
                                var name = $(this).html();
                                if(searchVal.length > 1){
                                    if(memberSearch.parent().find('.error-message').length){
                                        memberSearch.parent().find('.error-message').remove();
                                    }
                                    if (name.toLowerCase().indexOf(searchVal.toLowerCase()) > -1 && !$(this).attr('data-force-hide')) {
                                        $(this).show();
                                    } else {
                                        $(this).hide();
                                    }
                                } else {
                                    $(this).show();
                                }
                            });
    
                            // if all elements are hidden, show error message
                            if(memberBtns.filter(':visible').length === 0){
                                if(!memberSearch.parent().find('.error-message').length){
                                    memberSearch.parent().append('<div class="error-message">'+app.localization.golf.modal.noResults+'</div>')
                                }
                            }
                        });
                    })
                    $('#golfer-login').on('click', function (e) {
                        e.preventDefault();
                        var nextLink = window.location.hash.split('/').slice(1);
                        app.dispatcher.replace('profile', 'login', ['next'].concat(nextLink));
                    })
                    
                    $('#golfer-signup').on('click', function (e) {
                        e.preventDefault();
                        var nextLink = window.location.hash.split('/').slice(1);

                        //save in local context
                        app.data.loginNextURL = [nextLink[0], nextLink[1], nextLink.slice(2)];

                        //adding in the url as well which is purely informational
                        app.dispatcher.replace('profile', 'create', ['next'].concat(nextLink));
                    })
                    
                    $('#golferInformationModal .cancelBtn').on('click', function () {
                        app.dispatcher.redirect('golfBooking', 'location', [locationId, courseId, dateTime.slice(0,-6)]);
                    })
                }

            },
            updateSpaServiceStaffList: function (showitem, staffList, staffGenderOrId, location, type, value) {
                if (typeof value == 'undefined') { value = staffGenderOrId }
                app.data.staffGenderOrId = staffGenderOrId = value //  || staffGenderOrId
                var requireGender = ""
                    , found = (value == "M" || value == "F" || value == "P") ? "found" : "";
                if (typeof staffGenderOrId == 'undefined') { staffGenderOrId = ''; }
                if ($('#spaRecipientGender' + showitem).length) {
                    requireGender = $('#spaRecipientGender' + showitem).val()
                    $('#spaServiceForm #itemStaffPref' + showitem + ' select.spaServiceStaff').html(
                        location.AllowStaff == "Y"
                            ? '<optgroup class="staffList" label="' + app.localization.spaBooking.serviceSelection.staffLabel + '">' + (staffGenderOrId == "" ? '<option value="">' + (location.ForceGenderSelect == 'Y' ? app.localization.general.gender.notSpecifiedRequired : app.localization.general.gender.notSpecified) + '</option>' : '') + '</optgroup>'
                            : ''
                    );
                } else {
                    $('#spaServiceForm #itemStaffPref' + showitem + ' select.spaServiceStaff').html(
                        (
                            location.AllowGender == "Y"
                                ? '<optgroup label="' + app.localization.spaBooking.serviceSelection.genderLabel + '">' + (staffGenderOrId == "" ? '<option value="">' + (location.ForceGenderSelect == 'Y' ? app.localization.general.gender.notSpecifiedRequired : app.localization.general.gender.notSpecified) + '</option>' : '') + '<option ' + (staffGenderOrId == "M" ? 'selected="selected" ' : '') + 'value="M">' + app.localization.general.gender.male + '</option><option ' + (staffGenderOrId == "F" ? 'selected="selected" ' : '') + 'value="F">' + app.localization.general.gender.female + '</option><option ' + (staffGenderOrId == "P" ? 'selected="selected" ' : '') + 'value="P">' + app.localization.general.gender.noPreference + '</option></optgroup>'
                                : ''
                        ) + (
                            location.AllowStaff == "Y"
                                ? '<optgroup class="staffList" label="' + app.localization.spaBooking.serviceSelection.staffLabel + '">' + (location.AllowGender != "Y" ? '<option value="P">' + app.localization.general.gender.noPreference + '</option>' : '') + '</optgroup>'
                                : ''
                        )
                    );
                }
                if (location.AllowStaff == "Y") {
                    staffList = _.sortBy(staffList, function (staff) { return staff.SpaStaffName });
                    $.each(staffList, function (index, spaStaff) {
                        if (!requireGender || requireGender == spaStaff.Gender) {
                            $('#spaServiceForm #itemStaffPref' + showitem + ' select.spaServiceStaff .staffList').append('<option ' + ((type == 'spaServiceStaff' ? value : staffGenderOrId) == spaStaff.SpaStaffId ? (found = 'selected="selected" ') : '') + 'value="' + spaStaff.SpaStaffId + '">' + xmlEscape(spaStaff.SpaStaffName) + '</option>');
                            staffGenderOrId == spaStaff.SpaStaffId && $('.spaRecipientGender').val(spaStaff.Gender);
                        }
                    });
                }
                if (type == "spaServiceStaff") {
                    thisValue = found ? value : ""
                    $('.spaServiceStaff').val(thisValue);
                    var recipientGender = $('#spaRecipientGender' + showitem).val()
                    app.data.staffGenderOrId = recipientGender ? (thisValue || recipientGender) : thisValue
                }
                $('#spaServiceStaff' + showitem).addClass('hasData')
            },
            formatContactLogNotes: function (contactLogs) {
                //needs to be removed after backend changes
                // formatting "UpdateCustomerProfile - log text" to "log text"
                if(Array.isArray(contactLogs)) {
                    var formattedContactLogs = contactLogs;
                    formattedContactLogs.forEach(function(contactLog) {
                        contactLog.LogNote = contactLog.LogNote.split("-").slice(-1);
                    });
                    return formattedContactLogs;
                } else {
                    var formattedContactLog = Object.assign({}, contactLogs);
                    formattedContactLog.LogNote = formattedContactLog.LogNote.split("-").slice(-1)
                    return [formattedContactLog];
                }
            },
            combineContactLogsByName: function (contactLogs) {
                if(Array.isArray(contactLogs)) {
                    var logNotesListByType = {};
                    var uniqueContactLogs = {};

                    contactLogs.forEach(function(contactLog) {
                        if(!logNotesListByType[contactLog.LogType]) {
                            logNotesListByType[contactLog.LogType] = [{LogId: contactLog.LogId, LogNote: contactLog.LogNote, LogType: contactLog.LogType}];
                        } else {
                            logNotesListByType[contactLog.LogType].push({LogId: contactLog.LogId, LogNote: contactLog.LogNote, LogType: contactLog.LogType});
                        }
                        contactLog.LogNotesList = logNotesListByType[contactLog.LogType];
                        uniqueContactLogs[contactLog.LogType] = contactLog;
                    })

                    return Object.values(uniqueContactLogs);
                } else {
                    var combinedContactLog = Object.assign({}, contactLogs);
                    combinedContactLog.LogNotesList = [{LogId: contactLogs.LogId, LogNote: contactLogs.LogNote}];
                    return [combinedContactLog];
                }
              
            },
            prepUserProfileForm: function (type,userId, proceedToCheckout) {
                $('#userMainPhone .btn, #userLanguage .btn').on('click', function (obj) {
                    $('#userProfileForm').validate();
                    obj.preventDefault();
                })

                var skiInCartLoopPerGuest =!!(app.customization.skiBooking.guestProfileUpdateOnCheckout  && type == "redirect"),
                isRequired = function(field){
                    return _.some(app.customization.skiBooking.requiredSkiFields, function(o) { 
                        return o.field == field
                     }) 
                }
                if(skiInCartLoopPerGuest){
               
                    var visitedRentalProfile = JSON.parse(window.localStorage.getItem('visitedRentalProfile')) || {}
                  
                    visitedRentalProfile[userId|| app.data.CustomerId] = Date.now()
                    visitedRentalProfile = JSON.stringify(visitedRentalProfile);
                    window.localStorage.setItem("visitedRentalProfile",visitedRentalProfile);
                }
                skiInCartLoopPerGuest && addAsteriskSignForRequiredSkiField()
                function addAsteriskSignForRequiredSkiField(){
                    isRequired('SkiBootSize') &&  $('.userSkiBootSize label').html($('.userSkiBootSize label').html()+' *')
                    isRequired('SkiSize') &&   $('.userSkiSize label').html($('.userSkiSize label').html()+' *')
                    isRequired('Weight') &&    $('.userWeight label').html($('.userWeight label').html()+' *')
                    isRequired('Height') &&   $('.userHeight label').html($('.userHeight label').html()+' *')
                    isRequired('SkierType') &&   $('.userSkierType label').html($('.userSkierType label').html()+' *')
                    isRequired('SkiCustomerType') &&    $('.userCustomerType label').html($('.userCustomerType label').html()+' *')
                    isRequired('Age') &&   $('.userAge label').html($('.userAge label').html()+' *')
                    isRequired('SnowboardSize') &&   $('.userSnowboardSize label').html($('.userSnowboardSize label').html()+' *')
                    isRequired('SnowboardBootSize') &&   $('.userSnowboardBootSize label').html($('.userSnowboardBootSize label').html()+' *')
                    isRequired('DinNumber') &&   $('.userDinNumber label').html($('.userDinNumber label').html()+' *')
                }
                // this comes from app.customization.auth.requiredFieldsBeforeCheckout
                var defaultRequiredFields = ['Salutation', 'Gender', 'Phone'];
                var checkWhichFieldsNotRequired = [];
                // Add asterisk for auth required fields 
                if(app.customization.auth.requiredFieldsBeforeCheckout && app.customization.auth.requiredFieldsBeforeCheckout.length){
                    _.each(app.customization.auth.requiredFieldsBeforeCheckout, function(field){
                        if(field.field == 'DateOfBirth'){
                            $('.userDOB label').html($('.userDOB label').html()+' *');
                        } else if(field.field == 'Address'){
                            $('.userHomeAddress1 label').html($('.userHomeAddress1 label').html()+' *');
                        }
                    })
                }
                _.each(defaultRequiredFields, function(field){
                    if(!_.some(app.customization.auth.requiredFieldsBeforeCheckout, function(o) { return o.field == field })){
                        checkWhichFieldsNotRequired.push(field);
                    }
                })
                if(checkWhichFieldsNotRequired.length){
                    _.each(checkWhichFieldsNotRequired, function(field){
                        if(field == 'Salutation'){
                            $('.userSalutation label').html($('.userSalutation label').html().replace(' *', ''));
                            $('select#userSalutation').removeClass('required').removeClass('error');
                        } else if(field == 'Gender'){
                            $('.userGender label').html($('.userGender label').html().replace(' *', ''));
                            $('select#userGender').removeClass('required').removeClass('error');
                        } else if(field == 'Phone'){
                            $('.phoneSectTitle strong').html($('.phoneSectTitle strong').html().replace(' *', ''));
                        }
                    })
                }
                // Contact log buttons click events
                $('#userProfileForm > div.well.update-contact-logs .accordion-group').each(function(){
                    // edit button
                    var thisContactLogSection = $(this);
                    function attachHandlers(isNewNote) {
                        function sanitize(string) {
                            var map = {
                                '&': '&amp;',
                                '<': '&lt;',
                                '>': '&gt;',
                                '"': '&quot;',
                                "'": '&#x27;',
                                "/": '&#x2F;',
                            };
                            var reg = /[&<>"'/]/ig;
                            return string.replace(reg, function(match) {return map[match]});
                          }
                        thisContactLogSection.find('.log-note').each(function(){
                            //delete btn
                            var logNote =  $(this);
                            var inputField = logNote.find('.input-log>textarea,.input-log>input');
                            logNote.find('.clear-contact-log').click(function(e){
                                e.preventDefault();
                                inputField.addClass('edited');
                                inputField.attr({type: 'hidden', "aria-hidden": true, value: '' });
                                inputField.val('');
                                logNote.hide();
                            });
                            //edit btn
                            logNote.find('.edit-contact-log').click(function(e){
                                e.preventDefault();
                                inputField.parent().removeClass('hide');
                                $(this).addClass('hide')
                            });
                            //save btn
                            logNote.find('.save-log').click(function(e){
                                e.preventDefault();
                                if(!inputField.hasClass('error')){
                                    inputField.parent().addClass('hide');
                                    logNote.find('.edit-contact-log').removeClass('hide');
                                }
                            });
                            if(!isNewNote){
                                logNote.find('.notes').html(sanitize(inputField.val()).replace(/(\r\n|\n|\r|%0A)/gm, '<br>').replace(/(%20)/gm, ' '));
                            }
                            inputField.change(function(){
                                if(!inputField.hasClass('error')){
                                    inputField.addClass('edited');
                                    logNote.find('.notes').html(sanitize($(this).val()).replace(/(\r\n|\n|\r|%0A)/gm, '<br>').replace(/(%20)/gm, ' '));
                                }
                            })
                        })
                    }
                    //adds new field
                    thisContactLogSection.find('.add-contact-log').click(function(e){
                        e.preventDefault();

                        var logType = thisContactLogSection.find('.accordion-inner').attr('log-type');
                        var logCustomization = app.customization.visibleContactLogs[logType];
            
                        var type = logCustomization && logCustomization.type ? logCustomization.type : 'text';
                        var tag = logCustomization && logCustomization.tag ? logCustomization.tag : 'input';
                        var input = '';
                        if(tag === 'textarea'){
                            input = '<textarea class="input-log new" value="" log-type="'+logType+'"></textarea>';
                        } else {
                            input = '<input type="'+type+'" class="input-log new" value="" log-type="'+logType+'">';
                        }
                        thisContactLogSection.find('.accordion-inner').append('<div class="log-note controls" guest-option=""><div><div class="cl-btns"><button class="clear-contact-log"><i class="icon-trash"></i></button><button class="edit-contact-log hide"><i class="icon-pencil"></i></button></div><div class="notes">'+app.localization.visibleContactLogs.newField+'</div><div class="input-log">'+input+'<button class="save-log"><i class="icon-ok-circle"></i></button></div></div></div>');

                        //auto expand if collapsed
                        if(!thisContactLogSection.find('.accordion-body').hasClass('in')){
                            $(this).prev().click();
                        };                      
                        attachHandlers(true);
                    });
                    attachHandlers();
                })

                $('#userProfileSubmit').on('click', function (obj) {
                    obj.preventDefault();
                    if ($('#userProfileForm').valid()) {
                        $('#progressIndicator').modal('show');
                        // Gets all the contactlogs
                        var contactLogs = [];
                        $('#userProfileForm > div.well.update-contact-logs input, #userProfileForm > div.well.update-contact-logs textarea').each(function(){
                            var contactLog = {};
                            contactLog.name = $(this).attr('log-type');
                            contactLog.id = $(this).attr('id');
                            var isEdited = $(this).hasClass('edited');
                            var hasError = $(this).hasClass('error');
                            var isNew = $(this).hasClass('new');
                            //update only when edited and has no error
                            if(isEdited && !hasError){
                                if(isNew && !$(this).val()){
                                    return;
                                }
                                contactLog.value = $(this).val();
                                contactLogs.push(contactLog);
                            };
                        });
                        app.datal('updatedContactLogs', contactLogs);
                        // dispatch to submit all updated details
                        app.dispatcher.dispatch('profile', 'detailssubmit', [
                            encodeURIComponent($('#userEmail1').val() || ""),
                            encodeURIComponent($('#userPassword1').val() || ""),
                            encodeURIComponent($('#userGender').val() || ''),
                            encodeURIComponent($('#userSalutation').val() || ''),
                            encodeURIComponent($('#userFirstName').val() || ''),
                            encodeURIComponent($('#userLastName').val() || ''),
                            $('#userMainPhoneH').hasClass('active') ? "H" :
                                $('#userMainPhoneW').hasClass('active') ? "W" :
                                    $('#userMainPhoneO').hasClass('active') ? "O" :
                                        $('#userMainPhoneM').hasClass('active') ? "M" : "",
                            encodeURIComponent($('#userHomePhone').val() || ''),
                            encodeURIComponent($('#userWorkPhone').val() || ''),
                            encodeURIComponent($('#userWorkExt').val() || ''),
                            encodeURIComponent($('#userOtherPhone').val() || ''),
                            encodeURIComponent($('#userMobilePhone').val() || ''),
                            encodeURIComponent($('#userHomeAddress1').val() || ''),
                            encodeURIComponent($('#userHomeAddress2').val() || ''),
                            encodeURIComponent($('#userHomeCity').val() || ''),
                            encodeURIComponent($('#userHomeProvince').val() || ''),
                            encodeURIComponent($('#userHomeCountry').val() || ''),
                            encodeURIComponent($('#userHomePostalCode').val() || ''),
                            encodeURIComponent($('#userOtherAddress1').val() || ''),
                            encodeURIComponent($('#userOtherAddress2').val() || ''),
                            encodeURIComponent($('#userOtherCity').val() || ''),
                            encodeURIComponent($('#userOtherProvince').val() || ''),
                            encodeURIComponent($('#userOtherCountry').val() || ''),
                            encodeURIComponent($('#userOtherPostalCode').val() || ''),
                            $('#newsletter').prop('checked') ? "1" : "0",
                            $('#mailmarketing').prop('checked') ? "1" : "0",
                            $('#phonemarketing').prop('checked') ? "1" : "0",
                            $('#smsmarketing').prop('checked') ? "1" : "0",
                            $('#userLanguageen-us').hasClass('active') ? "en-us" :
                                $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                                    $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                                        $('#userLanguagees-sp').hasClass('active') ? "es-sp" : "",
                            encodeURIComponent($('#userClubAddress').val() || ''),
                            $('#userClubMemberList').prop('checked') ? "1" : "0",
                            encodeURIComponent($('#userClubListPhone').val() || ''),
                            $('#userClubListEmail').prop('checked') ? "1" : "0",
                            encodeURIComponent($('#userSkiSize').val() || ''),
                            encodeURIComponent($('#userSkiBootSize').val() || ''),
                            encodeURIComponent($('#userSkierType').val() || ''),
                            encodeURIComponent($('#userCustomerType').val() || ''),
                            encodeURIComponent($('#userSnowboardSize').val() || ''),
                            encodeURIComponent($('#userSnowboardBootSize').val() || ''),
                            encodeURIComponent($('#userDinNumber').val() || ''),
                            encodeURIComponent($('#userAge').val() || ''),
                            encodeURIComponent($('#userWeight').val() || ''),
                            encodeURIComponent($('#userHeight').val() || ''),
                            encodeURIComponent($('#userDOB').val() || ''),
                            encodeURIComponent($('#userCustomerId').val()),
                            proceedToCheckout
                        ]);
                        
                    } else {
                        $('html, body').animate({
                            scrollTop: $("label.error:visible").offset().top - 70
                        }, 300);
                    }
                })

              
         
                $('#userProfileForm').validate({
                    rules: {
                        userPassword1: {
                            minlength: 8
                        },
                        userPassword2: {
                            equalTo: "#userPassword1"
                        },
                        userDOBhuman:{
                            required: app.customization.auth.requiredFieldsBeforeCheckout && _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'DateOfBirth' }),
                        },
                        userHomeAddress1: {
                            required: app.customization.auth.requiredFieldsBeforeCheckout && _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Address' }),
                        },
                        userHomePhone: {
                            required: function (e) {
                                return _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Phone' }) && $('#userMainPhoneH').hasClass('active');
                            }
                        },
                        userWorkPhone: {
                            required: function (e) {
                                return _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Phone' }) && $('#userMainPhoneW').hasClass('active');
                            }
                        },
                        userOtherPhone: {
                            required: function (e) {
                                return  _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Phone' }) && $('#userMainPhoneO').hasClass('active');
                            }
                        },
                        userMobilePhone: {
                            required: function (e) {
                                return  _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Phone' }) && $('#userMainPhoneM').hasClass('active');
                            }
                        },
                        userHomeProvince: {
                            required: function (e) {
                                return  _.some(app.customization.auth.requiredFieldsBeforeCheckout, function(field){ return field.field  == 'Address' }) && $('#userHomeCountry').val() == "CA" || $('#userHomeCountry').val() == "US" && app.customization.requireAddress;
                            }
                        },
                        userSkiBootSize:{
                            required: skiInCartLoopPerGuest && isRequired('SkiBootSize')
                        },
                        userSkiSize:{
                            required: skiInCartLoopPerGuest && isRequired('SkiSize')
                        },
                        userWeight:{
                            required: skiInCartLoopPerGuest && isRequired('Weight')
                        },
                        userHeight:{
                            required: skiInCartLoopPerGuest && isRequired('Height')
                        },
                        userSkierType:{
                            required: skiInCartLoopPerGuest && isRequired('SkierType')
                        },
                        userCustomerType:{
                            required: skiInCartLoopPerGuest && isRequired('SkiCustomerType')
                        },
                        userAge:{
                            required: skiInCartLoopPerGuest &&  isRequired('Age')
                        },
                        userSnowboardSize:{
                            required: skiInCartLoopPerGuest &&  isRequired('SnowboardSize')
                        },
                        userSnowboardBootSize:{
                            required: skiInCartLoopPerGuest &&  isRequired('SnowboardBootSize')
                        },
                        userDinNumber:{
                            required: skiInCartLoopPerGuest   &&  isRequired('DinNumber')
                        }
                        
                    },
                });

                var clearDOBifEmpty = function () {
                    if ($(this).val() == "") {
                        $('#userDOB').val('')
                    }
                }
                $('#userDOBhuman')
                    .datepicker({
                        altField: '#userDOB',
                        altFormat: 'yy-mm-dd',
                        dateFormat: 'yy-mm-dd',
                        minDate: "-120y",
                        maxDate: "-1d",
                        yearRange: "-120:+0",
                        numberOfMonths: 1,
                        showMonthAfterYear: true,
                        changeMonth: true,
                        changeYear: true,
                        onClose: clearDOBifEmpty
                    })
                    .datepicker('setDate', $('#userDOB').val())
                    .datepicker('option', 'dateFormat', app.localization.newUser.dobFormat)
                    .on('blur', clearDOBifEmpty)
            },
            cardOnFile: function (userData, groupMemberId) {
                app.data.loadedPayEngineIframeOnProfile = false
                app.models.systemModel.fetchSystemState()
                    .done(function (r_fss) {
                        if (r_fss.Configuration.AllowStoreCard == "Y" && Customization.payment.allowedPayEnginesForUpdatingOnFileToken.indexOf(r_fss.Configuration.PayEngine) > -1 && !groupMemberId) {
                            if (userData.OnFileCards && userData.OnFileCards.OnFileCard)     renderOnFileCredit() 
                            else{
                                $('.credit-card-parent strong').html(app.localization.paymentProcessing.noCreditCardOnfile + " ")
                                $('#updateOnFileToken span').html(app.localization.paymentProcessing.addCreditCard)
                            }
                            
                            $('.cancelUpdateOnFileToken').on('click',function(){
                                if(r_fss.Configuration.PayEngine == "I4")  $('.credit-card-parent .i4gospecificinstruction').remove()
                                toggleSavedCardDOM(r_fss.Configuration.PayEngine,false,userData)
                            })
                            $('.deleteOnFileToken').on('click',function(){ deleteCreditCardOnFile() })
                            $('.updateOnFileToken').on('click',function(){ 
                                console.log("3666",r_fss)
                                if(r_fss.Configuration.PayEngine == "I4"){
                                    $('<p class="i4gospecificinstruction" </p>').text(app.localization.paymentProcessing.i4GoUpdateCardOnFileSpecific).insertAfter('.credit-card-parent h4')
                                }
                                renderPaymentEngine(r_fss)
                                
                            })
                        } else   $('.update_creditcard_tab').addClass('hide')
                    })
                function throwPayEngineLoadFailMsg(title) {
                    app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-error',
                        actions: [],
                        title: title,
                        message: ''
                    });
                    app.dispatcher.replace('profile', 'details', []);
                }
                function deleteCreditCardOnFile() {
                    $('#progressIndicator').modal('show');
                    var param = {
                        "Customer.CustomerId": app.data.CustomerId,
                        "Customer.CustomerGUID": app.data.CustomerGUID,
                        "Customer.RemoveOnFileCard": "Y"
                    }
                    $.when(app.models.systemModel.getData('updateCustomerProfile', param))
                        .done(function (r_fb) {
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-success',
                                actions: [],
                                title: app.localization.paymentProcessing.SuccessOnFileTokenDeleteTitle,
                                message: ''
                            });   
                            app.dispatcher.replace('profile', 'details', []);
                        }).fail(function (r_fb) {
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-error',
                                actions: [],
                                title: r_fb.Result.Text,
                                message: ''
                            });
                            app.commonViewHelper.showMessages();
                        }).always(function () {
                            $('#progressIndicator').modal('hide');
                          
                        })
                }

                function renderPaymentEngine(payEngineDetails) {

                     //Hide saved card 
                     var hideCard = true
                     toggleSavedCardDOM(payEngineDetails.Configuration.PayEngine,hideCard)


                    if (app.data.loadedPayEngineIframeOnProfile) {
                        return
                    }
                    //Add loader --
                    // check if loader is already added
                    if ($('.LoaderBalls').length > 0) {
                        return
                    } else {
                        var fetchingTextDOM = $('<p class="loading-text-eventscalendar"></p>').html("Loading Payment Engine")
                        $('.onfileCreditCart').append(' <div class="LoaderBalls"> <div class="LoaderBalls__item"></div> <div class="LoaderBalls__item"></div><div class="LoaderBalls__item"></div></div>')
                        $('.LoaderBalls').append(fetchingTextDOM)
                    }
                    
                    var params = {CreateToken: 'Y'},
                    errorMessageTitle = app.localization.paymentProcessing.onFileTokenUpdateError
                    payEngineDetails.Configuration.PayEngine == "FP" ? params['ThirdPartyPayEngine'] = 'Google' : ''
                    $.when(app.models.systemModel.getData('setCheckout', params))
                        .done(function (r_sc) {

                            var errorCheck = app.commonViewHelper.processCardOnFile(r_sc);
                            if (errorCheck === false) {
                                throwPayEngineLoadFailMsg(errorMessageTitle)
                                return
                            }
                        })
                        .fail(function (r_sc) {
                            if ((r_sc.Result.Text == "Invalid address: Address 1/Street is required.") || (r_sc.Result.Text == "Invalid address: City is required")) {
                                throwPayEngineLoadFailMsg(app.localization.paymentProcessing.PPPostAddressRequired)
                            } else throwPayEngineLoadFailMsg(errorMessageTitle)
                        });
                }
                function renderOnFileCredit() {
                    var onfileCardDOM = $('.onfileCreditCart .credit-card ')
                    onfileCardDOM.removeClass('hide')
                    app.customization.payment.allowOnFileCreditCardRemoval ? $('.deleteOnFileToken').removeClass('hide'): ''
                    var cardOnFile = userData.OnFileCards.OnFileCard
                    switch (cardOnFile.CardType) {
                        case 'VISA':
                            onfileCardDOM.addClass('visa')
                            break;
                        case "M/C":
                            onfileCardDOM.addClass('mastercard')
                            break;
                        default:
                    }
                    var expiry = cardOnFile.CardExpiryDate.slice(0, cardOnFile.CardExpiryDate.length - 2) + '/' + cardOnFile.CardExpiryDate.slice(cardOnFile.CardExpiryDate.length - 2 + Math.abs(0));
                    onfileCardDOM.find('.credit-card-expiry').html(xmlEscape(expiry))
                    onfileCardDOM.find('.credit-card-person').html(xmlEscape(cardOnFile.CardHolderName))
                    onfileCardDOM.find('.credit-card-last4').html(xmlEscape(cardOnFile.LastFourDigits))
                }

                function toggleSavedCardDOM(paymentEngine,state,userData) {
                    if (state == false ) {
                        $('.updateOnFileToken,.credit-card-parent .credit-card').removeClass('hide')
                        userData.OnFileCards && userData.OnFileCards.OnFileCard && app.customization.payment.allowOnFileCreditCardRemoval? $(' .deleteOnFileToken').removeClass('hide'):''
                        $('.credit-card-parent .cancelUpdateOnFileToken,.CreditCardIframes').addClass('hide')
                    } else {
                        $('.credit-card-parent .credit-card,.credit-card-parent .updateOnFileToken,.deleteOnFileToken').addClass('hide')
                        $('.credit-card-parent .cancelUpdateOnFileToken').removeClass('hide')
                        app.data.loadedPayEngineIframeOnProfile ? $('.CreditCardIframes').removeClass('hide') : ''
                    }
                   // if(userData.OnFileCards.OnFileCard.)
                   if(state && paymentEngine == "FP")
                    $( " .fpNameFieldParent" ).removeClass( 'hide')
                   else   $( " .fpNameFieldParent" ).addClass( 'hide')
                }
            },
            processCardOnFile: function(r_sc) {
                var updatingOnFileCard = true
                var paymentEngines = ['I4GO', 'WPAY', 'FREEDOMPAY', '3C']
                if(!r_sc.ForwardURL || paymentEngines.indexOf(r_sc.PaymentEngine) == -1 || (r_sc.PaymentEngine == 'I4GO' && !r_sc.AccessBlock )) {
                    return false
                }

                if (r_sc.PaymentEngine == "I4GO") {
                    app.commonViewHelper.redirectI4G(r_sc.ForwardURL, r_sc.AccessBlock, updatingOnFileCard);
                } else if (r_sc.PaymentEngine == "WPAY") {
                    app.commonViewHelper.redirectWP(r_sc.ForwardURL, r_sc.WPCustomerId, r_sc.AllowStoreCard, updatingOnFileCard);
                } else if (r_sc.PaymentEngine == "FREEDOMPAY") {
                    app.commonViewHelper.redirectFP(r_sc.ForwardURL, r_sc.AllowStoreCard, r_sc.PaymentAmount, r_sc.ThreeDSEnabled, r_sc.ApplePayEnabled, r_sc.GooglePayEnabled, r_sc.SamsungPayEnabled, r_sc.PayPalEnabled,updatingOnFileCard);
                } else if(r_sc.PaymentEngine == "3C"){
                    app.commonViewHelper.redirect3C(r_sc.ForwardURL, r_sc.AllowStoreCard, r_sc.PaymentAmount, r_sc.ThreeDSEnabled, r_sc.ThreeCSession, updatingOnFileCard);
                }

            },
            prepCreateUserForm: function (type) {
                $('#userMainPhone .btn, #userLanguage .btn').on('click', function (obj) {
                    $('#userCreateUserForm').validate();
                    obj.preventDefault();
                })
                $('#userAddressType .btn').on('click', function (obj) {
                    obj.preventDefault();
                })
                $('#userCreateCancel').on('click', function (obj) {
                    if (app.data.loginNextURL) {
                        obj.preventDefault();
                        app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                        app.data.loginNextURL = undefined;
                    } else {
                        obj.target.href += "/profile"
                    }
                })
                $('#userEmail1').on('change', function (obj) {
                    $('#userEmail1').attr('data-isChecked', 'false');
                    $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: $('#userEmail1').val() }))
                        .done(function (r_ce) {
                            $('#userEmail1').attr('data-isChecked', 'true');
                            $('#userEmail1').attr('data-exists', 'false');
                            $('#userEmail1').valid();
                            //                        $('.alert-hide').alert('close');
                        })
                        .fail(function (r_ce) {
                            $('#userEmail1').attr('data-isChecked', 'true');
                            $('#userEmail1').attr('data-exists', 'true');
                            $('#userEmail1').valid();
                            //console.log('email exists')
                            /* app.data.messages.push({ type:'alert', class:'alert-info', actions:[],
                                 title:"You already have an account in this system. Log in or Reset your password to continue."//,
                                 //message:"(" + r_cc.Result.Text + ")"
                             });
                             app.dispatcher.dispatch('profile','login',[$('#userEmail1').val()])*/
                            //                        $('.alert-hide').alert('close');
                            //                        app.commonViewHelper.showMessage({type:'alert', class:'alert-error alert-hide', title:app.localization.general.err.emailErrExist })
                        })

                });

                $('#userCreateSubmit').on('click', function (obj) {
                    obj.preventDefault();

                    if ($('#userCreateUserForm').valid()) {
                        $('#progressIndicator').modal('show');
                        // Gathers all contact logs
                        var contactLogs = [];
                        $('#userCreateUserForm > div.well.edit-contact-logs input').each(function(){
                        var contactLog = {};
                        contactLog.name = $(this).attr('log-type');
                        contactLog.id = $(this).attr('id');
                        var hasError = $(this).hasClass('error');
                        if(!hasError){
                            contactLog.value = encodeURIComponent($(this).val() || '');
                            contactLogs.push(contactLog);
                        }
                        });
                        var stringifiedContactLogs = JSON.stringify(contactLogs);
                        app.dispatcher.dispatch('profile', (type == 'member' ? 'membercreatesubmit' : 'createsubmit'), [
                            encodeURIComponent($('#userEmail1').val() || ""),
                            encodeURIComponent($('#userPassword1').val() || ""),
                            encodeURIComponent($('#userGender').val() || ''),
                            encodeURIComponent($('#userSalutation').val() || ''),
                            encodeURIComponent($('#userFirstName').val() || ''),
                            encodeURIComponent($('#userLastName').val() || ''),
                            $('#userMainPhoneH').hasClass('active') ? "H" :
                                $('#userMainPhoneW').hasClass('active') ? "W" :
                                    $('#userMainPhoneO').hasClass('active') ? "O" : "",
                            encodeURIComponent($('#userHomePhone').val() || ''),
                            encodeURIComponent($('#userWorkPhone').val() || ''),
                            encodeURIComponent($('#userWorkExt').val() || ''),
                            encodeURIComponent($('#userOtherPhone').val() || ''),
                            encodeURIComponent($('#userMobilePhone').val() || ''),
                            encodeURIComponent($('#userHomeAddress1').val() || ''),
                            encodeURIComponent($('#userHomeAddress2').val() || ''),
                            encodeURIComponent($('#userHomeCity').val() || ''),
                            encodeURIComponent($('#userHomeProvince').val() || ''),
                            encodeURIComponent($('#userHomeCountry').val() || ''),
                            encodeURIComponent($('#userHomePostalCode').val() || ''),
                            encodeURIComponent($('#userOtherAddress1').val() || ''),
                            encodeURIComponent($('#userOtherAddress2').val() || ''),
                            encodeURIComponent($('#userOtherCity').val() || ''),
                            encodeURIComponent($('#userOtherProvince').val() || ''),
                            encodeURIComponent($('#userOtherCountry').val() || ''),
                            encodeURIComponent($('#userOtherPostalCode').val() || ''),
                            $('#newsletter').prop('checked') ? "1" : "0",
                            $('#mailmarketing').prop('checked') ? "1" : "0",
                            $('#phonemarketing').prop('checked') ? "1" : "0",
                            $('#smsmarketing').prop('checked') ? "1" : "0",
                            $('#userLanguageen-us').hasClass('active') ? "en-us" :
                                $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                                    $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                                        $('#userLanguagees-sp').hasClass('active') ? "es-sp" : "",
                            '',
                            '','','',
                            encodeURIComponent($('#userSkiSize').val() || ''),
                            encodeURIComponent($('#userSkiBootSize').val() || ''),
                            encodeURIComponent($('#userSkierType').val() || ''),
                            encodeURIComponent($('#userCustomerType').val() || ''),
                            encodeURIComponent($('#userSnowboardSize').val() || ''),
                            encodeURIComponent($('#userSnowboardBootSize').val() || ''),
                            encodeURIComponent($('#userDinNumber').val() || ''),
                            encodeURIComponent($('#userAge').val() || ''),
                            encodeURIComponent($('#userWeight').val() || ''),
                            encodeURIComponent($('#userHeight').val() || ''),
                            encodeURIComponent($('#userDOB').val() || ''),
                            stringifiedContactLogs
                        ]);
                    } else {
                        $('html, body').animate({
                            scrollTop: $("label.error:visible").offset().top - 70
                        }, 300);
                    }
                })
                 // Password strength logic --Start 
                 $('#userPassword1').on('keyup', function () {
                    var password = $(this).val();
                    if (app.data.minPasswordStrength < 5) {
                        if (password == '') {
                            $('.passwordComplexityUI').css('display', 'none')
                        } else {
                            $("label[for='userNewPassword1']").remove() // default error like field is required is taking up the empty space
                            $('.passwordComplexityUI').css('display', 'block')
                        }
                        app.commonViewHelper.performPasswordComplexityCheck(password).then(function(score){
                            currentPasswordComplexity = score;
                        })
                    }  
                });
            // Password strength logic --Start
                jQuery.validator.addMethod(
                    "emailExists",
                    function (value, element) {
                        var retval = ($(element).attr('data-isChecked') == 'false' || $(element).attr('data-exists') == 'false');

                        return this.optional(element) || retval;
                    },
                    app.localization.general.err.emailErrExist + (app.customization.disablePasswordReset ? '' : '<a class="btn btn-mini" href="#/profile/reset/' + encodeURIComponent($('#userEmail1').val()) + '">' + Localization.general.login.forgotPasswordButtonLabel + '</a>')
                );
                 //part of password complexity feature -- start
                 var currentPasswordComplexity = 0, // initial value is 0 as user has not begun typing
                 minlengthErrorMessage = app.data.minPasswordStrength == 5 ? "Please enter at least 8 characters." : '';
                 jQuery.validator.addMethod("PasswordComplexityOrMinCharCheck", function (value, element) {
                     return app.data.minPasswordStrength == 5 ? value.length >= 8 : currentPasswordComplexity >= app.data.minPasswordStrength
                 }, minlengthErrorMessage);
                $('#userCreateUserForm').validate({
                    rules: {
                        userPassword1: {
                            PasswordComplexityOrMinCharCheck:true
                        },
                        userEmail1: {
                            emailExists: "#userEmail1"
                        },
                        userEmail2: {
                            equalTo: "#userEmail1"
                        },
                        userPassword2: {
                            equalTo: "#userPassword1"
                        },
                        userHomePhone: {
                            required: function (e) {
                                return $('#userMainPhoneH').hasClass('active');
                            }
                        },
                        userWorkPhone: {
                            required: function (e) {
                                return $('#userMainPhoneW').hasClass('active');
                            }
                        },
                        userOtherPhone: {
                            required: function (e) {
                                return $('#userMainPhoneO').hasClass('active');
                            }
                        },
                        userHomeProvince: {
                            required: function (e) {
                                return $('#userHomeCountry').val() == "CA" || $('#userHomeCountry').val() == "US" && app.customization.requireAddress;
                            }
                        },
                        userAge: {
                            maxlength: 3
                        },
                        userSkiBootSize: {
                            maxlength: 3
                        },
                        userSnowboardBootSize: {
                            maxlength: 3
                        },
                        userDinNumber: {
                            maxlength: 5
                        }

                    }
                });
                var clearDOBifEmpty = function () {
                    if ($(this).val() == "") {
                        $('#userDOB').val('')
                    }
                }
                $('#userDOBhuman')
                    .datepicker({
                        altField: '#userDOB',
                        altFormat: 'yy-mm-dd',
                        dateFormat: 'yy-mm-dd',
                        minDate: "-120y",
                        maxDate: "-1d",
                        yearRange: "-120:+0",
                        numberOfMonths: 1,
                        showMonthAfterYear: true,
                        changeMonth: true,
                        changeYear: true,
                        onClose: clearDOBifEmpty
                    })
                    .datepicker('setDate', $('#userDOB').val())
                    .datepicker('option', 'dateFormat', app.localization.newUser.dobFormat)
                    .on('blur', clearDOBifEmpty)

            },
            prepChangePasswordForm: function (eventName, oldPassword, conflictsRemoved) {
                //part of password complexity feature -- start
                var currentPasswordComplexity = 0, // initial value is 0 as user has not begun typing
                minlengthErrorMessage = app.data.minPasswordStrength == 5 ? "Please enter at least 8 characters." : '';
                jQuery.validator.addMethod("PasswordComplexityOrMinCharCheck", function (value, element) {
                    return app.data.minPasswordStrength == 5 ? value.length >= 8 : currentPasswordComplexity >= app.data.minPasswordStrength
                }, minlengthErrorMessage);
                //part of password complexity feature --end
                var validateOnChange = function () {
                    $('#userChangePasswordForm').validate({
                        rules: {
                            userNewPassword1: {
                                PasswordComplexityOrMinCharCheck: true,
                            },
                            userNewPassword2: {
                                equalTo: "#userNewPassword1"
                            }
                        }
                    });
                    if ($('#userChangePasswordForm').valid()) {
                        $('#userChangeSubmit').addClass('btn-primary').removeClass('disabled');
                    } else {
                        $('#userChangeSubmit').removeClass('btn-primary').addClass('disabled');
                    }
                }
                $('#userChangePasswordForm .required').on('change', validateOnChange);
                $('#userChangePasswordForm .required').on('keyup', validateOnChange);
                $('#userChangeCancel').on('click', function (obj) {
                    if (conflictsRemoved != 'Y') {
                        obj.target.href += "/profile"
                    } else {
                        obj.preventDefault();
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: Localization.general.conflictingSpaBookingRemovedTitle,
                            message: Localization.general.conflictingSpaBookingRemoved
                        });
                        app.dispatcher.redirect('summary', 'show', []);
                    }
                }
                )
                if (window.location.href.indexOf("#/profile/resetpassword") >= 0) {
                    $('#userOldPassword').parents('div.control-group:first').css('display', 'none');
                }
                $('#userOldPassword').val(oldPassword);
                $('#userEmailAddress').val(app.data.CustomerEmail || '');
                $('#userEmailAddress').on('change', function (obj) {
                    $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: $('#userEmailAddress').val() }))
                        .done(function (r_ce) {
                            obj.preventDefault();
                            $('.alert-hide').alert('close');
                            app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.err.emailErrNotExist })
                        })
                        .fail(function (r_ce) {
                            $('.alert-hide').alert('close');
                        })

                });
                
                
        // Password strength logic --Start 
          
            $('#userNewPassword1').on('keyup', function () {
                var password = $(this).val();
                if (app.data.minPasswordStrength < 5) {
                    if (password == '') {
                        $('.passwordComplexityUI').css('display', 'none')
                    } else {
                        $("label[for='userNewPassword1']").remove() // default error like field is required is taking up the empty space
                        $('.passwordComplexityUI').css('display', 'block')
                    }
                    app.commonViewHelper.performPasswordComplexityCheck(password).then(function(score){
                        currentPasswordComplexity = score;
                    })
                }  
            });
        // Password strength logic --end 
            $('#userChangeSubmit').on('click', function (obj) {
                    obj.preventDefault();
                    if (app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio) {
                        $('#userChangePasswordForm > div > div > ')
                    } else {
                        if ($('#userOldPassword').val().length < 8 && app.data.minPasswordStrength == 5) {
                            $('.alert-hide').alert('close');
                            app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.login.changePassword.err.min8chars })
                            return;
                        }
                    }
                    if ( app.data.minPasswordStrength == 5 && (($('#userNewPassword1').val().length < 8)  || ($('#userNewPassword2').val().length < 8))) {
                        $('.alert-hide').alert('close');
                        app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.login.changePassword.err.min8chars })
                        return;
                    }
                    if ($('#userNewPassword1').val() != $('#userNewPassword2').val()) {
                        $('.alert-hide').alert('close');
                        app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.login.changePassword.err.passwordsDoNotMatch })
                        return;
                    }
                    if ($('#userChangePasswordForm').valid()) {
                        $('#progressIndicator').modal('show')
                        $('.alert.hide').alert('close');
                        if (app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio) {
                            app.dispatcher.dispatch('profile', 'createpassword', [$("#userEmailAddress").val(), $("#userOldPassword").val(), $("#userNewPassword1").val(), eventName, conflictsRemoved]);
                        } else {
                            app.dispatcher.dispatch('profile', 'dochange', [$("#userEmailAddress").val(), $("#userOldPassword").val(), $("#userNewPassword1").val(), eventName, conflictsRemoved]);
                        }
                    } else {
                        return false;
                    }
                }
                )
            },
            prepResetPasswordSubmit: function(email, passwordGuid) {
                //part of password complexity feature -- start
                var currentPasswordComplexity = 0, // initial value is 0 as user has not begun typing
                minlengthErrorMessage = app.data.minPasswordStrength == 5 ? "Please enter at least 8 characters." : '';
                jQuery.validator.addMethod("PasswordComplexityOrMinCharCheck", function (value, element) {
                    return app.data.minPasswordStrength == 5 ? value.length >= 8 : currentPasswordComplexity >= app.data.minPasswordStrength
                }, minlengthErrorMessage);
                //part of password complexity feature --end

                var validateOnChange = function () {
                    $('#userChangePasswordForm').validate({
                        rules: {
                            userNewPassword1: {
                                PasswordComplexityOrMinCharCheck: true,
                            },
                            userNewPassword2: {
                                equalTo: "#userNewPassword1"
                            }
                        }
                    });
                    if ($('#userChangePasswordForm').valid()) {
                        $('#userChangeSubmit').addClass('btn-primary').removeClass('disabled');
                    } else {
                        $('#userChangeSubmit').removeClass('btn-primary').addClass('disabled');
                    }
                }

                $('#userChangePasswordForm .required').on('change', validateOnChange);
                $('#userChangePasswordForm .required').on('keyup', validateOnChange);
                $('#userChangeCancel').on('click', function (obj) {
                        obj.target.href += "/profile"
                })
                // Removing old password field from change password form
                $('#userOldPassword').parents('div.control-group:first').remove();
                
                $('#userChangeSubmit').html(app.localization.general.login.passwordReset.buttonTitle);
                $('#userChangePasswordForm > div:nth-child(1) > p > strong').html(app.localization.general.login.passwordReset.titleForForm)
                $('#userEmailAddress').val(email || app.data.CustomerEmail);
                
                //Check email on change
                $('#userEmailAddress').on('change', function (obj) {
                    $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: $('#userEmailAddress').val() }))
                        .done(function (r_ce) {
                            obj.preventDefault();
                            $('.alert-hide').alert('close');
                            app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.err.emailErrNotExist })
                        })
                        .fail(function (r_ce) {
                            $('.alert-hide').alert('close');
                        })
                });
                    
                    
                // Password strength logic --Start 
                $('#userNewPassword1').on('keyup', function () {
                    var password = $(this).val();
                    if (app.data.minPasswordStrength < 5) {
                        if (password == '') {
                            $('.passwordComplexityUI').css('display', 'none')
                        } else {
                            $("label[for='userNewPassword1']").remove() // default error like field is required is taking up the empty space
                            $('.passwordComplexityUI').css('display', 'block')
                        }
                        app.commonViewHelper.performPasswordComplexityCheck(password).then(function(score){
                            currentPasswordComplexity = score;
                        })
                    }  
                });
                // Password strength logic --end 

                // Click handler for reset button
                $('#userChangeSubmit').on('click', function (e) {
                    e.preventDefault();
                    if ( app.data.minPasswordStrength == 5 && (($('#userNewPassword1').val().length < 8)  || ($('#userNewPassword2').val().length < 8))) {
                        $('.alert-hide').alert('close');
                        app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.login.changePassword.err.min8chars })
                        return;
                        }
                        if ($('#userNewPassword1').val() != $('#userNewPassword2').val()) {
                            $('.alert-hide').alert('close');
                            app.commonViewHelper.showMessage({ type: 'alert', 'class': 'alert-error alert-hide', title: app.localization.general.login.changePassword.err.passwordsDoNotMatch })
                            return;
                        }
                        
                        if ($('#userChangePasswordForm').valid()) {
                            $('.alert.hide').alert('close');
                            // if (app.data.folioLoginHasPassword == "N" && app.data.RestrictedFolio) - TODO: verify and wrap this whole when block if required
                            
                            // reset password, redirect and authenticate
                            //Second call of resetPasswordCustomer with the password
                            $.when(app.models.userModel.getData('resetPasswordCustomer', { EmailAddress: (email || app.data.CustomerEmail).toLowerCase(), PasswordGUID: passwordGuid, NewPassword: $('#userNewPassword2').val()}))
                                .done(function (r_pc) {
                                    $('#progressIndicator').modal('show');

                                    // Authentication logic
                                    var customerInfo = r_pc.rawData;
                                    app.datac('userLoggedIn', true);
                                    app.datac('CustomerId', customerInfo.CustomerId);
                                    app.datac('CustomerGUID', customerInfo.CustomerGUID);
                                    app.datac('FirstName', customerInfo.FirstName);
                                    app.datac('LastName', customerInfo.LastName);
                                    app.datac('folioLoginHasPassword', null);
                                    app.datac('RestrictedFolio', null);
                                    app.datac('RestrictedLogin', null);
                                    app.datac('CustomerEmail', email.toLowerCase());
                                    if (!app.data.SessionId) {
                                        window.location.reload(false);
                                        return
                                    }
                                    $.when(
                                        app.models.systemModel.getData('updateSession', { CustomerId: customerInfo.CustomerId, CustomerGUID: customerInfo.CustomerGUID }),
                                        app.controllers.initController.initGuestItinerary()
                                    )
                                        .done(function (r_us) {
                                            var store = null;
                                            if(app.data.vueAppRef) {
                                                store = app.data.vueAppRef.$store;
                                                store.commit('setActiveService',''); //if you previously selected a service, before logging in, then upon return to that page again, it was auto selecting that service again
                                            }
                                            else if(app.data.modeSelectorVueAppRef) store = app.data.modeSelectorVueAppRef.$store;
                                            else if(app.data.optionalClassVueAppRef) store = app.data.optionalClassVueAppRef.$store;
                                            else if(app.data.vueLoginAppRef) {
                                                if(!store){
                                                    store = app.data.vueLoginAppRef.$store
                                                } else {
                                                    store = _.extend(store, app.data.vueLoginAppRef.$store)
                                                    store.commit('setFirstName',{firstName: r_l.FirstName}); //if you previously selected a service, before logging in, then upon return to that page again, it 
                                                }
                                            }
                                            if(store) {
                                                store.commit('setLoggedInUser',{userId: customerInfo.CustomerId});
                                            
                                            }
                                            //If guestProfileUpdateOnCheckout is true and user added ski/class that is rental than CustomerId(app.data.CustomerId)  is different when user logs in. So it is important to replace old Customer Ids inside  GuestwithSkiInCart  -START-
                                            if(app.customization.skiBooking.guestProfileUpdateOnCheckout && app.data.GuestsWithSkiInCart && !_.isEmpty(app.data.GuestsWithSkiInCart)){  
                                                var customerobjectWithNewId = {}
                                                _.each(app.data.GuestsWithSkiInCart,function(folio,customerId){
                                                    customerobjectWithNewId[app.data.CustomerId] = folio
                                                    app.datal('GuestsWithSkiInCart',customerobjectWithNewId)
                                                })

                                            }
                                            //-END-
                                            //part of partial pms payment
                    
                                            if( app.data.loginNextURL && (window.location.href.indexOf('summary/eReg')> -1)) {
                                                app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                                return;
                                            } else {
                                                if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                                        title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                                        message:app.localization.general.conflictingSpaBookingRemoved
                                                    });
                                                    app.dispatcher.dispatch('summary');
                                                    return
                                                }
                             
                                                if (app.data.loginNextURL) {
                                                    app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                                    app.data.loginNextURL = undefined;
                                                } else {
                                                    app.dispatcher.dispatch('summary');
                                                }
                                            }
                                        }).fail(function (r_us, r_fb) {
                                            window.location.reload(false);
                                        }).always(function(){
                                            $('#progressIndicator').modal('hide');  
                                        })
                                    
                                    // password reset success
                                    app.data.messages.push({
                                        type: 'alert', 'class': '', actions: [],
                                        title: app.localization.general.login.passwordReset.newPasswordEmailConfirmationMessage,
                                        message: ""
                                    });
                                }).fail(function (r_pc) {
                                    $('#progressIndicator').modal('hide');
                                    // Invalid guid or failure
                                    app.data.messages.push({
                                        type: 'alert', 'class': 'alert-error', actions: [],
                                        title: app.localization.general.err.passwordResetFail || r_pc.Result.Text,
                                        message: ""
                                    });
                                    app.commonViewHelper.showMessages();
                                })
                            } else {
                                return false;
                            }
                    })
            },
            prepResetPasswordForm: function () {
                var validateOnChange = function () {
                    $('#userResetPasswordForm').validate();
                    if ($('#userResetPasswordForm').valid()) {
                        $('#userResetSubmit').addClass('btn-primary').removeClass('disabled');
                    }else {
                        $('#userResetSubmit').removeClass('btn-primary').addClass('disabled');
                    }
                }
                $('#userResetPasswordForm .required').on('input',validateOnChange);
                //            $('.nav-tabs').button();
                $('#userResetCancel').on('click', function (obj) {
                    obj.target.href += "/profile"
                }
                )
                // $('#userResetSubmit').on('click', function (obj) {
                //     if ($('#userResetPasswordForm').valid()) {
                //         $('#progressIndicator').modal('show')
                //         obj.preventDefault();
                //         app.dispatcher.dispatch('profile', 'doreset', [$("#userEmailAddress").val(), 'loginResetPasswordCustomer']);

                //     } else {
                //         return false;
                //     }
                // }
                // )
                $('#userResetPasswordForm').on('submit',function(e){
                    e.preventDefault();
                    if ($('#userResetPasswordForm').valid()) {
                        $('#progressIndicator').modal('show')
                        app.dispatcher.dispatch('profile', 'doreset', [$("#userEmailAddress").val(), 'loginResetPasswordCustomer']);
                    } else {
                        return false;
                    }
                })
            },
            performPasswordComplexityCheck: function (password) {
                var result = '',
                    score = '',
                    bar = $('#password-strength-meter'),
                    text = $('#password-strength-text'),
                    passwordComplexitySet = app.data.minPasswordStrength;
                    dfd2 = $.Deferred();
                require(['lib/zxcvbn'], function (zxcvbn) {
                    result = zxcvbn(password),
                        score = result.score;
                        console.log("score",score)
                    if (password.length < 8) {
                        $(bar).attr('class', 'progress-bar progress-bar-danger').css('width', '5%');
                        text.html("<span class='feedback-danger'>" + Localization.newUser.passwordComplexityMessages.short + "</span>");
                        return;
                    }
                    // Update the password strength meter
                    switch (score) {
                        case 0:
                            $(bar).attr('class', 'progress-bar progress-bar-danger').css('width', '15%');
                            if(passwordComplexitySet == 0) {
                                text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                                $(bar).removeClass('progress-bar-danger').addClass('progress-bar-success');
                                $(bar).css('width', '100%');
                            } else if(passwordComplexitySet > 0) {
                                text.html("<span class='feedback-danger'>"+app.localization.newUser.passwordComplexityMessages.tooGuessable+"</span>");
                            }
                            break;
                        case 1:
                            if(passwordComplexitySet > 0){
                                $(bar).attr('class', 'progress-bar progress-bar-danger').css('width', '25%');
                                if(passwordComplexitySet == 1) {
                                    text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                                    $(bar).removeClass('progress-bar-danger').addClass('progress-bar-success');
                                    $(bar).css('width', '100%');
                                } else {
                                    text.html("<span class='feedback-danger'>"+app.localization.newUser.passwordComplexityMessages.veryGuessable+"</span>");
                                }
                            } else {
                                $(bar).attr('class', 'progress-bar progress-bar-success').css('width', '100%');
                                text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                            }
                            break;
                        case 2:
                            if(passwordComplexitySet > 1){
                                $(bar).attr('class', 'progress-bar progress-bar-warning').css('width', '50%');
                                if(passwordComplexitySet == 2){
                                    text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                                    $(bar).removeClass('progress-bar-warning').addClass('progress-bar-success');
                                    $(bar).css('width', '100%');
                                } else {
                                    text.html("<span class='feedback-warning'>"+app.localization.newUser.passwordComplexityMessages.someWhatGuessable+"</span>");
                                }
                            } else {
                                $(bar).attr('class', 'progress-bar progress-bar-success').css('width', '100%');
                                text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                            }
                            break;
                        case 3:
                            if(passwordComplexitySet > 2){
                                $(bar).attr('class', 'progress-bar progress-bar-info').css('width', '75%');
                                if(passwordComplexitySet == 3){
                                    text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                                    $(bar).removeClass('progress-bar-info').addClass('progress-bar-success');
                                    $(bar).css('width', '100%');
                                } else {
                                    text.html("<span class='feedback-info'>"+app.localization.newUser.passwordComplexityMessages.fairlyStrong+"</span>");
                                }
                            } else {
                                $(bar).attr('class', 'progress-bar progress-bar-success').css('width', '100%');
                                text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                            }
                            break;
                        case 4:
                            if(passwordComplexitySet > 3){
                                $(bar).attr('class', 'progress-bar progress-bar-success').css('width', '100%');
                                if(passwordComplexitySet == 4){
                                    text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                                    $(bar).removeClass('progress-bar-danger').addClass('progress-bar-success');
                                    $(bar).css('width', '100%');
                                } else {
                                    text.html("<span class='feedback-success'>"+app.localization.newUser.passwordComplexityMessages.veryStrong+"</span>");
                                }
                            } else {
                                $(bar).attr('class', 'progress-bar progress-bar-success').css('width', '100%');
                                text.html("<span class='feedback-success'>"+Localization.newUser.passwordComplexityMessages.met+"</span>");
                            }
                            break;
                    }
                    dfd2.resolve(score)
                    
                })
                return dfd2.promise();
            },
            prepCCPaymentForm: function () {
                //            $('.nav-tabs').button();
                $('#cartCCFormCancel').on('click', function (obj) {
                    obj.target.href += "/summary"
                }
                )
                var maskOptions = {
                    onKeyPress: function (cep, e, field, options) {
                        var mask = '0000 0000 0000 0999'
                        switch (cep.substr(0, 1)) {
                            case "3": $('#cartCCtype').val('AMEX')
                                mask = '0000 000000 00000'
                                break;
                            case "4": $('#cartCCtype').val('VISA')
                                break;
                            case "2":
                            case "5": $('#cartCCtype').val('M/C')
                                break;
                            case "6": $('#cartCCtype').val('DISC')
                                break;
                        }
                        $('#cartCCNum').mask(mask, options);
                    }
                }
                $('#cartCCNum').mask('0000 0000 0000 0999', maskOptions);
                jQuery.validator.addMethod(
                    "lessThanCurrent",
                    function (value, element, param) {
                        var isValid = $('#cartCCexpyear').val() == Date.today().toString("yyyy") ? ($('#cartCCexpmon').val() >= +Date.today().toString("M")) : true;
                        if (isValid) {
                            $('#cartCCexpmon, #cartCCexpyear').removeClass('error').addClass('valid');
                        } else {
                            $('#cartCCexpmon, #cartCCexpyear').removeClass('valid').addClass('error');
                        }
                        return isValid
                    },
                    app.localization.paymentProcessing.err.pastExpiryDate
                );
                var validator = $('#cartCCPaymentForm').validate({
                    rules: {
                        cartCCcvv: {
                            minlength: 3,
                            maxlength: 4,
                            required: true
                        },
                        cartCCexpmon: 'lessThanCurrent',
                        cartCCexpyear: 'lessThanCurrent',
                        cartCCNum: {
                            minlength: 13,
                            maxlength: 19,
                            required: true,
                            creditcard: true
                        }
                    },
                    errorPlacement: function (error, element) {
                        $('#cartCCFormSubmit').removeClass('btn-primary').addClass('disabled');
                        if (element.attr("name") == "cartCCexpmon") {
                            error.insertAfter("#cartCCexpContainer");
                        } else {
                            error.insertAfter(element);
                        }

                    },
                    groups: {
                        cartCCexp: "cartCCexpmon cartCCexpyear"
                    },
                    messages: {
                        cartCCexpmon: app.localization.paymentProcessing.err.pastExpiryDate,
                        cartCCexpyear: app.localization.paymentProcessing.err.pastExpiryDate,
                        cartCCNum: Localization.general.err.jquery_validate.creditcard
                    },
                    submitHandler: function () {
                        $('#progressIndicator').modal('show')
                        $('#cartCCFormSubmit').button('loading');

                        app.dispatcher.dispatch('summary', 'ccPaySubmit', [
                            encodeURIComponent($('#cartCCNum').val().replace(/[^\d]*/g, '')),
                            encodeURIComponent($('#cartCCtype').val() || ''),
                            encodeURIComponent($('#cartCCexpmon').val() || ''),
                            encodeURIComponent($('#cartCCexpyear').val() || ''),
                            encodeURIComponent($('#cartCCcvv').val() || ''),
                            encodeURIComponent($('#cartCCFName').val() || ''),
                            encodeURIComponent($('#cartCCLName').val() || ''),
                            encodeURIComponent($('#cartCCaddress').val() || ''),
                            encodeURIComponent($('#cartCCaddress2').val() || ''),
                            encodeURIComponent($('#cartCCcity').val() || ''),
                            encodeURIComponent($('#cartCCstate').val() || ''),
                            encodeURIComponent($('#cartCCzip').val() || ''),
                            encodeURIComponent($('#cartCCcountry').val() || '')
                        ])
                        return false;
                    },
                    success: function (label) {
                        if (!$('#cartCCPaymentForm .required:not(.valid)').length) {
                            $('#cartCCFormSubmit').addClass('btn-primary').removeClass('disabled');
                        }
                    },
                    invalidHandler: function (event, validator) {
                        $('#cartCCFormSubmit').removeClass('btn-primary').addClass('disabled');
                    }
                });
                /*$('#cartCCFormSubmit').on('click', function (obj) {
                        obj.preventDefault();
                        if ($(obj.target).hasClass('disabled')) {
                            $('#cartCCPaymentForm').valid();
                            return false;
                        }
                        if ($('#cartCCPaymentForm').valid()) {
                            $('#progressIndicator').modal('show')
                            $('#cartCCFormSubmit').button('loading');

                            app.dispatcher.dispatch('summary', 'ccPaySubmit', [
                                $('#cartCCNum').val(),
                                $('#cartCCtype').val(),
                                $('#cartCCexpmon').val(),
                                $('#cartCCexpyear').val(),
                                $('#cartCCcvv').val(),
                                $('#cartCCFName').val(),
                                $('#cartCCLName').val(),
                                $('#cartCCaddress').val(),
                                $('#cartCCaddress2').val(),
                                $('#cartCCcity').val(),
                                $('#cartCCstate').val(),
                                $('#cartCCzip').val(),
                                $('#cartCCcountry').val()
                            ])
                            return false;
                        } else {
                            return false;
                        }
                    }
                )*/
                loadCustomerAddressIntoForm();
                var isFormValid = function (elem, form) {
                    var valid = validator.check(elem, true)
                    valid && $.each(form[0], function () {
                        valid &= validator.check(arguments[1], true);
                    });
                    return valid
                }

                var validateOnChange = _.debounce(function () {
                    if (isFormValid(this, $('#cartCCPaymentForm'))) {
                        $('#cartCCFormSubmit').addClass('btn-primary').removeClass('disabled');
                    }
                }, 300)
                $('#cartCCPaymentForm .required').change(validateOnChange);
                $('#cartCCPaymentForm .required').blur(validateOnChange);
                $('#cartCCPaymentForm .required').keypress(validateOnChange);
                setTimeout(function () {
                    $('#cartCCNum').focus()
                }, 150)
            },
            authenticatefolioresult: function (success, response) {
                if (success) return;
                    app.data.messages.push({
                        type: 'alert',
                        'class': 'alert-error',
                        actions: [],
                        title: app.localization.spaBooking.packageBooking.login.err.alternateLogicAuthFail,
                        message: ''
                    });
              app.commonViewHelper.showMessages();
                
            },
            prepUserLoginForm: function (mode,urlParameter) {
                currentPasswordComplexity = 0;
                if ((!app.customization.login.useIntegratedLogin || !!app.data.userLoggedIn) && mode != 'signon') {
                    $('#userCreateUser').on('click', this, function (obj) {
                        obj.target.href += "/profile/create"
                        //                    obj.preventDefault();
                        //                    obj.data.showMessage({type:'alert', class:'alert-info', title:'Not yet implemented'})
                    }
                    )
                    $('#userResetPassword').on('click', this, function (obj) {
                        obj.target.href += "/profile/reset"
                        //                    obj.preventDefault();
                        //                    this.showMessage({type:'alert',class:'alert-info',title:'Not yet implemented'})
                    }
                    )
                    $('#userLoginCancel').on('click', function (obj) {
                        obj.target.href += "/"
                    }
                    )
                    $('#userLoginForm').submit(function (obj) {
                        obj.preventDefault();
                        $(obj.target).validate();
                        if ($(obj.target).valid()) {
                            $('#progressIndicator').modal('show');
                            app.dispatcher.updateURL('profile', 'login', [], true)
                            app.dispatcher.dispatch('profile', 'authenticate', [encodeURIComponent($('#userEmailAddress').val()), encodeURIComponent($('#userPassword').val()),'',urlParameter,false, mode]);
                        }
                    })
                } else {
                    var clearDOBifEmpty = function () {
                        if ($(this).val() == "") {
                            $('#userDOB').val('')
                        }
                    }
                    $('#userDOBhuman')
                        .datepicker({
                            altField: '#userDOB',
                            altFormat: 'yy-mm-dd',
                            dateFormat: 'yy-mm-dd',
                            minDate: "-120y",
                            maxDate: "-1d",
                            yearRange: "-120:+0",
                            numberOfMonths: 1,
                            showMonthAfterYear: true,
                            changeMonth: true,
                            changeYear: true,
                            onClose: clearDOBifEmpty
                        })
                        .datepicker('setDate', $('#userDOB').val())
                        .datepicker('option', 'dateFormat', app.localization.newUser.dobFormat)
                        .on('blur', clearDOBifEmpty)
                    $('.folioIdBtn').on('click', function (e) {
                       var lastName = $('#lastName').val()
                       var folioNumber = $('#folioNumber').val()
                       if(lastName && folioNumber){
                        app.dispatcher.dispatch('profile', 'authenticatefolio', [encodeURIComponent($('#folioNumber').val()), encodeURIComponent($('#lastName').val()), 'folioEvent']);
                       }
                    })
                    var emailCheckResult = function (email, data) {
                        if (data[email]) {
                            $('.control-group.userEmail1 .controls')
                                .popover('destroy')
                                .removeClass('arrow-right')
                            $('.control-group.userPassword1 .controls')
                                .popover({ content: '<span class="close" onclick="$($(this).parents(\'.popover\')).remove()" href="#">&times;</span>' + app.localization.newUser.enterPasswordPrompt, trigger: 'focus', selector: 'input', placement: popoverPositionFn, container: '#userCreateUserForm1' })
                            // $('#userPassword1').focus()
                            // .popover('show')
                            
                            $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other, .well.edit-contact-logs, #userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                                .addClass('disabled').find('input,select,textarea').attr('disabled', 'disabled')
                            $('.row-fluid.passwords.exist, .row-fluid.login').addClass('in')
                            $('#userPassword1, .row-fluid .forgot .btn').removeAttr('disabled') // .row-fluid.login = login and forgot btns. .row-fluid .login = just login btn
                            $('#userEmail2').attr('disabled', 'disabled')
                            // $('input').one('touchstart.lala', function () {
                            //     $(this).focus();   // inside this function the focus works
                            //     focused = $(this); // just for the example when I click next on fiddle
                            // });

                            $('#userPassword1').trigger('touchstart.lala');
                            setTimeout(function () {
                                //event handler to set the focus()


                                checkFields({ target: $('#userPassword1')[0] })
                            }, 125)
                        } else if (data[email] === false ) {
                            $('.control-group.userEmail1 .controls').popover('destroy');
                            $('.control-group.userEmail1 .controls').removeClass('arrow-right spinner')
                            $('.row-fluid.emails .control-group').removeClass('span4 span8').show().addClass('in span6')
                            $('#userPassword1').attr('disabled', 'disabled')
                            $('#userEmail2').removeAttr('disabled')
                            $('.well.passwords.new').addClass('in')
                            $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other, .well.edit-contact-logs, #userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                                .removeClass('disabled').find('input,select,textarea').removeAttr('disabled')
                            checkPasswordStrength()
                            $('.well.passwords.new .random').text(app.data.newpassword)
                      
                            function checkPasswordStrength() {
                                var passwordLengthPerScore = {
                                        0: '8',
                                        1: '8',
                                        2: '8',
                                        3: '10',
                                        4: '13'
                                    },
                                    pwchars = 'abcdefghijklmnopqrstuvwxyz0987654321',
                                    minStrengthRequried = app.data.minPasswordStrength,
                                    lengthOfPassword = minStrengthRequried == 5 ? 8 : passwordLengthPerScore[minStrengthRequried]

                                app.data.newpassword = ''
                                for (i = 0; i < lengthOfPassword; i++) {
                                    app.data.newpassword += pwchars.charAt(Math.floor(Math.random() * pwchars.length))
                                }
                                minStrengthRequried < 5 && require(['lib/zxcvbn'], function (zxcvbn) {
                                    result = zxcvbn(app.data.newpassword),
                                        score = result.score;
                                    if (score == minStrengthRequried) return;
                                    checkPasswordStrength()
                                })
                            }
                        }
                    }
                        , doEmailCheck = _.debounce(function (email, data) {
                            if (!data.hasOwnProperty(email)) {
                                $('#userEmail1').removeData('data-hasResult')
                                data[email] = null
                                if (validEmail(email)) {
                                    $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: email }))
                                        .done(function (r_ce) {
                                            data[email] = false
                                            emailCheckResult(email, data)
                                            $('#userEmail1').data('data-hasResult', true)
                                        })
                                        .fail(function (r_ce) {
                                            data[email] = true
                                            emailCheckResult(email, data)
                                            $('#userEmail1').data('data-hasResult', true)
                                        })
                                }
                            } else {
                                emailCheckResult(email, data)
                            }
                        }, 500)
                        , countryStates = _.chain(app.localization.stateList).map(function (x) { return x.country }).uniq()/*.map(function(x){return x && _.find(Localization.countryList,function(y){return y.code==x}).name})*//*.filter(function(x){return x})*/.value()  // The unique country names based on the country codes found in the state list
                        , checkFields = (function (e, reset, instant) {
                            var func = function (e, reset, instant) {
                                target = e && e.target || '.form-float.control-group input, .form-float.control-group select, .form-float.control-group textarea, .form-float.control-group .btn-group'
                                if (reset) {
                                    $('.form-float.control-group').addClass('pristine')
                                }
                                _.each($(target), function (elem) {
                                    var me = $(elem)
                                        , group = $(me.parents('.control-group')[0])
                                        , row = $(group.parents('.row-fluid')[0])
                                        , required = me.hasClass('required') && me.attr('disabled') != 'disabled' && (elem.id != 'userHomeProvince' || countryStates.indexOf($('#userHomeCountry').val()) >= 0) && (!row.hasClass('hide'))
                                        , pristine = group.hasClass('pristine')
                                        , focused = group.hasClass('focused')
                                    if (me.val()) {
                                        group.addClass('filled')
                                        switch (elem.id) {
                                            case "userEmail1": if (!validEmail(me.val())) {
                                                target != elem && attachError(group, app.localization.general.err.jquery_validate.email)
                                            } else {
                                                group.removeClass('invalid').find('.control-label span.required').remove()
                                            }
                                                break;
                                            case "userEmail2": if (me.val() != $('#userEmail1').val()) {
                                                target != elem && attachError(group, app.localization.general.err.jquery_validate.equalTo)
                                            } else {
                                                group.removeClass('invalid').find('.control-label span.required').remove()
                                            }
                                                break;
                                            case "newPassword1": if (me.val().length < 8  &&  app.data.minPasswordStrength >= 5 ||  app.data.minPasswordStrength < 5 && currentPasswordComplexity < app.data.minPasswordStrength) {
                         
                                                app.data.minPasswordStrength >= 5 ? target != elem && attachError(group, app.localization.general.err.jquery_validate.minlength(8)):''
                                            } else {
                                                group.removeClass('invalid').find('.control-label span.required').remove()
                                            }
                                                break;
                                            case "newPassword2": if (me.val() != $('#newPassword1').val()) {
                                                target != elem && attachError(group, app.localization.general.err.jquery_validate.equalTo)
                                            } else {
                                                group.removeClass('invalid').find('.control-label span.required').remove()
                                            }
                                                break;
                                            // case "userPassword1": if (me.val().length < 8 &&   app.data.minPasswordStrength >= 5) {
                                            //     target != elem && attachError(group, app.localization.general.err.jquery_validate.minlength(8))
                                            //     $('#userCreateUserForm .login.control-group .btn ').attr('disabled', 'disabled')
                                            // } else {
                                            //     $('#userCreateUserForm .login.control-group .btn ').removeAttr('disabled')
                                            //     group.removeClass('invalid').find('.control-label span.required').remove()
                                            // }
                                            //     break;
                                            //with the introduction of password complexity check, it is possible that user signed up with 5 password letters and later client decided to instead use  default check(minimium 8 char), user wont be able to login
                                            case "userPassword1":
                                                $('#userCreateUserForm .login.control-group .btn ').removeAttr('disabled')
                                                group.removeClass('invalid').find('.control-label span.required').remove()
                                            break;
                                            case "userHomeProvince": var selectedProvince = _.find(app.localization.stateList, function (x) { return x.code == $('#userHomeProvince').val() })

                                                if (selectedProvince && selectedProvince.country != $('#userHomeCountry').val()) {
                                                    var selectedCountry = selectedProvince && _.find(app.localization.countryList, function (x) { return x.code == selectedProvince.country })
                                                    $('#userHomeCountry').val(selectedCountry && selectedCountry.code || "")
                                                    checkFields($.extend(e, { target: $('#userHomeCountry')[0] }))
                                                    group.removeClass('invalid')
                                                }
                                                break;
                                            case "userHomeCountry": var selectedProvince = _.find(app.localization.stateList, function (x) { return x.code == $('#userHomeProvince').val() })
                                                //, selectedCountry = _.find(app.localization.countryList,function(x){return x.name==$('#userHomeCountry').val()})
                                                if (selectedProvince && selectedProvince.country && selectedProvince.country != $('#userHomeCountry').val()) {
                                                    $('#userHomeProvince').val("")
                                                }
                                            //                                                             if(_.any( app.localization.stateList, function(x){return x.country==$('#userHomeCountry').val()} ) ){
                                            //                                                                 $('#userHomeProvince').addClass('required')
                                            //                                                             } else {
                                            //                                                                 $('#userHomeProvince').removeClass('required')
                                            //                                                             }
                                            default: group.removeClass('invalid')
                                                break;
                                        }
                                    } else {
                                        if (required && !pristine && !focused) {
                                            attachError(group, app.localization.general.err.jquery_validate.required)
                                            if (elem.id == "userPassword1") {
                                                $('#userCreateUserForm .login.control-group .btn ').attr('disabled', 'disabled')
                                            }
                                        } else {
                                            group.removeClass('invalid').find('.control-label span.required').remove()
                                        }
                                     //   group.removeClass('filled')
                                    }
                                })
                            }
                            var timeout = null
                            return function () {
                                var context = this, args = arguments, doNow = !!args[2], wait = 750
                                if (args[0] && timeout !== null) {
                                    args[0] = null
                                    doNow = true
                                }
                                clearTimeout(timeout)
                                if (args[0] || doNow) {
                                    timeout = null
                                    func.apply(context, args)
                                    // wait=50
                                } else {
                                    var later = function () {
                                        timeout = null
                                        func.apply(context, args)
                                    }
                                    timeout = setTimeout(later, 750)
                                }
                            }
                        })()
                        , popoverPositionFn = function () {
                            this.$tip.css('display', 'none');
                            return $(document).width() < 768 ? 'in bottom' : 'right'
                        }
                    $('#userCreateUserFormContainer').on('focus', '.form-horizontal input, .form-horizontal select, .form-horizontal textarea', function (e) {
                        $(this).parents('.control-group').addClass('focused')
                    })
                    $('#userCreateUserFormContainer').on('blur',' .form-horizontal input, .form-horizontal select, .form-horizontal textarea', function (e) {
                        var removeClassStr = 'focused'
                        if (this.id != 'userEmail1' || $(this).val()) {
                            removeClassStr += ' pristine'
                        }
                        $(this).parents('.control-group').removeClass(removeClassStr)
                        checkFields(e)
                    })
                    $('#userCreateUserFormContainer').on('.form-horizontal change',' .form-horizontal input, .form-horizontal select, .form-horizontal textarea', function (e) {
                        var removeClassStr = 'focused'
                        if (this.id != 'userEmail1' || $(this).val()) {
                            removeClassStr += ' pristine'
                        }
                        $(this).parents('.control-group').removeClass(removeClassStr)
                        if (this.id == 'userEmail1') {
                            if (validEmail($(this).val())) {
                                $('.control-group.userEmail1 .controls').addClass('spinner')
                            }
                            if (this.id == 'userEmail1' && $(this).data('data-hasResult')) {
                                doEmailCheck($('#userEmail1').val(), $('#userEmail1').data('data-isChecked'))
                            }
                        }
                        checkFields(e)
                    })
                    $('#userCreateUserFormContainer').on('change', '.form-horizontal input, .form-horizontal select, .form-horizontal textarea, .form-horizontal .btn-group', function (e) {
                        $(this).parents('.control-group').removeClass('pristine')
                        if ($(this).val()) {
                            $(this).parents('.control-group').addClass('filled')
                        } else {
                            $(this).parents('.control-group').removeClass('filled')
                        }
                        checkFields()
                    })
                    $('#userCreateUserFormContainer').on('input', '.form-horizontal input, .form-horizontal select, .form-horizontal textarea', function (e) {
                        if (this.id == 'userEmail1') {
                            var email = $(this).val()
                            if (email) {
                                if (!$('.control-group.userEmail1 .controls').data('popover') ||
                                    $('.control-group.userEmail1 .controls').data('popover').getContent() != app.localization.newUser.enterExistingEmailPrompt) {
                                    $('.control-group.userEmail1 .controls')
                                        .popover('destroy')
                                    setTimeout(function () {
                                        $('.control-group.userEmail1 .controls')
                                            .popover({ content: app.localization.newUser.enterExistingEmailPrompt, trigger: 'manual', placement: popoverPositionFn, container: '#userCreateUserForm2' })
                                            .popover('show')
                                    }, 250)
                                }
                                if (validEmail(email)) {
                                    var data = $('#userEmail1').data('data-isChecked')
                                    if (!data) {
                                        $('#userEmail1').data('data-isChecked', (data = {}))
                                    }
                                    doEmailCheck(email, data)
                                }
                            }
                            if ($('#userEmail1').data('data-hasResult')) {
                                $('.control-group.userPassword1 .controls').data('popover') && $('.control-group.userPassword1 .controls, .control-group.userPassword1 .controls input').popover('destroy')
                                $('.control-group.userEmail1 .controls')
                                    .addClass('arrow-right')
                                    .removeClass('spinner')
                                // setTimeout(function(){
                                //     $('.control-group.userEmail1 .controls')
                                //         .popover({content:app.localization.newUser.enterExistingEmailPrompt, trigger:'manual', placement: $(document).width()<768?'bottom':'right', container:'#userCreateUserForm3'})
                                //         .popover('show')

                                // },250)
                                $('.row-fluid.emails .control-group.userEmail1').addClass('span8').removeClass('in span6')
                                $('.row-fluid.emails .control-group.userEmail2').addClass('span4').removeClass('in span6').hide()
                                $('.row-fluid.passwords, .well.passwords, .row-fluid.login').removeClass('in')
                                $('#userPassword1, #userEmail2, .row-fluid.login .btn').attr('disabled', 'disabled')
                                $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other,.well.edit-contact-logs,#userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                                    .addClass('disabled').find('input,select,textarea').attr('disabled', 'disabled')
                                $('#userCreateSubmit').text(app.localization.newUser.activeContext.buttonCreate)
                            }
                        }
                        if (this.id == 'userSalutation') {
                            switch ($(this).val()) {
                                case "Mr.":
                                    $('#userGender').val('M')
                                    break
                                case "Ms.":
                                case "Mrs.":
                                case "Miss.":
                                    $('#userGender').val('F')
                            }
                        }
                        if (this.id == 'userGender') {
                            if ($(this).val() == "M") {
                                switch ($('#userSalutation').val()) {
                                    case "Ms.":
                                    case "Mrs.":
                                    case "Miss.":
                                        $('#userSalutation').val('Mr.')
                                }
                            } else {
                                switch ($('#userSalutation').val()) {
                                    case "Mr.":
                                        $('#userSalutation').val('Ms.')
                                }
                            }
                        }
                        if ($(this).hasClass('required')) {
                            checkFields(e)
                        }
                    })
                    $('#userCreateUserForm label.control-label').on('click', function (e) {
                        setTimeout(function () {
                            $('#' + $(this).attr('for')).focus().click()
                        }, 50)
                    })
                    $('#userMainPhone').on('change', function (e) {
                        if ($(this).val() == 'WORK') {
                            $('.control-group.userPhoneExt').addClass('in').find('input').removeAttr('disabled')
                        } else {
                            $('.control-group.userPhoneExt').removeClass('in').find('input').attr('disabled', 'disabled')
                        }
                    })
                    $('#userLanguage .btn').on('click', function (obj) {
                        obj.preventDefault();
                        $('#userLanguage .btn').removeClass('btn-primary')
                        $(this).addClass('btn-primary')
                        $('#userCreateUserFormContainer').trigger.call($(this), 'change')
                    })
                    $('input[type=radio][name=newPasswordType]').on('change', function (obj) {
                        console.log('change', obj, this)
                        if (this.value == "Random") {
                            $('.newPasswordTypeCustom input[type=password]').addClass('disabled').removeClass('required')
                            $('#userCreateSubmit').removeClass('disabled')
                        } else {
                            $('.newPasswordTypeCustom input[type=password]').addClass('required').removeClass('disabled')
                            $('.newPasswordTypeCustom .newPassword1 input[type=password]').focus()
                            $('#userCreateSubmit').addClass('disabled')
                        }
                    })
                    $('#newPassword1').on('keyup', function () {
                        var password = $(this).val();
                        $('#userCreateSubmit').addClass('disabled')
                        if (app.data.minPasswordStrength < 5) {
                            if (password == '') {
                                $('.passwordComplexityUI').css('display', 'none')
                            } else {
                                $('.passwordComplexityUI').css('display', 'block')
                            }
                            app.commonViewHelper.performPasswordComplexityCheck(password).then(function(score){
                                currentPasswordComplexity = score;
                                $('#userCreateSubmit').removeClass('disabled')
                            })
                        } else if(app.data.minPasswordStrength == 5 && password.length >= 8) {
                            $('#userCreateSubmit').removeClass('disabled')
                        }
                    });
                    $('.newPasswordTypeCustom input[type=password],.newPasswordTypeCustom label.control-label').on('click', function (obj) {
                        $('input[type=radio][name=newPasswordType][value=Custom]').click()
                    })

                    $('#userPassword1').keypress(function(e){ //to submit on enter
                        if(e.key == "Enter"){
                            if (validEmail($('#userEmail1').val())) {
                                $('.control-group.login .controls').addClass('spinner')
                                $('.alert.hide').alert('close');
                                app.dispatcher.dispatch('profile', 'authenticate', [encodeURIComponent($('#userEmail1').val()), encodeURIComponent($('#userPassword1').val()), 'updateLoginResult',urlParameter?urlParameter[0]:'', false, mode]);
                            }
                        }
                    })
                    
                    
                    // Add Contact Log
                    $('#userCreateUserForm > div.well.edit-contact-logs .add-contact-log').each(function() {
                        $(this).on('click', function(e){
                            e.preventDefault();
                            var thisSuperParent = $(this).parent().parent();
                            var addnlInputs = thisSuperParent.find('.additional-inputs');
                            var logType = $(this).attr('log-type');
                            var logCustomization = app.customization.visibleContactLogs[logType];
                            var inputType = logCustomization && logCustomization.type ? logCustomization.type : 'text';

                            $('<div class="additional-log"><input type='+inputType+' class="additional-log-input" log-type="'+ logType+'"><button class="clear-contact-log"><i class="icon-trash"></i></button></div>').appendTo(addnlInputs);
                            // delete button
                            thisSuperParent.find('.clear-contact-log').on('click', function(e){
                              e.preventDefault();
                              // remove value and hide field, button
                              // $(this).prev().attr({type: 'hidden', "aria-hidden": true, value: '' });
                              $(this).prev().remove();
                              $(this).remove();
                          })
                        });
                    });
                    $('#userCreateUserForm .login.control-group .btn ').on('click', function (e) {
                        e.preventDefault();

                        if (validEmail($('#userEmail1').val())) {
                            $('.control-group.login .controls').addClass('spinner')
                            $('.alert.hide').alert('close');
                            $(this).attr('disabled', 'disabled')
                            app.dispatcher.dispatch('profile', 'authenticate', [encodeURIComponent($('#userEmail1').val()), encodeURIComponent($('#userPassword1').val()), 'updateLoginResult',urlParameter?urlParameter[0]:'', false, mode]);
                        }
                    })
                    $('#userCreateUserForm .forgot.control-group .btn ').on('click', function (e) {
                        e.preventDefault();
                        $('.control-group.forgot .controls').addClass('spinner')
                        app.dispatcher.dispatch('profile', 'doreset', [encodeURIComponent($('#userEmail1').val()), 'loginResetPasswordCustomer']);
                    })
                    $('#userCreateUserForm').on('submit', function (e) {
                        e.preventDefault();
                        if ($(this).attr('id') == 'userChangePasswordForm') {
                            $('#userChangeSubmit').click()
                        }
                        console.log('submit')
                    })
                    // This is attached to create user form submit in place of #userCreateSubmit 's click event
                    $('.userUpdateSubmit').on('click', function (e) {
                        e.preventDefault()
                        if ($(this).hasClass('save') || $(this).hasClass('update')) {
                            $('.pristine').removeClass('pristine')
                            $('.invalid').removeClass('invalid')
                            checkFields(null, false, true)
                            if ($('.form-float.control-group.invalid').length == 0) {
                                $('#progressIndicator').modal('show');

                                // Gathers contact logs on create customer
                                var contactLogs = [];
                                var stringifiedContactLogs = '';

                                $('#userCreateUserForm > div.well.edit-contact-logs input').each(function(){
                                    var contactLog = {};
                                    contactLog.value = encodeURIComponent($(this).val());
                                    //value exists and editedd
                                    if(contactLog.value){
                                        contactLog.name = $(this).attr('log-type');
                                        contactLogs.push(contactLog);
                                    };
                                });
                                if(contactLogs.length){
                                    stringifiedContactLogs = JSON.stringify(contactLogs);
                                }


                                app.dispatcher.dispatch('profile', $(this).hasClass('update') ? 'detailssubmit' : 'createsubmit', [
                                    encodeURIComponent($('#userEmail1').val() || ""),
                                    encodeURIComponent(($('input[type=radio][name=newPasswordType]:checked').val() == "Random" ? app.data.newpassword : $('#newPassword1').val()) || ""),
                                    encodeURIComponent($('#userGender').val() || ''),
                                    encodeURIComponent($('#userSalutation').val() || ''),
                                    encodeURIComponent($('#userFirstName').val() || ''),
                                    encodeURIComponent($('#userLastName').val() || ''),
                                    ($('#userMainPhone').val() || '').substr(0, 1),
                                    // $('#userMainPhoneH').hasClass('active') ? "H" :
                                    //     $('#userMainPhoneW').hasClass('active') ? "W" :
                                    //         $('#userMainPhoneO').hasClass('active') ? "O" : "",
                                    encodeURIComponent($('#userMainPhone').val() == "HOME" && $('#userPhone').val() || $('#userPhoneHOME').val() || $('#userPhoneTypeHOME').val() || ''),
                                    encodeURIComponent($('#userMainPhone').val() == "WORK" && $('#userPhone').val() || $('#userPhoneWORK').val() || $('#userPhoneTypeWORK').val() || ''),
                                    encodeURIComponent($('#userPhoneExt').val() || $('#userPhoneWORKExt').val() || $('#userPhoneTypeWORKExt').val() || ''),
                                    encodeURIComponent($('#userMainPhone').val() == "OTHER" && $('#userPhone').val() || $('#userPhoneOTHER').val() || $('#userPhoneTypeOTHER').val() || ''),
                                    encodeURIComponent($('#userMainPhone').val() == "MOBILE" && $('#userPhone').val() || $('#userPhoneMOBILE').val() || $('#userPhoneTypeMOBILE').val() || ''),
                                    encodeURIComponent($('#userHomeAddress1').val() || ''),
                                    encodeURIComponent($('#userHomeAddress2').val() || ''),
                                    encodeURIComponent($('#userHomeCity').val() || ''),
                                    encodeURIComponent($('#userHomeProvince').val() || ''),
                                    encodeURIComponent($('#userHomeCountry :selected').text()),
                                    encodeURIComponent($('#userHomePostalCode').val() || ''),
                                    encodeURIComponent($('#userOtherAddress1').val() || ''),
                                    encodeURIComponent($('#userOtherAddress2').val() || ''),
                                    encodeURIComponent($('#userOtherCity').val() || ''),
                                    encodeURIComponent($('#userOtherProvince').val() || ''),
                                    encodeURIComponent($('#userOtherCountry').val() || ''),
                                    encodeURIComponent($('#userOtherPostalCode').val() || ''),
                                    $('#newsletter').prop('checked') ? "1" : "0",
                                    $('#mailmarketing').prop('checked') ? "1" : "0",
                                    $('#phonemarketing').prop('checked') ? "1" : "0",
                                    $('#smsmarketing').prop('checked') ? "1" : "0",
                                    $('#userLanguageen-us').hasClass('active') ? "en-us" :
                                        $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                                            $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                                                $('#userLanguagees-sp').hasClass('active') ? "es-sp" : "",
                                    encodeURIComponent($('#userListAddress').val() || ''),
                                    encodeURIComponent($('#userMemberList').val() || ''),
                                    encodeURIComponent($('#userListPhone').val() || ''),
                                    encodeURIComponent($('#userListEmail').val() || ''),
                                    encodeURIComponent($('#userSkiSize').val() || ''),
                                    encodeURIComponent($('#userSkiBootSize').val() || ''),
                                    encodeURIComponent($('#userSkierType').val() || ''),
                                    encodeURIComponent($('#userCustomerType').val() || ''),
                                    encodeURIComponent($('#userSnowboardSize').val() || ''),
                                    encodeURIComponent($('#userSnowboardBootSize').val() || ''),
                                    encodeURIComponent($('#userDinNumber').val() || ''),
                                    encodeURIComponent($('#userAge').val() || ''),
                                    encodeURIComponent($('#userWeight').val() || ''),
                                    encodeURIComponent($('#userHeight').val() || ''),
                                    encodeURIComponent($('#userDOB').val()),
                                    stringifiedContactLogs
                                ]);
                    
                            } else {
                                var group = $($('.form-float.control-group.invalid')[0])
                                $('html, body').animate({
                                    scrollTop: group.offset().top - 70
                                }, 300, function () {
                                    group.find('input, select, textarea').focus()
                                });

                            }
                        } else {
                            if(!app.data.loginNextURL){
                                app.dispatcher.replace('profile');
                            } else {
                                app.dispatcher.redirect.apply(this, app.data.loginNextURL)
                                app.data.loginNextURL = undefined;
                            }
                        }
                    })
                    $('#userCreateUserForm').on('login-success', function (e) {
                        checkFields(null, true, true)
                        var once = false
                            , onceFn = function (e) {
                                if (!once) {
                                    $('.userUpdateSubmit').addClass('update').text(app.localization.newUser.activeContext.buttonUpdate)
                                    once = true
                                }
                            }
                        $('#userCreateUserFormContainer').on('change', '.form-horizontal input, .form-horizontal select, .form-horizontal textarea, .form-horizontal .btn-group', onceFn)
                        $('#userCreateUserFormContainer').on('input', '.form-horizontal input, .form-horizontal select, .form-horizontal textarea', onceFn)
                    })
                    if (!!app.data.windowResizeHandler) {
                        $(window).unbind('resize', app.data.windowResizeHandler);
                    }
                    app.data.windowResizeHandler = _.debounce(function () {
                        $('.control-group.userEmail1 .controls, .control-group.userPassword1 .controls').each(function () {
                            var popover = $(this).data('popover')
                            if (popover) {
                                popover.show()
                            }
                        })
                    }, 100);
                    $(window).bind('resize', app.data.windowResizeHandler);
                    if (validEmail($('#userEmail1').val())) {
                        $('#userEmail1').trigger('input')
                    } else {
                        setTimeout(function () {
                            $('html, body').animate({
                                scrollTop: ($("#userEmail1").offset().top - window.document.body.scrollTop < $(window).height() * .6)
                                    ? $("#userEmail1").offset().top - $(window).height() * .5
                                    : 0
                            }, 300);
                        }, 100)
                        setTimeout(function () {
                            popoverPositionFn = function () {
                                this.$tip.css('display', 'none');
                                return $(document).width() < 768 ? 'in bottom' : 'top'
                            }
                            $('.control-group.userEmail1 .controls')
                                .popover({ content: app.localization.newUser.enterEmailFirstPrompt, trigger: 'manual', placement: popoverPositionFn, container: '#userCreateUserForm4' })
                                .popover('show')
                            // $('#userEmail1')[0] && $('#userEmail1')[0].scrollIntoView(true)
                            $('#userEmail1').focus()
                        }, 500)
                    }
                    checkFields(null, true)
                }

            },
            loginResetPasswordCustomer: function (result, error) {
                $('.control-group.forgot .controls').removeClass('spinner')
                if (result) {
                    $('#userCreateUserForm .forgot.control-group .btn ').attr('disabled', 'disabled')
                }
                app.commonViewHelper.showMessages();
                $('#userCreateUserForm').trigger('login-reset-password')

            },
            updateDiningLoginResult: function (result, service, redirect) {
                $('#thirdPartyAuthDine').remove();
                $('.control-group.login .controls').removeClass('spinner')
                $('#userCreateUserForm .login.control-group .btn ').removeAttr('disabled')
                $('.control-group.userPassword1 .controls, .control-group.userPassword1 .controls input')
                    .popover('destroy')

                if (result) {
                    app.models.userModel.getData('fetchCustomerProfile', {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    })
                        .done(function (r_fcp) {
                            var customer = $.firstOrOnly(r_fcp.Customer)
                            var mobilePhone = _.find(customer.Phone, function (phone) {
                                return phone.type == "MOBILE"
                            })
                            var mobileNumber = mobilePhone && mobilePhone.PhoneNumber
                            $('.diningReservation .dining .contact .phones #userPhone').val(mobileNumber).removeAttr('disabled')
                            $('.diningReservation .dining .contact .specialRequests #userRequest').removeAttr('disabled')
                                .parents('.control-group').addClass(mobileNumber ? 'filled' : '')
                            $('.diningReservation .dining .contact').removeClass('hidden')
                            $('.diningReservation .dining .passwords,.diningReservation .dining .login,.diningReservation .dining .emails,.diningReservation .dining .contact .names').removeClass('in').addClass('collapse')
                            $('.diningReservation .dining .diningResBtn').removeClass('disabled')
                        })
                        $('.diningReservation .dining .passwords input, .diningReservation .dining .login button, .diningReservation .dining .emails input').attr('tabindex', -1);
                } else {
                    var popoverPositionFn = function () {
                        this.$tip.css('display', 'none');
                        return $(document).width() < 768 ? 'in bottom' : 'left'
                    }
                    $('.control-group.userPassword1 .controls')
                        .popover({ content: '<span class="close" onclick="$($(this).parents(\'.popover\')).remove()" href="#">&times;</span>' + app.localization.newUser.passwordIncorrect, trigger: 'focus', selector: 'input', placement: popoverPositionFn, container: '#userCreateUserForm5' })
                    $('.tab-pane.accordion.active #userPassword1').focus()
                }
            },
            updateLoginResult: function (result, service) {
                $('.control-group.login .controls').removeClass('spinner')
                $('#userCreateUserForm .login.control-group .btn ').removeAttr('disabled')
                $('.control-group.userPassword1 .controls, .control-group.userPassword1 .controls input')
                    .popover('destroy')
                if (result) {
                    $('#userCreateUserForm .well.confirm').addClass('in')
                    $('#userCreateUserForm #userEmail1').attr('disabled', 'disabled')
                    $('.row-fluid.passwords, .well.passwords, .row-fluid.login').removeClass('in')
                    $('#userCreateSubmit').text(app.localization.newUser.activeContext.buttonUpdate)
                    app.models.userModel.getData('fetchCustomerProfile', {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    })
                        .done(function (r_fcp) {
                            $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other,#userCreateUserForm .well.language, .well.edit-contact-logs, #userCreateUserForm .well.newsletter')
                                .removeClass('disabled').find('input,select,textarea').removeAttr('disabled')
                            
                            $('.well.edit-contact-logs').hide();
                            $('.userUpdateSubmit.save').addClass('update')
                            var customer = $.firstOrOnly(r_fcp.Customer)
                            if (customer) {
                                $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other,#userCreateUserForm .well.language, .well.edit-contact-logs,#userCreateUserForm .well.newsletter')
                                    .removeClass('disabled')
                                $('#userCreateUserForm #userSalutation').val(customer.Name && customer.Name.Salutation)
                                $('#userCreateUserForm #userGender').val(customer.Name && customer.Gender)
                                $('#userCreateUserForm #userDOBhuman').val(customer.DateOfBirth)
                                $('#userCreateUserForm #userFirstName').val(customer.Name && customer.Name.FirstName).parents('.control-group').addClass('filled')
                                $('#userCreateUserForm #userLastName').val(customer.Name && customer.Name.LastName).parents('.control-group').addClass('filled')
                                var primaryPhone = _.find(customer.Phone, function (phone) {
                                    return phone.primary == "true"
                                })
                                if (primaryPhone) {
                                    $('#userCreateUserForm #userMainPhone').val(primaryPhone.type)
                                    $('#userCreateUserForm #userPhone').val(primaryPhone.PhoneNumber || (primaryPhone.PhoneData && primaryPhone.PhoneData.PhoneNumber)).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userPhoneExt').val(primaryPhone.PhoneData && primaryPhone.PhoneData.Extension).parents('.control-group').addClass('filled')
                                }
                            if(customer.SkiSettings){
                                $('#userCreateUserForm #userSkiSize').val(customer.SkiSettings.SkiSize)
                                $('#userCreateUserForm #userSkiBootSize').val(customer.SkiSettings.SkiBootSize)
                                $('#userCreateUserForm #userSkierType option').val(customer.SkiSettings.SkierType)
                                $('#userCreateUserForm #userCustomerType option').val(customer.SkiSettings.SkiCustomerType)
                                $('#userCreateUserForm #userSnowboardSize').val(customer.SkiSettings.SnowboardSize)
                                $('#userCreateUserForm #userSnowboardBootSize').val(customer.SkiSettings.SnowboardBootSize)
                                $('#userCreateUserForm #userDinNumber').val(customer.SkiSettings.DinNumber)
                                $('#userCreateUserForm #userAge').val(customer.SkiSettings.Age)
                                $('#userCreateUserForm #userWeight').val(customer.SkiSettings.Height)
                                $('#userCreateUserForm #userHeight').val(customer.SkiSettings.Weight)
                            }
                            if(customer.ClubSettings){
                                $('#userCreateUserForm #userListAddress').val(customer.ClubSettings.ListAddress)
                                $('#userCreateUserForm #userListEmail option').val(customer.ClubSettings.ListEmail == "Y" ? '1': '0')
                                $('#userCreateUserForm #userListPhone').val(customer.ClubSettings.ListPhone)
                                $('#userCreateUserForm #userMemberList option').val(customer.ClubSettings.MemberList == "Y" ? '1':'0')
                            }
                         

                                _.each(customer.Phone, function (phone) {
                                    $('#userCreateUserForm #userPhone' + phone.type).val(phone.PhoneNumber || (phone.PhoneData && phone.PhoneData.PhoneNumber))
                                    $('#userCreateUserForm #userPhone' + phone.type + 'Ext').val(phone.PhoneData && phone.PhoneData.Extension)
                                })
                                var homeAddress = _.find(customer.Address, function (address) {
                                    return address.type == "HOME"
                                })

                                if (homeAddress) {
                                    $('#userCreateUserForm #userHomeAddress1').val(homeAddress.Address1).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userHomeAddress2').val(homeAddress.Address2).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userHomeCity').val(homeAddress.City).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userHomeProvince').val(homeAddress.StateProv).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userHomeCountry').val(homeAddress.Country).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userHomePostalCode').val(homeAddress.PostCode).parents('.control-group').addClass('filled')
                                    if (!$('#userCreateUserForm #userHomeCountry').val() && homeAddress.Country) {
                                        $('#userCreateUserForm #userHomeCountry').val(
                                            $('#userCreateUserForm #userHomeCountry option').filter(function () { return $(this).html() == homeAddress.Country; }).val()
                                        )
                                    }
                                    if (!$('#userCreateUserForm #userHomeProvince').val() && homeAddress.StateProv) {
                                        $('#userCreateUserForm #userHomeProvince').val(
                                            $('#userCreateUserForm #userHomeProvince option').filter(function () { return $(this).html() == homeAddress.StateProv; }).val()
                                        )
                                    }
                                }
                                var otherAddress = _.find(customer.Address, function (address) {
                                    return address.type == "OTHER"
                                })
                                if (otherAddress) {
                                    $('#userCreateUserForm #userOtherAddress1').val(otherAddress.Address1).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userOtherAddress2').val(otherAddress.Address2).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userOtherCity').val(otherAddress.City).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userOtherProvince').val(otherAddress.StateProv).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userOtherCountry').val(otherAddress.Country).parents('.control-group').addClass('filled')
                                    $('#userCreateUserForm #userOtherPostalCode').val(otherAddress.PostCode).parents('.control-group').addClass('filled')
                                }
                                $('#userLanguage .btn').removeClass('active btn-primary')
                                $('#userLanguage' + _.invert(app.customization.submitLanguage)[customer.Language]).addClass('active btn-primary')
                                if (customer.NoEmail == 'N') {
                                    $('#userCreateUserForm #newsletter').attr('checked', 'checked')
                                }
                                if (customer.NoMail == 'N') {
                                    $('#userCreateUserForm #mailmarketing').attr('checked', 'checked')
                                }
                                if (customer.NoCall == 'N') {
                                    $('#userCreateUserForm #phonemarketing').attr('checked', 'checked')
                                }
                                if (customer.NoSMS == 'N') {
                                    $('#userCreateUserForm #smsmarketing').attr('checked', 'checked')
                                }
                            }
                            $('#nav').html(navbarTpl({
                                Customization: app.customization,
                                Localization: app.localization,
                                services: app.data.serviceTypes,
                                languages: app.data.languageNames,
                                siteName: app.localization.siteName,
                                backLink: app.customization.serverURL
                            }));
                            app.commonViewHelper.updateNavBar(service, app.language, !!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance, {})]);
                            $('#userCreateUserForm').trigger('login-success')
                        })
                } else {
                    var popoverPositionFn = function () {
                        this.$tip.css('display', 'none');
                        return $(document).width() < 768 ? 'in bottom' : 'right'
                    }
                    $('.control-group.userPassword1 .controls')
                        .popover({ content: '<span class="close" onclick="$($(this).parents(\'.popover\')).remove()" href="#">&times;</span>' + app.localization.newUser.passwordIncorrect, trigger: 'focus', selector: 'input', placement: popoverPositionFn, container: '#userCreateUserForm5' })
                    $('#userPassword1').focus()
                }
            },
            prepGCForm: function (categoryId, itemId, giftCertificates, packageCertificates, wrappings, shippings) {
                if(app.customization.googleAnalytics){
                    $(' #categoryTabs > li > a').click(function (e) {
                         e.preventDefault();
                         var category = $(this).attr('data-cat')
                         app.commonViewHelper.analyticsInit('requestGCSelectionCatClick', [giftCertificates, packageCertificates, category]);
                    });
                }

                addTabIndexToMailFields($('.deliverVia .delivery-option .gcPost.active').length > 0);

                function addTabIndexToMailFields(bool) {
                    var deliverByMail = $('.deliverVia .delivery-option .gcPost');
                    var accordionId = deliverByMail.data('target');
                    if(bool) {
                        $('.accordion-group .gcPost input, '+'.accordion-group .gcPost select').attr('tabindex',0);
                    }else {
                        $('.accordion-group .gcPost input, '+'.accordion-group .gcPost select').attr('tabindex',-1);
                    }
                }

                $('img.gcStyle').attr('tabindex',0).on('keydown', function(e){
                    if(e.keyCode == 13) {
                        e.target.click();
                    }
                })

                $('img.gcStyle').click(function () {
                    var parent = $(this).parents().eq(2),
                        greatParent = $(this).parents().eq(3),
                        value = $(this).attr('data-gcstyle');
                    parent.find('.gcStyleActive').attr('src', this.src);
                    greatParent.find('.gcStyleValue').val(value);
                });
                $('.accordion-inner').on('shown', function (obj) {
                    if ($(obj.target).parents('.giftCertCollapse').data('collapse')) {
                        $(obj.target).parents('.giftCertCollapse').collapse('reset')
                    }
                });
                $('.accordion-heading .accordion-toggle').click(function (e) {
                    if ($(e.currentTarget).children('i').length) {
                        $(e.currentTarget).find('i').toggleClass(function () {
                            return $(this).is('.icon-chevron-down, .icon-chevron-up') ? 'icon-chevron-up icon-chevron-down' : '';
                        })
                    }
                    var deliverVia = $(this).parent().siblings().find('div.btn-group')[0]
                    if ($(deliverVia).find('.gcEmail').hasClass('active')) {
                        var wrappingMethodDiv = $(this).parent().siblings().find('div.gcWrappingRadio a')
                        var shippingMethodDiv = $(this).parent().siblings().find('div.gcShippingRadio a')
                        if (wrappingMethodDiv.length > 0) {
                            wrappingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultemail') == "Y") {
                                    $(this).addClass('active');
                                    $(this).parent().css('display', 'none');
                                } else {
                                    return;
                                }
                            })
                        }
                        if (shippingMethodDiv.length > 0) {
                            shippingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultemail') == "Y") {
                                    $(this).addClass('active');
                                    $(this).parent().css('display', 'none');
                                } else {
                                    return;
                                }
                            })
                        }
                    }
                    app.commonViewHelper.analyticsInit('requestGCSelectionItemClick', [giftCertificates, packageCertificates, $(this).attr('data-itemid')]);
                })
                $('.delivery-option a').on('click', function (e) {
                    e.preventDefault();


                    var wrappingMethodDiv = $(this).parents('form').find('.gcWrapping .gcWrappingRadio a');
                    var shippingMethodDiv = $(this).parents('form').find('.gcShipping .gcShippingRadio a');
                    $(wrappingMethodDiv).removeClass('active');
                    $(shippingMethodDiv).removeClass('active');
                    var clickTarget = $(this).attr('data-target')
                    var deliverVia = $(this).parents('.deliverVia')
                    var form = $(this).parents('.giftCert').find('form');
                    deliverVia.find('.gcDeliverVia').each(function () {
                        $(this)['#' + $(this).attr('id') == clickTarget ? 'addClass' : 'removeClass']('in')
                    })
                    $(this).parents('.giftCertCollapse').collapse('reset');
                    if ($(this).data('value') == "E") {
                        if (wrappingMethodDiv.length > 0) {
                            wrappingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultemail') == "Y") {
                                    $(this).addClass('active');
                                    $(this).parent().css('display', 'none');
                                } else {
                                    $(this).css('display', '');
                                    return;
                                }
                            })
                        }
                        if (shippingMethodDiv.length > 0) {
                            shippingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultemail') == "Y") {
                                    $(this).parent().css('display', '');
                                    $(this).addClass('active');
                                    $(this).parent().css('display', 'none');
                                } else {
                                    $(this).css('display', '');
                                    return;
                                }
                            })
                        }
                        form.find('.componentGiftCertificate .gcPkgEmailAddress').show()
                    } else if ($(this).data('value') == "M") {
                        if (wrappingMethodDiv.length > 0) {
                            wrappingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultmail') == "Y") {
                                    $(this).parent().css('display', '');
                                    $(this).addClass('active');
                                } else {
                                    return;
                                }
                            })
                        }
                        if (shippingMethodDiv.length > 0) {
                            shippingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultmail') == "Y") {
                                    $(this).parent().css('display', '');
                                    $(this).addClass('active');
                                } else {
                                    return;
                                }
                            })
                        }
                        form.find('.componentGiftCertificate .gcPkgEmailAddress').hide();

                    } else if ($(this).data('value') == "P") {
                        if (wrappingMethodDiv.length > 0) {
                            wrappingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultpickup') == "Y") {
                                    $(this).parent().css('display', '');
                                    $(this).addClass('active');
                                } else {
                                    return;
                                }
                            })
                        }
                        if (shippingMethodDiv.length > 0) {
                            shippingMethodDiv.each(function () {
                                if ($(this).attr('data-defaultpickup') == "Y") {
                                    $(this).addClass('active');
                                    $(this).parent().css('display', 'none');
                                } else {
                                    return;
                                }
                            })
                        }
                        form.find('.componentGiftCertificate .gcPkgEmailAddress').hide()
                    }

                    addTabIndexToMailFields($(this).data('value') == "M");

                })
                $('.gcWrappingBtn').tooltip();
                $('.gcShippingBtn').tooltip();
                $('content.giftCertificates .accordion-toggle').on('click', function () {
                    app.dispatcher.updateURL('giftCertificates', 'show', [categoryId, $(this).attr('data-itemid')], true)
                })
                $('.submitGCForm').on('click', function (obj) {
                    obj.preventDefault();
                    var parent = $(obj.target).parents('.giftCert'),
                        form = parent.find('form');
                    if (form.find('.gcDeliverViaBtn.active').attr('data-value') == 'E') {
                        form.find('.componentGiftCertificate .gcPkgEmailAddress').each(function () {
                            if (!validEmail($(this).val())) {
                                $(this).addClass('required')
                                    .parents('.componentGiftCertCollapse').addClass('in').attr('style', null)
                            }
                        })
                    } else {
                        form.find('.componentGiftCertificate .gcPkgEmailAddress').removeClass('required')
                    }

                    form.find('.componentGiftCertificate .gcRecipient').each(function () {
                        if (!$(this).val()) {
                            $(this).addClass('required').parents('.componentGiftCertCollapse').addClass('in').attr('style', null)
                        }
                    })
                    var validateOptons = {
                        rules: {
                            gcEmailAddress: {
                                required: function (e) {
                                    return form.find('.gcEmail').hasClass('active');
                                }
                            },
                            gcPostAddress: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            },
                            gcPostCity: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            },
                            gcPostState: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            },
                            gcPostCountry: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            },
                            gcPostZip: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            },
                            gcExpress: {
                                required: function (e) {
                                    return form.find('.gcPost').hasClass('active');
                                }
                            }
                        }
                    };
                    form.validate(validateOptons);
                    $(obj.target).parents('.giftCertCollapse').css('height', '');
                    parent.find('.gcDeliverVia').css('height', '');
                    if (form.valid()) {
                        $('#progressIndicator').modal('show')
                        $('.submitGCForm').button('loading');
                        if (form.find('.gcType').val() == 'Package') {
                            var dataToSubmit = {
                                itemId: encodeURIComponent(form.find('.gcId').val()),
                                toName: encodeURIComponent(form.find('.gcRecipient').val()),
                                message: encodeURIComponent(form.find('.gcMessage').val() || ""),
                                method: encodeURIComponent(form.find('.gcDeliverViaBtn.active').attr('data-value') || ""),
                                layout: encodeURIComponent(form.find('.gcStyleValue').val() || ""),
                                email: encodeURIComponent(form.find('input.gcPkgEmailAddress').val() || ""),
                                address: encodeURIComponent(form.find('.gcPostAddress').val() || ""),
                                address2: encodeURIComponent(form.find('.gcPostAddress2').val() || ""),
                                city: encodeURIComponent(form.find('.gcPostCity').val() || ""),
                                state: encodeURIComponent(form.find('.gcPostState').val() || ""),
                                country: encodeURIComponent(form.find('.gcPostCountry').val() || ""),
                                zipcode: encodeURIComponent(form.find('.gcPostZip').val() || ""),
                                express: encodeURIComponent(form.find('.gcExpress').val() || ""),
                                wrappingid: encodeURIComponent(form.find('.gcWrappingBtn.active').attr('data-value') || ""),
                                shippingid: encodeURIComponent(form.find('.gcShippingBtn.active').attr('data-value') || ""),
                                packItems: []
                            }
                            $(form.find('.componentGiftCertificate')).each(function () {
                                dataToSubmit.packItems.push({
                                    PackageItemId: $(this).find('.gcPkgItemId').val(),
                                    EmailAddress: $(this).find('input.gcPkgEmailAddress').val() || '',
                                    IssueToName: $(this).find('.gcRecipient').val(),
                                    Layout: $(this).find('.gcStyleValue').val() || "",
                                    Message: $(this).find('.gcMessage').val() || ""
                                })
                            })
                            app.controllers.retailController.giftCertificatePurchase("arrayMode", dataToSubmit)
                        } else {

                            app.dispatcher.dispatch('giftCertificates', 'purchaseGC', [
                                encodeURIComponent(form.find('.gcId').val()),
                                encodeURIComponent(form.find('.gcRecipient').val()),
                                encodeURIComponent(form.find('.gcMessage').val() || ""),
                                encodeURIComponent(form.find('.gcDeliverViaBtn.active').attr('data-value') || ""),
                                encodeURIComponent(form.find('.gcStyleValue').val() || ""),
                                encodeURIComponent(form.find('input.gcPkgEmailAddress').val() || ""),
                                encodeURIComponent(form.find('.gcPostAddress').val() || ""),
                                encodeURIComponent(form.find('.gcPostAddress2').val() || ""),
                                encodeURIComponent(form.find('.gcPostCity').val() || ""),
                                encodeURIComponent(form.find('.gcPostState').val() || ""),
                                encodeURIComponent(form.find('.gcPostCountry').val() || ""),
                                encodeURIComponent(form.find('.gcPostZip').val() || ""),
                                encodeURIComponent(form.find('.gcExpress').val() || ""),
                                encodeURIComponent(form.find('.gcWrappingBtn.active').attr('data-value') || ""),
                                encodeURIComponent(form.find('.gcShippingBtn.active').attr('data-value') || "")
                            ])

                        }
                        // app.controllers.retailController.giftCertificatePurchase("arrayMode", dataToSubmit)
                        // app.dispatcher.dispatch('giftCertificates', 'purchaseGC', ["arrayMode", dataToSubmit])
                        return false;
                    } else {
                        return false;
                    }
                }
                )
            },
            prepClassModalClick: function(calEvent, jsEvent, view, spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group){
                var isQtyBookMode  =  !!(app.customization.spaBooking.spaClassQtyBookMode == true||(typeof app.customization.spaBooking.spaClassQtyBookMode == "function" 
                 && app.customization.spaBooking.spaClassQtyBookMode(calEvent,spaLocationId)))
                if(isQtyBookMode)  {
                     $('.non-qty-Mode-UI').css('display','none')
                     $('.qty-Mode-UI').css('display','block')
                    }
                else  {
                    $('.non-qty-Mode-UI').css('display','block')
                    $('.qty-Mode-UI').css('display','none')
                }
                var modifySpaQueue = function (spaQueue, selected_guest_id, equipment_name, equipment_id) {
                    for (var i = 0; i < spaQueue.length; i++) {
                        if (spaQueue[i].CustomerId == selected_guest_id) {
                            spaQueue[i].equipment_name = equipment_name
                            spaQueue[i].equipment_id = equipment_id
                            break; //Stop this loop, we found it!
                        }
                    }
                    app.datal('spaClassQueue',app.data.spaClassQueue)
                }
                
                app.datal("user_equipment_not_loggedin", app.data.user_equipment_not_loggedin||{})
                    app.datal('spaClassQueue',app.data.spaClassQueue||{})
                    app.datal('countOfGuest',app.data.countOfGuest||{})
                    app.datal('waitListedInCurrentSession',[])
                  //  app.datal('eligibleUsersForProgramOrClass',{})
                    // in case of optional class program. reset the store in cache before app initialize. --START
                    app.datal('store',{})
                    var store = null
                     if(app.data.optionalClassVueAppRef) store = app.data.optionalClassVueAppRef.$store;
                    if(store) store.commit('setStore');
                    app.data.optionalClassVueAppRef? app.data.optionalClassVueAppRef.$destroy():''
                    // in case of optional class program. reset the store in cache before app initialize. --END
                    var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location, calEvent.SpaClass))
                    var startTime = moment.tz(calEvent.SpaClass.StartTime, 'YYYY-MM-DDHHmm', bookingWindow.timeZone);
                    var endMinTime = startTime.clone()
                    var restrictedPmsEndMinTime;
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endMinTime.add(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endMinTime[unit](num)
                        })
                    }
                    var startMaxTime =  moment('2000-01-01')
                    if (!_.isEmpty(bookingWindow.startOffset)) {
                        startMaxTime = startTime.clone()
                        startMaxTime.add(bookingWindow.startOffset)
                    }
                    if (!_.isEmpty(bookingWindow.startSet)) {
                        _.each(bookingWindow.startSet, function (num, unit) {
                            startMaxTime[unit](num)
                        })
                    }
                    if(app.data.RestrictedFolio){
                        if(app.data.datesForRestrictedFolio) {
                            var restrictedDates = app.data.datesForRestrictedFolio;
                            var folioEndDate = moment(restrictedDates[restrictedDates.length-1].machine,'YYYY-MM-DD');
                            restrictedPmsEndMinTime =  folioEndDate 
                    }
                      var dateList = (location.PMSRoomMandatory == "Y" ? (!!app.data.pmsDateList ? (app.data.pmsDateList[location.PropertyId] || []) : []) : []);
                      if(dateList.length > 0){
                        restrictedPmsEndMinTime=  moment(dateList[dateList.length-1].machine, 'YYYY-MM-DD')
                      }
                    }
                    var now = moment.tz(bookingWindow.timeZone);
                    var future =endMinTime>now && ( restrictedPmsEndMinTime?startTime>=restrictedPmsEndMinTime:startMaxTime<=now)
                    isEventInFuture = future // endMinTime > now 
                    //booking window check -end
                    $('#eventModal').remove();
                    var modal = $('#eventModalTpl').clone().attr('id', 'eventModal').insertAfter('#eventModalTpl')
                    modal.find('#eventModalLabel').text(calEvent.SpaClass.SpaItemName);

                    //initializing class components if this is the program. Also if user is not logged in then check right away if it mandatory component meats requirment or not. In case of logged in user, check will happen soon user selects a member from a drop down.
                    if(calEvent.SpaClass.IsProgramHeader == "Y"){
                        var eventPrograms = {}
                        $.when(app.models.spaModel.getData('spaClassComponents', {ProgramId: calEvent.SpaClass.SpaClassId})).then(function(item){
                        eventPrograms[item.ProgramId] = item.SpaClassComponent
                        app.datal('eventPrograms',eventPrograms)
                        })
                    }
           
                    var reInitializeLayout = function (isLoggedIn, id) {
                        var className = isLoggedIn ? ' .guestopt .equipment_bike_map' : ' .equipment_bike_map.not_logged_in'
                        modal.find('#equippick' + id + className + ' #map').remove()
                        modal.find('#equippick' + id + className).append('<div id="map" class="hide_class" style="height: 341px;width:100%; border: 1px solid #AAA;float: left;box-sizing: border-box;border-top:none"></div>')
                        $('#equippick' + id + className + ' #map').removeClass("hide_class")
                        modal.find('#equippick' + id + className + ' .map-info').removeClass('hide_class')
                        modal.find('#equippick' + id + ' .equipment_bike_map.not_logged_in ').toggleClass('hide_class')
                    }

                   if (calEvent.SpaClass.ClassImage) {
                        modal.find('.image-container').removeClass('hide').addClass('span4')
                        modal.find('.description').removeClass('span12').addClass('span8')
                        modal.find('.image-container img').attr('src', calEvent.SpaClass.ClassImage)
                        modal.find('.serviceRecipientLabel').css('display', 'block')
                    } else {
                        modal.find('.image-container').addClass('hide').removeClass('span4')
                        modal.find('.description').addClass('span12').removeClass('span8')
                        modal.find('.serviceRecipientLabel').css('display', 'inline')
                    }
                    modal.find('.ItemDescription').html(nl2br(calEvent.SpaClass.ItemDescription))
                    modal.find('.AvailSlots').text(calEvent.SpaClass.AvailSlots)
                    modal.find('.SpaRoomId').text(calEvent.SpaClass.SpaRoomId)
                    if (calEvent.SpaClass.NumClasses == '1') {
                        modal.find('.hideIf1').addClass('hide')
                    } else {
                        modal.find('.hideIf1').removeClass('hide')
                    }
                    modal.find('.NumClasses').text(calEvent.SpaClass.NumClasses)
                    modal.find('.Price').text(app.localization.general.currencyPrefix + (+calEvent.SpaClass.Price).toFixed(2) + app.localization.general.currencyPostfix)
                    modal.find('.ServiceTime').text(calEvent.SpaClass.ServiceTime)
                    console.log("start time", calEvent.SpaClass.StartTime.toString("yyyy-MM-dd"))

                    modal.find('.c_class_start_time').text(rsDateToString(calEvent.SpaClass.StartTime, window.Date.CultureInfo.formatPatterns.shortTime))
                    modal.find('.StartTime').text(rsDateToString(calEvent.SpaClass.StartTime, window.Date.CultureInfo.formatPatterns.longDate))
                    modal.find('.valueGuestNameUnlessMe').val(guestName == 'me' ? '' : guestName).on('change', function () {
                        guestName = $(this).val()
                    })
                    modal.find('.availableSlots').text(app.localization.spaBooking.classSelection.availableSlots)
                    modal.find('.room').text(app.localization.spaBooking.classSelection.room)
                    modal.find('.numClasses').text(app.localization.spaBooking.classSelection.numClasses)
                    modal.find('.servicePriceLabel').text(app.localization.spaBooking.confirmation.servicePriceLabel)

                    modal.find('.serviceDurationLabel').text(app.localization.spaBooking.confirmation.serviceDurationLabel)
                    modal.find('.serviceEquipmentLabel').text(app.localization.spaBooking.confirmation.serviceEquipmentLabel)
                    
                    modal.find('.serviceguestClassLabel').text(app.localization.spaBooking.confirmation.serviceguestClassLabel)
                    modal.find('.serviceGroupMemberLabel').text( app.localization.spaBooking.classSelection.selectedMembers)
                    modal.find('.serviceNameLabel').text(app.localization.spaBooking.confirmation.serviceNameLabel)

                    modal.find('.serviceTimeLabel').text(app.localization.spaBooking.confirmation.serviceTimeLabel)
                    modal.find('.otherName').text(app.localization.spaBooking.serviceSelection.otherName)
                    modal.find('.meLabel').text(app.localization.spaBooking.serviceSelection.meLabel)
                    modal.find('.someoneLabel').text(app.localization.spaBooking.serviceSelection.someoneLabel)
                    modal.find('.otherNameLabel').text(app.localization.spaBooking.serviceSelection.otherNameLabel)
                    if (location.AllowOverbook == 'G') {
                        modal.find('.ifAllowOverbook').removeClass('hide')
                    } else {
                        modal.find('.ifAllowOverbook').addClass('hide')
                    }
                    $('.guestList').addClass('hide_class')
                    $('.guestopt .equipment_bike_dropdown .equipment_bike_selection').remove()
                    var showNotLoggedInEquipment = function showNotLoggedInEquipment(id, classObj) {
                        isEventInFuture ? modal.find('.spaEventButton').removeClass('disable_spaEventButton') : ''
            
                        var bookingObj = {
                            CustomerId: app.data.CustomerId ||app.data.DefaultCustomerId ,
                            CustomerName: '',
                            ItemId: id,
                            ClassId: calEvent.SpaClass.SpaClassId,
                            StartDateTime: calEvent.SpaClass.StartTime,
                            ProgramName: classObj.SpaItemName ||classObj.GroupItemName,
                            Price: classObj.Price || classObj.GroupItemPrice
                        }
                        // handle the case where guestNote Config is enabled - ui and api
                        if(app.customization.spaBooking.showClassItemNote){
                            var textAreaDOM =  $('<textarea  class="groupMemberClassNote" col="30"  placeholder="guest note"></textarea>')
                            textAreaDOM.insertBefore(modal.find('#equippick' + id+ ' .user-not-logged-in-equipment'))

                            modal.find('#equippick' + id + ' .groupMemberClassNote').on('change', function (e) {
                                bookingObj['guestNote'] = this.value
                            })
                        }

                        modal.find('.spaEventButton')
                        .attr('href',
                            "#/spaBooking/confirmEvent/" + spaLocationId
                            + "/" + calEvent.SpaClass.SpaClassId
                            + "/" + id
                            + "/" + calEvent.SpaClass.StartTime
                            + "/"+(!!calEvent.SpaClass.GroupItems ? 1: 0)
                        )
                        if (isEquipmentExist()) {
                            modal.find('#equippick' + id + ' .user-not-logged-in-equipment .info .spa-details-div').append('<p class="groupItemEquipment"><span class="serviceEquipmentLabel"> </span><span class="GroupItemEquipment "></span></p>')
                            modal.find('#equippick' + id + ' .serviceEquipmentLabel').text(app.localization.spaBooking.confirmation.serviceEquipmentLabel)
                            modal.find('#equippick' + id + ' .GroupItemEquipment').html(app.data.user_equipment_not_loggedin.equipment_name || app.localization.spaBooking.classSelection.noneSelected)
                            if (!user.Name) { // if user not logged in then map and equipment functionality is different
                                if (app.customization.spaBooking.serviceSelection.map[calEvent.SpaClass.ClassLayout] != undefined) {
                                    modal.find('#equippick' + id + ' .groupItemEquipment').append('<a class="openEquipMap">' + app.localization.spaBooking.classSelection.selectEquipOnMap + ' <i class="fas fa-chevron-left"></i></a>')

                                    modal.find('#equippick' + id + ' .user-not-logged-in-equipment .openEquipMap').on('click', function (e) {
                                        modal.find('.openEquipMap i').toggleClass('fa-chevron-left')
                                        modal.find('.openEquipMap i').toggleClass('fa-chevron-down')

                                        var equipment_layout_details = app.customization.spaBooking.serviceSelection.map[calEvent.SpaClass.ClassLayout]
                                        var uniqueIdForQueue = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId,
                                        equipments = calEvent.SpaClass.Equipments.EquipLabel

                                        reInitializeLayout(!!user.Name, id)
                                        equipmentMap.call(this, equipment_layout_details, equipments, false, "",uniqueIdForQueue, id)
                                        //  modal.find('#equippick' + id + '.equipment_bike_map not_logged_in').remove()
                                    })
                                } else {
                                    $(' #eventModal #equippick' + id + ' .equipment_bike_selection_div').append('<select class="equipment_bike_selection"><option  value="' + app.localization.spaBooking.classSelection.noneSelected + '">' + Localization.spaBooking.serviceSelection.equipmentsLabel + ' </option></select>')

                                    var equipments = calEvent.SpaClass.Equipments.EquipLabel
                                    _.each(equipments, function (bike) {
                                        if (bike.avail == "Y") {
                                            $('#equippick' + id + ' .equipment_bike_selection').append('<option data-id="' + bike.id + '" value="' + xmlEscape(bike.text) + '">' + xmlEscape(bike.text) + '</option>')
                                        }
                                    })
                                    console.log("calEvent.SpaClass.SpaItemId", calEvent.SpaClass.SpaItemId)
                                    $('#equippick' + id + ' .equipment_bike_selection').change(function () {


                                        if ($(this).children('option:first-child').is(':selected')) {
                                            //app.data.user_equipment_not_loggedin = {}
                                            bookingObj.equipment_id = ''
                                            bookingObj.equipment_name = ''
                                        } else {
                                            // app.data.user_equipment_not_loggedin = app.data.user_equipment_not_loggedin || {}
                                            bookingObj.equipment_id = $(this).find(':selected').data('id')
                                            bookingObj.equipment_name = $(this).val()
                                        }
                                        modal.find('#equippick' + id + ' .user-not-logged-in-equipment .info .groupItemEquipment .GroupItemEquipment').html($(this).val())
                                        //app.datal('user_equipment_not_loggedin', app.data.user_equipment_not_loggedin)
                                    })
                                }
                            }
                        }
                        app.data.user_equipment_not_loggedin = app.data.user_equipment_not_loggedin || {}
                        app.datal('user_equipment_not_loggedin', bookingObj)
                    }
                    //below function is responsible of performing the age restriction check and UI logic(which includes rendering of error messages,DOB picker,etc) only when user is will or has entered DOB using a Date picker
                    var AgeRestrictionDatePickerUIHandler = function AgeRestrictionDatePickerUIHandler(q){
                        var result = checkEligibilityByAge(q,q.birthdate,q.CustomerName,q.CustomerId,q.canEditGroupMember)
                        if ((!q.birthdate && (q.MaxAge || q.MinAge)) || (q.birthdate  && q.dateAddedByDatePicker)) {
                            //run eligiblity check on mount for existing user selection before closing event popup -START
                            if (!result.isValid) {
                              modal.find('#equippick' + q.ItemId).prepend(result.errorElement)
                            //  modal.find('#equippick' + q.ItemId + ' .selectNumberOfGuests').remove()
                            
                            } 
                            handleBookBtnAndQtyDropDownEligibility(q,q.CustomerId, result.isValid,result.requireUserToEnterDate, 'add')
                            //run eligiblity check on mount for existing user selection before closing event popup -END
                            renderDatePickerMessage(q)

                            // By default, it will render Date picker besides the individual guest entry. In case of quantity book mode, we need to render it somewhere else as there is no guest entry. ==START==
                            if(isQtyBookMode){
                                $(' <span class="optional-class-datepicker"><p class="age-validation-error-event"></p>'+app.localization.spaBooking.ageRestriction.yourDOB +': <input type = "text" class="qtyModeDatePicker" id = "datepicker-' + q.CustomerId + '" placeholder="MM/DD/YYYY"></span>').insertAfter(modal.find('#equippick' + q.ItemId).children().eq(0))
                            }
                            else{
                                $(".groupItemGuest[data-customerid='" + q.CustomerId + "']").prepend('  <span class="optional-class-datepicker"><p class="age-validation-error-event"></p> <input type = "text" id = "datepicker-' + q.CustomerId + '" placeholder="MM/DD/YYYY"></span>')

                                $(".groupItemGuest[data-customerid='" + q.CustomerId + "']").addClass   ("optional-class-datepicker-parent") // to adjust grid column
                            }
                            //==END==
                            
                         //handling the date selection and its validity
                            $(document).ready(function () {

                                var notValidDateError = isQtyBookMode?  $('#equippick' + q.ItemId + '') : $(".groupItemGuest[data-customerid='" + q.CustomerId + "']")
                                notValidDateError = $(notValidDateError).find(' .optional-class-datepicker .age-validation-error-event')

                                $('#datepicker-'+q.CustomerId).on('input',function(val){
                                     var date  = $(this).val()
                                     var isDateValid = isDate(date)
                                     if(date && isDateValid){
                                        notValidDateError.html('')
                                        handleClick(q, date, q.CustomerName, q.CustomerId)
                                     }
                                     else   notValidDateError.html(app.localization.spaBooking.ageRestriction.notValidDateFormat)
                                  
                                      function isDate (value) {
                                         return moment(value, 'MM/DD/YYYY', true).isValid()
                                     }
                                 })
                                $(function () {
                                    $('#datepicker-' + q.CustomerId).datepicker({
                                        onSelect: function (e) {
                                            notValidDateError.html('') // incase user entered the dob and was in wrong format. Selecting from date picker is always in correct format
                                            handleClick(q, e, q.CustomerName, q.CustomerId)
                                        },
                                        defaultDate:q.birthdate || ''
                                    })
                                    q.birthdate ?$("#datepicker-" + q.CustomerId ).val(q.birthdate):''
                                })
                            })
                            function handleClick(program,dob,cname,cid) {
                                //update birthdate in spa class queue; an object which keep array of all users (and their important details) selelected under program/class. 
                                _.find(app.data.spaClassQueue[program.StartDateTime+'-'+program.ClassId], function(user){
                                    if(user.CustomerId == q.CustomerId){
                                    user.birthdate = dob
                                    user.dateAddedByDatePicker = true
                                }// This is to indicate user didnt have birthdate before in their profile. This value is used to display datepicker again to edit a Dob 
                                });
                                 
                                app.datal("spaClassQueue",app.data.spaClassQueue)

                                var param ={
                                    "Customer.CustomerId": app.data.CustomerId,
                                    "Customer.CustomerGUID": app.data.CustomerGUID,
                                    "Customer.DateOfBirth": moment(dob).format('YYYY-MM-DD')
                                }
                                !!q.CustomerId && q.CustomerId != app.data.CustomerId? param["Customer.CustomerToChange"]=q.CustomerId:''
                                $.when(app.models.systemModel.getData('updateCustomerProfile', param))
                                    .then(function (r_cc) {
                                        var result = checkEligibilityByAge(program,dob,cname,cid)
                                        //remove error message to avoid dublicate
                                        modal.find('#equippick' + program.ItemId + ' #age-restriction-' + q.CustomerId + '').remove()
                                        //remove date picking warning instruction
                                        $('#datepicker-warning' + q.CustomerId).html('')
       
                                       if (!result.isValid) {
                                           //add error message
                                           modal.find('#equippick' + program.ItemId).prepend(result.errorElement)
                                       }
                                    
                                       handleBookBtnAndQtyDropDownEligibility(program,cid, result.isValid, result.requireUserToEnterDate, 'add')
                                       
                                       
                                    })
                                    .fail(function(err){
                                        $('#datepicker-warning' + q.CustomerId).html(app.localization.spaBooking.packageBooking.errors.failedToUpdateDOB )

                                    })
                            }
                            function renderDatePickerMessage(q){
                                if(q.birthdate) return;

                                modal.find('#equippick' + q.ItemId + '').prepend($('<p class="date-picker-warning-per-user" id = "datepicker-warning' + q.CustomerId + '"  >'+app.localization.spaBooking.ageRestriction.enterDobPreText+' '+xmlEscape(q.CustomerName)+ ' '+app.localization.spaBooking.ageRestriction.enterDobPostText+'</p>'))
                            }
                        }
                        else{
                            //since this function is directly called in case of qty mode, below code needs to run here, unlike a non qty mode where this function is not directly called so below code is added somewhere
                            if(isQtyBookMode){
                                var result = checkEligibilityByAge(q,q.birthdate,q.CustomerName,q.CustomerId,q.canEditGroupMember)
                                if(_.isEmpty(app.data.eligibleUsersForProgramOrClass) || app.data.eligibleUsersForProgramOrClass && app.data.eligibleUsersForProgramOrClass.isAllEligible){
                                    modal.find('#equippick' + q.ItemId + ' .age-restriction-class-error-message').remove()
                                }
                                if (!result.isValid) {
                                //   var itemId =  programOrCLass.SpaItemId || programOrCLass.id
                                    modal.find('#equippick' + q.ItemId + ' .age-restriction-class-error-message').remove()
                                    modal.find('#equippick' + q.ItemId).prepend(result.errorElement)
                                }
                                    handleBookBtnAndQtyDropDownEligibility(q,q.CustomerId, result.isValid,result.requireUserToEnterDate, 'add')
                            }      
                        }
                    }
                    var showLoggedInGuestEquipment = function showLoggedInGuestEquipment(q) {
                  
                        //Disabling this user from the dropdown of other group classes. -START
                        modal.find('.guests select.serviceRecipient option[value=' + q.CustomerId + ']').prop('disabled', true)
                        modal.find('.guests select.serviceRecipient').val('')
                        //END
                        guestsSelect = modal.find('#equippick' + q.ItemId + ' .guestList '),
                        guestName = modal.find('#equippick' + q.ItemId + ' .guestList .guestMem .guestMem-body'),
                        guestEquipment = modal.find('#equippick' + q.ItemId + ' .guestList .guestEquipment')
                        guestClass = modal.find('#equippick' + q.ItemId + ' .guestList .guestClass')

                        $('<span class="groupItemGuest GuestMem" data-classid="' + q.ItemId + '" data-customerid="' + q.CustomerId  + '"><span class="groupMemberName"> ' + xmlEscape(q.CustomerName) + '</span><i class="fa fa-trash-alt removeGuest" id="remove_guest_' + q.CustomerId + '" ></i></span><span class="GuestEquipment" id="guest_equip_' + q.CustomerId + '" data-customerid="' + q.CustomerId + '"> </span>').appendTo(guestName)
                        
                        if(app.customization.spaBooking.showClassItemNote){ 
                            $('<textarea  class="groupMemberClassNote" id="guest_note_' + q.CustomerId + '" data-customerid="' + q.CustomerId + '" placeholder="guest note"></textarea><br />').insertAfter(guestName.find('#guest_equip_' + q.CustomerId ))
                            //increase grid column section
                            guestName.addClass('classNoteColumnFix')
                        }
                       
                        // part of age restriction enhancement --START
                        //if there is no user birthdate defined in the  application and min and max for the program is defined, or birthdate is defined but it was previously set by date picker, then render datepicker again.
                        AgeRestrictionDatePickerUIHandler(q)
                        //// part of age restriciton enchancement --END

                
                        //If guest class Node enabled in the  customization  then store a guest note for this user
                        if (app.customization.spaBooking.showClassItemNote) {
                            // since this function also runs to render  bookings on mount, or on accordion change, if note was added , we wil prefill it
                            var existingBookingIndex = 0,
                                uniqueIdForQueue = calEvent.SpaClass.StartTime + '-' + calEvent.SpaClass.SpaClassId

                            _.each(app.data.spaClassQueue[uniqueIdForQueue], function (x, i) {
                                if (x.CustomerId == q.CustomerId) existingBookingIndex = i
                            })

                            var existingGuestNote = app.data.spaClassQueue[uniqueIdForQueue] && app.data.spaClassQueue[uniqueIdForQueue][existingBookingIndex].guestNote || ''
                            guestsSelect.find('#guest_note_' + q.CustomerId + '').val(existingGuestNote)

                            guestsSelect.find('#guest_note_' + q.CustomerId + '').on('change', function (e) {
                                var guestNote = this.value,
                                    uniqueIdForQueue = calEvent.SpaClass.StartTime + '-' + calEvent.SpaClass.SpaClassId
                                app.data.spaClassQueue[uniqueIdForQueue][existingBookingIndex]['guestNote'] = guestNote
                                app.datal('spaClassQueue', app.data.spaClassQueue)
                            })
                        }
                        //below logic runs when user removes a guest by clicking a recycle bin
                        $('#equippick' + q.ItemId + ' .guestList').removeClass('hide_class')
                        guestsSelect.find('#remove_guest_' + q.CustomerId + '').on('click', function (e) {
                            e.preventDefault();
                            decrementGuestCount()
                            //part of age restriction; remove any age restriction error message if it exists and also remove this user from app.data.eligibleUsersForProgramOrClass which is used to toggle the book btn
                            handleBookBtnAndQtyDropDownEligibility(q,q.CustomerId,'','','remove')

                            modal.find('#equippick' + q.ItemId + ' #age-restriction-'+q.CustomerId+'').remove()

                            modal.find('#equippick' + q.ItemId + ' #guest_note_'+q.CustomerId+'').next().remove()

                            modal.find('#equippick' + q.ItemId + ' #guest_note_'+q.CustomerId+'').remove()
                           
                            $('select.serviceRecipient').prop('disabled', false);
                           
                            //remove date picking warning instruction
                            $('#datepicker-warning' + q.CustomerId).remove()
                            //part of age restriction; remove any age --end
                            var removedEl = $(this).parents('span.groupItemGuest').remove(),
                                removedCustomerId = $(removedEl).attr('data-customerid')
                            //making sure i make equipment available if guest is rmeoved
                            var selected_equipment = $('#equippick' + q.ItemId + ' #guest_equip_' + removedCustomerId + ' .guest_equipment_name').text()
                            $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection option[value="' + selected_equipment + '"]').prop('disabled', false)
                            $('#equippick' + q.ItemId + ' #guest_equip_' + removedCustomerId).remove()
                            $('#equippick' + q.ItemId + ' #edit_guest_' + removedCustomerId).remove()
                            $('#equippick' + q.ItemId + ' #program_class_guest_' + removedCustomerId).remove()
                            modal.find(' .guests select.serviceRecipient option[value=' + removedCustomerId + ']').prop('disabled', false)
                            var uniqueIdForQueue = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId
                            app.data.spaClassQueue[uniqueIdForQueue] = _.filter(app.data.spaClassQueue[uniqueIdForQueue], function (x) {
                                return x.CustomerId != removedCustomerId
                            })
                            app.datal('spaClassQueue', app.data.spaClassQueue)
                            if (!app.data.spaClassQueue[uniqueIdForQueue].length) {
                                modal.find('.spaEventButton').removeClass('btn-primary')
                                modal.find('.serviceRecipient .selectMember').html(app.localization.spaBooking.serviceSelection.selectMember)
                            }
                            var specificClassFilteredQueue = _.filter(app.data.spaClassQueue[uniqueIdForQueue], function (x) {
                                return x.ItemId == q.ItemId
                            }) //to remove labels(group member and equipment) if that was the last guest in queue for this class
                            if (specificClassFilteredQueue.length <= 0) { //if no guest in queue
                                $('#equippick' + q.ItemId + ' .guestList').addClass('hide_class')
                                $("#equippick" + q.ItemId + " .guestopt .equipment_bike_dropdown .equipment_bike_selection").remove()
                                modal.find('#equippick' + q.ItemId + ' .guestopt .equipment_bike_map .map-info').addClass('hide_class')
                               
                            }
                            if (localStorage.getItem('editing_equipment_guest_id') == removedCustomerId) {
                                $("#equippick" + q.ItemId + " .guestopt .equipment_bike_dropdown .equipment_bike_selection").remove()
                                modal.find('#equippick' + q.ItemId + ' .guestopt .equipment_bike_map .map-info').addClass('hide_class')
                            }

                            function decrementGuestCount() {
                                // app.data.countOfGuest[activeItemId] = app.data.countOfGuest[activeItemId]
                                app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+q.ItemId+'-'+calEvent.SpaClass.StartTime]--
                                app.datal('countOfGuest', app.data.countOfGuest)
                                $('#' + q.ItemId + ' .countOfGuests').html(app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+q.ItemId+'-'+calEvent.SpaClass.StartTime])
                            }

                            //if no user selected then disable book button again
                            _.isEmpty(app.data.spaClassQueue[calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId]) ? modal.find('.spaEventButton').addClass('disable_spaEventButton') : ''

                            //part of new feature "optional class component"
                            //removing user from new optional class component vue app
                            if(app.data.optionalClassVueAppRef) {
                                var store = null;
                                store = app.data.optionalClassVueAppRef.$store;
                                store.commit('removeUser',{userId:removedCustomerId});
                            }
                            recheckAllItems();

                            function recheckAllItems() {
                                var availableSlots = calEvent.SpaClass.AvailSlots;

                                app.data.spaClassQueue[uniqueIdForQueue].forEach(function(booking, idx){
                                    if(idx+1 <= availableSlots && booking.isWaitListed === true) {
                                        booking.isWaitListed = false;
                                        var el = $('#equippick' + q.ItemId + ' #guest_equip_' + booking.CustomerId + ' .guest_equipment_name_waitlisted');
                                        if(el.text() === app.localization.spaBooking.classSelection.addedToWaitListText) { 
                                            $('#equippick' + q.ItemId + ' #guest_equip_' + booking.CustomerId + ' .guest_equipment_name_waitlisted').remove();
                                        }
                                    }
                                });

                                app.datal('spaClassQueue', app.data.spaClassQueue);
                            }
                        })

                        function handleBookedOrWaitlisted(q) {
                            var GroupCustomerId = app.data.CustomerId != q.CustomerId ? q.CustomerId : ''
                            var isAlreadyWaitListed = false;
                            if(app.data.waitListedInCurrentSession[q.CustomerId] == q.StartDateTime){// waitlisted in folio
                                addWaitListText(q, app.localization.spaBooking.classSelection.waitListedNotConfirmed)
                            }
                            else{ //waitlisted confirmed
                            $.when(app.models.userModel.getData('fetchCustomerSpaBookings', {
                                CustomerId: app.data.CustomerId,
                                CustomerGUID: app.data.CustomerGUID,
                                GroupCustomerId: GroupCustomerId
                            })).always(function (x) {
                                if (!x.rawData || !x.rawData.SpaClassWaitList) {
                                    addWaitListText(q, app.localization.spaBooking.classSelection.addedToWaitListText)
                                    return;
                                }
                                _.each([].concat(x.rawData.SpaClassWaitList), function (wait) {
                                    if (q.ItemId == wait.WaitListItemId && q.StartDateTime == wait.WaitListStartDatetime) isAlreadyWaitListed = true
                                })
                                addWaitListText(q, app.localization.spaBooking.classSelection[isAlreadyWaitListed?'AlreadyWaitlisted':'addedToWaitListText'])
                            })
                        }

                            function addWaitListText(guest, text) {
                                $('#equippick' + guest.ItemId + ' #guest_equip_' + guest.CustomerId).append($('<span class="guest_equipment_name guest_equipment_name_waitlisted">' + text + '</span>'))
                                guest.equipment_name = text
                            }
                        }
                        if (!q.isWaitListed) {

                            $('#equippick' + q.ItemId + ' #guest_equip_' + q.CustomerId).append($('<span class="guest_equipment_name actual-equipment">' + xmlEscape(q.equipment_name) + '</span>'))

                            // $('#equippick' + q.ItemId + ' #guest_equip_' + q.CustomerId + ' .guest_equipment_name ').html().addClass('actual-equipment')
                            $('<i  id="edit_guest_' + q.CustomerId + '" data-customerid="' + q.CustomerId + '" class="fa fa-pen edit_guest actual-equipment " ></i>').appendTo(modal.find('#equippick' + q.ItemId + ' .guestList #guest_equip_' + q.CustomerId + ''))
                        } else handleBookedOrWaitlisted(q)

                        if (!isEquipmentExist()) {
                            $("#guest_equip_" + q.CustomerId + " .actual-equipment").css('visibility', 'hidden')
                            $('.serviceEquipmentLabel').css('visibility', 'hidden')
                        } else {
                            guestsSelect.find('#edit_guest_' + q.CustomerId + '').on('click', function (e) {
                                e.preventDefault()
                                var spaQueue = app.data.spaClassQueue[calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId]
                                var selected_guest_id = $(this).attr('data-customerid') //customer id
                                localStorage.setItem("editing_equipment_guest_id", selected_guest_id)
                                var hasMapLayout = !!app.customization.spaBooking.serviceSelection.map[calEvent.SpaClass.ClassLayout]
                                //adding editing text
                                $('.GuestEquipment').css('background-color', 'transparent')
                                $('.currentlyEditingEquipmentText').remove()
                                $('#equippick' + q.ItemId + ' #guest_equip_' + selected_guest_id).append('<p class="currentlyEditingEquipmentText"><i class="fas fa-arrow-left"></i> ' + app.localization.spaBooking.classSelection.currentlyEditingEquipText + '</p>')

                                if (hasMapLayout) { // means map layout available
                                    var equipment_layout_details = app.customization.spaBooking.serviceSelection.map[calEvent.SpaClass.ClassLayout]
                                    var equipments = ""
                                    if (calEvent.SpaClass.Equipments.EquipLabel != undefined) {
                                        equipments = calEvent.SpaClass.Equipments.EquipLabel
                                    }
                                    reInitializeLayout(!!user.Name, q.ItemId)
                                    var uniqueIdForQueue = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId
                                    equipmentMap.call(this, equipment_layout_details, equipments, true, selected_guest_id, uniqueIdForQueue, q.ItemId)
                                    // $('.modal-body').animate({
                                    //     scrollTop: $("#map").offset().top - 250
                                    // }, 700);
                                    // window.scrollTo({
                                    //     top: document.body.scrollHeight + 60,
                                    //     left: 0,
                                    //     behavior: 'smooth'
                                    // })

                                } else { // if no layout
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection').remove()
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown').append('<select class="equipment_bike_selection"></select>')
                                    var equipments = [].concat(calEvent.SpaClass.Equipments.EquipLabel)
                                    _.each(equipments, function (bike) {
                                        if (bike.avail == "Y") {
                                            $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection').append('<option value="' + escapeJSString(bike.text) + '" data-id="' + bike.id + '">' + xmlEscape(bike.text) + '</option>')
                                        }
                                    })
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection').change(function () {
                                        modal.find('#equippick' + q.ItemId + ' #guest_equip_' + selected_guest_id + ' .guest_equipment_name').html($(this).val())
                                        modifySpaQueue(spaQueue, selected_guest_id, $(this).val(), $(this).find(':selected').data('id'))
                                        if ($(this).children('option:first-child').is(':selected')) {
                                            modifySpaQueue(spaQueue, selected_guest_id, "", "")
                                        }
                                    })
                                    var selected_equipment = $('#equippick' + q.ItemId + '  #guest_equip_' + selected_guest_id + ' .guest_equipment_name').text()
                                    $('#equippick' + q.ItemId + '  .guestopt .equipment_bike_dropdown .equipment_bike_selection').val(selected_equipment)
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection').prepend($(' <option  value="' + app.localization.spaBooking.classSelection.noneSelected + '">' + Localization.spaBooking.serviceSelection.equipmentsLabel + '</option>'))
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection option[value="' + selected_equipment + '"]').prop('disabled', true)
                                    for (var i = 0; i < spaQueue.length; i++) {
                                        $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection option[value="' + spaQueue[i].equipment_name + '"]').prop('disabled', true)

                                    }
                                    $('#equippick' + q.ItemId + ' .guestopt .equipment_bike_dropdown .equipment_bike_selection option[value="' + selected_equipment + '"]').prop('disabled', false)
                                }


                            })
                        }
                    }
                    var isEquipmentExist = function(){
                        var equipments = [].concat(calEvent.SpaClass.Equipments.EquipLabel)
                        var exist= false
                        if(_.isEmpty(equipments)) return exist
                        _.each(equipments,function(equip){
                            if ((equip|| {}).avail == "Y") exist = true
                        })
                        
                        return exist;
                    }
                    modal.find('.groupItem:not(.primary)').remove()
                    modal.find('.modal-body .row-fluid .select_c').empty()

                     modal.find('.modal-body .row-fluid .select_c').append( '<div class="accordion-class-list" id="accordion2"><div class="accordion-section"></div></div> ')
                     var countOfGuest =   app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+calEvent.SpaClass.SpaItemId+'-'+calEvent.SpaClass.StartTime] ||0
                     modal.find('.modal-body .row-fluid .select_c .accordion-section').append(' <a  class=" accordion-section-title  " id="' + calEvent.SpaClass.SpaItemId + '"  href="#accordion-' + calEvent.SpaClass.SpaItemId + '"><span class="accordionEquipmentClass-itemName">'+ xmlEscape(calEvent.SpaClass.SpaItemName) + '</span><span class="countOfGuestsLabel">'+app.localization.spaBooking.classSelection.NoOfGuest+'<span class="countOfGuests">'+countOfGuest+'</span></span><span class="accordionEquipmentClass-time-price"> ' + app.localization.general.currencyPrefix + (+calEvent.SpaClass.Price).toFixed(2) + app.localization.general.currencyPostfix + ' - ' + calEvent.SpaClass.ServiceTime + app.localization.spaBooking.classSelection.Minute + '</span></a> <div  id="accordion-' + calEvent.SpaClass.SpaItemId + '" class="accordion-section-content" ><div class="class-list-selection-body"><div class="nongrid-img-dec"> <div  class="class-list-selection-body-desc">' + nl2br(calEvent.SpaClass.ItemDescription)+ '</div><div  class="service-details-clientInstruction">' + nl2br(calEvent.SpaClass.Instructions)+ '</div></div><div id="equippick' + calEvent.SpaClass.SpaItemId + '" class="equippick' + '">ttt</div></div></div> ')
                   //  modal.find('.guestopt selectNumberOfGuests').attr('id',calEvent.SpaClass.SpaItemId)

        
                   setTimeout(function(){ $('.select_c #' + calEvent.SpaClass.SpaItemId).click()}, 100);
                    if(!user.Name){
                        $('.countOfGuestsLabel').css('visibility','hidden')
                    }
                    

                             //map function
                    var equipmentMap = function (equipment_layout_details, equipments, isLoggedIn, guest_equipment, spa_class_unique_id,classItemId) {
                        var mapConfig =  app.customization.spaBooking.serviceSelection.MapConfig
                       // if (map != undefined) { map.remove() }
                        var map = L.map('map', {
                            minZoom: mapConfig.minZoom,
                            maxZoom: mapConfig.maxZoom,
                            center: mapConfig.center,
                            zoom: mapConfig.defaultZoom,
                            maxBoundsViscosity: 1,
                            tap:false,
                            crs: L.CRS.Simple,
                        })
                        var layout = equipment_layout_details.imageConfiguration
                        var image = L.imageOverlay(layout.imgUrl, [
                            layout.leftRightBound,
                            layout.upDownBound
                        ]); //initial size ( at zoom 0, double size at zoom 1 )
                        image.addTo(map);
                        // tell leaflet that the map is exactly as big as the image
                        map.setMaxBounds(new L.LatLngBounds(layout.leftRightBound, layout.upDownBound)); // prevent panning outside the image area 
                          var popup = L.popup();
                          function onMapClick(e) {
                            popup
                              .setLatLng(e.latlng)
                              .setContent("You clicked the map at " + e.latlng.toString())
                              .openOn(map);
                          }
                          mapConfig.showLongLatOnMap ? map.on('click', onMapClick) : ''
                          map.on('click', function() { 
                           var b = map.getBounds()
                           // map.dragging.enable();
                       });
                        icon = L.divIcon({ className: 'numberCircle ', iconAnchor: [7.75, 15.5], iconSize: equipment_layout_details.icon.size, popupAnchor: [4, -120] })
                        if (isLoggedIn) {
                            var currently_editing_guest = guest_equipment;
                            $('#remove_guest_' + guest_equipment).on('click', function (e) {
                                if (localStorage.getItem('editing_equipment_guest_id') == guest_equipment) {
                                    modal.find('#equippick'+classItemId+' .guestopt .equipment_bike_map #map').remove()
                                }
                                else {
                                    var currently_editing_guest = localStorage.getItem('editing_equipment_guest_id')
                                    $('#equippick'+classItemId+' #edit_guest_' + currently_editing_guest).click()
                                }
                            })
                        }
                        var selection = function (e) {
                            var isEquipmentSelected = this._icon.classList.contains('numberCircleInCart')
                            var prev_selected_equipment = ($('#equippick'+classItemId+' #guest_equip_' + guest_equipment + ' .guest_equipment_name').text()).trim()
                            if (!isEquipmentSelected) {
                                this._icon.classList.toggle("numberCircleselected")
                                this._icon.classList.toggle("numberCircleavailable")
                            }
                            var id = this.options.id
                            var name = this.options.name
                           var spaQueue = app.data.spaClassQueue[spa_class_unique_id] || ''
                            var isSelected = this._icon.classList.contains('numberCircleselected')
                            if (isLoggedIn) {
                                if (isSelected) {
                                    $('#equippick'+classItemId+' #guest_equip_' + guest_equipment+ ' .guest_equipment_name').html( xmlEscape(name))
                                    for (var i = 0; i < spaQueue.length; i++) {
                                        if (spaQueue[i].CustomerId == guest_equipment) {
                                            spaQueue[i].equipment_name = name;
                                            spaQueue[i].equipment_id = id;
                                            break; //Stop this loop, we found it!
                                        }
                                    }
                                    map.eachLayer(function (layer) {
                                        if (layer.options.name != name) {
                                            console.log("this layer", layer)
                                            if (layer._icon != undefined) {
                                            replaceClass(layer._icon,'numberCircleselected','numberCircleavailable') 
                                            }
                                        }
                                        if (layer.options.name === prev_selected_equipment) {
                                            if (layer._icon != undefined) {
                                                replaceClass(layer._icon,'numberCircleInCart','numberCircleavailable') 
                                            }
                                        }
                                    });
                                }
                                else if (isEquipmentSelected && this.options.name == prev_selected_equipment) {
                                    replaceClass(this._icon,'numberCircleInCart','numberCircleselected') 
                                    this._icon.classList.toggle("numberCircleselected")
                                    this._icon.classList.toggle("numberCircleavailable")
                                    for (var i = 0; i < spaQueue.length; i++) {
                                        if (spaQueue[i].CustomerId == guest_equipment) {
                                            spaQueue[i].equipment_name = app.localization.spaBooking.classSelection.noneSelected;
                                            spaQueue[i].equipment_id = '';
                                            break; //Stop this loop, we found it!
                                        }
                                    }
                                }
                                else if (isEquipmentSelected && this.options.name != prev_selected_equipment) {
                                }
                                else {
                                    $('#equippick'+classItemId+' #guest_equip_' + guest_equipment+ ' .guest_equipment_name').html(app.localization.spaBooking.classSelection.noneSelected)
                                    console.log(guest_equipment)
                                    for (var i = 0; i < spaQueue.length; i++) {
                                        if (spaQueue[i].CustomerId == guest_equipment) {
                                            spaQueue[i].equipment_name = app.localization.spaBooking.classSelection.noneSelected;
                                            spaQueue[i].equipment_id = '';
                                            break; //Stop this loop, we found it!
                                        }
                                    }
                                   
                                }
                                app.datal('spaClassQueue',app.data.spaClassQueue)
                            }
                            else {
                                if (isSelected) { 
                                    modal.find('#equippick'+classItemId+' .user-not-logged-in-equipment .info .groupItemEquipment .GroupItemEquipment').html(xmlEscape(name))
                                    app.data.user_equipment_not_loggedin = app.data.user_equipment_not_loggedin || {}
                                    app.data.user_equipment_not_loggedin.equipment_id = id
                                    app.data.user_equipment_not_loggedin.equipment_name = name
                                    map.eachLayer(function (layer) {
                                        if (layer.options.name != name) {
                                            if (layer._icon != undefined) {
                                                replaceClass(layer._icon,'numberCircleselected','numberCircleavailable') 
                                            }
                                        }
                                    });
                                }
                                else{
                                    modal.find('#equippick'+classItemId+' .user-not-logged-in-equipment .info .groupItemEquipment .GroupItemEquipment').html(app.localization.spaBooking.classSelection.noneSelected) 
                                    app.data.user_equipment_not_loggedin.equipment_id = ''
                                    app.data.user_equipment_not_loggedin.equipment_name = ''}
                                app.datal('user_equipment_not_loggedin',app.data.user_equipment_not_loggedin)
                            }
                           
                        }
                        var aval = []
                        var reserved = []
                        var CabanaList = []
                        var spaQueue = [];
                        if (app.data.spaClassQueue != undefined) {
                            spaQueue = app.data.spaClassQueue[spa_class_unique_id]
                            app.datal('spaClassQueue',app.data.spaClassQueue)
                        }
                        _.each(equipment_layout_details.configuration, function (idx, val) {
                            idx.marker = L.marker([idx.lat, idx.long], {
                                icon: icon,
                                id: idx.id,
                                name: val  
                            }).bindTooltip(idx.name).addTo(map)
                            idx.marker._icon.classList.add("numberCirclereserved")
                            idx.marker._icon.innerHTML = idx.number
                            idx.marker._icon.title = name
                            CabanaList.push(idx.marker.options)
                        })
                        _.each(equipments, function (bike) {
                            _.each(equipment_layout_details.configuration, function (idx, val) {
                                if ((val === bike.text) && bike.avail == "Y") {
                                    if (idx.marker != undefined) {
                                        aval.push(idx.marker.options)
                                    }
                                }
                            })
                        })
                        aval = _.uniq(aval)
                        reserved = CabanaList.filter(function (x) {
                            return !_.contains(aval,x)
                        })
                        if (isLoggedIn) {  for (var i = 0; i < spaQueue.length; i++) {
                            map.eachLayer(function (layer) {
                                if (layer.options != undefined && spaQueue[i].equipment_name != app.localization.spaBooking.classSelection.noneSelected) {
                                    if (layer.options.name === spaQueue[i].equipment_name) {
                                        replaceClass(layer._icon,'numberCirclereserved','numberCircleInCart') 
                                        layer.on({
                                            click: selection
                                        })
                                    }
                                }
                            });
                        }
                    }
                        aval.forEach(function (cabana) {
                            map.eachLayer(function (layer) {
                                if (layer.options.name === cabana.name) {
                                    replaceClass(layer._icon,'numberCirclereserved','numberCircleavailable') 
                                    layer.on({
                                        click: selection
                                    })
                                }
                            });
                        })
                        map.eachLayer(function (layer) {
                            if (layer.options != undefined) {
                                var prev_selected_equipment = isLoggedIn ? ($('#equippick'+classItemId+' #guest_equip_' + guest_equipment+ ' .guest_equipment_name').text()).trim() : modal.find('#equippick'+classItemId+' .user-not-logged-in-equipment .info .groupItemEquipment .GroupItemEquipment').html()
                                var c = isLoggedIn? 'numberCircleInCart': 'numberCircleavailable'
                                if (layer.options.name === prev_selected_equipment) {
                                    replaceClass(layer._icon,c,'numberCircleselected')
                                }
                            }
                        })
                        function replaceClass(elem,oldClass,newClass) {
                            $(elem).wrap(function () {
                                if ($(this).hasClass(oldClass)){
                                    $(this).removeClass(oldClass).addClass(newClass)
                                 }
                            })
                        }
                    }
                    function createEquipmentCloneForEachClass(id, classObj) {
                        modal.find('.equippick').empty()
                        var clonedEquip = modal.find(user.Name ? '.guestopt' : '.user-not-logged-in-equipment').clone(true)
                        $('#equippick' + id).append(clonedEquip),
                        uniqueId = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId
                        if(isQtyBookMode && app.data.userLoggedIn){
                            //render quantity
                            //Because we are not selecting a guest in this situation, by default age restriction check will happen against the loggedIn user automatically
                            
                            var programOrCLass =   classObj.SpaClass || classObj,
                            programName =  classObj.GroupItemName || classObj.SpaItemName,               
                            bookingObject = {
                                CustomerId: user.CustomerId,
                                CustomerName: user.Name.FirstName + ' ' + user.Name.LastName,
                                ItemId: id /*calEvent.SpaClass.SpaItemId*/ ,
                                ClassId: calEvent.SpaClass.SpaClassId,
                                StartDateTime: calEvent.SpaClass.StartTime,
                                ProgramName: programName,
                                MinAge: programOrCLass.MinAge ,
                                MaxAge: programOrCLass.MaxAge,
                                birthdate:user.DateOfBirth,
                                canEditGroupMember:true //set to true because main user doesnt have thiss setting
                            }
                            var ItemGuestQty = 0,
                            guestNotePerBooking = ''
                            if(app.data.spaClassQueue && app.data.spaClassQueue[uniqueId]){
                                 _.each(app.data.spaClassQueue[uniqueId],function(booking){
                                    if(booking.ItemId == id){
                                       
                                        ItemGuestQty++;
                                        guestNotePerBooking = booking.guestNote,
                                        bookingObject.birthdate = booking.birthdate ,
                                        bookingObject.dateAddedByDatePicker = booking.dateAddedByDatePicker
                                    }
                                })

                            }
                      
                           // app.datal()
                            //handling dropdown selection, available slot filtering, and guest notes on group item toggling or on mount
                            ItemGuestQty > 0 ? $('#accordion-'+id).find('#qtyOption-'+calEvent.SpaClass.StartTime+'-'+ItemGuestQty).attr('selected','selected'): ''

                            !!guestNotePerBooking ? $('#accordion-'+id).find('#spaGuestNote').val( guestNotePerBooking) : ''

                            var remainingSlot = calEvent.SpaClass.AvailSlots - (app.data.spaClassQueue && app.data.spaClassQueue[uniqueId]? (app.data.spaClassQueue[uniqueId].length -ItemGuestQty):'')
                            
                          
                           
                            $('.selectNumberOfGuests > option').each(function () {
                                var optionValue = $(this).val()
                                if (+optionValue > remainingSlot)
                                    $(this).attr("disabled", "disabled")
                                else   $(this).removeAttr("disabled")
                            });
                            AgeRestrictionDatePickerUIHandler(bookingObject)
                        } else   handleRenderLogic();

                        
                        function handleRenderLogic() {
                                if (user.Name) {
                                    //below code runs on mount. It mounts all the user entires for that program/class. Below code handles the toggling of the book btn on mount
                                    if (app.data.spaClassQueue && app.data.spaClassQueue[uniqueId]  && !_.isEmpty(app.data.spaClassQueue[uniqueId]) ) {
                                        modal.find('.serviceRecipient .selectMember').html(app.localization.spaBooking.serviceSelection.addMoreGuests)

                                        var GuestListForThisProgram = _.filter(app.data.spaClassQueue[uniqueId], function (x) {
                                            return x.ClassId == calEvent.SpaClass.SpaClassId && calEvent.SpaClass.StartTime == x.StartDateTime
                                        })
                                        modal.find('.spaEventButton').toggleClass('disable_spaEventButton', _.isEmpty(GuestListForThisProgram) || !isEventInFuture)
                                        _.each(GuestListForThisProgram, function (guest) {
                                            showLoggedInGuestEquipment(guest)
                                        })
                                    }
                                } else showNotLoggedInEquipment(id, classObj)
                        }
                    }
                    
                    $('.select_c #' + calEvent.SpaClass.SpaItemId).click(function (e) {
                        $('.groupItem').removeClass('hide_class')
                        $('.groupItem').addClass('hide_class')
                        $("div[data-classid='']").removeClass('hide_class');
                        $('.modal-header #eventModalLabel').html(xmlEscape(calEvent.SpaClass.SpaItemName))
                        createEquipmentCloneForEachClass( calEvent.SpaClass.SpaItemId,calEvent.SpaClass)  
                        //auto run age restriction check when user is not loggedin. When user is logged in, it will run upon guest selection
                        if(!app.data.userLoggedIn){
                        var eligibilityCheckResult = checkEligibilityByAge(calEvent.SpaClass)
                            if(!eligibilityCheckResult.isValid) {
                                modal.find('#equippick' + calEvent.SpaClass.SpaItemId).prepend(eligibilityCheckResult.errorElement)
                            }
                    
                            modal.find('.spaEventButton').toggleClass('disable_spaEventButton', !eligibilityCheckResult.isValid || !isEventInFuture)
                        }
                    
                    })
                    modal.find('.groupItem').data('groupItem', calEvent.SpaClass).attr('data-classid', "")
                    modal.find('.guestopt .serviceRecipient option:not(.recipientSelf,.selectMember,.newMemberOption), .guestopt .groupItemGuest').remove()
                    modal.find('.guestopt .serviceRecipient option').prop('disabled', false)

                    if (user.Name) {
                        modal.find('.modal-footer').css("display", "none")
                        modal.find('.guestopt a.selectGuest').text(app.localization.spaBooking.classSelection.selectGroupItem).removeClass('btn-primary')
                        modal.find('.serviceRecipientLabel').text(app.localization.spaBooking.confirmation.serviceRecipientLabel)
                        modal.find('.loginPrompt').hide();
                        modal.find('.guestopt .serviceRecipient').show();
                        
                        var recipientSelf = modal.find('.guestopt .serviceRecipient option.recipientSelf')
                            .val(user.CustomerId)
                            .text(user.Name.FirstName + ' ' + user.Name.LastName)
                            .attr('data-gender', user.Gender)
                            .attr('data-birthdate', user.DateOfBirth)
                  
                         
                        _.each(group, function (member) {
                       
                            var memberEl = recipientSelf.clone()
                            memberEl
                                .removeClass('recipientSelf')
                                .val(member.CustomerId)
                                .text(member.Name.FirstName + ' ' + member.Name.LastName)
                                .attr('data-gender', member.Gender)
                                .attr('data-birthdate', member.DateOfBirth)
                                .attr('data-canEdit', member.CanEdit)
                                .insertAfter(recipientSelf);
                        })
                        //for disabling main user also if user has already reserved a service at start time of service, then disable that user also(unless location allows overbook) and in case user refresh; if user has already added some guests, then disable them from dropdown
                        disableOccupiedGuest()
                        disableGuestIfReserved()

                        function disableOccupiedGuest(CustomerId) {
                            _.each(app.data.spaClassQueue[calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId] || [], function (user) {
                                _.each(group, function (member) {
                                    disableDropDownOption(member.CustomerId)
                                })
                                disableDropDownOption(user.CustomerId)
                            })
                            function disableDropDownOption(CustomerId) {
                                if (CustomerId == user.CustomerId && calEvent.SpaClass.StartTime == user.StartDateTime) modal.find('.guests select.serviceRecipient option[value=' + user.CustomerId + ']').prop('disabled', true)
                            }
                        }
                        function disableGuestIfReserved(){
                          
                            $.when(app.models.systemModel.getData('folioBookings', {})).then(function (folioBookings) {
                                var cartData = folioBookings.WebFolioItem
                             
                                var waitlistedList = {}
                                _.each(cartData, function (folio) {
                                    _.each(group, function (member) {
                                        disableDropDownAndHandleWaitList(folio, member.CustomerId, waitlistedList)
                                    })
                                    disableDropDownAndHandleWaitList(folio, user.CustomerId, waitlistedList) // main user which is not in group data
                                })
                                app.datal('waitListedInCurrentSession', waitlistedList)
                            })
                            function disableDropDownAndHandleWaitList(folio,CustomerId,waitlistedList) {
                                if (folio.CustomerId == CustomerId && calEvent.SpaClass.StartTime == folio.StartDate && folio.Category == "Spa" || location.AllowOverBook == "G") {
                                    modal.find('.guests select.serviceRecipient option[value=' + CustomerId + ']').prop('disabled', true)
                                }
                                //storing waitlisting members for checking on confirmation screen
                                if (folio.Category == "SpaWait") {
                                    waitlistedList[folio.CustomerId] = folio.StartDate
                                }
                            }
                        }
                    } else {
                        modal.find('.modal-footer').remove()
                        modal.find('.guestopt a.selectGuest').text(app.localization.spaBooking.classSelection.book).addClass('btn-primary')
                        modal.find('.serviceRecipientLabel').text(app.localization.spaBooking.classSelection.bookClassLabel)
                        modal.find('.loginPrompt').show();
                        modal.find('.guestopt .serviceRecipient').hide();
                        modal.find('.loginPrompt .textBefore').text(app.localization.spaBooking.areYouAMember);
                        modal.find('.loginPrompt a')
                            .attr('href', '#/profile/login/next' + document.location.hash.replace('#', ''))
                            .text(app.localization.general.login.loginButtonLabel);
                        modal.find('.loginPrompt .textAfter').text(app.localization.spaBooking.loginToReceive)
                        if (calEvent.SpaClass.AvailSlots >= 1) {
                            modal.find('.guestopt .serviceRecipient,.AddToWaitList,.WaitListText,.SpaWaitNote').hide();
                            modal.find('.equipment_bike_map_link').show()
                        }
                        else  {
                            modal.find('.selectGuest,.AddToWaitList,.WaitListText,.SpaWaitNote,.equipment_bike_map_link,.textAfter,.spaEventButton,.select_c').hide()
                            modal.find('.WaitListText').show()
                            modal.find('.loginPrompt a').text("Login to Waitlist")
                            modal.find('.loginPrompt .textBefore').text(app.localization.spaBooking.classSelection.noSlotAvail).css("color", 'black')
                        }

                    }
                    
                    calEvent.SpaClass.GroupItems /*&&calEvent.SpaClass.IsProgramHeader!='Y'*/ && _.each(_.uniq(app.commonViewHelper.sortHelper(calEvent.SpaClass.GroupItems.Item), function(x){return x.id}), function (groupItem) {
                        var newGroupItemEl = modal.find('.groupItem.primary').clone()
                        .removeClass('primary');
                        console.log("el", groupItem)
                        newGroupItemEl.addClass("hide_class")
                        var countOfGuest =   app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+groupItem.id+'-'+calEvent.SpaClass.StartTime] ||0
                        modal.find('.modal-body .row-fluid .select_c .accordion-section').append(' <a  class=" accordion-section-title " id="' + groupItem.id + '"  href="#accordion-' + groupItem.id + '"><span class="accordionEquipmentClass-itemName">'+xmlEscape(groupItem.GroupItemName)  + '</span><span class="countOfGuestsLabel">'+app.localization.spaBooking.classSelection.NoOfGuest+'<span class="countOfGuests">'+ countOfGuest+'</span></span><span class="accordionEquipmentClass-time-price"> ' + app.localization.general.currencyPrefix + (+groupItem.GroupItemPrice).toFixed(2) + app.localization.general.currencyPostfix + ' - ' + groupItem.GroupItemServiceTime + app.localization.spaBooking.classSelection.Minute + '</span></a> <div  id="accordion-' + groupItem.id + '" class="accordion-section-content"><div class="class-list-selection-body"><div class="nongrid-img-dec"> <div  class="class-list-selection-body-desc">' + nl2br(groupItem.GroupItemDescription) + '</div><div  class="service-details-clientInstruction">' + nl2br(groupItem.Instructions) + '</div></div><div id="equippick' + groupItem.id + '" class="equippick' + '">ttt</div></div></div> ')

                        newGroupItemEl.data('groupItem', groupItem).attr('data-classid', groupItem.id)
                        newGroupItemEl.insertAfter(modal.find('.groupItem:last'));
                        $('.select_c #' + groupItem.id).click(function (e) {
                            console.log("elll",groupItem)
                            $('.groupItem').removeClass('hide_class')
                            $('.groupItem').addClass('hide_class')
                            $("div[data-classid='" + groupItem.id + "']").removeClass('hide_class');
                            $('.modal-header #eventModalLabel').html(xmlEscape(groupItem.GroupItemName))
                            createEquipmentCloneForEachClass(groupItem.id,groupItem)

                              //auto run age restriction check when user is not loggedin. When user is logged in, it will run upon guest selection
                            if(!app.data.userLoggedIn){
                                 var eligibilityCheckResult = checkEligibilityByAge(groupItem)
                                if(!eligibilityCheckResult.isValid) {
                                    modal.find('#equippick' + groupItem.id).prepend(eligibilityCheckResult.errorElement)
                                }
                                modal.find('.spaEventButton').toggleClass('disable_spaEventButton', !eligibilityCheckResult.isValid || !isEventInFuture)
                            }
                            //end
                           
                        })
                        if(!user.Name){
                            $('.countOfGuestsLabel').css('visibility','hidden')
                        }    
                    })
                    modal.find('.modal-body .row-fluid .select_c .accordion-section-title').on('click',function(e){
                        e.preventDefault()
                        var currentAttrvalue = $(this).attr('href');
                        if($(e.currentTarget).is('.active')){
                            $(this).removeClass('active');
                            $('.accordion-section-content:visible').slideUp(300);
                        } else {
                            $('.accordion-section-title').removeClass('active').filter(this).addClass('active');
                            $('.accordion-section-content').slideUp(300).filter(currentAttrvalue).slideDown(300);
                        }
                    });

                    var numGroupItems = modal.find('.groupItem').length
                    if (!calEvent.future) {
                        modal.find('.guestopt,.loginPrompt').hide()
                    }
                    //only if user is logged in recipient select -start
                    modal.find('.guestopt select.serviceRecipient').on('change', function (e) {
                        $(this).find('option.selectMember').prop('disabled', true);
                        if ($(this).find('option.newMemberOption').prop('selected')) {
                            if (app.customization.spaBooking.useFullPageAddGroupMember) {
                                app.data.loginNextURL = updateLocation(e, calEvent.SpaClass.SpaClassId)
                                app.dispatcher.redirect('profile', 'addmember', []);
                                return;
                            }
                            var newMemberEl = $('#newMemberTpl').clone().attr('id', '').removeClass('hide').insertAfter($(this).parents('.guests').find('a.selectGuest'))
                            newMemberEl.find('.newMemberAdd').on('click', function (e) {
                                e.preventDefault();
                                app.data.loginNextURL = updateLocation(e, calEvent.SpaClass.SpaClassId);
                                app.dispatcher.dispatch('profile', 'quickeventmembercreatesubmit', [
                                    "", // encodeURIComponent($('#userEmail1').val()),
                                    "", // encodeURIComponent($('#userPassword1').val()),
                                    "", // encodeURIComponent($('#userGender').val()),
                                    "", // encodeURIComponent($('#userSalutation').val()),
                                    encodeURIComponent($(this).parents('.newMember').find('.newMemberFirstName').val()),
                                    encodeURIComponent($(this).parents('.newMember').find('.newMemberLastName').val()),
                                    // $('#userMainPhoneH').hasClass('active') ? "H" :
                                    //     $('#userMainPhoneW').hasClass('active') ? "W" :
                                    //         $('#userMainPhoneO').hasClass('active') ? "O" : "",
                                    "",
                                    "", // encodeURIComponent($('#userHomePhone').val()),
                                    "", // encodeURIComponent($('#userWorkPhone').val()),
                                    "", // encodeURIComponent($('#userWorkExt').val()),
                                    "", // encodeURIComponent($('#userOtherPhone').val()),
                                    "", // encodeURIComponent($('#userMobilePhone').val()),
                                    user.Address[0].Address1 || "", // encodeURIComponent($('#userHomeAddress1').val()),
                                    user.Address[0].Address2 || "", // encodeURIComponent($('#userHomeAddress2').val()),
                                    user.Address[0].City || "", // encodeURIComponent($('#userHomeCity').val()),
                                    user.Address[0].StateProv || "", // encodeURIComponent($('#userHomeProvince').val()),
                                    user.Address[0].Country || "", // encodeURIComponent($('#userHomeCountry').val()),
                                    user.Address[0].PostCode || "", // encodeURIComponent($('#userHomePostalCode').val()),
                                    "", // encodeURIComponent($('#userOtherAddress1').val()),
                                    "", // encodeURIComponent($('#userOtherAddress2').val()),
                                    "", // encodeURIComponent($('#userOtherCity').val()),
                                    "", // encodeURIComponent($('#userOtherProvince').val()),
                                    "", // encodeURIComponent($('#userOtherCountry').val()),
                                    "", // encodeURIComponent($('#userOtherPostalCode').val()),
                                    "1", // $('#newsletter').prop('checked') ? "1" : "0",
                                    "1", // $('#mailMarketing').prop('checked') ? "1" : "0",
                                    "1", // $('#phonemarketing').prop('checked') ? "1" : "0",
                                    "1", // $('#smsmarketing').prop('checked') ? "1" : "0",
                                    { "English": "en-us", "French": "fr-ca", "Spanish": "es-sp", "Chinese": "zh-cn", "": "en-us" }[user.Language],
                                    // $('#userLanguageen-us').hasClass('active') ? "en-us" :
                                    //     $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                                    //         $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                                    //             $('#userLanguagees-sp').hasClass('active') ? "es-sp" : "",
                                    '',
                                    '',
                                    '',
                                    '',
                                    '', //$('#userSkiSize').val()||'',
                                    '', //$('#userSkiBootSize').val()||'',
                                    '',
                                    '',
                                    '', //$('#userSnowboardSize').val()||'',
                                    '', //$('#userSnowboardBootSize').val()||'',
                                    '', //$('#userDinNumber').val()||'',
                                    '', //$('#userAge').val()||'',
                                    '', //$('#userWeight').val()||'',
                                    '', //$('#userHeight').val()||'',
                                    '', //$('#userDOB').val()||'',
                                    '' //$('#userCustomerId').val()
                                ]);
                            })
                        } else {
                         $(this).parents('.guests').find('a.selectGuest').addClass('btn-primary').click()
                           modal.find('.newMember').remove()
                        }
                    })
                     //only if user is logged in recipient select -end
                    if (user.Name) {
                        modal.find('.guestoptCl a.selectGuest').css('visibility', 'hidden')
                    }
                    
                    function checkEligibilityByAge(program, userDob, CustomerName, CustomerId,canEditGroupMember) {
                
                        var valid = true,
                        requireUserToEnterDate = false,
                        errorElement = '<div class="age-restriction-class-error-message" id="age-restriction-' + CustomerId + '">',
                        localStrings = app.localization.spaBooking.ageRestriction

                        if (app.data.userLoggedIn) {
                            var age = moment().diff(userDob, 'years', false);
                            var isAgeNotValid = ((program.MinAge && age < program.MinAge) || (program.MaxAge && age > program.MaxAge))
                            if ((program.MinAge || program.MaxAge)) {
                                (isAgeNotValid || !userDob && canEditGroupMember == "N") ? valid = false: ''
                                if (isAgeNotValid) {
                                    errorElement += '<p >' + CustomerName + ' '+localStrings.classRequiredTextTwo+'  - ' + ' '+localStrings.ageRestriction+' ( ' + (program.MinAge ? ' '+localStrings.min+':' + program.MinAge : '') + ' ' + (program.MaxAge ? ' ' +localStrings.max+':'+ program.MaxAge : '') + ')</p>'
                                }
                                requireUserToEnterDate = !!!userDob
                            }
                            if (!userDob && canEditGroupMember == "N") {
                                errorElement += '<p>'+localStrings.cannotEditUserDobTextOne +' '+ CustomerName + ' '+localStrings.cannotEditUserDobTextTwo +'  </p>'
                            }
                        } else {
                            if ((program.MinAge || program.MaxAge)) {
                                valid = false;
                                errorElement += '<p>'+localStrings.loginToVerifyTwo+'</p>'
                            }
                        }
                        errorElement += '</div>'
                        return obj = {
                            isValid: valid,
                            errorElement: errorElement,
                            requireUserToEnterDate:requireUserToEnterDate
                        }
                    }
                     function handleBookBtnAndQtyDropDownEligibility(program, customerId, isAgeValid, requireUserToEnterDate, mutation) {
                        var eligibleUsers = app.data.eligibleUsersForProgramOrClass || {}
                        eligibleUsers.users = eligibleUsers.users || {}
                        var eventDate = program.StartDateTime || program.StartTime,
                        isAllEligible = true,
                        // by default,this function will disable the button if age req is not met. We only want to disable the button in this mode if quantity is not 0  and age req is not met, or age req is met and no qty for any item was selected. This case can happen when user picks a valid date from the Datepicker and selects the quantity, and later selects invalid date from Datepicker. Below two fields will be checked 
                        quantitySelectedForIdvItem = 0,
                        quantitySelectedForThisClass = 0
                        if(app.data.spaClassQueue && app.data.spaClassQueue[program.StartDateTime+'-'+program.ClassId]){
                            var bookingsForThisClass = app.data.spaClassQueue[program.StartDateTime+'-'+program.ClassId]
                            quantitySelectedForIdvItem =  _.filter(bookingsForThisClass,function(booking){
                                return booking.ItemId == program.ItemId
                            }).length
                            quantitySelectedForThisClass = bookingsForThisClass.length
                        }
                         if(!isQtyBookMode || (isQtyBookMode && +quantitySelectedForIdvItem > 0))
                        {
                            var key = eventDate + '-' + customerId;
                            isQtyBookMode ? key = key + '-'+program.ItemId: '' //in qty Mode, customer is and it will overide the existing value if not differentiated using groupItem id

                            mutation == "add" ? eligibleUsers.users[key] = !!(isAgeValid && !requireUserToEnterDate) : delete eligibleUsers.users[eventDate + '-' + customerId]
                        }
                        
                         _.each(eligibleUsers.users, function (isValid, key) {
                             if (!isValid && key.indexOf(eventDate) !== -1) isAllEligible = false
                         })
                        
                         if(isQtyBookMode &&(!isAllEligible && +quantitySelectedForIdvItem > 0 || +quantitySelectedForThisClass <= 0 )) isAllEligible = false

                         eligibleUsers.isAllEligible = isAllEligible
                         app.datal('eligibleUsersForProgramOrClass', eligibleUsers)
                         //disable or enable book button; until date is selected or event in past
                         modal.find('.spaEventButton').toggleClass('disable_spaEventButton', !isAllEligible || !isEventInFuture)
                   
                         isQtyBookMode ? modal.find('#equippick'+program.ItemId+ ' .selectNumberOfGuests').toggleClass('disable_spaEventButton', !(isAgeValid && !requireUserToEnterDate)  || !isEventInFuture ) : '' //decision is based on each groupItem 
                     }

                    //Quantity Type booking --START-- Below is the logic that gets triggered when spaClassQtyBookMode is true. There is a logic that runs on a page load, which removes any existing booking Queue. Also, update quantity in the dropdown upon changing the group items
                    //Step 0: check if quantity is not zero. 
                    //Step 1: Render quantity based on number of availability
                    //Step 2: Added the quantity click handler and create copies of user objects based on the quantity and store it in spaClassQueue
                    //Step 3: update spaClassQueue based on increment/decremental action on thr quanity
                    //Step 4: In case of group Items, modify quantities in the dropdown. For example if No of classes avail are 4 and 2 are selected for group item A, then only 1 and 2 should show in the drop down for the gorup itme B. Unless quantiy in the Group item A drop down changes.
                    // step5: toggle book button based on qty
                    if (isQtyBookMode) {
                        //step 0
                        if (calEvent.SpaClass.AvailSlots <= 0)
                            $('.selectNumberOfGuests').addClass('hidden')
                        else {
                            //step 1
                            $('.selectNumberOfGuests').removeClass('hidden')
                            $('.selectNumberOfGuests .qtyOptionElement').remove()
                            var quantityAvailable = calEvent.SpaClass.AvailSlots,
                            uniqueId = calEvent.SpaClass.StartTime + '-' + calEvent.SpaClass.SpaClassId,
                            guestNote = ''
                            for (var i = 1; i <= quantityAvailable; i++) {
                                var opt = $('<option class="qtyOptionElement"></option>')
                                $(opt).attr('id', 'qtyOption-' + calEvent.SpaClass.StartTime + '-' + i);
                                $(opt).attr('value', i);
                                $(opt).html(i)
                                $('.selectNumberOfGuests').append(opt)
                            }
                            modal.find("#spaGuestNote").on('keyup', function() {
                                // if user has already selected the qty then insert a guest note directly to each of them. Otherwise, save it locally above and use it when a user chooses a qty 
                                var  activeItemId = modal.find('.select_c .accordion-section-title.active').attr('id'),
                                note = this.value;
                                if(app.data.spaClassQueue[uniqueId] && !_.isEmpty(app.data.spaClassQueue[uniqueId])){
                                    _.each(app.data.spaClassQueue[uniqueId],function(booking){
                                        if(booking.ItemId == activeItemId) {
                                            booking.guestNote = note
                                        }
                                    })
                                    app.datal('spaClassQueue', app.data.spaClassQueue)
                                }
                                else  guestNote =  note
                            })
                            //step 2
                            modal.find('.selectNumberOfGuests').on('change', function (e) {
                                var selectedQty = this.value,
                                activeItemId = modal.find('.select_c .accordion-section-title.active').attr('id'),
                                groupItem = $('.groupItem[data-classid="' + activeItemId + '"]').data('groupItem') || $('.groupItem[data-classid=""]').data('groupItem')

                               var userSelectedDOB = modal.find('.qtyModeDatePicker').val() //in case user was prompted witht he dob picker then store that value to create the bookingObject, otherwise store one that is returned from the profile
                               var  programOrCLass = groupItem || calEvent.SpaClass,
                                programName = programOrCLass.GroupItemName || programOrCLass.SpaItemName,
                                bookingObject = {
                                    CustomerId: user.CustomerId,
                                    CustomerName: user.Name.FirstName + ' '+  user.Name.LastName,
                                    ItemId: activeItemId /*calEvent.SpaClass.SpaItemId*/ ,
                                    ClassId: calEvent.SpaClass.SpaClassId,
                                    StartDateTime: calEvent.SpaClass.StartTime,
                                    ProgramName: programName,
                                    equipment_name: app.localization.spaBooking.classSelection.noneSelected,
                                    equipment_id: "",
                                    MinAge: programOrCLass.MinAge,
                                    MaxAge: programOrCLass.MaxAge,
                                    birthdate:userSelectedDOB || user.DateOfBirth,
                                    Price: programOrCLass.Price || programOrCLass.GroupItemPrice,
                                    guestNote : guestNote,
                                    dateAddedByDatePicker: !!userSelectedDOB
                                }
                                //step 3
                                app.data.spaClassQueue[uniqueId] = _.filter(app.data.spaClassQueue[uniqueId], function (booking) {
                                    return booking.ItemId != activeItemId
                                })
                                for (var i = 1; i <= selectedQty; i++) {
                                    app.data.spaClassQueue[uniqueId].push(bookingObject)
                                }
                                app.datal('spaClassQueue', app.data.spaClassQueue)
                                var remainingSlot = quantityAvailable - (app.data.spaClassQueue[uniqueId].length -selectedQty)
                                //step 4
                  
                                $('.selectNumberOfGuests > option').each(function () {
                                    var optionValue = $(this).val()
                                    if (+optionValue > remainingSlot)
                                        $(this).attr("disabled", "disabled")
                                    else   $(this).removeAttr("disabled")
                                });
                                //Step 5 - toggle book button based on quantity seelcted for this class(regardless of group items)
                                modal.find('.spaEventButton').toggleClass('disable_spaEventButton', +app.data.spaClassQueue[uniqueId].length <= 0)
                            })
                        }
                    }
                    //Quantity Type booking --END --

                    ////Guest Type booking --- Below is the logic that gets triggered  when spaClassQtyBookMode is false.
                    modal.find('.guestopt a.selectGuest').on('click', function (e) {
                        e.preventDefault();
                        var activeItemId = modal.find('.select_c .accordion-section-title.active').attr('id')
                        var groupItem = $('.groupItem[data-classid=' + activeItemId + ']').data('groupItem')
                        var birthdate =  $(this).parents('.guests').find('.serviceRecipient option:checked').data('birthdate')
                        var CustomerName = $(this).parents('.guests').find('.serviceRecipient option:checked').text()
                        var selectedCustomerId = $(this).parents('.guests').find('.serviceRecipient').val()  
                        var programOrCLass =  groupItem || calEvent.SpaClass
                        var canEditGroupMember =  $(this).parents('.guests').find('.serviceRecipient option:checked').data('canedit')
                       
                       
                       if (groupItem == null) groupItem = $('.groupItem[data-classid=""]').data('groupItem')
                        var programName =  groupItem.GroupItemName || calEvent.SpaClass.SpaItemName
                        if (user.Name) {
                            // add
                            if (!$(this).parents('.guests').find('.serviceRecipient').val())  return;
                            //
                            var uniqueId = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId
                            app.data.spaClassQueue = app.data.spaClassQueue || {};
                            app.data.spaClassQueue[uniqueId] = app.data.spaClassQueue[uniqueId] || [];
                                             
                            var q = {
                                CustomerId: selectedCustomerId,
                                CustomerName: CustomerName,
                                ItemId: activeItemId /*calEvent.SpaClass.SpaItemId*/ ,
                                ClassId: calEvent.SpaClass.SpaClassId,
                                StartDateTime: calEvent.SpaClass.StartTime,
                                ProgramName: programName,
                                equipment_name: app.localization.spaBooking.classSelection.noneSelected,
                                equipment_id: "",
                                MinAge: programOrCLass.MinAge,
                                MaxAge: programOrCLass.MaxAge,
                                birthdate:birthdate,
                                Price: programOrCLass.Price || programOrCLass.GroupItemPrice,
                                canEditGroupMember:canEditGroupMember,
                                allowWaitList: calEvent.SpaClass.AllowWaitList,
                                ItemCategory:calEvent.SpaClass.ItemCategory,
                                ItemSubcategory:calEvent.SpaClass.ItemSubcategory,
                            }

                             //Below logic is the initial part of age restriction check. If there is a age restriction on the program and user doesnt have birthdate and at the same time cannot edit profile stop right there -- START - only runs in non qty mode
                                var result = checkEligibilityByAge(q,birthdate,CustomerName,selectedCustomerId,canEditGroupMember)
                                if(_.isEmpty(app.data.eligibleUsersForProgramOrClass) || app.data.eligibleUsersForProgramOrClass && app.data.eligibleUsersForProgramOrClass.isAllEligible){
                                    modal.find('#equippick' + q.ItemId + ' .age-restriction-class-error-message').remove()
                                }
                                if (!result.isValid) {
                                    var itemId =  programOrCLass.SpaItemId || programOrCLass.id
                                    modal.find('#equippick' + itemId + ' .age-restriction-class-error-message').remove()
                                    modal.find('#equippick' + itemId).prepend(result.errorElement)
                                    return
                                } else   {
                                    handleBookBtnAndQtyDropDownEligibility(q,selectedCustomerId, result.isValid,result.requireUserToEnterDate, 'add')}
                            //------age restriction logic --END
                            createGuestObjectPerUser(q) // creates the user object
                            modal.find('.serviceRecipient .selectMember').html(app.localization.spaBooking.serviceSelection.addMoreGuests)
                            
                            function createGuestObjectPerUser(obj){
                                var isValid  = checkValid();
                                
                                if(!isValid && obj.allowWaitList !== 'Y') return;

                                obj.isWaitListed = !isValid;
                                app.data.spaClassQueue[uniqueId].push(obj)
                                app.datal('spaClassQueue',app.data.spaClassQueue)
                                showLoggedInGuestEquipment(obj);
                                isValid?  modal.find('#edit_guest_' + selectedCustomerId + '').click() :''//to activate equipment selection for that user:
                                modal.find('.spaEventButton').addClass('btn-primary')
                            }
                            
                        } else {
                            // continue
                            $('#progressIndicator').modal('show')
                            var user_equipment_selected = app.data.user_equipment_not_loggedin || {}
                            app.datal("selected_equipment_not_loggedIn", user_equipment_selected)
                            app.dispatcher.dispatch('spaBooking', 'confirmClass', [spaLocationId, calEvent.SpaClass.SpaClassId, groupItem.id || '' /*calEvent.SpaClass.SpaItemId*/ , calEvent.SpaClass.StartTime, '' /*guestName*/ , user_equipment_selected.id, false /*confirmed*/ ])
                        }
                        incrementGuestCount()
                        $(this).removeClass('btn-primary')
                        $(this).parents('.guests').find('option.selectMember').prop('disabled', false)
                        if(!checkValid() && calEvent.SpaClass.AllowWaitList !== "Y"){
                            $('select.serviceRecipient').prop('disabled', true);
                        }
                        function incrementGuestCount(){
                            app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+activeItemId+'-'+calEvent.SpaClass.StartTime] = app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+activeItemId+'-'+calEvent.SpaClass.StartTime] || 0
                            app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+activeItemId+'-'+calEvent.SpaClass.StartTime]++
                            app.datal('countOfGuest',app.data.countOfGuest)
                            $('#' + activeItemId + ' .countOfGuests').html(app.data.countOfGuest[calEvent.SpaClass.SpaClassId+'-'+activeItemId+'-'+calEvent.SpaClass.StartTime])
                        }
                    })
                    
                    modal.find('.activeIfGuestNameMe,.hiddenIfGuestNameMe,.activeUnlessGuestNameMeANDifGuestName,.hiddenUnlessGuestNameMeANDUnlessGuestName,.activeUnlessGuestNameMeANDUnlessGuestName').removeClass('active hidden')
                    if (guestName == 'me') {
                        modal.find('.activeIfGuestNameMe').addClass('active')
                        modal.find('.hiddenIfGuestNameMe').addClass('hide')
                    } else {
                        if (guestName) {
                            modal.find('.activeUnlessGuestNameMeANDifGuestName').addClass('active')
                        } else {
                            modal.find('.hiddenUnlessGuestNameMeANDUnlessGuestName').addClass('hide')
                            modal.find('.activeUnlessGuestNameMeANDUnlessGuestName').addClass('active')
                        }
                    }
                    modal.find('.continueProcessButtonLabel').text(+calEvent.SpaClass.AvailSlots
                        ? app.localization.general.continueProcessButtonLabel
                        : app.localization.spaBooking.serviceSelection.eventCalendarSoldOut)
                    modal.find('.closeButtonLabel').text(app.localization.general.close)
                    modal.find('.titleErrDateRequired').attr('title', app.localization.spaBooking.serviceSelection.err.dateRequired)
                    modal.find('.titleErrDateRequired').attr('data-loading-text', app.localization.general.progressIndicatorMessage)

                    modal.find('.serviceRecipient .btn-group .btn').on('click', function () {
                        if ($(this).hasClass('me')) {
                            modal.find('.someoneInput').addClass('hide')
                        } else {
                            modal.find('.someoneInput').removeClass('hide')
                        }

                    })
                    modal.find('.spaEventButton')
                        .attr('href',
                            "#/spaBooking/confirmEvent/" + spaLocationId
                            + "/" + calEvent.SpaClass.SpaClassId
                            + "/" + ''/*calEvent.SpaClass.SpaItemId*/
                            + "/" + calEvent.SpaClass.StartTime
                            + "/"+(!!calEvent.SpaClass.GroupItems ? 1 : 0)
                        )
                        .on('click', function (e) {
                         //   isAlreadyWaitListed()
                            $('#progressIndicator').modal('show')
                            window.scrollTo(0, 0);
                        })
                        .text( app.localization.spaBooking.classSelection.book).addClass('disable_spaEventButton')
                   
                    modal.modal()
                    updateLocation(jsEvent, calEvent.SpaClass.SpaClassId)
                    // if (guestName && modal.find('.guestopt select.serviceRecipient option[value=' + guestName + ']')) {
                    //     modal.find('.guestopt select.serviceRecipient').val(guestName).trigger('change');
                    //     modal.find('.guestopt a.selectGuest').addClass('btn-primary');
                    // }
                    modal.on('hidden', function () {
                        updateLocation();

                    })
                  
                    app.commonViewHelper.prepSpaEventCalendarEventClick(calEvent, jsEvent, view, modal, spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group)

                    var uniqueId = calEvent.SpaClass.StartTime+'-'+calEvent.SpaClass.SpaClassId;

                    $('select.serviceRecipient').prop('disabled', (!checkValid() && calEvent.SpaClass.AllowWaitList !== "Y"));

                    function checkValid() {
                        var userFilteredBooking = _.filter(app.data.spaClassQueue[uniqueId],function(userObj){
                            return !userObj.isWaitListed && userObj.StartDateTime == calEvent.SpaClass.StartTime
                        })
                        return +calEvent.SpaClass.AvailSlots > (userFilteredBooking.length );
                    }

                app.commonViewHelper.analyticsInit('prepClassModalClick', [calEvent, spaLocationId, startDate]);
            },
            prepSpaEventCalendarCategories: function prepSpaEventCalendarCategories() { },
            prepSpaEventCalendarEventClick: function prepSpaEventCalendarEventClick(calEvent, jsEvent, view, modal) { },
            prepSpaEventCalendarUpdateLocation: function prepSpaEventCalendarUpdateLocation(e, classid, backURL) { },
            prepSpaEventCalendar: function prepSpaEventCalendar(spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group,promoCode) {
                //  var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location))
                // var now = moment.tz(bookingWindow.timeZone);
                //  var endMinTime = now.clone()
                //  if (!_.isEmpty(bookingWindow.endOffset)) {
                //      endMinTime.subtract(bookingWindow.endOffset)
                // }
              
                var eventCalendarTitle = Handlebars.compile(app.localization.spaBooking.classSelection.eventCalendarTitle),
                    eventCalendarTitlePast = Handlebars.compile(app.localization.spaBooking.classSelection.eventCalendarTitlePast),
                    showCategories = showItem ? String(showItem).split('|') : null,
                    isItemId = (showCategories && showCategories.length == 1) ? (showCategories[0].match(/^[0-9]+$/) ? showCategories[0] : null) : null

                eventClick = function eventClick(calEvent, jsEvent, view) {
                    app.commonViewHelper.prepClassModalClick(calEvent, jsEvent, view, spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group)
                },
                    updateLocation = function updateLocation(e, classid) {
                        var date = $('#eventcalendar').fullCalendar('getDate').format("YYYY-MM-DD"),
                            categories = Array.prototype.join.call(
                                $('.spaClassCalendar .categories li input').map(function () {
                                    var el = $(this)
                                    return el.prop('checked') ? (el.data('category') || "") : null
                                }),
                                "|"),
                            modal = $('#eventModal'),
                            me = ''// modal.find('.serviceRecipient .btn-group .me').hasClass('active')?"":modal.find('.someoneInputField').val()
                        if (!!categories) {
                            isItemId = null
                        } else if (!!isItemId) {
                            categories = isItemId
                        }
                        var backURL = ['spaBooking', 'eventcalendar', [spaLocationId, date, categories, me, classid || ''], true]
                        app.dispatcher.updateURL.apply(this, backURL);
                        modal.find('.loginPrompt a').attr('href', '#/profile/login/next/spaBooking/eventcalendar/' + spaLocationId + '/' + date + '/' + categories + '/' + me + '/' + (classid || ''))
                        app.commonViewHelper.prepSpaEventCalendarUpdateLocation(e, classid, backURL, spaLocationId, startDate, showItem, guestName, spaItemId, location, user, group)
                        return backURL
                    }
                require(['moment', 'lib/fullcalendar'], function (moment) {
                    var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location))

                    var now = moment.tz(bookingWindow.timeZone);
                    var endMinTime = now.clone()
                    if (!_.isEmpty(bookingWindow.endOffset)) {
                        endMinTime.subtract(bookingWindow.endOffset)
                    }
                    if (!_.isEmpty(bookingWindow.endSet)) {
                        _.each(bookingWindow.endSet, function (num, unit) {
                            endMinTime[unit](num)
                        })
                    }
                    $('#eventcalendar').fullCalendar({
                        header: {
                            left: 'prev,next today',
                            center: 'title',
                            right: app.customization.spaBooking.eventCalendarViews
                        },
                        views: {
                            agenda: {
                                allDaySlot: false,
                                slotDuration: app.customization.spaBooking.eventCalendarTimeSlot
                            },
                            basicDay: {
                                buttonText: app.localization.spaBooking.serviceSelection.eventCalendar_basicDay,
                                timeFormat: 'h:mmt'
                            },
                            agendaWeek: {
                                buttonText: app.localization.spaBooking.serviceSelection.eventCalendar_agendaWeek
                            },
                            agendaDay: {
                                buttonText: app.localization.spaBooking.serviceSelection.eventCalendar_agendaDay
                            },
                            month: {
                                buttonText: app.localization.spaBooking.serviceSelection.eventCalendar_month
                            }

                        },
                        defaultDate: startDate || endMinTime.format('YYYY-MM-DD'),
                        defaultView: app.customization.spaBooking.eventCalendarDefaultView || 'month',
                        minTime: app.customization.spaBooking.eventCalendarTimeMin || (function (location) {
                            // sort the Start times and take the first (earliest) one
                            var mintime = [location.SundayStart.substr(10, 4),
                            location.MondayStart.substr(10, 4),
                            location.TuesdayStart.substr(10, 4),
                            location.WednesdayStart.substr(10, 4),
                            location.ThursdayStart.substr(10, 4),
                            location.FridayStart.substr(10, 4),
                            location.SaturdayStart.substr(10, 4)
                            ].sort()[0]
                            return String(mintime).substr(0, 2) + ":" + String(mintime).substr(2, 2)
                        })(location),
                        maxTime: app.customization.spaBooking.eventCalendarTimeMax || (function (location) {
                            // sort the Start times and take the last (latest) one
                            var maxtime = [location.SundayEnd.substr(10, 4),
                            location.MondayEnd.substr(10, 4),
                            location.TuesdayEnd.substr(10, 4),
                            location.WednesdayEnd.substr(10, 4),
                            location.ThursdayEnd.substr(10, 4),
                            location.FridayEnd.substr(10, 4),
                            location.SaturdayEnd.substr(10, 4)
                            ].sort()[6]
                            return String(maxtime).substr(0, 2) + ":" + String(maxtime).substr(2, 2)
                        })(location),
                        slotEventOverlap: app.customization.spaBooking.eventCalendarSlotEventOverlap,
                        events: function spaCalEventGetter(start, end, timezone, callback) {
                            $('#progressIndicator').modal('show');
                            var cb = callback
                            app.controllers.spaController.getEvents(spaLocationId, start.toDate(), end.toDate())
                                .then(function (classes) {
                                    var events = [],
                                        clickThisClass = false,
                                        restrictedPmsEndMinTime
                                    _.each(classes, function (spaClasses) {
                                        spaClasses.SpaClass = $.wrapArray(spaClasses.SpaClass)
                                        _.each(spaClasses.SpaClass, function (spaClass) {
                                            var allowedPromoCodes = app.customization.spaBooking.promoBasedClasses
                                            if(!_.isEmpty(allowedPromoCodes)){
                                                if(_.contains(allowedPromoCodes,spaClass.ItemSubcategory) && spaClass.ItemSubcategory != app.data.eventCalendarPromoCode) return;
                                            }
                                            var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location, spaClass))

                                            var startTime = moment.tz(spaClass.StartTime, 'YYYY-MM-DDHHmm', bookingWindow.timeZone);
                                            var endMinTime = startTime.clone()
                                            if (!_.isEmpty(bookingWindow.endOffset)) {
                                                endMinTime.add(bookingWindow.endOffset)
                                            }
                                            if (!_.isEmpty(bookingWindow.endSet)) {
                                                _.each(bookingWindow.endSet, function (num, unit) {
                                                    endMinTime[unit](num)
                                                })
                                            }
                                            var startMaxTime =  moment('2000-01-01')
                                            if (!_.isEmpty(bookingWindow.startOffset)) {
                                                startMaxTime = startTime.clone()
                                                startMaxTime.add(bookingWindow.startOffset)
                                            }
                                            if (!_.isEmpty(bookingWindow.startSet)) {
                                                _.each(bookingWindow.startSet, function (num, unit) {
                                                    startMaxTime[unit](num)
                                                })
                                            }
                                            if(app.data.RestrictedFolio){
                                                if(app.data.datesForRestrictedFolio) {
                                                    var restrictedDates = app.data.datesForRestrictedFolio;
                                                    var folioEndDate = moment(restrictedDates[restrictedDates.length-1].machine,'YYYY-MM-DD');
                                                    restrictedPmsEndMinTime =  folioEndDate 
                                            }
                                              var dateList = (location.PMSRoomMandatory == "Y" ? (!!app.data.pmsDateList ? (app.data.pmsDateList[location.PropertyId] || []) : []) : []);
                                              if(dateList.length > 0){
                                                restrictedPmsEndMinTime=  moment(dateList[dateList.length-1].machine, 'YYYY-MM-DD')
                                              }
                                            }
                                            var now = moment.tz(bookingWindow.timeZone);
                                            var spaClassStartTime = moment(spaClasses.Date,'YYYY-MM-DD')
                                            var future =endMinTime>now && ( restrictedPmsEndMinTime?spaClassStartTime>=restrictedPmsEndMinTime:startMaxTime<=now)
                                            
                                            function htmlDecode(input){
                                                var e = document.createElement('div');
                                                e.innerHTML = input;
                                                return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
                                            }
                                            
                                            eventData = {
                                                title: future ? htmlDecode(eventCalendarTitle(spaClass)) : htmlDecode(eventCalendarTitlePast(spaClass)),
                                                start: startTime,
                                                end: startTime.clone().add(spaClass.ServiceTime, 'minute'),
                                                SpaClass: $.extend({ Date: spaClasses.Date }, spaClass),
                                                future: future,
                                                className: future ? 'future' : 'past'
                                            }
                                            events.push(eventData)
                                            if (spaItemId == spaClass.SpaClassId) {
                                                if (!startDate) {
                                                    $('#eventcalendar').fullCalendar('gotoDate', startTime.format('YYYY-MM-DD'))
                                                }
                                                clickThisClass = eventData
                                            }
                                        })

                                    })
                                    //view item list
                                    app.commonViewHelper.analyticsInit('spaClassEvents', [spaLocationId, startDate, events]);
                                    var categories = _.uniq(_.map(events, function (x) { return x.SpaClass && x.SpaClass.ItemCategory })).sort()
                                    _.each(categories, function (category) {
                                        var exists = $('.spaClassCalendar .categories li').find('#cat_' + stripChars(category)).length
                                        if (!exists) {
                                            var input = $('<input>', { type: "checkbox", id: 'cat_' + stripChars(category), data: { category: category } })
                                            if (!isItemId && (!showCategories || (showCategories.indexOf(category) >= 0))) {
                                                input.prop('checked', true)
                                            }
                                            if (category) {
                                                $('.spaClassCalendar .categories').append(
                                                    $('<li>').append(
                                                        $('<label>', {
                                                            'for': 'cat_' + stripChars(category)
                                                        }).append(
                                                            input,
                                                            $('<span>' + category + '</span>')
                                                        )
                                                    )
                                                )
                                            }
                                        }
                                    })
                                    typeof cb == 'function' && setTimeout(function () {
                                        cb(events)
                                    }, 1)
                                    clickThisClass && setTimeout(function () { eventClick(clickThisClass) }, 100)

                                    app.commonViewHelper.prepSpaEventCalendarCategories()
                                }).always(function(){
                                    $('#progressIndicator').modal('hide');
                                });
                        },
                        eventRender: function eventRender(event, element, view) {
                            var render
                            if (!!isItemId) {
                                render = event.SpaClass.SpaItemId == isItemId
                            } else {
                                var categoryElem = $('.spaClassCalendar .categories input#cat_' + stripChars(event.SpaClass.ItemCategory))
                                render = categoryElem.length ? categoryElem.prop('checked') : true
                            }

                            if(render) {
                                if(event.future) {
                                    $(element).attr('tabindex',0).on('keydown', function(e){
                                        if(e.keyCode == 13) {
                                            $(this).click();
                                        }
                                    })
                                }
                            }
                            return render;
                        },
                        eventClick: eventClick,
                        dayClick: function dayClick(date, jsEvent, view) {
                            $('#eventcalendar').fullCalendar('gotoDate', date)
                            if ($('#eventcalendar').fullCalendar && ['month', 'agendaWeek'].indexOf(view.name) >= 0) {
                                $('#eventcalendar').fullCalendar('changeView', 'basicDay')
                            }
                            updateLocation()
                        }
                    })
                    $('.spaClassCalendar .categories').on('click', 'input, label', function (e) {
                        if ($('#eventcalendar').fullCalendar) {
                            $('#eventcalendar').fullCalendar('rerenderEvents');
                            updateLocation();
                        }
                    })
                    $('#eventcalendar .fc-prev-button, #eventcalendar .fc-next-button').click(function () {
                        updateLocation();
                    });
                    enquire.register("screen and (max-width: 481px)", function () {
                        $('#eventcalendar').fullCalendar && $('#eventcalendar').fullCalendar('option', 'contentHeight', "auto");
                    });
                    enquire.register("screen and (min-width: 482px)", function () {
                        $('#eventcalendar').fullCalendar && $('#eventcalendar').fullCalendar('option', 'contentHeight', false);
                    });
                })
            },
            // This Function is used for utilizing WebSort field for Group items in Spa classes / Spa Services 
            //PMS Venues, Golf Locations, Courses, Rates, SkiItems, Gift Certs
            sortHelper: function (array){
                var itemsNoWebSort = [];
                var itemsWebSort = [];
                _.each(array, function(item){
                    if(!item.WebSort) {
                        itemsNoWebSort.push(item);
                    } else {
                        itemsWebSort.push(item);
                    }
                });
                // sort the items that has sort field as in 1 to first 2 to second etc. 
                var itemsWebSort = itemsWebSort.sort(function(a, b){
                    return a.WebSort - b.WebSort;
                });
                // concat the two arrays
                return  itemsWebSort.concat(itemsNoWebSort);
            },
            prepClassForm: function (spaLocationId, startDate, location) {
                var bookingWindow = getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location))
                var now = moment.tz(bookingWindow.timeZone);
                var endMinTime = now.clone()
                if (!_.isEmpty(bookingWindow.endOffset)) {
                    endMinTime.subtract(bookingWindow.endOffset)
                }
                if (!_.isEmpty(bookingWindow.endSet)) {
                    _.each(bookingWindow.endSet, function (num, unit) {
                        endMinTime[unit](num)
                    })
                }
                var startMaxTime = now.clone().add(2, 'years')
                if (!_.isEmpty(bookingWindow.startOffset)) {
                    startMaxTime = now.clone()
                    startMaxTime.subtract(bookingWindow.startOffset)
                }
                if (!_.isEmpty(bookingWindow.startSet)) {
                    _.each(bookingWindow.startSet, function (num, unit) {
                        startMaxTime[unit](num)
                    })
                }

                $('#alt-spaClassDate').datepicker({
                    minDate: endMinTime.toDate(),
                    maxDate: startMaxTime.toDate(),
                    numberOfMonths: 2,
                    dateFormat: "yy-mm-dd",
                    dateFormat: app.localization.spaBooking.dateFormat[0],
                    defaultDate: startDate || endMinTime.toDate(),
                    altField: '#spaClassDate',
                    altFormat: "yy-mm-dd",
                })

                //placeholder dates Classes
                var myDate="";
                if(sessionStorage.getItem('phWid-' + app.data.WebFolioId)){
                    var phDate = JSON.parse(sessionStorage.getItem('phWid-' + app.data.WebFolioId));
                    if($($('input.datepicker')[0]).datepicker('option', 'dateFormat').toLocaleLowerCase()[0] == 'd'){
                    myDate = new Date(phDate.year + ',' + phDate.month + "," + phDate.day);
                    }else{
                        myDate = new Date(phDate.year,phDate.altMonth,phDate.day);
                    }
                }

                $('#alt-spaClassDate').datepicker('setDate', (Date.parse($('#alt-spaClassDate').val(), 'yyyy-MM-dd') || myDate));

                $('#alt-spaClassDate').on('change', function (obj) {
                    $('#progressIndicator').modal('show');
                    app.dispatcher.redirect('spaBooking', 'class', [
                        'Location' + spaLocationId + ($('#spaClassSelectForm').data('lastItem') ? '|' + $('#spaClassSelectForm').data('lastItem') : ''),
                        $('#spaClassDate').val()
                    ])
                });
                $('.crossTypeLink').on('click', function (obj) {
                    obj.target.href += '/' + $('#spaClassDate').val()
                })
                
            },
            prepClassSelectionForm: function (spaLocationId, location, spaItemId,categories) {
             
                var updateBookButton = function () {
                    $('#spaClassSelectForm').validate();
                    if ($('#spaClassSelectForm').valid()) {
                        $('.spaServiceButton').addClass('btn-primary').removeClass('disabled').removeAttr('title');
                    } else {
                        $('.spaServiceButton').removeClass('btn-primary').addClass('disabled');
                    }
                }
                $('#spaClassSelectForm').data('lastItem', spaItemId);
                $('#spaClassSelectForm .spaServiceButton').on('click', function (obj) {
                    //                if ($('#spaServiceForm').valid()) {
                    $(obj.target).button('loading');
                    $('#progressIndicator').modal('show');
                    obj.target.orighref = obj.target.orighref || obj.target.href
                    //obj.target.href = obj.target.orighref + '/' + spaLocationId;
                    var spaItem = $(obj.target).parents('.spaItem');
                    if (location.AllowOverbook == "G") {
                        obj.target.href = obj.target.orighref + '/' + (spaItem.find('.serviceRecipient .me').hasClass('active')
                            ? "me"
                            : encodeURIComponent(spaItem.find('.serviceRecipient .someoneInput input').val())
                        );
                    }
                    /*var spaItem = $(obj.target).parents('.spaItem'),
                        recipientGender = spaItem.find('.spaRecipientGender').val(),
                        staffGender = spaItem.find('.spaServiceStaff').val();*/
                });
                $('.spaItem .serviceRecipient .me').click(function (obj) {
                    obj.preventDefault();
                    $(obj.target).parents('.spaItem').find('.someoneInput').addClass('hidden');
                    updateBookButton();
                    $('.someoneInputField').removeClass('required');
                    if ($(obj.target).parents('.spaItem').data('collapse')) {
                        $(obj.target).parents('.spaItem').collapse('reset');
                    }
                });
                $('.spaItem .serviceRecipient .someone').click(function (obj) {
                    obj.preventDefault();
                    $(obj.target).parents('.spaItem').find('.someoneInput').removeClass('hidden');
                    updateBookButton();
                    $('.someoneInputField').addClass('required');
                    if ($(obj.target).parents('.spaItem').data('collapse')) {
                        $(obj.target).parents('.spaItem').collapse('reset');
                    }
                });
                //var loggedInUserProfile = {}
                if(app.data.userLoggedIn){
                app.models.userModel.getData('fetchCustomerProfile', { CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })
                .done(function (result) {
                    if(result.Customer && !_.isEmpty(result.Customer)){
                        app.data.loggedInUserProfile = result.Customer[0]    
                    }    
                })}
                    $('.accordion-toggle').on('click', function () {
                        var itemId = ($(this).attr('href')).substr(8),
                            itemData = '';
                        _.each(categories, function (v, k, l) {
                            itemData = itemData || _.find(v.value, function (x) {
                                return x.SpaClassId == itemId;
                            })
                        });
                        app.data.selectedClass = itemData
                      
                        var serviceItemDOM = $('#spaItem'+app.data.selectedClass.SpaClassId)
                        if(!$(serviceItemDOM).hasClass('in')){
                            $('.old-service-datepicker').remove()
                            $('.age-restriction-class-error-message').remove()
                        var guestSelectionDOM = serviceItemDOM.find('.itemDescription')
                        var loggedInUserProfile = app.data.loggedInUserProfile ||{}
                        var payload = {
                            selectedGuestDob:loggedInUserProfile.DateOfBirth || '',
                            canEditGroupMember:"Y", // for default user it doesnt matter
                            CustomerId:loggedInUserProfile.CustomerId,
                            service:itemData,
                            addedByDatePicker:(app.data.datePickedCustomerList || {})[loggedInUserProfile.CustomerId],
                            CustomerName:(loggedInUserProfile['Name'] || {}).FirstName,
                            self:serviceItemDOM,
                            guestSelectionDOM:guestSelectionDOM
                         }  
                         app.commonViewHelper.runAgeRestrictionMechanism(payload)
                        }
                        })
                
              //  }
        
                // if (templateData.showDateList && app.data.pmsPropertyIdsInCart.length < 1) {
                //     spaItemElement.find('.spaServiceDateContainer').popover({
                //         trigger: 'hover',
                //         placement: 'in left',
                //         offsetY: 10,
                //         delay: { show: 250, hide: 300 },
                //         title: app.localization.spaBooking.pmsbeforespa.dateSelectorAcknowledgePromptTitle,
                //         content: app.localization.spaBooking.pmsbeforespa.dateSelectorAcknowledgePromptText.replace('a href="#/summary/setOverride"', 'a onclick="app.data.overridePMSRestriction = true;" href="#/spaBooking/service/'+spaItemElement.attr('id').substr(7)+'"')
                //     });
                // }
                $('.spaItem .required').change(updateBookButton);
                updateBookButton();
                //            $('#categories .nav-tabs li:first-child').addClass('active');
                //            $('#categories .tab-content div.tab-pane:first-child').addClass('active');
                //            $('#categories .tab-content div.accordion-group:first-child div.accordion-body').addClass('in')
                $('#categoryTabs a').click(function (e) {
          
                    e.preventDefault();
                    $('.accordion-toggle').each(function(){
                        var itemId = $(this).attr('href').substr(8)
                         if (!$(this).hasClass('collapsed')) {
                             $('#spaItem'+itemId).removeClass('in')
                             $('#spaItem'+itemId).css('display','none')
                             $('#spaItem'+itemId).css('height',"0px")
                         }
                    });
                    $(this).tab('show');
                    //$(this.hash).has('div.accordion-group div.accordion-body.in').length || $(this.hash).find('div.accordion-group:first-child div.accordion-body').addClass('in');
                })
                $('#spaClassSelectForm .accordion-heading').on('click', function (obj) {
                    $('#spaClassSelectForm').data('lastItem',
                        app.customization.spaBooking.preserveClassItemCrossDate ? $(obj.target).parents('.accordion-group').find('.spaItem').attr('data-itemid') : null
                    );
                })
                $('.spaItem').on('shown', function (obj) {
                    app.customization.googleAnalytics && _gaq.push(['_trackPageview', '#/spaBooking/class/' + $(obj.target).attr('id').substr(7)]);
                })

            },
            showPPProgressIndicator: function (message) {
                var message = message || app.localization.paymentProcessing.PPPreRedirect;
                $('#progressIndicator .modal-body p').html(message);
                $('#progressIndicator').modal('show');
            },
            prepCartSummary: function () {
                if(app.customization.dynamicRestrictions){
                    app.commonViewHelper.evalCriteria();
                }
                $('.pay-pp').click(function (o) {
                    $('.pay-pp').button('loading');
                });
                $('.pay-cc').click(function (o) {
                    $('.pay-cc').button('loading');
                });
                $('.folioSwitchBtn').on('click', function (e) {
                    e.preventDefault();
                    var inputField = $(this).parents('div.controls').find('input.switchFolioId');
                    app.dispatcher.dispatch('profile', 'switchfolio', [$(this).attr('data-folio-id'), encodeURIComponent(inputField.val()), 'folioSwitch']);
                })
                $('.clearRestrictedFolio').on('click', function (e) {
                    e.preventDefault();
                    // var inputField = $(this).parents('div.controls').find('input.switchFolioId');
                    app.dispatcher.dispatch('profile', 'clearFolio', 'folioClear');
                })
                $('#bookingHistoryCollapse').on('shown', function (obj) {
                    $('.bookingHistoryCollapseButton').html('<i class="icon-minus-sign"></i> Hide');
                    app.data.bookingHistoryCollapseHidden = false;

                }).on('hidden', function (obj) {
                    $('.bookingHistoryCollapseButton').html('<i class="icon-plus-sign"></i> Show');
                    app.data.bookingHistoryCollapseHidden = true;
                });
                $('a.guestNote').click(function (o) {
                    var note = encodeURIComponent($(this).siblings('textarea').val());
                    if (note) {
                        $(this).button('loading');
                        this.href += note;
                    } else {
                        o.preventDefault();
                    }
                });
                $('textarea[maxlength].guestNote').bind('input propertychange', function () {
                    var maxLength = $(this).attr('maxlength');
                    if ($(this).val().length > maxLength) {
                        $(this).val($(this).val().substring(0, maxLength));
                    }
                });
                
                // Cancel Spa bookings
                // type, folioId, folioItemId, automatic, doRefundAllGCs,doRefundPromoActivatingItem,waitListId, isFutureBooking
                $('a.cancelSpaBookings').each(function() {
                    var mainCancelBtn = $(this);
                    var spafolioId = '';
                    var spaFolioItemId = '';

                    spaLocation = '';
                    $(this).after('<a class="cancel-flow btn btn-primary" >'+app.localization.bookingSummary.proceedCancel+'</a><a class="cancel-btn btn btn-primary">'+ app.localization.bookingSummary.abortCancellation +'</a>').parent().prepend('<p class="cancel-flow">'+app.localization.bookingSummary.cancelQuestion +'</p>')
                    $(this).parent().find('a.cancel-flow').hide().click(function(e){
                        e.preventDefault();
                        $('#progressIndicator').modal('show');
                        $(this).attr('disabled', 'disabled');
                        // type, folioId, folioItemId, automatic, doRefundAllGCs,doRefundPromoActivatingItem,waitListId, isFutureBooking
                        app.dispatcher.dispatch('summary', 'cancel', ['Spa', spafolioId, spaFolioItemId,,,,,true]);
                    })
                    $(this).parent().find('.cancel-flow').hide();
                    $(this).parent().find('.cancel-btn').hide().click(function(e){
                        e.preventDefault();
                        $(this).hide();
                        mainCancelBtn.parent().find('.cancel-flow').hide();
                        mainCancelBtn.show()
                    });

                    $(this).on('click', function(e) {
                        e.preventDefault();
                         spafolioId = $(this).attr('spa-folio-id');
                         spaFolioItemId = $(this).attr('spa-folio-item-id');
                         var spaFolioItem = $(this).attr('spa-item');
                         var bookingPrice = $(this).attr('spa-price');
                         var spaBookTime = $(this).attr('spa-book-time');
                         var endTime = $(this).attr('spa-end-time');
                         var spaLocation = $(this).attr('spa-location');
                         var spaGuestName = $(this).attr('spa-guest-name');
                         var cancellationSpaItem = {
                            spaFolioItem: spaFolioItem,
                            spaFolioItemId: spaFolioItemId,
                            spafolioId: spafolioId,
                            bookingPrice : bookingPrice,
                            bookDate : spaBookTime, 
                            endTime : endTime,
                            location: spaLocation,
                            spaGuestName: spaGuestName
                         }
                         app.datal('cancellationSpaItem', cancellationSpaItem)
                         $(this).hide().parent().find('.cancel-btn').show();
                         $(this).parent().find('.cancel-flow').show();
                    })
                })

                // Cancel pms bookings
                $('a.cancelPmsBookings').each(function() {
                    
                    var mainCancelBtn = $(this);
                    var pmsfolioId = '';

                    $(this).after('<a class="cancel-flow btn btn-primary" >'+app.localization.bookingSummary.proceedCancel+'</a><a class="cancel-btn btn btn-primary">'+ app.localization.bookingSummary.abortCancellation +'</a>').parent().prepend('<p class="cancel-flow">'+app.localization.bookingSummary.cancelQuestion +'</p>')
                    $(this).parent().find('a.cancel-flow').hide().click(function(e){
                        e.preventDefault();
                        $('#progressIndicator').modal('show');
                        $(this).attr('disabled', 'disabled');
                        // // type, folioId, folioItemId, automatic, doRefundAllGCs,doRefundPromoActivatingItem,waitListId, isFutureBooking
                        // app.dispatcher.dispatch('summary', 'cancel', ['Spa', spafolioId, spaFolioItemId,,,,,true]);
                        app.dispatcher.dispatch('summary', 'cancel', ['Hotel', pmsfolioId,,,,,,true]);
                    })
                    $(this).parent().find('.cancel-flow').hide();
                    $(this).parent().find('.cancel-btn').hide().click(function(e){
                        e.preventDefault();
                        $(this).hide();
                        mainCancelBtn.parent().find('.cancel-flow').hide();
                        mainCancelBtn.show()
                    });

                    $(this).on('click', function(e) {
                        e.preventDefault();
                         pmsfolioId = $(this).attr('pms-folio-id');
                         var pmsRoomType = $(this).attr('pms-room-type');
                         var pmsRateType = $(this).attr('pms-rate-type');
                         var pmsVenue = $(this).attr('pms-venue');
                         var pmsPrice = $(this).attr('pms-price');
                         var pmsArrival = $(this).attr('pms-arrival');
                         var pmsDeparture = $(this).attr('pms-departure');
                         var cancellationPmsItem = {
                            bookingPrice : pmsPrice, 
                            roomType:pmsRoomType,
                            rateType: pmsRateType,
                            location: pmsVenue,
                            arrival: pmsArrival,
                            departure: pmsDeparture
                         }
                         app.datal('cancellationPmsItem', cancellationPmsItem)
                         $(this).hide().parent().find('.cancel-btn').show();
                         $(this).parent().find('.cancel-flow').show();
                    })
                })

                // Cancel Golf Bookings
                $('a.cancelGolfBookings').each(function() {
                    var mainCancelBtn = $(this);
                    var parentToCancelBtn = mainCancelBtn.parent();
                    var golfBookingId = '';
                    var positions = {};
                    var allPositions = {};
                    var cancelStr = app.localization.bookingSummary.cancelGolf;
                    var cancelPosStr = app.localization.bookingSummary.cancelGolfPositions;
                    $(this).after('<a class="cancel-flow btn btn-primary" >'+cancelStr+'</a><a class="cancel-btn btn btn-primary">'+ app.localization.bookingSummary.abortCancellation +'</a>')
                        
                    parentToCancelBtn.find('a.cancel-flow').hide().click(function(e){
                        e.preventDefault();
                        $('#progressIndicator').modal('show');
                        $(this).attr('disabled', 'disabled');
                        var cancelledItem = app.data.cancellationGolfItem;
                        var positionsStr = ''
                        var allPositionsStr = ''

                        _.each(Object.values(positions), function(position, index, posArr){
                            var isLast = index === posArr.length - 1;
                            positionsStr += position + (!isLast ? ',' : '');
                        });

                        _.each(Object.values(allPositions), function(position, index, posArr){
                            var isLast = index === posArr.length - 1;
                            allPositionsStr += position + (!isLast ? ',' : '');
                        });

                        if(!cancelledItem.positions){
                            app.datal('cancellationGolfItem', _.extend({}, cancelledItem, {positions: positionsStr || allPositionsStr}))
                        }

                        app.dispatcher.dispatch('summary', 'cancel', ['Golf', golfBookingId,,,,,,true,positionsStr || cancelledItem.positions || allPositionsStr]);
                    })
                    parentToCancelBtn.find('.cancel-flow').hide();
                    parentToCancelBtn.find('.cancel-btn').hide().click(function(e){
                        e.preventDefault();
                        $(this).hide();
                        mainCancelBtn.parent().find('.cancel-flow').hide();
                        mainCancelBtn.show()
                    });

                    parentToCancelBtn.find('.single-player').each(function(){
                        var position = $(this).attr('golf-position');
                        if(!allPositions[position]){
                            allPositions[position] = position
                        }
                        $(this).click(function(e){
                            e.preventDefault();
                            $(this).toggleClass('cancel-this-slot');
                            if(!positions[position]){
                                positions[position] = position
                            } else {
                                delete positions[position];
                            }
                            var slots = Object.keys(positions);
                            parentToCancelBtn.find('a.cancel-flow.btn.btn-primary').html(slots.length ? cancelPosStr + slots : cancelStr)
                        });
                    })
                    $(this).on('click', function(e) {
                        e.preventDefault();
                         golfBookingId= $(this).attr('golf-booking-id');
                         var golfItemName = $(this).attr('golf-name');
                         var golfPrice = $(this).attr('golf-price');
                         var golfTime = $(this).attr('golf-time');
                         var golfPosition = $(this).attr('golf-position-single')
                         var cancellationGolfItem = {
                            golfItemName:golfItemName,
                            bookingPrice: golfPrice,
                            golfTime: golfTime,
                            positions: golfPosition
                         }
                         if(golfPosition){
                             parentToCancelBtn.find('a.cancel-flow.btn.btn-primary').html('Yes')
                         }
                         app.datal('cancellationGolfItem', cancellationGolfItem)
                         $(this).hide().parent().find('.cancel-btn').show();
                         parentToCancelBtn.find('.cancel-flow').show();
                    })
                })
                // Dynamic Restriction effects
                if (app.commonViewHelper.activeEffects.preventCheckout) {
                    var preventCheckResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.preventCheckout);
                    if(preventCheckResult.isActive){

                        var msg = '<div id="alert-' + preventCheckResult.value + '" class="alert hide alert-error' + '"><a class="close" data-dismiss="alert" role="button" aria-labelledby="alert-head-' + preventCheckResult.value + '" aria-describedby="alert-body-' + preventCheckResult.value + '" href="#" style="color: red">×</a>';
                        msg += '<h4 id="alert-head-' + preventCheckResult.value + '">' + preventCheckResult.value + '</h4>';
                        msg += '</div>';

                        $('.mainContent').find('#alerts').append(msg);

                        // Prevent checkout for the checkout button
                        $('a[href="#/summary/checkout"]').on('click', function(e){
                            e.preventDefault();
                            if(!$('.mainContent').find('#alerts').children().length) {
                                $('.mainContent').find('#alerts').append(msg);
                                $('.mainContent').find('#alerts').children().removeClass('hide');
                                $('.mainContent').find('#alerts').children().css('border', '0px');
                            } else {
                                $('.mainContent').find('#alerts').children().css('border', '1px solid red');
                            }
                            return;
                        }).css({'background':'#cc0000','color':'#fff','opacity':'0.3'})

                    } else {
                        $('a[href="#/summary/checkout"]').tooltip({title:preventCheckResult.value, position:'bottom'});
                    }
                }

                if (app.commonViewHelper.activeEffects.messageOnSummary) {
                    var messageOnSummary = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.messageOnSummary);
                    if(messageOnSummary.isActive){
                        $('div.total-display').after( 
                            $('<div></div>').attr('class','summary-message').append( 
                                $('<p></p>').text(messageOnSummary.value)
                            )
                        )
                    }
                }
                if (app.customization.features.pmsBooking) {
                    app.models.roomsModel.getData('pmsVenues').done(function (pmsVenues) {
                        var venues = getVenuesObject(pmsVenues)
                        venues && _.each(app.data.pmsBookings, function (pmsBooking) {
                            var arrivalDate = moment(pmsBooking.ArrivalDate, 'YYYY-MM-DDHHmmss').format('YYYYMMDD');
                            var arriveOnOperatingDay = false;
                            if(venues[pmsBooking.Venue]){
                                arriveOnOperatingDay = moment(venues[pmsBooking.Venue].CurrentOperatingDay, 'YYYYMMDD').isSame(arrivalDate);
                            }
                            toggleCheckInButton(pmsBooking, arriveOnOperatingDay)
                            handleCheckInClick(pmsBooking.PMSFolioId)
                        })
                    }).fail(function () {
                        _.each(app.data.pmsBookings, function (pmsBooking) {
                            var arrivalDate = moment(pmsBooking.ArrivalDate, 'YYYY-MM-DDHHmmss').format('YYYYMMDD');
                            var arriveOnOperatingDay = false;
                            if(venues[pmsBooking.Venue]){
                                arriveOnOperatingDay = moment(venues[pmsBooking.Venue].CurrentOperatingDay, 'YYYYMMDD').isSame(arrivalDate);
                            }
                            toggleCheckInButton(pmsBooking, arriveOnOperatingDay)
                            handleCheckInClick(pmsBooking.PMSFolioId)
                        })
                    })

                    // remove name and price container only for golf when we use member roster for golf because each player can have a different rate, showing rate names for each player and price against date instead - this is a simpler solution than modifying complicating the template
                    if(app.customization.golfBooking.enableGolfMemberRoster){
                        // target all elements with data-category="golf" attribute
                        $('[data-category="Golf"]').each(function(){
                            // remove name and price container
                            $(this).find('.nameAndPriceContainer').remove();
                        });
                    }

                    function toggleCheckInButton(pmsBooking, arriveOnOperatingDay) {
                        var canCheckIn = pmsBooking.HasSignature == 'Y' && arriveOnOperatingDay
                        Customization.roomsBooking.allowPMSCheckIn
                        if (typeof app.customization.roomsBooking.allowPMSCheckIn == "function") {
                            $.when(app.customization.roomsBooking.allowPMSCheckIn(pmsBooking)).done(function (val) {
                                canCheckIn = canCheckIn && val
                            })
                        } else {
                            canCheckIn = canCheckIn && app.customization.roomsBooking.allowPMSCheckIn
                        }
                        $('#pmsCheckInUser' + pmsBooking.PMSFolioId).toggleClass('hide', !canCheckIn)
                    }

                    function getVenuesObject(pmsVenues) {
                        var venues = {}
                        _.each(pmsVenues.Venue, function (val, key) {
                            venues[val.VenueId] = val
                        })
                        return venues
                    }

                    function handleCheckInClick(folioId) {
                        $('#pmsCheckInUser' + folioId).on('click', function () {
                            $('#progressIndicator').modal('show');
                            app.models.roomsModel.getData('checkCustomerIn', {
                                    App: 'PMS',
                                    FolioId: folioId
                                })
                                .done(function () {
                                    app.data.messages.push({
                                        type: 'alert',
                                        'class': 'alert-success',
                                        actions: [],
                                        title: app.localization.roomReservation.onlineCheckInSuccessful,
                                        message: ''
                                    });
                                })
                                .fail(function () {
                                    app.data.messages.push({
                                        type: 'alert',
                                        'class': 'alert-error',
                                        actions: [],
                                        title: app.localization.roomReservation.onlineCheckInFailed,
                                        message: ''
                                    });
                                })
                                .always(function () {
                                    $('#progressIndicator').modal('hide');
                                    app.dispatcher.dispatch('summary', 'show', []);
                                })
                        })
                    }
                }
            },
            updateRoomTypeDetails: function (PMSRoomTypeDetails) {
                $('.pmsRoomTypeName' + stripChars(PMSRoomTypeDetails.PMSRoomType)).text(PMSRoomTypeDetails.PMSRoomTypeDesc);
            },
            updateRateDetails: function (PMSRateDetails) {
                $('.pmsRateName' + stripChars(PMSRateDetails.PMSRateType)).text(PMSRateDetails.PMSRateName);
            },
            handleGoogleAuth: function () {
                var googleClientLib = app.customization.googleAuth.showGoogleButton && app.customization.googleAuth.googleClientLib;

                require([googleClientLib], function () {

                    // Mobile & Desktop rendering for Navigationbar
                    if(window.innerWidth <= 979 && !$('.nav-collapse #navbarLoginControl > ul #gSignInWrapper').length){
                        $('.nav-collapse #navbarLoginControl > ul').append('<li id="gSignInWrapper"></li>');
                        $('#gSignInWrapper').append('<div id="googleAuthBtn" class="customGPlusSignIn" ><i class="fab fa-google"></i>'+app.localization.auth.googleSignin+'</div>');
                    } else if(window.innerWidth >= 980 && !$('#navLoginForm #gSignInWrapper').length) {
                        $('#navLoginForm #authWrapper').append('<div id="gSignInWrapper"></div>');
                        $('<div id="googleAuthBtn" class="customGPlusSignIn" ><i class="fab fa-google"></i>'+app.localization.auth.googleSignin+'</div>').appendTo('#gSignInWrapper');
                    }
                    // Adding to Login Page
                    $('#gSignInWrapper').clone().css('list-style','none').appendTo('#thirdPartyLogins');
                    $('#thirdPartyLogins #googleAuthBtn').attr('id','googleBut');        
                    // Adding to Dining Page
                    $('#gSignInWrapper').clone().css('list-style','none').prependTo('.content-diningReservation #thirdPartyAuthDine');
                    $('.content-diningReservation #thirdPartyAuthDine #googleAuthBtn').attr('id', 'gBtn').addClass('diningAuth');                    

                    var attachSignin = function(e){
                        $('#progressIndicator').modal('show');

                        var client = window.google.accounts.oauth2.initTokenClient({
                            client_id: app.customization.googleAuth.googleAuthClientID,
                            scope: 'https://www.googleapis.com/auth/userinfo.profile',
                            callback: function (tokenResponse) {
                                $('#progressIndicator').modal('hide');
                                onSignIn(tokenResponse);                                
                            },
                            error_callback: function (error) {
                                $('#progressIndicator').modal('hide');
                                if(error.type == 'popup_closed'){
                                    renderError(app.localization.auth.applePopupClosed);
                                } else {
                                    renderError(error.message);
                                }
                            }                           
                        });

                        client.requestAccessToken();
                    }

                    $('.customGPlusSignIn').off().on('click', function(e){
                        // Disable other login buttons
                        app.commonViewHelper.disableOtherLoginButtons();
                        var nextUrlPrep =  window.location.hash.replace(/^#/, '').split('/');
                        nextUrlPrep = _.filter(nextUrlPrep, function(param){ return param.length > 0});
                        nextUrlPrep = _.map(nextUrlPrep,function(prm){return decodeURIComponent(prm)});
                        var params = nextUrlPrep.slice(2);

                        if(e.target.className.indexOf('diningAuth') >= 0){
                            actualNextUrl = [nextUrlPrep[0],nextUrlPrep[1],params];
                            app.data.loginNextURL = actualNextUrl;
                        } else {
                            app.data.loginNextURL = undefined; 
                        }

                        attachSignin(e);
                    })

                    var onSignIn = function (googleUser) {
                        // Disable other login buttons
                        app.commonViewHelper.disableOtherLoginButtons();
                        $('#progressIndicator').modal('show');
                        $('#progressIndicator').modal({backdrop:'static', keyboard:false});
                        var id_token = googleUser.id_token || googleUser.access_token || googleUser.credential;
                        var isAccessToken = googleUser.access_token ? true : false;
                        verifyToken(id_token, isAccessToken);   
                    }

                    var verifyToken = function(token, isAccessToken){
                        xhr = new XMLHttpRequest();
                        xhr.open('POST','/auth', true);
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.onreadystatechange = function receiveResponse() {
                            if (this.readyState == 4) {
                                if (this.status == 200) {
                                    var user = JSON.parse(xhr.response);
                                    if (Object.keys(user).length){   
                                        if(user.UserCreated){
                                            renderInfo(app.localization.auth.accountCreateSuccess+' Google'+app.localization.auth.account);
                                        } else renderInfo(app.localization.auth.loginSuccess+' Google'+app.localization.auth.account);  
                                        updateSession(user, 'Google');
                                        signOut();
                                    }
                                } else if (!this.response && this.status == 0) {
                                    renderError(app.localization.auth.networkError);
                                } else renderError();
                            };
                        }
                        xhr.send(JSON.stringify({token: token, engineType:'GOOGLE', isAccessToken: isAccessToken}));
                    }

                    var updateSession = app.commonViewHelper.postOauthSessionUpdate;

                    var renderError = function(message) {
                        $('#progressIndicator').modal('hide');
                        var isMessageRendered = $('.googleAuthErr').length;
                        var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                        var checkMessageInQuee = _.find(app.data.messages, function(message){ return message.class.indexOf('googleAuthErr') >= 0});
                        if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                            app.data.messages.push({ type:'alert', 'class':'alert-error googleAuthErr', actions:[],
                                title: message || app.localization.auth.googleLoginFail,
                                message: ''
                            });
                        }
                        app.commonViewHelper.showMessages();
                        app.commonViewHelper.enableOtherLoginButtons();
                    }

                    var renderInfo = function(message) {
                        var isMessageRendered = $('.googleAuthSuc').length;
                        var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                        var checkMessageInQuee = _.find(app.data.messages, function(message){ return message.class.indexOf('googleAuthSuc') >= 0});
                        if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                            app.data.messages.push({ type:'alert', 'class':'alert-success googleAuthSuc', actions:[],
                                title: message,
                                message:''
                            });
                        } 
                        // This is to show the message for index.html#/dining especially since app.commonViewHelper.showMessages() cancelled in the diningView.requestDiningReservationSelection function
                        setTimeout(function(){
                            app.commonViewHelper.showMessages();
                        }, 3000);
                        app.commonViewHelper.enableOtherLoginButtons();
                    }

                    var signOut = function() {
                        if(window.google.accounts){
                            window.google.accounts.id.disableAutoSelect();  
                        }
                        app.commonViewHelper.enableOtherLoginButtons();
                    }

                    var renderGoogleYolo = function () {
                        if(!window.google.accounts && !app.customization.googleAuth.showGoogleYolo || app.data.googleYoloIsShown) return;
    
                        window.google.accounts.id.initialize({
                                client_id:app.customization.googleAuth.googleAuthClientID,
                                callback: onSignIn
                        })
                        window.google.accounts.id.prompt(function(notification){
                            if (notification.isDisplayed()) {
                                app.data.googleYoloIsShown = true
                            }
                        });
                    }
                    
                    if(!app.data.userLoggedIn){
                        renderGoogleYolo()
                    }                
                })

            },
            handleFacebookAuth: function(){    
                    // Install Facebook Library to Window
                    var facebookClientLib = app.customization.facebookAuth.showFacebookButton && app.customization.facebookAuth.facebookSDK;
    
                    require([facebookClientLib], function () {
                        // Keys in mobiledev
                        window.fbAsyncInit = function() {
                            FB.init({
                            appId      : app.customization.facebookAuth.facebookAuthAppID,
                            cookie     : true,
                            xfbml      : true,
                            version    : app.customization.facebookAuth.facebookApiVersion
                            });                
                        };
                        // Mobile & Desktop rendering for Navigationbar
                        if(window.innerWidth <= 979 && !$('.nav-collapse #navbarLoginControl > ul #fb-root').length){
                            $('.nav-collapse #navbarLoginControl > ul').append('<li id="fb-root"></li>');
                            $('#fb-root').append('<div id="facebookAuthBtn" class="fbAuthBtn" style="background: #4267b2;color: white; text-align: center;cursor:pointer;" class="fb-login-button" data-max-rows="1" data-size="large" data-button-type="continue_with" data-use-continue-as="true"><i class="fab fa-facebook-f"></i>'+app.localization.auth.facebookSignin+' </div>');
        
                        } else if(!$('#navLoginForm #fb-root').length) {
                            $('#navLoginForm #authWrapper').append('<div id="fb-root"></div>');
                            $('#fb-root').html('<div id="facebookAuthBtn" class="fbAuthBtn" style="background: #4267b2;border-radius: 5px;color: white; height: 40px;text-align: center;cursor:pointer;" class="fb-login-button" data-max-rows="1" data-size="large" data-button-type="continue_with" data-use-continue-as="true"><i class="fab fa-facebook-f"></i>'+app.localization.auth.facebookSignin+' </div>');
                        }
                        // Adding to Login Page
                        $('#fb-root').clone().css('list-style','none').appendTo('#thirdPartyLogins');
                        // Adding to Dining Page
                        $('#fb-root').clone().css('list-style','none').prependTo('.content-diningReservation #thirdPartyAuthDine');
                        $('#thirdPartyAuthDine .fbAuthBtn').addClass('diningAuth');
        
                        function statusChangeCallback(response){
                            if(response.status === 'connected'){
                                verifyToken(response.authResponse.accessToken);
                            } else {
                                console.log('not authenticated yet')
                                // Enable other login buttons
                                app.commonViewHelper.enableOtherLoginButtons();

                            }
                        }      
        
                        var verifyToken = function(token){
                            xhr = new XMLHttpRequest();
                            xhr.open('POST','/auth', true);
                            xhr.setRequestHeader('Content-Type', 'application/json');
                            xhr.onreadystatechange = function receiveResponse() {
                                if (this.readyState == 4) {
                                    if (this.status == 200) {
                                        var user = JSON.parse(xhr.response);
                                        if (Object.keys(user).length){   
                                            if(user.UserCreated){
                                                renderInfo(app.localization.auth.accountCreateSuccess+' Facebook'+ app.localization.auth.account);
                                            } else renderInfo(app.localization.auth.loginSuccess+' Facebook'+ app.localization.auth.account);      
                                            updateSession(user, 'Facebook');
                                        }
                                    } else if (!this.response && this.status == 0) {
                                        renderError(app.localization.auth.networkError);
                                    } else renderError();

                                    app.commonViewHelper.enableOtherLoginButtons();
                                };
                            }
                            xhr.send(JSON.stringify({token: token, engineType:'FACEBOOK'}));
                        }
        
                        var updateSession = app.commonViewHelper.postOauthSessionUpdate;
        
                        var renderError = function(message) {
                            $('#progressIndicator').modal('hide');
                            var isMessageRendered = $('.fbAuthErr').length;
                            var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                            var checkMessageInQuee = _.find(app.data.messages, function(message){ return message.class.indexOf('fbAuthErr') >= 0});
                            if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                                app.data.messages.push({ type:'alert', 'class':'alert-error fbAuthErr', actions:[],
                                    title: message || app.localization.auth.facebookLoginFail,
                                    message: ''
                                });
                            }     
                            app.commonViewHelper.showMessages();                    
                        }

                        var renderInfo = function(message) {
                            var isMessageRendered = $('.fbAuthSuc').length;
                            var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                            var checkMessageInQuee = _.find(app.data.messages, function(message){ return message.class.indexOf('fbAuthSuc') >= 0});
                            if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                                app.data.messages.push({ type:'alert', 'class':'alert-success fbAuthSuc', actions:[],
                                    title: message,
                                    message:''
                                });
                            }
                            // This is to show the message for index.html#/dining especially since app.commonViewHelper.showMessages() cancelled in the diningView.requestDiningReservationSelection function
                            setTimeout(function(){
                                app.commonViewHelper.showMessages();
                            }, 3000);
                        }
        
                        $('.fbAuthBtn').off().on('click', function(e){
                            // Disable other login buttons
                            app.commonViewHelper.disableOtherLoginButtons();
                            var nextUrlPrep =  window.location.hash.replace(/^#/, '').split('/');
                            nextUrlPrep = _.filter(nextUrlPrep, function(param){ return param.length > 0});
                            nextUrlPrep = _.map(nextUrlPrep,function(prm){return decodeURIComponent(prm)});
                            var params = nextUrlPrep.slice(2);
                            
                            if(e.target.className.indexOf('diningAuth') >= 0){
                                actualNextUrl = [nextUrlPrep[0],nextUrlPrep[1],params];
                                app.data.loginNextURL = actualNextUrl;
                            } else {
                                app.data.loginNextURL = undefined; 
                            }

                            FB.login(function(response) {        
                                // handle the response
                                if (response.status === 'connected') {
                                    $('#progressIndicator').modal('show');
                                    // Logged into your webpage and Facebook.
                                    statusChangeCallback(response);
                                } else {
                                    renderError(app.localization.auth.facebookPopupClosed);
                                    // Enable other login buttons
                                    app.commonViewHelper.enableOtherLoginButtons();

                                    console.log('no facebook');
                                }
                            }, {scope: 'public_profile,email'});       
        
                        })               

                    })            
                
            },
            handleAppleAuth: function(){

            var appleAuthLib = app.customization.appleAuth.showAppleButton && app.customization.appleAuth.appleAuthLib; 

            require([appleAuthLib], function (appleAuth) {
                window.appleAuth = appleAuth;
                // Mobile & Desktop rendering for Navigationbar 
                if(window.innerWidth <= 979 && !$('.nav-collapse #navbarLoginControl > ul #apple-root').length){
                    $('.nav-collapse #navbarLoginControl > ul').append('<li id="apple-root"></li>');
                    $('#apple-root').append('<div style="cursor:pointer;" data-type="sign-in" data-color="black" class="appleAuthBtn" id="appleAuthBtn"><i class="fab fa-apple"></i>'+app.localization.auth.appleSignin+'</div>');

                } else if(!$('#navLoginForm #apple-root').length) {
                    $('#navLoginForm #authWrapper').append('<div id="apple-root"></div>');
                    $('#apple-root').html('<div style="height:30px;cursor:pointer;" data-type="sign-in" data-color="black" class="appleAuthBtn" id="appleAuthBtn"><i class="fab fa-apple"></i>'+app.localization.auth.appleSignin+'</div>');
                }
                // Adding to Login Page
                $('#apple-root').clone().css('list-style','none').appendTo('#thirdPartyLogins');
                // Adding to Dining Page
                $('#apple-root').clone().css('list-style','none').prependTo('.content-diningReservation #thirdPartyAuthDine');
                $('#thirdPartyAuthDine .appleAuthBtn').addClass('diningAuth');
                
                var verifyToken = function(userInfo){
                    xhr = new XMLHttpRequest();
                    xhr.open('POST','/auth', true);
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.onreadystatechange = function receiveResponse() {
                        if (this.readyState == 4) {
                            if (this.status == 200) {
                                var user = JSON.parse(xhr.response)
                                if (Object.keys(user).length){   
                                    if(user.UserCreated){
                                        renderInfo(app.localization.auth.accountCreateSuccess+' Apple'+ app.localization.auth.account);
                                    } else renderInfo(app.localization.auth.loginSuccess+' Apple'+ app.localization.auth.account);      
                                    updateSession(user, 'Apple');
                                }
                            } else if (!this.response && this.status == 0) {
                                renderError(app.localization.auth.networkError);
                            } else {
                                renderError();
                            }
                            app.commonViewHelper.enableOtherLoginButtons();                       
                        };
                    }
                    xhr.send(JSON.stringify({token: userInfo.detail.authorization.id_token, code:userInfo.detail.authorization.code, engineType:'APPLE', userAuthData:userInfo.detail.user}));
                }

                var updateSession = app.commonViewHelper.postOauthSessionUpdate;


                var renderError = function(message, type) {
                    $('#progressIndicator').modal('hide');
                    var className = 'alert-error appleAuthErr' + (type ? ' ' + type : '');
                    // check if the message is already rendered
                    var isMessageRendered = $('.'+type).length;
                    var checkMessageInQuee = _.find(app.data.messages, function(msg){ return msg.class.indexOf(type) >= 0});
                    var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                    if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                        app.data.messages.push({ type:'alert', 'class':className, actions:[],
                        title: message || app.localization.auth.appleLoginFail,
                        message: '',
                        });
                    }
                    app.commonViewHelper.showMessages();
                }

                var renderInfo = function(message) {
                    var isMessageRendered = $('.appleAuthSuc').length;
                    var checkMessageInQuee = _.find(app.data.messages, function(message){ return message.class.indexOf('appleAuthSuc') >= 0});
                    var checkSpaVueApp = window.location.href.indexOf('/spaBooking/package/');
                    if(!isMessageRendered && checkSpaVueApp == -1 && !checkMessageInQuee){
                        app.data.messages.push({ type:'alert', 'class':'alert-success appleAuthSuc', actions:[],
                            title: message,
                            message:''
                        });
                    }
                    // This is to show the message for index.html#/dining especially since app.commonViewHelper.showMessages() cancelled in the diningView.requestDiningReservationSelection function
                    setTimeout(function(){
                        app.commonViewHelper.showMessages();
                    }, 3000);
                }

                var startAuthentication = function(){
                    //Listen for authorization success
                    document.addEventListener('AppleIDSignInOnSuccess', function(data){
                        verifyToken(data);
                    });

                    //Listen for authorization failures
                    document.addEventListener('AppleIDSignInOnFailure', function(error){
                        if(error.detail.error == 'popup_closed_by_user'){
                            renderError(app.localization.auth.applePopupClosed, error.detail.error);
                        } else if(error.detail.error == 'user_trigger_new_signin_flow' || error.detail.error == 'popup_blocked_by_browser'){
                            renderError(app.localization.auth.applePopupWindowBlocked, error.detail.error );
                        } else if( error.detail.error == 'user_cancelled_authorize' ){
                            renderError(app.localization.auth.applePopupClosed, error.detail.error);
                        } else renderError(error.detail.error, error.detail.error);
                        $('#progressIndicator').modal('hide');
                        app.commonViewHelper.enableOtherLoginButtons();                       
                    });

                    appleAuth.auth.init({
                        clientId : app.customization.appleAuth.clientID,
                        scope : 'name email',
                        redirectURI : app.customization.appleAuth.redirectURL,
                        usePopup : true //or false defaults to false
                    });

                    appleAuth.auth.signIn();
                }
                
                $('.appleAuthBtn').off().on('click', function(e){
                    // Disable other login buttons
                    app.commonViewHelper.disableOtherLoginButtons();

                    var nextUrlPrep =  window.location.hash.replace(/^#/, '').split('/');
                    nextUrlPrep = _.filter(nextUrlPrep, function(param){ return param.length > 0});
                    nextUrlPrep = _.map(nextUrlPrep,function(prm){return decodeURIComponent(prm)});
                    var params = nextUrlPrep.slice(2);

                    if(e.target.className.indexOf('diningAuth') >= 0){
                        actualNextUrl = [nextUrlPrep[0],nextUrlPrep[1],params];
                        app.data.loginNextURL = actualNextUrl;
                    } else {
                        app.data.loginNextURL = undefined; 
                    }

                    $('#progressIndicator').modal('show');
                    startAuthentication();
                })
            })
            },
            loginUserIfVuePackage: function (vm, user, updateSessionRes) {
                if (Object.keys(user).length){
                    var store = vm.$store;    
                    if(user.UserCreated){
                        store.commit('addGlobalMessage',{type:'success',message:app.localization.auth.accountCreateSuccess +' '+ user.EngineType + app.localization.auth.account });
                    } else store.commit('addGlobalMessage',{type:'success',message:app.localization.auth.loginSuccess +' '+ user.EngineType + app.localization.auth.account});

                    store.commit('setScheduleBtnValidity', {
                        action: "remove",
                        removeAll: true
                    });         
                    var modifedProfile = _.extend({}, store.state.guestProfiles[user.CustomerId], user);
                    store.commit('addGuestProfile', modifedProfile);
                    delete store.state.guestProfiles[user.CustomerId].requireDatePicker;

                    app.datal('thirdPartyAuth', true);
                    app.datac('userLoggedIn', true);
                    app.datac('CustomerId',user.CustomerId);
                    app.datac('CustomerGUID', user.CustomerGUID);
                    app.datac('FirstName', user.FirstName);
                    app.datac('LastName', user.LastName);
                    app.datac('folioLoginHasPassword', null);
                    app.datac('RestrictedFolio',  null);
                    app.datac('RestrictedLogin', null);

                    app.datac('CustomerEmail', user.CustomerEmail);
                    store.commit('setLoggedInUser',{userId: user.CustomerId});
                    store.commit('addUserWithId',{name: user.FirstName+" "+user.LastName, id: user.CustomerId});
                    store.commit('SetmobileViewMessages',{key:'success',message: app.localization.general.login.loginSuccess});
                    setTimeout((function(){
                        store.commit('SetmobileViewMessages',{key:'success',message: ""});
                    }), 3000)
                    if (!app.data.SessionId) {
                         window.location.reload(false);
                        return
                    }

                    var serviceType = $.firstOrOnly($.grep( app.data.serviceTypes, function(a){
                        return a.id==app.views.spaView.module;
                    }));

                    app.commonViewHelper.updateNavBar(serviceType, app.language, !!app.data.SessionId && app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance, {})]);
                    var dfd = $.Deferred()
                    app.models.userModel.getData('fetchGroupMembers', {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }).then(function (groupMembers) {
                        groupMembers.GroupMember.forEach(function (member) {
                            store.commit('addGroupMember',member.Name.FirstName + " " + member.Name.LastName);
                            store.commit('addUserWithId',{name: member.Name.FirstName + " " + member.Name.LastName, id: member.CustomerId});
                            //part of age restriction
                            var modifedProfile = _.extend({}, store.state.guestProfiles[member.CustomerId], member);
                            store.commit('addGuestProfile',modifedProfile);
                            dfd.resolve();
                        }, function(){
                            dfd.resolve(); 
                        })

                    dfd.then(function(){
                        // vm.$emit('loginSuccess');
                        vm.$emit('update:userLoggedIn',true); 
                    })
                    }, function (err) {
                        if(err.Result && err.Result.ErrorId == '106'){
                            // Account doesn't have group members
                        } else {
                            store.commit('addGlobalMessage',{type:'warn',message:app.localization.roomReservation.pmsCheckIn.errors.unableToFetchGroupMembers});
                        }
                    })
                        
                    if (updateSessionRes && updateSessionRes.ConflictingSpaBookingRemoved == 'Y') {
                        store.commit('addGlobalMessage',{type:'warn',message:app.localization.general.conflictingSpaBookingRemoved});
                        return
                    }
        
                    //update session fail case removed check this if anything breaks
                    // .fail(function (r_us) {
                    //     window.location.reload(false);
                    // })                           
                } else {
                    vm.error = app.localization.auth.networkError;
                }
            },
            postOauthSessionUpdate: function(user, engineType){
                app.datal('thirdPartyAuth', true);
                user.EngineType = engineType;
                app.controllers.userController.userLoginSubmit('','','','',user);       
            },
            authProfileChecker: function(fields){
                $('#progressIndicator').modal('hide');
                var errorMessage = getErrorMessage(fields);
                setErrorMessage(errorMessage);
                redirectToProfile();

                function redirectToProfile(){
                    app.dispatcher.redirect('profile', 'details', ['', 'truthy']);
                }
                
                function setErrorMessage(errorMessage){
                    if(!_.find(app.data.messages, function(message) {
                        return message.title === errorMessage
                    })){
                        app.data.messages.push({
                            type: 'alert',
                            'class': 'alert-error',
                            actions: [],
                            title: errorMessage,
                            message: ''
                        }); 
                    }
                }
                
                function getErrorMessage(missingFields) {
                    var errorMessage = '';
                    var missingFieldString = '';
                    if (missingFields.length) {
                        _.each(missingFields, function (field, i) {
                            missingFieldString += '<strong>'+field.name + (i == (missingFields.length -1)? '.' : ', ')+ '</strong>';
                        })
                        errorMessage = app.localization.auth.missingFieldsError + ' ' + missingFieldString;
                    } 
                    return errorMessage
                }                
            },
            disableOtherLoginButtons: function(){
                // Disable other login buttons
                $('[id="fb-root"]').css('pointer-events','none');
                $('[id="apple-root"]').css('pointer-events','none');
                $('[id="gSignInWrapper"]').css('pointer-events','none');
                $('#loginButton').css('pointer-events','none');
                $('.control-group.login .btn').css('pointer-events','none');
            },
            enableOtherLoginButtons: function(){
                // Enable other login buttons
                $('[id="fb-root"]').css('pointer-events', 'auto');
                $('[id="apple-root"]').css('pointer-events', 'auto');
                $('[id="gSignInWrapper"]').css('pointer-events', 'auto');
                $('#loginButton').css('pointer-events','auto');
                $('.control-group.login .btn').css('pointer-events','auto');
            },
            redirectYP: function () {
                var form = $("#redirectYPForm");
                app.models.userModel.getData('fetchCustomerProfile', { CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })
                    .done(function (customer) {
                        var addresses = $.wrapArray($.firstOrOnly(customer.Customer).Address),
                            address = _.find(addresses, function (addr) { return addr.type == 'HOME' }) || $.firstOrOnly(addresses);
                        if (address) {
                            form.append(
                                $('<input type="hidden">').prop('name', 'addLine1').val(xmlEscape(address.Address1)),
                                $('<input type="hidden">').prop('name', 'addLine2').val(xmlEscape(address.Address2)),
                                $('<input type="hidden">').prop('name', 'city').val(xmlEscape(address.City)),
                                $('<input type="hidden">').prop('name', 'postcode').val(xmlEscape(address.PostCode)),
                                $('<input type="hidden">').prop('name', 'state').val(xmlEscape(address.StateProv)),
                                $('<input type="hidden">').prop('name', 'country').val(xmlEscape(address.Country))
                            )
                        }
                        form.submit()
                    })
                    .fail(function (err) {
                        form.submit()
                    })
            },
            showCancellationModal: function(type, item){
                $('#cancellationModal').remove();
                
                $('#main').append(cancellationModalTpl({
                    Localization : app.localization,
                    type: type,
                    Item: item
                }));

                $('#cancellationModal').modal();
                $('#cancellationModal .continueBtn').on('click', function (e) {
                 e.preventDefault();
                 app.dispatcher.dispatch('summary', 'show', []);
                })
                $('#cancellationModal').on('hide', function(){
                    app.dispatcher.dispatch('summary', 'show', []);
                })
              
            },
            redirectPaytm: function () {
                $('#redirectPaytmForm').submit();
            },
            redirect3DS: function (forwardURL, params) {
                $('#redirect3DSForm').submit();
            },
            redirectWP: function (forwardURL, WPCustomerId, allowStoreCard,updatingOnFileCard) {
                // loadCustomerAddressIntoForm();
                window.Worldpay = undefined;
                app.data._lastWPCallBack = false;
                require.undef('https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js');
                require(['https://payments.worldpay.com/resources/hpp/integrations/embedded/js/hpp-embedded-integration-library.js'], function (worldpayjs) {
                    /*window.Worldpay.customCallback = function(obj) {
                        console.log('wp callback',obj)
                        if (app.data._lastWPCallBack && (app.data._lastWPCallBack + 3000) > (+(new Date()))) {
                            console.log('extra callback');
                            return;
                            }
                        app.data._lastWPCallBack = +(new Date());
                        if (obj && obj.token) {
                                app.dispatcher.dispatch('summary','wpReturn', [
                                    encodeURIComponent(JSON.stringify(obj)),
                                    encodeURIComponent($('#cartCCaddress').val()),
                                    encodeURIComponent($('#cartCCaddress2').val()),
                                    encodeURIComponent($('#cartCCcity').val()),
                                    encodeURIComponent($('#cartCCzip').val()),
                                    encodeURIComponent($('#cartCCcountry').val()),
                                    encodeURIComponent($('#storeCard').val())
                                    //response, ccaddress, ccaddress2, cccity, cczip, cccountry
                                ]);
                        } else {
                           app.models.systemModel.getData('debugfolio',{Debug: "<![CDATA["+encodeURIComponent('WPTokenizationFail: '+JSON.stringify(arguments))+"]]>"});
                           app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                           title:app.localization.paymentProcessing.PPPreError,
                                           message:''
                                       });
                           app.dispatcher.replace('summary','show',[]);
                           return;
                        }
                    }
                    var wpParams = {
                        'clientKey':clientKey,
                        'form':'cartCCPaymentForm',
                        'paymentSection':'wpFrame',
                        'display':'inline',
                        'reusable':true,
                        'saveButton':false,
                        'callback': window.Worldpay.customCallback,
                        'beforeSubmit': function() {
                            if ($('#cartCCPaymentForm').valid()) {
                                $('#cartCCFormSubmit').attr('disabled','disabled')
                                return true
                            } else {
                                return false
                            }
                        },
                        'validationError': function() {
                            $('#cartCCFormSubmit').attr('disabled',null)
                        }
                    }*/
                    // $('#cartCCFormSubmit').on('click',function(){
                    //     Worldpay.submitTemplateForm()
                    // })
                    // window.Worldpay.useTemplateForm(wpParams);
                    //set your options
                    var handleWpReturn = function (result) {
                            if (result.error) {
                                app.data.messages.push({
                                    type: 'alert',
                                    'class': 'alert-error',
                                    actions: [],
                                    title: app.localization.paymentProcessing[updatingOnFileCard? 'onFileTokenUpdateError':'PPPostError'],
                                    message: ''
                                });
                                if (!updatingOnFileCard) app.dispatcher.replace('summary', 'show', [])
                                else {
                                    if (app.data.loginNextURL) {
                                        app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                        app.data.loginNextURL = undefined;
                                    } else app.dispatcher.replace('profile', 'details');
                                }
                                return;
                            }
                            if (result.gateway) {
                                app.dispatcher.dispatch('summary', 'wpReturn', [
                                    result.order.status,
                                    result.gateway.orderKey,
                                    result.gateway.paymentStatus,
                                    result.gateway.paymentAmount,
                                    result.gateway.paymentCurrency,
                                    result.gateway.mac2,
                                    updatingOnFileCard
                                ]);
                            }
                        },
                        customOptions = {
                        type: 'iframe',
                        iframeIntegrationId: 'libraryObject',
                        inject: 'immediate',
                        iframeHelperURL: window.location.protocol + '//' + window.location.host + window.location.pathname + 'js/lib/helper.html',
                        iframeBaseURL: window.location.protocol + '//' + window.location.host + window.location.pathname,
                        url: forwardURL,
                        target: 'wpFrame',
                        accessibility: true,
                        debug: true,
                        language: 'en',
                        country: 'gb',
                        preferredPaymentMethod: '',
                        // successURL: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/summary/wpReturn/success/',
                        // cancelURL: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/summary/wpReturn/cancel/',
                        // failureURL: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/summary/wpReturn/failure/',
                        // pendingURL: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/summary/wpReturn/pending/',
                        // errorURL: window.location.protocol + '//' + window.location.host + window.location.pathname + '#/summary/wpReturn/error/',
                        resultCallback: handleWpReturn
                    };
                    
                    //initialise the library and pass options
                    var libraryObject = new WPCL.Library();
                    libraryObject.setup(customOptions);
                    $('#wpFrame #wp-cl-wpFrame-iframe').load(function(){
                        $('.LoaderBalls').remove()
                        app.data.loadedPayEngineIframeOnProfile = true
                        
                    });
                })
                $('#storeCard').on('change', function (el) {
                    window.localStorage['storeCard' + app.data.WebFolioId] = $(this).prop('checked') ? 'Y' : 'N'
                })
                window.localStorage['storeCard' + app.data.WebFolioId] = $('#storeCard').prop('checked') ? 'Y' : 'N'
                if(updatingOnFileCard)  window.localStorage['updatingOnFileCard' + app.data.WebFolioId] = updatingOnFileCard

            },
            redirectSQ: function (applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode) {
                var profilePromise = loadCustomerAddressIntoForm();
                window.Square = undefined;
                app.data._lastWPCallBack = false;
                var sqJsUrl = forwardURL || app.customization.square.url || 'https://web.squarecdn.com/v1/square.js' 
                require.undef(sqJsUrl);
                require([sqJsUrl], function (squarejs) {
                    var payments = window.Square.payments(applicationId, locationId);
                    var card;
                    try {
                        payments.card().then(function(paymentcard){
                            card = paymentcard;
                            return card.attach("#sq-card-number")
                        }).then(function(x){
                            card.configure({
                                "postalCode" : $('#cartCCzip').val() || "",
                            })
                        })
                    } catch (e) {
                        console.error('Initializing Card failed', e);
                        return;
                    }

                    $('#sq-creditcard').prop('onclick',null).on('click',function(e){
                        e.preventDefault();
                        card.tokenize().then(function(tokenResult){
                            if (tokenResult.status === 'OK') {
                                if (threeDSEnabled!='Y') {
                                    app.dispatcher.dispatch('summary', 'sqReturn', [
                                        tokenResult.token,
                                        encodeURIComponent(JSON.stringify(tokenResult)),
                                        ""
                                    ]);
                                } else {
                                    $.when(profilePromise).then(function(customer){
                                        var balance = paymentAmount || app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId})
                                        var verificationDetails = { 
                                            locationId: locationId,
                                            billingContact: {
                                                email: app.data.CustomerEmail
                                            } 
                                        }
                                        if (balance=="0"||balance=="0.00") {
                                            verificationDetails.intent="STORE";
                                        } else {
                                            verificationDetails.intent='CHARGE';
                                            verificationDetails.amount= balance;
                                            verificationDetails.currencyCode= currencyCode || 'GBP';
                                        }

                                        customer.Name && customer.Name.FirstName && (verificationDetails.billingContact.givenName = customer.Name.FirstName);
                                        customer.Name && customer.Name.LastName && (verificationDetails.billingContact.familyName = customer.Name.LastName);
                                        
                                        customer.phones = _.indexBy(customer.Phone, "type");
                                        customer.phones && (
                                               (customer.phones.HOME && customer.phones.HOME.PhoneNumber && (verificationDetails.billingContact.phone = customer.phones.HOME.PhoneNumber))
                                            || (customer.phones.MOBILE && customer.phones.MOBILE.PhoneNumber && (verificationDetails.billingContact.phone = customer.phones.MOBILE.PhoneNumber))
                                            || (customer.phones.OTHER && customer.phones.OTHER.PhoneNumber && (verificationDetails.billingContact.phone = customer.phones.OTHER.PhoneNumber))
                                            || (customer.phones.WORK && customer.phones.WORK.PhoneData && customer.phones.WORK.PhoneData.PhoneNumber && (verificationDetails.billingContact.phone = customer.phones.WORK.PhoneData.PhoneNumber))
                                        );
                                        
                                        customer.address = customer.otherAddress || customer.homeAddress || false;
                                        if (customer.address) {
                                            customer.address.City && (verificationDetails.billingContact.city = customer.address.City);
                                            customer.address.StateProv && (verificationDetails.billingContact.region = customer.address.StateProv);
                                            customer.address.country && (verificationDetails.billingContact.country = customer.address.country);
                                            customer.address.PostCode && (verificationDetails.billingContact.postalCode = customer.address.PostCode);
                                            customer.address.Address1 && (verificationDetails.billingContact.addressLines = [customer.address.Address1]);
                                            if (customer.address.Address2) {
                                                verificationDetails.billingContact.addressLines = verificationDetails.billingContact.addressLines || []
                                                verificationDetails.billingContact.addressLines.push(customer.address.Address2)
                                            }
                                        }
    
                                        payments.verifyBuyer(tokenResult.token, verificationDetails).then(function(verificationResult) {
                                            app.dispatcher.dispatch('summary', 'sqReturn', [
                                                tokenResult.token,
                                                encodeURIComponent(JSON.stringify({tokenResult:tokenResult,verificationResult:verificationResult})),
                                                verificationResult && verificationResult.token
                                            ]);
                                        }, function(err) {
                                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                                        title:app.localization.paymentProcessing.PPPostError,
                                                                        message:err && err.status
                                                                    });
                                                                    app.dispatcher.redirect('summary', '', []);
                                            return;
                                            
                                        })
                                    })
                                    
                                }
                            } else {
                                return Promise.reject(new Error('Tokenization failed',{options:tokenResult}))
                            }
                        }).then(function(token){})
                        // console.log("(sq) cardNonceResponseReceived()", errors, nonce, cardData);
                                
                    })

                })
                $('#storeCard').on('change', function (el) {
                    window.localStorage['storeCard' + app.data.WebFolioId] = $(this).prop('checked') ? 'Y' : 'N'
                })
                window.localStorage['storeCard' + app.data.WebFolioId] = $('#storeCard').prop('checked') ? 'Y' : 'N'
            },
            redirect3C: function (forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession, updatingOnFileCard) {
                loadCustomerAddressIntoForm();
                $('#3cForm').attr('action',forwardURL+'/iPage/Service/_2006_05_v1_0_1/service.aspx');
                $('#3cForm input[name=XXX_IPGSESSION_XXX]').val(threeCSession)
                $('#3cForm input[name=trx_merchant_reference_2]').val(app.data.WebFolioId)
                $('#3cForm input[name=trx_merchant_reference_3]').val(app.data.SessionId)
                var path = location.pathname.replace('index.html','').replace(/\/$/g,'')
                $('#3cForm input[name=redirect_approved]').val(window.location.origin + path + '/js/lib/3Chelper.html' )
                $('#3cForm input[name=redirect_declined]').val(window.location.origin + path + '/js/lib/3Chelper.html')
                $('#3cForm').submit();
                $('#3cFrame').removeClass('hide');

                $('#update__cardOnFile .onfileCreditCart #3cFrame').load(function(){
                    $('.LoaderBalls').remove();
                    app.data.loadedPayEngineIframeOnProfile = true;
                });

                var listener = function(event) {
                    console.log("(3c) window message received", event);
                    if (event.data && event.data && event.data.type=="3cFrameLoaded") {
                        $('#3cFrame').css('height',event.data.height+'px')
                        var data = {
                            type:"address",
                            address: {
                                trx_email: app.data.CustomerEmail,
                                card_holder_first_name: $('#cartCCFName').val()||'',
                                card_holder_last_name: $('#cartCCLName').val()||'',
                                address1: $('#cartCCaddress').val()||'',
                                address2: $('#cartCCaddress2').val()||'',
                                zip_postcode: $('#cartCCzip').val()||'',
                                city: $('#cartCCcity').val()||''
                            }
                        }
                        document.getElementById('3cFrame').contentWindow.postMessage(data, event.origin)
                        return
                    }
                  
                    if(event.data && event.data && event.data.type=="3cReturn") {
                        window.removeEventListener('message', listener)
                        if (event.origin !== window.location.origin) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:app.localization.paymentProcessing.err.paymentFailed,
                                                message:'(invalid origin)'
                                            });
                            app.dispatcher.redirect('summary', '', []); 
                            return;
                        }
                        var getString = event.data.value,
                            returndata = {};
                        if (!getString) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                                title:app.localization.paymentProcessing.err.paymentFailed,
                                                message:'(no data)'
                                            });
                            app.dispatcher.redirect('summary', '', []); 
                            return;
                        }
                        var searchString = (getString+'').replace(/^\?+/, ''),
                        searchPairs = searchString.split('&')
                        $.each( searchPairs, function(id,pair){
                            var keyval = pair.split('=')
                            returndata[keyval[0]]=keyval[1]
                        })
                        if (!returndata['TxID'] || !returndata['AuthorisationCode']) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:app.localization.paymentProcessing.PPPostError,
                                message:''
                            });
                            app.models.systemModel.getData('doCheckout', {debug:JSON.stringify(getString)})
                            app.dispatcher.redirect('summary', '', []); 
                            return;
                        }
                        app.dispatcher.dispatch('summary', '3cReturn', [
                            returndata['TxID'], 
                            returndata['AuthorisationCode'],
                            returndata['3DSIndicator'],
                            returndata['SCATransRef'],
                            $('#cartCCname').val()||'',
                            $('#cartCCaddress').val()||'',
                            $('#cartCCzip').val()||'',
                            returndata['MerchantRef'],
                            updatingOnFileCard
                        ]); 
                    }
                }
                window.addEventListener("message", listener, false);
                document.getElementById('3cFrame').addEventListener('load',function(){
                    document.getElementById('3cFrame').contentWindow.postMessage({type:'RsInit'}, forwardURL);
                },true)
                $('#storeCard').on('change', function (el) {
                    window.localStorage['storeCard' + app.data.WebFolioId] = $(this).prop('checked') ? 'Y' : 'N'
                })
                window.localStorage['storeCard' + app.data.WebFolioId] = $('#storeCard').prop('checked') ? 'Y' : 'N'
            },
            redirectFP: function (forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled,updatingOnFileCard) {
                window.removeEventListener("message", app.commonViewHelper.handleFPReturn)
                var fpJsUrl = app.customization.freedompay && app.customization.freedompay.url || 'https://hpc.uat.freedompay.com/api/v1.4/cdn/cardinal_min.js' 
                require.undef(fpJsUrl);
                app.data.updatingOnFileCard = !!updatingOnFileCard
                require([fpJsUrl], function (hpcjs) {
                    window.addEventListener("message", app.commonViewHelper.handleFPReturn)
                 //   $('#fpFrame iframe').remove
                    $("#fpFrame").html(forwardURL)
                    $('#fpFrame iframe').load(function(){
                        $('.LoaderBalls').remove()
                        app.data.loadedPayEngineIframeOnProfile = true
                         

                    });
                })
                $('#storeCard').on('change', function (el) {
                    window.localStorage['storeCard' + app.data.WebFolioId] = $(this).prop('checked') ? 'Y' : 'N'
                })
                window.localStorage['storeCard' + app.data.WebFolioId] = $('#storeCard').prop('checked') ? 'Y' : 'N'
               
            },
            handleFPReturn: function(r){
                if (r&&r.data) {
                    try{
                        console.log('rdata',r.data)
                        switch(r.data.type) {
                            case 1:
                                if (r.data.data.errors && r.data.data.errors[0] && r.data.data.errors[0].messageCode) {
                                    params = {
                                        WebFolioId: app.data.WebFolioId,
                                        SessionId: app.data.SessionId,
                                        debug: JSON.stringify(r.data),
                                        CardHolderName:nameOnCard
                                    }
                                    app.models.systemModel.getData('doCheckout', params).always(function () {
                                        app.data.messages.push({
                                            type: 'alert',
                                            'class': 'alert-error',
                                            actions: [],
                                            title: app.localization.paymentProcessing.PPPreError,
                                            message: r.data.data.errors[0].message
                                        });
                                        delete app.data.auth3dsjson;
                                        window.removeEventListener("message", app.commonViewHelper.handleFPReturn)
                                        
                                        app.data.updatingOnFileCard ? app.commonViewHelper.showMessages() : app.dispatcher.replace('summary', 'show', [])
                                    })
                                }
                                break
                            // ChallengeCancel=01   messageCode consumerAuthCancelled
                            case 2: $('#fpFrame iframe').css('height',r.data.data.height + 'px'); break;
                            case 16:
                                app.data.auth3dsjson = JSON.stringify(r.data.data);
                                break
                            case 3: 
                            var nameOnCard = $('.fpNameFieldParent #NameOnCard').val()
                            if(!nameOnCard) {
                                $('.fpNameFieldParent .fpNameFieldError').html(app.localization.paymentProcessing.err.noCardHolderName)
                                return
                            }
                            $('.fpNameFieldParent .fpNameFieldError').html('')
                               app.dispatcher.dispatch('summary', 'fpReturn', [
                                   encodeURIComponent(JSON.stringify(r.data)),
                                    app.data.updatingOnFileCard ,nameOnCard, app.data.auth3dsjson
                                ]);
                                delete app.data.auth3dsjson;
                                window.removeEventListener("message", app.commonViewHelper.handleFPReturn)
                        }
                    
                    }catch(e){
                        
                    }
                }
            },
            redirectI4G: function (forwardURL, accessBlock,updatingOnFileToken) {
                loadCustomerAddressIntoForm();
                require(['https://i4m.i4go.com/js/jquery.i4goTrueToken.js'], function (i4goTrueToken) {
                    var i4g_elem = $("#I4GForm")
                    $('#storeCard').on('change', function (el) {
                        $(this).val($(this).prop('checked') ? 'Y' :'N')
                    })
                    if (!i4g_elem.i4goTrueToken) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.paymentProcessing.PPPreError,
                            message: ''
                        });
                        
                       if(!updatingOnFileCard)  app.dispatcher.replace('summary', 'show', [])
                       else{
                        if (app.data.loginNextURL) {
                            app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                            app.data.loginNextURL = undefined;
                        } else  app.dispatcher.replace('profile', 'details');
                       }
                       //todo
                        return;
                    }
                    // $('#I4GModal').modal();
                    var i4goParams = {
                        server: forwardURL,
                        accessBlock: accessBlock,
                        self: document.location,
                        template: "bootstrap2-horizontal", //todo: check different style
                        url: "", // i4go server
                        // If not provided (the default), value will be calculated based on the "server" parameter
                        // Defaults to production
                        // Must override for testing and certification to https://form.shift4test.com
                        encryptedOnlySwipe: true,

                        frameContainer: "i4goFrame", // Only used if frameName does not exist
                        frameName: "", // Auto-assigned if left empty
                        frameAutoResize: true,
                        frameClasses: "",
                        formAutoSubmitOnSuccess: false,
                        formAutoSubmitOnFailure: false,

                        onComplete: function (form, i4go_data) {
                            console.log("(i4goTrueToken) onComplete()", i4go_data);
                            app.dispatcher.dispatch('summary', 'i4gReturn', [
                                i4go_data.i4go_response,
                                i4go_data.i4go_uniqueid,
                                i4go_data.i4go_cardtype,
                                i4go_data.i4go_expirationmonth,
                                i4go_data.i4go_expirationyear,
                                i4go_data.i4go_responsecode,
                                i4go_data.i4go_cardholdername,
                                i4go_data.i4go_streetaddress,
                                i4go_data.i4go_postalcode,
                                i4go_data.i4go_responsetext,
                                encodeURIComponent($('#storeCard').val()),
                                updatingOnFileToken
                            ]);
                        },
                        acceptedPayments: [],
                        payments: [],
                        // pointer-events: none;
                        // tab-index: -1;
                        body: { classes: "", styles: { paddingLeft: 0, paddingRight: 0 } },
                        container: { classes: "" },
                        label: { classes: "" },
                        cardType: { classes: "", label: app.localization.paymentProcessing.cardTypeLabel, placeholder: "", message: "", required: true },
                        cardNumber: { classes: "", label: app.localization.paymentProcessing.cardNumberLabel, placeholder: "", message: "" },
                        expirationMonth: { classes: "", label: app.localization.paymentProcessing.expiryLabel, placeholder: app.localization.paymentProcessing.expiryMonthBlank, message: "" },
                        expirationYear: { classes: "", label: "", placeholder: "", message: "" },
                        cvv2Code: { classes: "", label: app.localization.paymentProcessing.cvvLabel, placeholder: "", message: "", visible: true, required: true },
                        submitButton: { classes: "", label: app.localization.paymentProcessing[updatingOnFileToken?'updateButtonLabel':'checkoutButtonLabel'] },
                        cardholderName: { classes: "", label: app.localization.paymentProcessing.cardHolderLabel, placeholder: "", message: "", visible: true, required: true },
                        streetAddress: { classes: "", label: app.localization.paymentProcessing.addressLabel, placeholder: "", message: "", visible: true, required: true },
                        postalCode: { classes: "", label: app.localization.paymentProcessing.zipLabel, placeholder: "", message: "", visible: true, required: true },
                        cssRules: []
                    }
                    var i4goPaymentTypes = [
                        { customizationName: "ccEnabledVisa", i4goType: "VS", i4goName: "Visa" },
                        { customizationName: "ccEnabledMC", i4goType: "MC", i4goName: "MasterCard" },
                        { customizationName: "ccEnabledAmex", i4goType: "AX", i4goName: "American_Express" },
                        { customizationName: "ccEnabledDisc", i4goType: "NS", i4goName: "Discover" }
                    ]
                    _.each(i4goPaymentTypes, function (i4goPaymentType) {
                        if (Customization.payment[i4goPaymentType.customizationName]) {
                            i4goParams.payments.push({ type: i4goPaymentType.i4goType, name: i4goPaymentType.i4goName })
                            i4goParams.acceptedPayments.push(i4goPaymentType.i4goType)
                        }
                    })
                    i4goParams.acceptedPayments = i4goParams.acceptedPayments.join(",")
                    if (app.localization.paymentProcessing.i4goParams) {
                        _.each(["body", "container", "label", "cardType", "cardNumber", "expirationMonth", "expirationYear", "cvv2Code", "submitButton"], function (elems) {
                            _.isObject(app.localization.paymentProcessing.i4goParams[elems]) && _.extend(i4goParams[elems], app.localization.paymentProcessing.i4goParams[elems])
                        })
                        _.each(["cssRules", "template"], function (elems) {
                            app.localization.paymentProcessing.i4goParams[elems] && (i4goParams[elems] = app.localization.paymentProcessing.i4goParams[elems])
                        })
                    }
                    var i4goTrueTokenObj = i4g_elem.i4goTrueToken(i4goParams);
                    $('.i4go-frame').load(function(){
                        $('.LoaderBalls').remove()
                        app.data.loadedPayEngineIframeOnProfile = true
                    });
                })
            },
            prepTermsModal: function (isGuest) {
                $.ajax({
                    url: app.localization.paymentProcessing.acceptTerms.termsContentURL,
                    dataType: "html"
                }).done(function (data) {
                    var content = $(document.createElement('div')).html(data).find(app.localization.paymentProcessing.acceptTerms.termsContentSelector);
                    if (content.length == 0) {
                        $('#acceptTermsModal .modal-body .content').html('<p>Error Finding Terms</p>');
                    } else {
                        $('#acceptTermsModal .modal-body .content').html(content);
                        $('#acceptTermsModal .modal-body #acceptBox').removeAttr('disabled');
                    }
                }).fail(function () {
                    $('#acceptTermsModal .modal-body .content').html('<p>Error Loading Terms</p>');
                })
                $('#acceptTermsModal').modal();
                $('#acceptTermsModal .continueBtn').on('click', function () {
                    if ($('#acceptTermsModal #acceptBox').attr('checked')) {
                        app.data.termsAccepted = true;
                        $(this).text('Loading..');
                        $(this).off('click');
                        //pass guest if guest 
                        app.dispatcher.dispatch('summary', 'checkout', [isGuest]);
                    }
                    else{
                        $('#acceptTermsModal .content .acceptTermsErrorMessage').remove()
                        $('#acceptTermsModal .content').prepend("<div class='acceptTermsErrorMessage alert alert-danger'>"+app.localization.paymentProcessing.acceptTerms.acceptTermsErrorMessage+"</div>")

                    }
                })
                $('#acceptTermsModal #acceptBox').on('change', function () {
                    if ($('#acceptTermsModal #acceptBox').attr('checked')) {
                        $('#acceptTermsModal .continueBtn').removeAttr('disabled');
                        $('#acceptTermsModal .content .acceptTermsErrorMessage').remove()
                    } 
                })
                $('#acceptTermsModal').on('hide', function () {
                    window.history.back();
                })
            },
            prepRedeemGCForm: function () {
                var form = $('#cartGCRedeemForm'),
                    validateOnChange = function (label) {
                        setTimeout(function () {
                            if (!form.find('.required:not(.valid)').length) {
                                $('#gcRedeemSubmit').addClass('btn-primary').removeClass('disabled');
                                form.find('label[generated=true]').remove();
                            }
                        }, 100)
                    },
                    validifier = form.validate({
                        rules: {
                            gcNumber: {
                                minlength: app.customization.payment.GCNumberLengthMin,
                                maxlength: app.customization.payment.GCNumberLengthMax,
                                required: true
                            }
                        },
                        success: validateOnChange,
                        showErrors: function (errorMap, errorList) {
                            $('#gcRedeemSubmit').removeClass('btn-primary').addClass('disabled');
                            this.defaultShowErrors();
                        }
                    });
                // $('#cartGCRedeemForm input').change(validateOnChange);
                // $('#cartGCRedeemForm input').blur(validateOnChange);
                // $('#cartGCRedeemForm input').keypress(validateOnChange);
                form.on('submit', function (obj) {
                    obj.preventDefault();
                    var form = $('#cartGCRedeemForm');

                    form.removeClass('pristine');
                    if (form.valid()) {
                        $('#progressIndicator').modal('show')
                        $('#gcRedeemSubmit').button('loading');
                        app.dispatcher.redirect('summary', 'redeemGCApply', [
                            encodeURIComponent(form.find('#gcNumber').val()),
                            encodeURIComponent(form.find('#gcRefNumber').val()),
                            encodeURIComponent(form.find('#gcType .active').attr('data-value') || "")
                        ])
                        // return false;
                    } else {
                        // return false;
                    }
                });
                var gcTypeCard = function (e) {
                    e && e.preventDefault();
                    $('#gcNumberLabel').text(app.localization.paymentProcessing.gcNumberCard);
                    $('#gcNumber').attr('placeholder', app.localization.paymentProcessing.gcNumberCardBlank);
                    if (app.customization.payment.redeemGCbyGCIDandRefNum) {
                        $('#cartGCRedeemForm .gcRefNumEnabled').show();
                        if (app.customization.payment.redeemGCbyGCID) {
                            $('#cartGCRedeemForm .gcRefNumberRequired').hide();
                            $('#cartGCRedeemForm #gcRefNumber').removeClass('required');
                        } else {
                            $('#cartGCRedeemForm .gcRefNumberRequired').show();
                            $('#cartGCRedeemForm #gcRefNumber').addClass('required');
                        }
                    } else {
                        $('#cartGCRedeemForm .gcRefNumEnabled').hide();
                    }
                    $('#cartGCRedeemForm #gcTypeCard').addClass('active');
                    $('#cartGCRedeemForm #gcTypeCert').removeClass('active');
                    app.data.gcLastType = 'Card';
                    validateOnChange();
                }
                $('#cartGCRedeemForm #gcTypeCard').on('click', gcTypeCard);
                var gcTypeCert = function (e) {
                    e && e.preventDefault();
                    $('#gcNumberLabel').text(app.localization.paymentProcessing.gcNumberCert);
                    $('#gcNumber').attr('placeholder', app.localization.paymentProcessing.gcNumberCertBlank);
                    if (app.customization.payment.redeemGCbyGCNumandRefNum) {
                        $('#cartGCRedeemForm .gcRefNumEnabled').show();
                        if (app.customization.payment.redeemGCbyGCNum) {
                            $('#cartGCRedeemForm .gcRefNumberRequired').hide();
                            $('#cartGCRedeemForm #gcRefNumber').removeClass('required');
                        } else {
                            $('#cartGCRedeemForm .gcRefNumberRequired').show();
                            $('#cartGCRedeemForm #gcRefNumber').addClass('required');
                        }
                    } else {
                        $('#cartGCRedeemForm .gcRefNumEnabled').hide();
                    }
                    $('#cartGCRedeemForm #gcTypeCert').addClass('active');
                    $('#cartGCRedeemForm #gcTypeCard').removeClass('active');
                    app.data.gcLastType = 'Cert';
                    validateOnChange();
                }
                $('#cartGCRedeemForm #gcTypeCert').on('click', gcTypeCert);
                if (app.data.gcLastType != 'Cert' && (app.customization.payment.redeemGCbyGCIDandRefNum || app.customization.payment.redeemGCbyGCID)) {
                    gcTypeCard();
                } else {
                    gcTypeCert();
                }


            },
            prepDiningForm: function (diningLocations, selectedDiningVenue, selectedDate, selectedTime, covers, selectedPromo, bookingReference) {
                console.log('prepDiningForm', diningLocations)
                if (Date.parse(selectedDate + ' 23:59:59') < Date.now()) {
                    selectedDate = ''
                }
                var searchDiningRes = function searchDiningRes(restaurantId, diningLocation, resdate, covers) {
                    app.commonViewHelper.showMessages();   
                    var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                    var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
                    // Dynamic access rest
                    app.commonViewHelper.eval_ttb({module:"diningBooking", diningVenue:restaurantId, diningLocation:diningLocation, covers: covers, date:resdate, vipLevel: vipLevels, membershipId:membershipIds});                 
                    //e.preventDefault();
                    app.dispatcher.updateURL('dining', 'show', [
                        diningLocation.VenueName,
                        resdate,
                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select').val() || selectedTime,
                        covers,
                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val() || selectedPromo
                    ], true)
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .diningResBtn')
                        .addClass('disabled')
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .name').html('<p>' + app.localization.dining.loadingDate(Date.parse(resdate).toString(app.localization.dining.dateFormat[1]), covers) + '</p>');
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .timeslots .btn-group').html('')
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .control-group.service[promotion-id]').remove()
                    var userSelectedTime = $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select').attr('user-selected')
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select')
                        .html('')
                        .prepend('<option value="">' + app.localization.dining.loadingTimes + '</option>')
                    // Getting Availibilities with Area Information
                    var fetchDiningAvailDaysParam = {
                        VenueName: diningLocation.VenueName,
                        VisitDate: resdate,
                        PartySize: covers,
                        StartDate: Date.today().add(app.customization.dining.allowBookingToday ? 0 : 1).days().toString('yyyy-MM-dd'),
                        EndDate: Date.today().add(+diningLocation.Setup.AcceptBookingsDaysInAdvance).days().toString('yyyy-MM-dd'),
                        VisitTime: '12:00:00',
                        TimeWindow: 720
                    }
                    // Storing Availibilities with areas and then filter according to area selection
                    var availibilitWithArea = [];
                    var filteredAreaTimeSlots = [];
                    var checkFirstDateAvail = '';
                    app.models.diningModel.getData('fetchDiningAvailDays', fetchDiningAvailDaysParam)
                        .done(function (r_fdad) {
                            var endDate = fetchDiningAvailDaysParam.EndDate < (r_fdad.DaysAvail && r_fdad.DaysAvail.DateTo && r_fdad.DaysAvail.DateTo.substr(0, 10))
                                ? fetchDiningAvailDaysParam.EndDate : (r_fdad.DaysAvail && r_fdad.DaysAvail.DateTo && r_fdad.DaysAvail.DateTo.substr(0, 10))
                            app.data.diningAvailDates = app.data.diningAvailDates || {}
                            app.data.diningAvailDates[diningLocation.Setup.RestaurantId] = app.data.diningAvailDates[diningLocation.Setup.RestaurantId] || {}
                            for (var i = Date.parse(fetchDiningAvailDaysParam.StartDate); i.toString('yyyy-MM-dd') < endDate; i.add(1).days()) {
                                app.data.diningAvailDates[diningLocation.Setup.RestaurantId][i.toString('yyyy-MM-dd')] = false
                            }
                            if (r_fdad.DaysAvail && r_fdad.DaysAvail.AvailableDates) {
                                _.each($.wrapArray(r_fdad.DaysAvail.AvailableDates), function (availableDay) {
                                    if (availableDay && availableDay.Date) {
                                        app.data.diningAvailDates[diningLocation.Setup.RestaurantId][availableDay.Date.substr(0, 10)] = true
                                    }
                                })
                            } else if (!r_fdad || !r_fdad.DaysAvail || !r_fdad.DaysAvail.AvailableDates ){
                                noTimeslots(restaurantId, diningLocation);
                                return;
                            }
                            if(r_fdad && r_fdad.DaysAvail && r_fdad.DaysAvail.AvailableDates ){
                                availibilitWithArea = r_fdad.DaysAvail.AvailableDates;
                            }
                            // Fixing for wrong default date selection
                            var allAvailDates = Object.keys(app.data.diningAvailDates[diningLocation.Setup.RestaurantId]);
                            checkFirstDateAvail = _.find(allAvailDates, function (date) { return app.data.diningAvailDates[diningLocation.Setup.RestaurantId][date]});
                            if(moment(checkFirstDateAvail)> moment(selectedDate || (Date.today().add(app.customization.dining.allowBookingToday ? 0 : 1).days()).toString('yyyy-MM-dd')) && !app.data.datesForRestrictedFolio){
                                selectedDate = checkFirstDateAvail;
                                $('.diningReservation .reservationDate input.human[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']').val($.datepicker.formatDate(app.localization.dining.dateFormat[0],Date.parse(checkFirstDateAvail)));
                                searchDiningRes(diningLocation.Setup.RestaurantId, diningLocation, checkFirstDateAvail, $('.diningReservation .reservationCovers select[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']').val());
                            }
                        }).then(function(){
                            $.when(app.models.diningModel.getData('fetchDiningAvailabilities', {
                                VenueName: diningLocation.VenueName,
                                VisitDate: resdate + 'T00:00:00',
                                PartySize: covers
                            }))
                                .then(function (r_da) {
                                    console.log(r_da);
                                    r_da.Availabilities = r_da.Availabilities || {}
                                    r_da.Availabilities.TimeSlots = r_da.Availabilities.TimeSlots || {}
                                    r_da.Availabilities.TimeSlots.Timeslot = r_da.Availabilities.TimeSlots.Timeslot && ($.isArray(r_da.Availabilities.TimeSlots.Timeslot) ? r_da.Availabilities.TimeSlots.Timeslot : r_da.Availabilities.TimeSlots.Timeslot) || []
                                    r_da.Availabilities.Promotions = r_da.Availabilities.Promotions || {}
                                    r_da.Availabilities.Promotions.Promotion = r_da.Availabilities.Promotions.Promotion && ($.isArray(r_da.Availabilities.Promotions.Promotion) ? r_da.Availabilities.Promotions.Promotion : [r_da.Availabilities.Promotions.Promotion]) || []
                                    r_da.Availabilities.TimeSlots.Timeslot = r_da.Availabilities.TimeSlots.Timeslot && !$.isArray(r_da.Availabilities.TimeSlots.Timeslot) ? [r_da.Availabilities.TimeSlots.Timeslot] : r_da.Availabilities.TimeSlots.Timeslot; //dealing with single and multi availability
                                    // Dynamic Access Restrictions
                                    if(app.customization.dynamicRestrictions){
                                        if(app.commonViewHelper.active_ttb_effects.restrictDiningTimeOfDay){
                                            var restrictDiningTimeResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.restrictDiningTimeOfDay);
                                            if(restrictDiningTimeResult.isActive && restrictDiningTimeResult.value && restrictDiningTimeResult.value.length){
                                                r_da.Availabilities.TimeSlots.Timeslot = _.filter(r_da.Availabilities.TimeSlots.Timeslot, function(availibility){
                                                    var checkAvailibility = _.any(restrictDiningTimeResult.value, function(restriction){
                                                        return restriction.startTime <= availibility.TimeSlot.substr(11,8) && availibility.TimeSlot.substr(11,8) <= restriction.endTime;
                                                    });
                                                    return checkAvailibility;
                                                });             
                                            }
                                        }
                                    }
                                    // Dynamic Access Restrictions
                                    filteredAreaTimeSlots = r_da.Availabilities.TimeSlots.Timeslot;
                                    var selectedArea = $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .areaSelectWrap .btn-group .active').attr('data-diningarea-id');
                                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime option').remove();
                                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select').off('change').on('change', function (e, nonUserSelection) {
                                        var reservationPromo = selectedPromo || $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val()
                                        var timeslottime = $(this).val()
                                        // Trigger Change Function re-evaluate time slots according to area
                                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .areaSelectWrap .btn-group span').off('click').on('click', function (e) {
                                            if($(this).attr('data-diningarea-id') != selectedArea){
                                                selectedArea = $(this).attr('data-diningarea-id');                                   
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select').trigger('change'); 
                                            }
                                        })
                                        // Filter Time Slots According to Selected Area
                                        filteredAreaTimeSlots = [];
                                        if(availibilitWithArea.length &&  r_da.Availabilities && r_da.Availabilities.TimeSlots && r_da.Availabilities.TimeSlots.Timeslot && r_da.Availabilities.TimeSlots.Timeslot.length){
                                            _.each(availibilitWithArea, function(availabilityDay){
                                                if(availabilityDay.Date.substr(0,10) == r_da.Availabilities.TimeSlots.Timeslot[0].TimeSlot.substr(0,10)){
                                                    if(selectedArea == undefined || !selectedArea.length || selectedArea == 'All'){
                                                        filteredAreaTimeSlots = r_da.Availabilities.TimeSlots.Timeslot;
                                                    } else {
                                                        _.each(availabilityDay.AvailableTimes, function(dayTimeSlot){
                                                            if(dayTimeSlot.AvailableAreaIds.includes(selectedArea)){
                                                                _.each(r_da.Availabilities.TimeSlots.Timeslot,function (timeslotItem) {
                                                                    if(timeslotItem.TimeSlot.substr(11,8) == dayTimeSlot.TimeSlot){
                                                                        filteredAreaTimeSlots.push(timeslotItem);
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    }
                                                }
                                            })
                                        } else {
                                            filteredAreaTimeSlots = r_da.Availabilities.TimeSlots.Timeslot;
                                        }
                                        var timeslotOffset = allTimeslots.indexOf(timeslottime)
                                        var timeslot = _.find(filteredAreaTimeSlots, function (x) { return timeslottime == x.TimeSlot.substr(11, 5) })
                                        if (!timeslot) {
                                            noTimeslots(restaurantId, diningLocation);
                                        } else {
                                            app.dispatcher.updateURL('dining', 'show', [
                                                diningLocation.VenueName,
                                                resdate,
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select').val() || selectedTime,
                                                covers,
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val() || selectedPromo
                                            ], true)
                                            if ((reservationPromo != '' && (!perPromotionTimeslots[reservationPromo] || perPromotionTimeslots[reservationPromo].indexOf(timeslottime) == -1))
                                                || (reservationPromo == '' && timeslot.HasStandardAvailability != 'true')) {
                                                if (timeslot.HasStandardAvailability == 'true') {
                                                    reservationPromo = ''
                                                } else {
                                                    reservationPromo = _.findKey(perPromotionTimeslots, function (x) {
                                                        return x.indexOf(timeslottime) >= 0
                                                    })
                                                }
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val(reservationPromo)
                                            }
                                            if (!nonUserSelection) {
                                                $(this).attr('user-selected', timeslottime)
                                            }
                                            if (timeslot.IsLeaveTimeRequired == 'true') {
                                                var leaveTime = timeslot.LeaveTime.substr(0, 5)
                                                if (reservationPromo) {
                                                    var timeSlotPromo = _.find(timeslot.AvailablePromotions.AvailablePromotions, function (x) { return x.Id == reservationPromo });
                                                    if (timeSlotPromo && timeSlotPromo.LeaveTime) {
                                                        leaveTime = timeSlotPromo.LeaveTime.substr(0, 5)
                                                    }
                                                }
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime').show()
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime span.message').text(app.localization.dining.leaveTime(Date.parse(leaveTime).toString(app.localization.dining.timeFormat)))
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime input').prop('checked', false);
                                            } else {
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime').hide()
                                            }
                                            var startOffset = timeslotOffset - 2
                                            if (startOffset < 0) {
                                                startOffset = 0
                                            }
                                            // loop per service
                                            // create allTimeslots arrays per service
                                            $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .control-group.service:not([promotion-id])').show()
                                            $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .control-group.service[promotion-id]').remove()
                                            $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .name').html(app.localization.dining.standardAvailability)
                                            $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .timeslots .btn-group').html('')
                                            $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .contact .specialRequests')[app.customization.dining.showSpecialRequest ? 'removeClass' : 'addClass']('hide').attr("disabled", app.customization.dining.showSpecialRequest ? null : 'disabled')
                                            var currenttimeslot = {}
                                            for (i = startOffset; i < (startOffset + 5) && i < allTimeslots.length; i++) {
                                                currenttimeslot[allTimeslots[i]] = _.find(filteredAreaTimeSlots, function (x) { return allTimeslots[i] == x.TimeSlot.substr(11, 5) })
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .timeslots .btn-group')
                                                    .append(
                                                        $('<a href="#" class="btn btn-small"></a>')
                                                            .text(Date.parse(allTimeslots[i]).toString(app.localization.dining.timeFormat))
                                                            .attr('data-time', allTimeslots[i])
                                                            .attr('data-timeslot', currenttimeslot[allTimeslots[i]].TimeSlot)
                                                            .addClass(i == timeslotOffset && reservationPromo == '' ? 'active btn-primary' : 'btn')
                                                            .addClass(currenttimeslot[allTimeslots[i]].HasStandardAvailability == 'true' ? 'btn' : 'disabled')
                                                            .on('click', function (e) {
                                                                e.preventDefault();
                                                                if ($(e.target).hasClass('disabled')) { return }
                                                                // $('.diningReservation .dining[data-restaurant-id='+restaurantId+'] .results .timeslots .btn-group a').removeClass('active')
                                                                // $(this).addClass('active')
                                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val('')
                                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select')
                                                                    .val($(e.currentTarget).attr('data-time'))
                                                                    .trigger('change')
                                                            })
                                                        //                                                 .append(currenttimeslot.)
                                                    )
        
                                            }
                                            _.each(perPromotionTimeslots, function (times, promoid) {
                                                var promotion = _.find(r_da.Availabilities.Promotions.Promotion, function (promo) { return promo.Id == promoid })
                                                var standardAvailability = $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .control-group.service:not([promotion-id])')
                                                var promoAvailability = standardAvailability
                                                    .clone()
                                                    .attr('promotion-id', promoid)
                                                    .appendTo($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results'))
                                                promoAvailability.find('.name')
                                                    .html('')
                                                    .append($('<a href="#">' + promotion.Name + ' <i class="icon-info-sign"></i></a>').tooltip({ 'title': promotion.Description }))
                                                promoAvailability.find('a')
                                                    .removeClass('active btn-primary disabled')
                                                    .on('click', function (e) {
                                                        e.preventDefault();
                                                        var btnTime = $(e.currentTarget).attr('data-time')
                                                        if (!btnTime) { return }
                                                        var btnTimeParsed = Date.parseExact(btnTime, 'HH:mm')
                                                        if ($(e.target).hasClass('disabled')) {
                                                            perPromotionTimeslots[promoid].indexOf(btnTime)
                                                            var newTime = _.min(perPromotionTimeslots[promoid], function (value, index, list) {
                                                                return Math.abs(Date.parseExact(value, 'HH:mm') - btnTimeParsed)
                                                            })
                                                            if (!newTime) {
                                                                return
                                                            }
                                                            btnTime = newTime
                                                        }
                                                        // $('.diningReservation .dining[data-restaurant-id='+restaurantId+'] .results .timeslots .btn-group a').removeClass('active')
                                                        // $(this).addClass('active')
                                                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val(promoid)
                                                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select')
                                                            .val(btnTime)
                                                            .trigger('change')
                                                    })
                                                _.each(promoAvailability.find('a'), function (btnEl) {
                                                    var $btnEl = $(btnEl)
                                                        , btnTime = $btnEl.attr('data-time')
                                                        , availablePromotion = currenttimeslot[btnTime] && currenttimeslot[btnTime].AvailablePromotions && _.find(currenttimeslot[btnTime].AvailablePromotions.AvailablePromotions, function (x) { return x.Id == promoid })
                                                    if (perPromotionTimeslots[promoid].indexOf(btnTime) >= 0) {
                                                        if (reservationPromo == promoid && btnTime == timeslottime) {
                                                            $btnEl.addClass('active btn-primary')
                                                        }
                                                        var cost = availablePromotion && (+availablePromotion.BasePrice + +availablePromotion.FeeAmount)
                                                        if (cost) {
                                                            $btnEl.append(
                                                                $('<div class="price btn btn-info disabled btn-mini"></div>')
                                                                    .html(app.localization.general.currencyPrefix + (+cost).toFixed(2) + app.localization.general.currencyPostfix)
                                                            )
                                                        }
                                                    } else {
                                                        $btnEl.addClass('disabled')
                                                    }
                                                })
                                            })
                                            //                                 if(timeslot.HasStandardAvailability!='true') {
                                            //                                     $('.diningReservation .dining[data-restaurant-id='+restaurantId+'] .results .control-group.service:not([promotion-id])').hide()
                                            //                                 }
                                            if (app.data.userLoggedIn) {
                                                $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .diningResBtn').removeClass('disabled')
                                                $.when(
                                                    app.models.userModel.dataModel.fetchCustomerProfile.data
                                                    && app.models.userModel.dataModel.fetchCustomerProfile.data[app.models.userModel.makeStandardName(app.models.userModel.dataModel.fetchCustomerProfile, { CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })]
                                                    || app.models.userModel.getData('fetchCustomerProfile', { CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })
                                                ).done(function (r_fcp) {
                                                    var customer = $.firstOrOnly(r_fcp.Customer)
                                                    var mobilePhone = _.find(customer.Phone, function (phone) {
                                                        return phone.type == "MOBILE"
                                                    })
                                                    var mobileNumber = mobilePhone && mobilePhone.PhoneNumber
                                                    $('.diningReservation .dining .contact .specialRequests #userRequest').removeAttr('disabled')
                                                    $('.diningReservation .dining .contact .phones #userPhone').val(mobileNumber).removeAttr('disabled')
                                                        .find('.control-group').addClass(mobileNumber ? 'filled' : '')
                                                    $('.diningReservation .dining .contact').removeClass('hidden')
                                                    $('.diningReservation .dining .passwords,.diningReservation .dining .login,.diningReservation .dining .emails,.diningReservation .dining .contact .names').removeClass('in').addClass('collapse')
                                                    $('.diningReservation .dining .diningResBtn').removeClass(!!app.customization.dining.userRequest && !!mobileNumber ? 'disabled' : '')
                                                })
                                            }
                                        }
                                    })
                                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .diningResBtn').off('click').on('click', function (e) {
                                        e.preventDefault();
                                        var userCreated = false,
                                            mobileUpdated = false
                                        checkFields(undefined, undefined, true, diningLocation);
                                        if ($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime').css('display') != 'none'
                                            && !$('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime input').prop('checked')) {
                                            attachError($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime'), app.localization.general.err.jquery_validate.required)
                                            $('html, body').animate({
                                                scrollTop: ($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime input').offset().top - window.document.body.scrollTop < $(window).height() * .6)
                                                    ? $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime input').offset().top - $(window).height() * .5
                                                    : 0
                                            }, 300);
                                            return
                                        }
                                        if (!app.data.userLoggedIn) {
                                            var requiredFields = $('.diningReservation .dining[data-restaurant-id=' + restaurantId + ']').find('.emails,.contact .names' + (app.customization.dining.requireMobileNumber ? ',.contact .phones' : '')).find('input').filter(function () { return !$(this).val() })
                                            if (requiredFields.length) {
                                                $('html, body').animate({
                                                    scrollTop: ($(requiredFields[0]).offset().top - window.document.body.scrollTop < $(window).height() * .6)
                                                        ? $(requiredFields[0]).offset().top - $(window).height() * .5
                                                        : 0
                                                }, 300);
                                                return
                                            }
                                            userCreated = app.controllers.userController.userCreateCustomerSubmit('dfd',
                                                $('#userEmail1').val() || "",
                                                app.data.newpassword,
                                                "", //$('#userGender').val(),
                                                "", //$('#userSalutation').val(),
                                                $('#userFirstName').val(),
                                                $('#userLastName').val(),
                                                "M", //$('#userMainPhone').val().substr(0,1),
                                                // $('#userMainPhoneH').hasClass('active') ? "H" :
                                                //     $('#userMainPhoneW').hasClass('active') ? "W" :
                                                //         $('#userMainPhoneO').hasClass('active') ? "O" : "",
                                                "", //$('#userMainPhone').val()=="HOME" && $('#userPhone').val() || $('#userPhoneHOME').val(),
                                                "", //$('#userMainPhone').val()=="WORK" && $('#userPhone').val() || $('#userPhoneWORK').val(),
                                                "", //$('#userPhoneExt').val()||$('#userPhoneWORKExt').val(),
                                                "", //$('#userMainPhone').val()=="OTHER" && $('#userPhone').val() || $('#userPhoneOTHER').val(),
                                                $('#userPhone').val() || "",
                                                "", //$('#userHomeAddress1').val(),
                                                "", //$('#userHomeAddress2').val(),
                                                "", //$('#userHomeCity').val(),
                                                "", //$('#userHomeProvince').val(),
                                                "", //$('#userHomeCountry :selected').text(),
                                                "", //$('#userHomePostalCode').val(),
                                                "", //$('#userOtherAddress1').val(),
                                                "", //$('#userOtherAddress2').val(),
                                                "", //$('#userOtherCity').val(),
                                                "", //$('#userOtherProvince').val(),
                                                "", //$('#userOtherCountry').val(),
                                                "", //$('#userOtherPostalCode').val(),
                                                "0", //$('#newsletter').prop('checked') ? "1" : "0",
                                                "0", //$('#mailmarketing').prop('checked') ? "1" : "0",
                                                "0", //$('#phonemarketing').prop('checked') ? "1" : "0",
                                                "0", //$('#smsmarketing').prop('checked') ? "1" : "0",
                                                $('#userLanguageen-us').hasClass('active') ? "en-us" :
                                                    $('#userLanguagefr-ca').hasClass('active') ? "fr-ca" :
                                                        $('#userLanguagezh-cn').hasClass('active') ? "zh-cn" :
                                                            $('#userLanguagees-sp').hasClass('active') ? "es-sp" : "",
                                                '', //$('#userSkiSize').val()||'',
                                                '', //$('#userSkiBootSize').val()||'',
                                                '',
                                                '',
                                                '', //$('#userSnowboardSize').val()||'',
                                                '', //$('#userSnowboardBootSize').val()||'',
                                                '', //$('#userDinNumber').val()||'',
                                                '', //$('#userAge').val()||'',
                                                '', //$('#userWeight').val()||'',
                                                '', //$('#userHeight').val()||'',
                                                '', //$('#userDOB').val()||'',
                                                '' //$('#userCustomerId').val()
                                            )
                                        } else {
                                            var requiredFields = $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .contact .phones input')
                                                , phoneNum = requiredFields.val()
                                            if (!phoneNum && app.customization.dining.requireMobileNumber) {
                                                $('html, body').animate({
                                                    scrollTop: ($(requiredFields[0]).offset().top - window.document.body.scrollTop < $(window).height() * .6)
                                                        ? $(requiredFields[0]).offset().top - $(window).height() * .5
                                                        : 0
                                                }, 300);
                                                return
        
                                            }
                                            var thename = app.models.userModel.makeStandardName(app.models.userModel.dataModel.fetchCustomerProfile, { CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })
                                            var oldPhoneNum = app.models.userModel.dataModel.fetchCustomerProfile.data
                                                && app.models.userModel.dataModel.fetchCustomerProfile.data[
                                                thename
                                                ]
                                                || ''
                                            oldPhoneNum = oldPhoneNum && _.find($.firstOrOnly(oldPhoneNum.Customer).Phone, function (phone) {
                                                return phone.type == "MOBILE"
                                            }) || ''
                                            oldPhoneNum = oldPhoneNum && oldPhoneNum.PhoneNumber
                                            if (!!phoneNum && phoneNum != oldPhoneNum) {
                                                mobileUpdated = app.models.systemModel.getData('updateCustomerProfile', {
                                                    "Customer.CustomerId": app.data.CustomerId,
                                                    "Customer.CustomerGUID": app.data.CustomerGUID,
                                                    "Customer.Name.FirstName": app.data.FirstName,
                                                    "Customer.Name.LastName": app.data.LastName,
                                                    "Customer.EmailAddress": app.data.CustomerEmail,
                                                    'Customer.Phone[1]:type=MOBILE.PhoneNumber': phoneNum
                                                })
                                            } else {
                                                mobileUpdated = true
                                            }
                                        }
                                        //                             $(this).attr('disabled','disabled')
                                        $('#progressIndicator').modal('show');
                                        $.when(userCreated, mobileUpdated).then(function (user) {
                                            if (!$(e.target).hasClass('disabled')) {
                                                return app.dispatcher.dispatch('dining', 'book', [
                                                    encodeURIComponent(diningLocation.VenueName),
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .timeslots .btn-group a.active').attr('data-time')),
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationDate input.machine').val()),
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationCovers select').val()),
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationPromo').val()),
                                                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime input').prop('checked') ? 'Y' : '',
                                                    bookingReference,
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .contact .specialRequests textarea').val()),
                                                    encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + restaurantId + ']  .areaSelectWrap .btn-group .active').attr('data-diningarea-id')),
                                                ])
                                                // var serviceElTpl = $('.diningReservation .dining[data-restaurant-id='+restaurantId+'] .results .service').remove()
                                            }
                                        }, function () {
                                            $('#progressIndicator').modal('hide');
                                        })
                                    })
                                    var allTimeslots = []
                                    var perPromotionTimeslots = {}
                                    var perServiceTimeslots = {}
                                    var promotions = {}
                                    _.each(r_da.Availabilities.Promotions.Promotion, function (promo) {
                                        if (!promo) return;
                                        promotions[promo.Id] = promo
                                    })
                                    var defaultSelectTime = selectedTime || (app.customization.dining.defaultSelectOffset !== null) && Date.now().add(app.customization.dining.defaultSelectOffset).minutes().toString('HH:mm')
                                    //var earliestSelectTime = diningLocation.Setup.Services[1].ServiceId
                                    var autoSelectTime = false
                                    // _.each(diningLocation.Setup.Services,function(service){
                                    // var serviceEl = serviceElTpl.clone().attr('data-service-id',service.ServiceId)
                                    // var timeslotElTpl = serviceEl.find('.timeslots').remove()
                                    _.each(filteredAreaTimeSlots, function (timeslot) {
                                        timeslot.AvailablePromotions = timeslot.AvailablePromotions || {}
                                        timeslot.AvailablePromotions.AvailablePromotions = timeslot.AvailablePromotions.AvailablePromotions && ($.isArray(timeslot.AvailablePromotions.AvailablePromotions) ? timeslot.AvailablePromotions.AvailablePromotions : [timeslot.AvailablePromotions.AvailablePromotions]) || []
                                        var timeSlotTime = timeslot.TimeSlot.substr(11, 5)
                                        allTimeslots.push(timeSlotTime)
                                        timeslot.timeslotOption = $('<option></option>')
                                        timeslot.timeslotOption
                                            .val(timeSlotTime)
                                            .text(Date.parse(timeSlotTime).toString(app.localization.dining.timeFormat))
                                            .appendTo($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select'))
                                        _.each(timeslot.AvailablePromotions.AvailablePromotions, function (promo) {
                                            perPromotionTimeslots[promo.Id] = perPromotionTimeslots[promo.Id] || []
                                            perPromotionTimeslots[promo.Id].push(timeSlotTime)
                                        })
                                        var service = _.find(diningLocation.Setup.Services, function (x) {
                                            return timeslot.ServiceId == x.ServiceId
                                        })
                                        if (service) {
                                            timeslot.service = service
                                            perServiceTimeslots[service.ServiceId] = perServiceTimeslots[service.ServiceId] || []
                                            perServiceTimeslots[service.ServiceId].push(timeslot)
                                        }
                                        if (userSelectedTime && timeSlotTime == userSelectedTime) {
                                            autoSelectTime = userSelectedTime
                                        } else if (timeSlotTime >= defaultSelectTime) {
                                            autoSelectTime = autoSelectTime || timeSlotTime
                                        }
                                        // if (timeslot.TimeSlot.substr(11,8)>=service.TimeFrom && timeslot.TimeSlot.substr(11,8)<=service.LastBookingTime) {
                                        // service.timeslots.push(timeslot)
                                        // timeslot.service = service
                                        // timeslotEl = timeslotElTpl.clone()
                                        // .attr('data-time',timeslot.TimeSlot.substr(11,8))
                                        // .attr('data-service-id',timeslot.ServiceId)
                                        // timeslotEl.find('.minutes').text(timeslot.TimeSlot.substr(14,2))
                                        // timeslotEl.find('.hour').text(timeslot.TimeSlot.substr(11,2))
                                        // timeslotEl.appendTo(serviceEl)
                                        // }
                                    })
                                    // serviceEl.appendTo( $('.diningReservation .dining[data-restaurant-id='+restaurantId+'] .results') )
                                    // })
                                    _.each(perServiceTimeslots, function (timeslots, serviceId) {
                                        $('<optgroup>')
                                            .attr('label', xmlEscape(timeslots[0].service.Name))
                                            .appendTo($('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select'))
                                            .append(_.map(timeslots, function (t) { return t.timeslotOption }))
                                    })
                                     //if (autoSelectTime) {
                                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select')
                                            .val(autoSelectTime || $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .reservationTime select option:first-child').val())
                                            .trigger('change', [autoSelectTime != userSelectedTime])
                                    //}
        
                                }, function (res) {
                                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .diningResBtn').off('click').on('click', function (e) {
                                        e.preventDefault();
                                    })
                                })
                                .fail(function (r_da) {
                                    noTimeslots(restaurantId, diningLocation);
                                })
                        })
                        .fail(function(r_fdad){
                            noTimeslots(restaurantId, diningLocation);
                        })                      
                }
                var noTimeslots = function noTimeslots(restaurantId, diningLocation) {
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .diningResBtn')
                        .addClass('disabled')
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .timeslots').html();
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .name').html('<p>' + (diningLocation.Setup.NoAvailabilityText || app.localization.dining.noAvailabilityText) + '</p>');
                    if (diningLocation.Setup.DisplayPhoneNumberWhenNoAvailability == 'true') {
                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .results .name')
                            .append('<p>' + xmlEscape(app.localization.dining.reservationPhoneNumber(diningLocation.Setup.ReservationPhoneNumber)) + '</p>');
                    }
                    $('.diningReservation .dining[data-restaurant-id=' + restaurantId + '] .leavetime').hide()
                }
                var emailCheckResult = function (email, data, diningLocation) {
                    if (data[email]) {
                        $('.control-group.userEmail1 .controls')
                            .popover('destroy')
                            .removeClass('arrow-right')
                        $('.control-group.userPassword1 .controls')
                            .popover({ content: '<span class="close" onclick="$($(this).parents(\'.popover\')).remove()" href="#">&times;</span>' + app.localization.newUser.enterPasswordPrompt, trigger: 'focus', selector: 'input', placement: popoverPositionFn, container: '#userCreateUserForm1' })
                        $('.control-group.userEmail1 .controls').removeClass('arrow-right spinner')
                        // $('#userPassword1').focus()
                        // .popover('show')
                        //$('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other,#userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .contact')
                            .addClass('hidden').find('input,select,textarea').attr('disabled', 'disabled')
                        $('.row-fluid.passwords.exist, .row-fluid.login').addClass('in')
                        $('#userPassword1, .row-fluid .forgot .btn').removeAttr('disabled') // .row-fluid.login = login and forgot btns. .row-fluid .login = just login btn
                        $('#userEmail2').attr('disabled', 'disabled')
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .diningResBtn').addClass('disabled')
                        setTimeout(function () {
                            //event handler to set the focus()
                            checkFields({ target: $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .userPassword1 input').focus()[0] }, undefined, undefined, diningLocation)
                        }, 125)
                    } else if (data[email] === false && $(document.activeElement).attr('id') != 'userEmail1') {
                        $('.control-group.userEmail1 .controls')
                            .popover('destroy')
                        $('.control-group.userEmail1 .controls').removeClass('arrow-right spinner')
                        //                     $('.row-fluid.emails .control-group').removeClass('span4 span8').show().addClass('in span6')
                        $('#userPassword1').attr('disabled', 'disabled')
                        $('#userEmail2').removeAttr('disabled')
                        $('.well.passwords.new').addClass('in')
                        //$('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other,#userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .contact')
                            .removeClass('hidden').find('input,select,textarea').removeAttr('disabled')
                        if (!app.data.newpassword) {
                            var pwchars = 'abcdefghijklmnopqrstuvwxyz0987654321'
                            app.data.newpassword = ''
                            for (i = 0; i < 8; i++) {
                                app.data.newpassword += pwchars.charAt(Math.floor(Math.random() * pwchars.length))
                            }
                        }
                        $('.well.passwords.new .random').text(app.data.newpassword)
                        $('#userFirstName').focus()
                    }
                }
                var popoverPositionFn = function () {
                    this.$tip.css('display', 'none');
                    return $(document).width() < 768 ? 'in bottom' : 'left'
                }
                var doEmailCheck = _.debounce(function (email, data, diningLocation) {
                    if (!data) {
                        data = {}
                    }
                    if (!data.hasOwnProperty(email)) {
                        $('#userEmail1').removeData('data-isChecked')
                        data[email] = null
                        if (validEmail(email)) {
                            $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: email }))
                                .done(function (r_ce) {
                                    data[email] = false
                                    emailCheckResult(email, data, diningLocation)
                                    $('#userEmail1').data('data-hasResult', data)
                                    $('#userEmail1').data('data-isChecked', true)
                                })
                                .fail(function (r_ce) {
                                    data[email] = true
                                    emailCheckResult(email, data, diningLocation)
                                    $('#userEmail1').data('data-hasResult', data)
                                    $('#userEmail1').data('data-isChecked', true)
                                })
                        }
                    } else {
                        emailCheckResult(email, data, diningLocation)
                    }
                }, 500)
                var checkFields = (function (e, reset, instant, diningLocation) {
                    var func = function (e, reset, instant, diningLocation) {
                        target = e && e.target || '.form-float.control-group input, .form-float.control-group select, .form-float.control-group textarea, .form-float.control-group .btn-group'
                        if (reset) {
                            $('.form-float.control-group').addClass('pristine')
                        }
                        if(!!diningLocation && diningLocation.Setup && diningLocation.Setup.RestaurantId) {
                            target = $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']').find('#'+target.id);
                        }

                        _.each($(target), function (elem) {
                            var me = $(elem)
                                , group = $(me.parents('.control-group')[0])
                                , required = me.hasClass('required') && me.attr('disabled') != 'disabled' && (elem.id != 'userHomeProvince' || countryStates.indexOf($('#userHomeCountry').val()) >= 0)
                                , pristine = group.hasClass('pristine')
                                , focused = group.hasClass('focused')
                            if (me.val()) {
                                group.addClass('filled')
                                var eid = elem.id
                                if (eid.substr(0, 9) == 'leavetime') {
                                    eid = 'leavetime'
                                }
                                switch (eid) {
                                    case "leavetime": if (!me.prop('checked')) {
                                        target != elem && attachError(group, app.localization.general.err.jquery_validate.required)
                                    } else {
                                        group.removeClass('invalid').find('.control-label span.required').remove()
                                    }
                                        break;
                                    case "userEmail1": if (!validEmail(me.val())) {
                                        target != elem && attachError(group, app.localization.general.err.jquery_validate.email)
                                    } else {
                                        group.removeClass('invalid').find('.control-label span.required').remove()
                                    }
                                        break;
                                    case "userFirstName":
                                    case "userLastName":
                                        if (me.val().legnth >= 1) {
                                            target != elem && attachError(group, app.localization.general.err.jquery_validate.minlength(1))
                                        } else {
                                            group.removeClass('invalid').find('.control-label span.required').remove()
                                        }
                                        break;
                                    case "userPhone": if (me.val().length < 8 && !!app.customization.dining.requireMobileNumber) {
                                        target != elem && attachError(group, app.localization.general.err.jquery_validate.minlength(8))
                                    } else {
                                        group.removeClass('invalid').find('.control-label span.required').remove()
                                    }
                                        break;
                                    case "userPassword1":
                                        if (me.val().length < 8 &&   app.data.minPasswordStrength == 5) {
                                            target != elem && attachError(group, app.localization.general.err.jquery_validate.minlength(8))
                                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .login.control-group .btn ').attr('disabled', 'disabled')
                                        } else {
                                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .login.control-group .btn ').removeAttr('disabled')
                                            group.removeClass('invalid').find('.control-label span.required').remove()
                                        }
                                        break;
                                    default: group.removeClass('invalid')
                                        break;
                                }
                            } else {
                                if (required && !pristine && !focused) {
                                    attachError(group, app.localization.general.err.jquery_validate.required)
                                    if (elem.id == "userPassword1") {
                                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .login.control-group .btn ').attr('disabled', 'disabled')
                                    }
                                } else {
                                    group.removeClass('invalid').find('.control-label span.required').remove()
                                }
                                group.removeClass('filled')
                            }
                        })
                        var enableButton = false
                        if (!app.data.userLoggedIn) {
                            if (!$('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']').find('.emails,.contact .phones,.contact .names').find('.control-group.invalid').length) {
                                enableButton = true
                            }
                        } else {
                            if ($('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .contact .phones input').val() || !app.customization.dining.requireMobileNumber) {
                                enableButton = true
                            }
                        }
                        if (enableButton) {
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .diningResBtn').removeClass('disabled')
                        } else {
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .diningResBtn').addClass('disabled')
                        }
                    }
                    var timeout = null
                    return function () {
                        var context = this, args = arguments, doNow = !!args[2], wait = 750
                        if (args[0] && timeout !== null) {
                            args[0] = null
                            doNow = true
                        }
                        clearTimeout(timeout)
                        if (args[0] || doNow) {
                            timeout = null
                            func.apply(context, args)
                            // wait=50
                        } else {
                            var later = function () {
                                timeout = null
                                func.apply(context, args)
                            }
                            timeout = setTimeout(later, 750)
                        }
                    }

                })()
                $('#categoryTabs li a').on('click', function (e) {
                    var restaurantId = $(this).attr('data-restaurant-id')
                    var venueName = $(this).attr('data-restaurant-venue')
                    app.dispatcher.updateURL('dining', 'show', [venueName], true)
                    if(app.customization.googleAnalytics){ 
                        $.when(app.models.diningModel.getData('fetchDiningVenues', {})).done(function (r_dv) {
                            app.commonViewHelper.analyticsInit('requestDiningReservationSelection', [venueName, r_dv]);
                        })
                    }
                    setTimeout(function () {
                        $('.diningReservation .dining[data-restaurant-id=' + restaurantId + ']  .searchBtn')
                            .trigger('click')
                    })
                })
                _.each(diningLocations, function (diningLocation) {
                    if (!diningLocation.Setup) { return; }
                    var diningDate = $('.diningReservation .reservationDate input.machine[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']')
                    if (app.data.RestrictedFolio) {
                        selectedDate = app.data.datesForRestrictedFolio[0].machine
                        diningDate.val(selectedDate)
                    } else {
                        diningDate.val(selectedDate || (Date.today().add(app.customization.dining.allowBookingToday ? 0 : 1).days()).toString('yyyy-MM-dd'))
                    }
                    $('.diningReservation .reservationDate input.human[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']')
                        .val($.datepicker.formatDate(app.localization.dining.dateFormat[0], new Date((selectedDate ? Date.parse(selectedDate) : Date.today().add(app.customization.dining.allowBookingToday ? 0 : 1).days()))))
                        .datepicker({
                            altField: '.diningReservation .reservationDate input.machine[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']',
                            altFormat: 'yy-mm-dd',
                            minDate: app.customization.dining.allowBookingToday ? "0" : "+1d",
                            maxDate: "+" + diningLocation.Setup.AcceptBookingsDaysInAdvance + "d",
                            numberOfMonths: 2,
                            dateFormat: app.localization.dining.dateFormat[0],
                            defaultDate: diningDate.val(),
                            onSelect: function (selectedDate) {
                                searchDiningRes(diningLocation.Setup.RestaurantId, diningLocation, diningDate.val(), coversSelect.val())
                            },
                            beforeShowDay: function (dateToShow) {
                                var dateToShowStr = dateToShow.toString('yyyy-MM-dd')
                                if (app.data.datesForRestrictedFolio || (app.customization.dining.PMSRoomMandatory && app.customization.dining.PMSRoomMandatory.indexOf(diningLocation.VenueName) >= 0)) {

                                    if (app.data.diningAvailDates &&
                                        app.data.diningAvailDates[diningLocation.Setup.RestaurantId] &&
                                        app.data.diningAvailDates[diningLocation.Setup.RestaurantId].hasOwnProperty(dateToShowStr)
                                    ) {
                                        return [app.data.diningAvailDates[diningLocation.Setup.RestaurantId][dateToShowStr]
                                            && (_.any(app.data.datesForRestrictedFolio, function (x) {
                                                return x.machine == dateToShowStr
                                            })) || (app.data.pmsPropertyIdsInCart && app.data.pmsPropertyIdsInCart.indexOf(diningLocation.PropertyId) >= 0
                                                && _.any(app.data.pmsDateList && app.data.pmsDateList[diningLocation.PropertyId], function (x) {
                                                    return x.machine == dateToShowStr
                                                })
                                            ), '', '']
                                    } else {
                                        return [_.any(app.data.datesForRestrictedFolio, function (x) {
                                            return x.machine == dateToShowStr
                                        }) || (app.data.pmsPropertyIdsInCart && app.data.pmsPropertyIdsInCart.indexOf(diningLocation.PropertyId) >= 0
                                            && _.any(app.data.pmsDateList && app.data.pmsDateList[diningLocation.PropertyId], function (x) {
                                                return x.machine == dateToShowStr
                                            })
                                            ), '', '']
                                    }
                                }
                                if (app.data.diningAvailDates
                                    && app.data.diningAvailDates[diningLocation.Setup.RestaurantId]
                                    && app.data.diningAvailDates[diningLocation.Setup.RestaurantId].hasOwnProperty(dateToShowStr)
                                ) {
                                    return [app.data.diningAvailDates[diningLocation.Setup.RestaurantId][dateToShowStr], '', '']
                                } else {
                                    return [true, '', '']
                                }
                            }
                        });

                        // placeHolderDate Dining

                        if(sessionStorage.getItem('phWid-' + app.data.WebFolioId)){
                            var phDate = JSON.parse(sessionStorage.getItem('phWid-' + app.data.WebFolioId));
                            if($($('.hasDatepicker')[0]).datepicker('option', 'dateFormat').toLocaleLowerCase()[0] == "d"){
                                $('.hasDatepicker').datepicker("setDate", new Date(phDate.year + ',' + phDate.month + "," + phDate.day));
                            }else{
                                $('.hasDatepicker').datepicker("setDate", new Date(phDate.year,phDate.altMonth,phDate.day));
                            }
                        }
                
                    var coversSelect = $('.diningReservation .reservationCovers select[data-restaurant-id=' + diningLocation.Setup.RestaurantId + ']')
                    if (+diningLocation.Setup.MinOnlinePartySize < +diningLocation.Setup.MaxOnlinePartySize) {
                        for (i = +diningLocation.Setup.MinOnlinePartySize; i <= +diningLocation.Setup.MaxOnlinePartySize; i++) {
                            $('<option>' + i + '</option>').val(i).attr('selected', (covers ? i == covers : i == diningLocation.Setup.OnlinePartySizeDefault) ? 'selected' : null).appendTo(coversSelect);
                        }
                    }
                    coversSelect.off('change').on('change', function (e) {
                        searchDiningRes(diningLocation.Setup.RestaurantId, diningLocation, diningDate.val(), coversSelect.val())
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .searchBtn').on('click', function (e) {
                        searchDiningRes(diningLocation.Setup.RestaurantId, diningLocation, diningDate.val(), coversSelect.val())
                    })
                    // When Area Change Search Dining Availabilities
                    // $('.areaSelectWrap .btn-group .btn').on('click', function (e) {
                    //     searchDiningRes(diningLocation.Setup.RestaurantId, diningLocation, diningDate.val(), coversSelect.val())
                    // })
                    // If there is only one area hide area selection
                    if(!diningLocation.Setup.Areas || $.wrapArray(diningLocation.Setup.Areas).length == 1){
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .areaSelectWrap').hide();
                    }
                    if (diningLocation.VenueName == selectedDiningVenue || diningLocation.ResDiaryRestaurant == selectedDiningVenue) {
                        setTimeout(function () {
                            $('#categoryTabs li a[data-restaurant-venue="' + diningLocation.VenueName + '"]').trigger('click')
                        })
                    }
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user').on('focus', '.form-float input, .form-float select, .form-float textarea', function (e) {
                        $(this).parents('.control-group').addClass('focused')
                        if (this.id == 'userPhoneMobile') {
                            $(this).attr('placeholder', app.localization.dining.phoneMobilePlaceholder)
                        }
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user').on('blur', '.form-float input, .form-float select, .form-float textarea', function (e) {
                        var removeClassStr = 'focused'
                        if (this.id != 'userEmail1' || $(this).val()) {
                            removeClassStr += ' pristine'
                        }
                        $(this).parents('.control-group').removeClass(removeClassStr)
                        if (this.id == 'userEmail1') {
                            if (validEmail($(this).val())) {
                                $('.control-group.userEmail1 .controls').addClass('spinner')
                                if (this.id == 'userEmail1' && $('#userEmail1').data('data-hasResult')) {
                                    doEmailCheck($('#userEmail1').val(), $('#userEmail1').data('data-hasResult'), diningLocation)
                                }
                            }

                        }
                        if (this.id == 'userPhoneMobile') {
                            $(this).removeAttr('placeholder')
                        }
                        checkFields(undefined, undefined, undefined, diningLocation)
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user').on('change', '.form-float input, .form-float select, .form-float textarea, .form-float .btn-group', function (e) {
                        $(this).parents('.control-group').removeClass('pristine')
                        if ($(this).val()) {
                            $('#' + this.id).val($(this).val())
                            $(this).parents('.control-group').addClass('filled')
                        } else {
                            $(this).parents('.control-group').removeClass('filled')
                        }
                        checkFields(undefined, undefined, undefined, diningLocation)
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user').on('input', '.form-float input, .form-float select, .form-float textarea', function (e) {
                        if (this.id == 'userEmail1') {
                            var email = $(this).val()
                            if (email) {
                                if (!$('.control-group.userEmail1 .controls').data('popover') ||
                                    $('.control-group.userEmail1 .controls').data('popover').getContent() != app.localization.newUser.enterExistingEmailPrompt) {
                                    $('.control-group.userEmail1 .controls')
                                        .popover('destroy')
                                    setTimeout(function () {
                                        $('.control-group.userEmail1 .controls')
                                            .popover({ content: app.localization.newUser.enterExistingEmailPrompt, trigger: 'manual', placement: popoverPositionFn, container: '#userCreateUserForm2' })
                                            .popover('show')
                                    }, 250)
                                }
                                if (validEmail(email)) {
                                    var data = $('#userEmail1').data('data-hasResult')
                                    if (!data) {
                                        $('#userEmail1').data('data-hasResult', (data = {}))
                                    }
                                    doEmailCheck(email, data, diningLocation)
                                }
                            }
                            var resultData = $('#userEmail1').data('data-hasResult')
                            if (resultData /*&& resultData[email]===undefined*/) {
                                $('.control-group.userPassword1 .controls').data('popover') && $('.control-group.userPassword1 .controls, .control-group.userPassword1 .controls input').popover('destroy')
                                $('.control-group.userEmail1 .controls')
                                    .addClass('arrow-right')
                                    .removeClass('spinner')
                                //                             $('.row-fluid.emails .control-group.userEmail1').addClass('span8').removeClass('in span6')
                                //                             $('.row-fluid.emails .control-group.userEmail2').addClass('span4').removeClass('in span6').hide()
                                $('.row-fluid.passwords, .well.passwords, .row-fluid.login').removeClass('in')
                                $('#userPassword1, #userEmail2, .row-fluid.login .btn').attr('disabled', 'disabled')
                                $('#userCreateUserForm .well.submit-controls,#userCreateUserForm .well.passwords,#userCreateUserForm .well.contact,#userCreateUserForm .well.address,#userCreateUserForm .well.address-other, .well.edit-contact-logs, #userCreateUserForm .well.language,#userCreateUserForm .well.newsletter')
                                    .addClass('disabled').find('input,select,textarea').attr('disabled', 'disabled')
                                $('#userCreateSubmit').text(app.localization.newUser.context['*/*'].buttonCreate)
                            }
                        }
                        if (this.id == 'userSalutation') {
                            switch ($(this).val()) {
                                case "Mr.":
                                    $('#userGender').val('M')
                                    break
                                case "Ms.":
                                case "Mrs.":
                                case "Miss.":
                                    $('#userGender').val('F')
                            }
                        }
                        if (this.id == 'userGender') {
                            if ($(this).val() == "M") {
                                switch ($('#userSalutation').val()) {
                                    case "Ms.":
                                    case "Mrs.":
                                    case "Miss.":
                                        $('#userSalutation').val('Mr.')
                                }
                            } else {
                                switch ($('#userSalutation').val()) {
                                    case "Mr.":
                                        $('#userSalutation').val('Ms.')
                                }
                            }
                        }
                        if ($(this).hasClass('required')) {
                            checkFields(e, undefined, undefined, diningLocation)
                        }
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .login.control-group .btn ').on('click', function (e) {
                        e.preventDefault();
                        if (validEmail($('#userEmail1').val())) {
                            $('.control-group.login .controls').addClass('spinner')
                            $('.alert.hide').alert('close');
                            $(this).attr('disabled', 'disabled')
                            app.data.loginNextURL = ['dining', 'show', [diningLocation.VenueName,
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .reservationDate input.machine').val(),
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .reservationTime select').val(),
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .reservationCovers select').val(),
                            $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .reservationPromo').val()
                            ]]
                            app.dispatcher.dispatch('profile', 'authenticate', [encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .userEmail1 input').val()), encodeURIComponent($('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .userPassword1 input').val()), 'updateDiningLoginResult']);
                        }
                    })
                    $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .forgot.control-group .btn ').on('click', function (e) {
                        e.preventDefault();
                        //                     $('.control-group.forgot .controls').addClass('spinner')
                        app.data.loginNextURL = ['dining', 'show', [diningLocation.VenueName]]
                        app.dispatcher.dispatch('profile', 'doreset', [encodeURIComponent($('#userEmail1').val())]);
                    })
                    if (app.data.userLoggedIn) {
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .emails').hide()
                        $('.diningReservation .dining[data-restaurant-id=' + diningLocation.Setup.RestaurantId + '] .user .phones').addClass('in').find('.control-group').addClass('filled')

                    }
                })
            },
            prepPMSGroupBooking: function (groupCode, blockInfo) {
                if (!groupCode) {
                    function clickHandler(obj) {
                        obj.preventDefault();
                        if ($('#groupCode').val()) {
                            app.dispatcher.redirect('roomsBooking', 'group', [$('#groupCode').val()])
                        }
                    }
                    $('#pmsGroupCodeForm').on('submit', clickHandler)
                    $('#pmsGroupFormSubmit').on('click', clickHandler)
                    return;
                }
                function submitGroupForm(obj) {
                    obj.preventDefault()
                    var numAdults = Number($('#pmsNumAdults').val() || "")
                        , numYouth = Number($('#pmsNumYouth').val() || "")
                        , numChildren = Number($('#pmsNumChildren').val() || "")
                        , numInfants = Number($('#pmsNumJrChildren').val() || "")
                        , occupancy = numAdults + numYouth + numChildren
                        , price = 0
                        , block = null

                    for(var i =0;i< blocksPerSelectedDate.length;i++){
                        var availblock = blocksPerSelectedDate[i]
                        block = _.find(availblock.Block, function (b) { return b.RateType + '-' + b.RoomType == activeRate })
                        if(block) break
                    }
                    
                    if (occupancy && block) {
                        var pmsLastQueryParameters = {
                            Adults: numAdults,
                            Children: numChildren,
                            Infants: numInfants,
                            Youth: numYouth,
                            ArrivalDate: $('#pmsArrivalDate').val(),
                            DepartureDate: $('#pmsDepartureDate').val(),
                            PromoCode: '',
                            Venue: block.Venue,
                            GroupCode: groupCode,
                            dayGuestMode: false
                        }
                        var pmsLastQuery = [{
                            PMSRateTypeCustDesc: block.RateCustDesc,
                            PMSRateTypeDesc: block.RateTypeDesc,
                            PMSRateTypeId: block.RateType,
                            PMSRateTypeImage: "",
                            Venue: block.Venue
                        }]
                        var pmsRoomTypesParameters = $.extend({
                            PMSRateType: block.RateType,
                            Venue: block.Venue,
                            WebFolioId: app.models.systemModel.getSelectedValue('createSession')
                        }, pmsLastQueryParameters)
                        app.models.roomsModel.dataModel.pmsLastQuery.data = app.models.roomsModel.dataModel.pmsLastQuery.data || {};
                        app.models.roomsModel.dataModel.pmsLastQuery.data[app.models.roomsModel.makeStandardName(app.models.roomsModel.dataModel.pmsLastQuery, {})]
                            = { PMSRateType: [$.extend({ 'PMSLastQuery': pmsLastQuery }, { dayGuestMode: false }, pmsLastQueryParameters)] };
                        app.models.roomsModel.dataModel.pmsRoomTypes.data = app.models.roomsModel.dataModel.pmsRoomTypes.data || {};
                        app.models.roomsModel.dataModel.pmsRoomTypes.data[app.models.roomsModel.makeStandardName(app.models.roomsModel.dataModel.pmsRoomTypes, pmsRoomTypesParameters)]
                            = [{ PMSRoomType: block.RoomType }];
                        app.models.roomsModel.setSelected('pmsLastQuery', {}, pmsLastQuery)
                        app.models.roomsModel.setSelected('pmsRates', pmsLastQueryParameters, block.RateType);
                        app.models.roomsModel.setSelected('pmsRoomTypes', pmsRoomTypesParameters, block.RoomType);
                        app.models.roomsModel.setSelected('pmsVenues', pmsLastQueryParameters, block.Venue);

                        app.dispatcher.redirect('roomsBooking', 'book', [])
                    }
                }
                $('#pmsGroupForm').on('submit', submitGroupForm)
                $('#pmsFormSubmit').on('click', submitGroupForm)
                if (blockInfo.Availabilities && blockInfo.Availabilities.Blocks) {
                    blockInfo.Availabilities.Blocks = _.sortBy($.wrapArray(blockInfo.Availabilities.Blocks), function (block) { return block.Date });
                    var rates = {},
                        activeRate = '',
                        firstRate = true;
                        blocksPerSelectedDate = []
                    var updateGroupRates = function updateGroupRates() {
                        var block = null;
                        $('#pmsGroupDates .rateRow').each(function (i, rateRow) {
                            if ($(this).attr('x-rate') == activeRate) {
                                var minDate,
                                    maxDate,
                                    minDateOuter = $(this).data('minDate'),
                                    maxDateOuter = $(this).data('maxDate');
                                if (activeRange = _.find(rates[activeRate].dateRanges, function (range) {
                                    if ($('#pmsArrivalDate').val()) {
                                        var arrivalDate = moment($('#pmsArrivalDate').val(), 'YYYY-MM-DD')
                                        return arrivalDate.isBetween(range.min, range.max, null, '[]')
                                    }
                                    return false
                                })) {
                                    minDate = activeRange.min.format('YYYY-MM-DD');
                                    maxDate = activeRange.max.format('YYYY-MM-DD');
                                } else {
                                    minDate = minDateOuter
                                    maxDate = maxDateOuter
                                }
                                // if (rates[activeRate].dates.indexOf( caldate.format('YYYY-MM-DD') ) >= 0) {}
                                var minDatePlusOne = moment(minDate, "YYYY-MM-DD").add(1, 'days').format('YYYY-MM-DD')
                                var maxDateMinusOne = moment(maxDate, "YYYY-MM-DD").add(-1, 'days').format('YYYY-MM-DD'),
                                minStay = $(this).attr('x-minStay'),
                                maxStay = $(this).attr('x-maxStay')

                                 var stayDuration = setStayDuration(minStay,maxStay)
                                 stayDuration.setInitialArrivalDate()
                                 stayDuration.setMaximumStay()
                                 stayDuration.setInitialDepartureDate()
                                 stayDuration.setMinimumStay()
                            }
                            function setStayDuration(minLength, maxLength) {

                                var setMinimumStay = function () {
                                    var formattedArrivalDate = $('#alt-pmsArrivalDate').datepicker('getDate'),
                                        minStay = +minLength > 0 && minLength || 1

                                    $('#alt-pmsArrivalDate').datepicker('option', 'minDate', addDays(minDate, 0))

                                    setTimeout(function () {
                                        $('#alt-pmsDepartureDate').datepicker('option', 'minDate', addDays(formattedArrivalDate, minStay))
                                    })

                                }

                                var addDays = function (date, days) {
                                    var newdate = moment(date).add('days', days).toDate()
                                    return newdate
                                }

                                var setMaximumStay = function () {
                                    var maxStayDatePerLength = maxLength && +maxLength > 0 && getMaxStayDatePerLength(maxLength),
                                        minStay = +minLength > 0 && minLength || 1

                                    var possibleDepartureDate = maxStayDatePerLength && (moment(maxStayDatePerLength).isBefore(moment(maxDate)) ? maxStayDatePerLength : maxDate)

                                    $('#alt-pmsDepartureDate').datepicker('option', 'maxDate', (possibleDepartureDate))

                                    setTimeout(function () {
                                        $('#alt-pmsArrivalDate').datepicker('option', 'maxDate', addDays(maxDate, -minStay))
                                    })
                                }
                                var getMaxStayDatePerLength = function (maxStay) {
                                    var formattedArrivalDate = $('#alt-pmsArrivalDate').datepicker('getDate')
                            
                                    return maxStayDatePerLength = moment(formattedArrivalDate).add('days', maxStay).toDate()
                                }

                                var setInitialDepartureDate = function () {
                                    var possibleDepartureDate = +maxLength > 0 && getMaxStayDatePerLength(maxLength) || maxDate

                                    if (!$('#pmsDepartureDate').val() ||
                                        ($('#pmsDepartureDate').val() < minDatePlusOne) ||
                                        ($('#pmsDepartureDate').val() > maxDate)) {
                                        $('#pmsDepartureDate').val(possibleDepartureDate)
                                        $('#alt-pmsDepartureDate').val(moment(possibleDepartureDate).format("MMM D, YYYY"))
                                    }
                                }
                                var setInitialArrivalDate = function () {
                                    if (!$('#pmsArrivalDate').val() || ($('#pmsArrivalDate').val() < minDate) || ($('#pmsArrivalDate').val() > maxDateMinusOne)) {
                                        $('#pmsArrivalDate').val(minDate)
                                        $('#alt-pmsArrivalDate').val(Date.parse(minDate).toString("MMM d, yyyy"))
                                    }
                                }
                                return {
                                    setMinimumStay: setMinimumStay,
                                    setMaximumStay: setMaximumStay,
                                    setInitialDepartureDate: setInitialDepartureDate,
                                    setInitialArrivalDate: setInitialArrivalDate
                                }
                            }
                        })
                        var minQty = {}
                        $('#pmsGroupDates .dayTile:not(.template)').each(function (i, tile) {
                            var blocks = $(tile).data('block'),
                                element = this
                            $(element).addClass('unavailable').find('.price').text(app.localization.roomReservation.calendar.notAvailable)
                            _.each(blocks.Block, function (block) {
                                var allowSubmit = true
                                    , numAdults = Number($('#pmsNumAdults').val() || "")
                                    , numYouth = Number($('#pmsNumYouth').val() || "")
                                    , numChildren = Number($('#pmsNumChildren').val() || "")
                                    , numInfants = Number($('#pmsNumJrChildren').val() || "")
                                    , occupancy = numAdults + numYouth + numChildren
                                    , price = 0
                                    , qtyLeft = +block.NumberLeft;
                                if (!minQty[block.RateType + '-' + block.RoomType]) {
                                    minQty[block.RateType + '-' + block.RoomType] = 999999
                                }
                                minQty[block.RateType + '-' + block.RoomType] = minQty[block.RateType + '-' + block.RoomType] < qtyLeft ? minQty[block.RateType + '-' + block.RoomType] : qtyLeft;
                                if (numAdults <= 0
                                    //  || (+block.MinOccupancy&&(occupancy < +block.MinOccupancy))
                                    //  || (+block.MaxOccupancy&&(occupancy > +block.MaxOccupancy))
                                ) {
                                    allowSubmit = false
                                } else {
                                    if (numAdults == 1) {
                                        price = +block.SingleRate;
                                    } else if (numAdults == 2) {
                                        price = +block.DoubleRate;
                                    } else if (numAdults == 3) {
                                        price = +block.TripleRate;
                                    } else if (numAdults == 4) {
                                        price = +block.QuadRate;
                                    } else {
                                        price = +block.QuadRate;
                                        price += (numAdults - 4) * +block.AddAdult
                                    }
                                    price += numYouth * +block.AddYouth
                                    price += numChildren * +block.AddYouth
                                }
                                if (qtyLeft < 1) {
                                    allowSubmit = false
                                }
                                if (block.RateType + '-' + block.RoomType == activeRate) {
                                    if (allowSubmit) {
                                        $(element).find('.price').text(app.localization.general.currencyPrefix + Number(price).toFixed(2) + app.localization.general.currencyPostfix)
                                        $(element).removeClass('unavailable')
                                    }
                                    $('pmsGroupFormSubmit').prop('disabled', !allowSubmit);
                                }
                                $('.rateRow[x-rate=' + block.RateType + '-' + block.RoomType + ']').find('.qtyLeft').text(minQty[block.RateType + '-' + block.RoomType] + ' ' + app.localization.roomReservation.group.qtyLeft)
                            })
                        })
                    }
                    $('#pmsNumAdults,#pmsNumYouth,#pmsNumChildren,#pmsNumJrChildren').on('change', updateGroupRates)
                    $('#pmsGroupForm .control-group.accountName p').text(blockInfo.AccountName)
                    $('#pmsGroupForm .control-group.customerName p').text(blockInfo.CustomerName)
                    $('#pmsGroupForm .control-group.contactName p').text(blockInfo.ContactName)
                    $('#pmsGroupForm .control-group.accountName')[blockInfo.AccountName ? 'show' : 'hide']()
                    $('#pmsGroupForm .control-group.customerName')[blockInfo.CustomerName ? 'show' : 'hide']()
                    $('#pmsGroupForm .control-group.contactName')[blockInfo.ContactName ? 'show' : 'hide']()
                    if (blockInfo.NameToDisplay == 'ACCT') {
                        $('#pmsGroupForm .control-group.customerName').addClass('disabled')
                    } else {
                        $('#pmsGroupForm .control-group.accountName').addClass('disabled')
                    }
                    $('#pmsGroupForm .control-group.blockDescription p').html(nl2br(blockInfo.BlockDescription))
                    $('#pmsGroupForm .control-group.blockDescription')[blockInfo.BlockDescription ? 'show' : 'hide']()
                    if (blockInfo.BlockImage) {
                        $('#pmsGroupForm .control-group.blockDescription img').attr('src', blockInfo.BlockImage).removeClass('hide')
                    }
                    _.each(blockInfo.Availabilities.Blocks, function (block) {
                        console.log(block)
                        var date = moment(block.Date, "YYYY-MM-DDHHmmss"),
                            dayTile = $('#pmsGroupDates .dayTile.template').clone().removeClass('template')
                        dayTile.data('block', block)
                        dayTile.attr('data-date', date.format('YYYY-MM-DD'))
                        dayTile.find('.day').text(date.format('D'))
                        dayTile.find('.month').text(date.format('MMM'))
                        dayTile.find('.dayofweek').text(date.format('ddd'))
                        block.Block = $.wrapArray(block.Block)
                        blocksPerSelectedDate.push(block)
                        // check if dates are a continuous range for each rate type
                        _.each(block.Block, function (block) {
                            if (!rates[block.RateType + '-' + block.RoomType]) {
                                rates[block.RateType + '-' + block.RoomType] = {
                                    dates: [date.format('YYYY-MM-DD')],
                                    dateRanges: [{ min: date, max: date.clone().add(1, 'days') }],
                                    block: block
                                }
                                activeRate = activeRate || block.RateType + '-' + block.RoomType
                                var row = $('#pmsGroupDates .rateRow.template').clone().removeClass('template')
                                row.attr('x-rate', block.RateType + '-' + block.RoomType)
                                row.attr('x-minStay', block.MinLength)
                                row.attr('x-maxStay', block.MaxLength)
                                row.find('.accordion-toggle').attr('href', '#rate' + block.RateType + '-' + block.RoomType)
                                row.find('.accordion-body').attr('id', 'rate' + block.RateType + '-' + block.RoomType)

                                var minStaytext = +block.MinLength  &&   app.localization.roomReservation.group.minimumStayLengthText+' '+block.MinLength + ' '+  app.localization.roomReservation.group.daysText || ''
                                var maxStayText = +block.MaxLength && app.localization.roomReservation.group.maximumStayLengthText+' '+block.MaxLength + ' ' + app.localization.roomReservation.group.daysText || ''
                                
                                $('.minMaxStayInstructions').html(minStaytext + (+block.MinLength && +block.MaxLength? ' '+app.localization.roomReservation.group.to+ ' ': ' ') + maxStayText)

                                if (firstRate) {
                                    row.find('.accordion-body').addClass('in')
                                    firstRate = false;
                                }
                                row.find('.rateTypeDesc').text(block.RateTypeDesc)
                                row.find('.rateCustDesc').text(block.RateCustDesc)
                                row.find('.roomTypeDesc').text(block.RoomTypeDesc)
                                row.find('.rateTypeDescGroup')[block.RateTypeDesc ? 'show' : 'hide']()
                                row.find('.rateCustDescGroup')[block.RateCustDesc ? 'show' : 'hide']()
                                row.find('.roomTypeDescGroup')[block.RoomTypeDesc ? 'show' : 'hide']()
                                if (block.RoomTypeImage) {
                                    row.find('.roomTypeImageGroup').removeClass('hide')
                                    row.find('.roomTypeImage').attr('src', block.RoomTypeImage)
                                }
                                row.on('click', '.accordion-toggle', function (e) {
                                    // e.preventDefault();
                                    activeRate = block.RateType + '-' + block.RoomType;
                                    updateGroupRates();
                                })
                                // todo only add block inf leftqty >0
                                row.data('minDate', date.format('YYYY-MM-DD'));
                                row.data('maxDate', date.clone().add(1, 'days').format('YYYY-MM-DD'));
                                row.insertBefore('#pmsGroupDates .rateRow.template')
                            } else {
                                $('#pmsGroupDates .rateRow[x-rate=' + block.RateType + '-' + block.RoomType + ']').data('maxDate', date.clone().add(1, 'days').format('YYYY-MM-DD'));
                                rates[block.RateType + '-' + block.RoomType].dates.push(date.format('YYYY-MM-DD'))
                                // todo only add block inf leftqty >0
                                if (_.last(rates[block.RateType + '-' + block.RoomType].dateRanges).max < date) {
                                    rates[block.RateType + '-' + block.RoomType].dateRanges.push({ min: date, max: date.clone().add(1, 'days') })
                                } else {
                                    _.last(rates[block.RateType + '-' + block.RoomType].dateRanges).max = date.clone().add(1, 'days')
                                }
                                $('#pmsGroupDates tr[x-rate=' + block.RateType + '-' + block.RoomType + '] td').attr('colspan', rates[block.RateType + '-' + block.RoomType].dates.length)
                            }
                        })
                        dayTile.insertBefore('#pmsGroupDates .dayTile.template')
                    })
                    $('.content-pmsGroupBookingTpl #alt-pmsArrivalDate').datepicker({
                        minDate: app.customization.roomsBooking.allowBookingToday ? "0" : "+1",
                        maxDate: "+2Y",
                        dateFormat: "MMM d, yyyy",
                        altField: "#pmsArrivalDate",
                        altFormat: "yy-mm-dd",
                        onSelect: function () {
                            $('#pmsArrivalDate').trigger('change')
                        },
                        beforeShowDay: function (caldate) {
                            caldate = moment(caldate).add(this.id == "alt-pmsArrivalDate" ? 0 : -1, 'days');
                            return [rates[activeRate].dates.indexOf(caldate.format('YYYY-MM-DD')) >= 0, "", ""]
                        }
                    }).datepicker('setDate', Date.parse($('#alt-pmsArrivalDate').val(), 'yyyy-MM-dd'));
                    $('#pmsArrivalDate').on('change', updateGroupRates);

                    $('.content-pmsGroupBookingTpl #alt-pmsArrivalDate').datepicker('setDate', Date.parse($('#alt-pmsArrivalDate').val(), 'yyyy-MM-dd'))
                    $( "#alt-pmsArrivalDate" ).datepicker( "option", "dateFormat", Localization.roomReservation.groupDateFormat);

                    $('.content-pmsGroupBookingTpl #alt-pmsDepartureDate').datepicker({
                        minDate: app.customization.roomsBooking.allowBookingToday ? "0" : "+1",
                        maxDate: "+2Y",
                        dateFormat: "MMM d, yyyy",
                        altField: "#pmsDepartureDate",
                        altFormat: "yy-mm-dd",
                        onSelect: function () {
                            $('#pmsDepartureDate').trigger('change')
                            $('#alt-pmsArrivalDate').datepicker('option', 'maxDate', Date.parse($('#alt-pmsDepartureDate').val()))
                        },
                        beforeShowDay: function (caldate) {
                            caldate = moment(caldate).add(this.id == "alt-pmsDeparetureDate" ? 0 : -1, 'days');
                            return [rates[activeRate].dates.indexOf(caldate.format('YYYY-MM-DD')) >= 0, "", ""]
                        }
                    }).datepicker('setDate', Date.parse($('#alt-pmsDepartureDate').val(), 'yyyy-MM-dd'));
                    $( "#alt-pmsDepartureDate" ).datepicker( "option", "dateFormat", Localization.roomReservation.groupDateFormat);
                  
                    $('#pmsDepartureDate').on('change', updateGroupRates);
                    updateGroupRates();
                }
            },

            updatePlaceHolderDate : function (ArrivalDate){
                if(!ArrivalDate) return;
                
                var phDateObj = {};
                placeDate = ArrivalDate.substring(0,10);

                phDateObj.PkgsDate = moment(placeDate).format("YYYY, MM, DD");
                phDateObj.year = Date.parse(phDateObj.PkgsDate).getFullYear();
                phDateObj.month = Date.parse(phDateObj.PkgsDate).getMonth() + 1;
                phDateObj.altMonth = Date.parse(phDateObj.PkgsDate).getMonth();
                phDateObj.day = Date.parse(phDateObj.PkgsDate).getDate();
                sessionStorage.setItem('phWid-' + app.data.WebFolioId, JSON.stringify(phDateObj));
            },

            fetchFilteredGolfTeeSheet: function(golfTeeParameters, fetchFromCache) {
                var dfd = $.Deferred();
                if(app.data.golfTeeSheetPromise === undefined) {
                    app.data.golfTeeSheetPromise = dfd.promise();
                }else {
                    return app.data.golfTeeSheetPromise;
                }
                $('#progressIndicator').modal('show');
                    $.when( fetchFromCache !== true || !app.models.golfModel.dataModel.golfTeeSheet.data || !app.models.golfModel.dataModel.golfTeeSheet.data[ app.models.golfModel.makeStandardName(app.models.golfModel.dataModel.golfTeeSheet,golfTeeParameters) ]
                        ? app.models.golfModel.getData('golfTeeSheet', golfTeeParameters)
                        : app.models.golfModel.dataModel.golfTeeSheet.data[ app.models.golfModel.makeStandardName(app.models.golfModel.dataModel.golfTeeSheet,golfTeeParameters) ] 
                    ).done(function(r_gt){
                    if(r_gt.TeeTimes && r_gt.TeeTimes.TeeTime){
                        r_gt.TeeTimes.TeeTime = [].concat(r_gt.TeeTimes.TeeTime).filter(function(tt){
                            return !!tt.Rates.Rate && tt.SlotsAvailable > 0 && moment(tt.DateTime, 'YYYY-MM-DDHHmmss') > moment();
                        });
                    }
                    dfd.resolve(JSON.parse(JSON.stringify(r_gt)));
                }).always(function() {
                    $('#progressIndicator').modal('hide');
                    app.data.golfTeeSheetPromise = undefined;
                });
                return dfd.promise();
            },
            // better to use params as a object
            resolveCustomization: function(customization, params) {
                if (typeof customization == "function") {
                    return customization(params).then(function (result) {
                        return $.when(result);
                    },function(result){
                        return $.when(null);
                    })
                } else if (typeof customization == "boolean") return $.when(customization);
            },
            // Dynamic Access Restrictions Starts Here
            evalCriteria: function (){
                var obj = {
                    activeContext: {
                        pmsFolios: [],
                        spaFolios: [],
                        golfFolios: [],
                    }, 
                    pms_room_type: function(roomtypes, ctx){
                        var pmsFolios =  _.filter(ctx.pmsCartAndFolioItems, function(folio){
                            if(folio.PMSRoomType){
                                return roomtypes.indexOf(folio.PMSRoomType) > -1;
                            } else return roomtypes.indexOf(folio.RoomType) > -1;
                        }) // Check if room type exist in folios
              
                        return {matches: {pmsCartAndFolioItems: pmsFolios}, bool: !!pmsFolios.length };
                    },
                    pms_rate_type: function(ratetypes, ctx){
                        var pmsFolios = _.filter(ctx.pmsCartAndFolioItems, function(folio){
                                if(folio.DailyRates){
                                    return ratetypes.indexOf(folio.DailyRates.DailyRateDetails[0].PMSRateType) > -1;
                                } else return ratetypes.indexOf(folio.DailyRateDetails.DailyRateDetail[0].PMSRateType) > -1;

                        }); // Check if rate type exist in folios
              
                        return {matches: {pmsFolios: pmsFolios}, bool: !!pmsFolios.length };
                    },
                    pms_venue: function(venues, ctx) {
                        var pmsFolios = _.filter(ctx.pmsCartAndFolioItems, function(folio){
                            if(folio.Location){
                                return venues.indexOf(folio.Location) > -1;
                            } else return venues.indexOf(folio.Venue) > -1;
                            
                        }); // Check if venues exist in folios
              
                        return {matches: {pmsCartAndFolioItems: pmsFolios}, bool: !!pmsFolios.length };
                    },
                    pms_min_los: function(los, ctx){
              
                        var pmsFolios = _.filter(ctx.pmsCartAndFolioItems, function(pmsFolioItem){
                            var days = pmsFolioItem.DailyRateDetails.DailyRateDetail.length;
                            // los must be greater than days
                            if( typeof los == 'number' && days >= Math.abs(los) ){
                                return true;
                            } else {
                                return false;
                            }
                        }); // Check for min length of stay
              
                        return {matches: {pmsCartAndFolioItems: pmsFolios}, bool: !!pmsFolios.length};
                    },
                    spa_booking_loc: function(locations, ctx){
                        
                        var spaFolioItems = _.filter(ctx.spaCartAndFolioItems, function(spaCartAndFolioItem) {
                            return locations.indexOf(spaCartAndFolioItem.SpaFolioItem.LocationId) != -1; 
                        });

                        return {matches: {spaCartAndFolioItems: spaFolioItems}, bool: !!spaFolioItems.length};
                    },
                    spa_booking_count_min_any_day: function(countObj, ctx){
                        // according to countObj if countObj.ruletype 'pms' all the people has spa booking on pms days must have at least countObj.count spa bookings on their pms res days
                        // if countObj.ruletype 'no-pms' all the people has spa booking on the days excluding pms days, must have at least countObj.count spa bookings 
                        // if countObj.ruletype 'all' all the people has spa bookings must have at least countObj.count spa bookings

                        var spaItemsPerPerson = this.getAllSpaItemsPerPerson(ctx);
                        var spaItemsExclPmsDates = this.getAllSpaItemsExclPmsDates(ctx); 
                        var checkDateRangeExist = countObj.dateRange;
                        var dateRangesArr = [];

                        // if date range exist it'll filter spaitems by date range prior to evaluation
                        if(checkDateRangeExist){
                            if(!Array.isArray(checkDateRangeExist)) {
                                dateRangesArr.push(checkDateRangeExist);
                            } else {
                                dateRangesArr = checkDateRangeExist.slice();
                            }      

                            spaItemsExclPmsDates = _.filter(spaItemsExclPmsDates, function(spaItem){
                                return _.some(dateRangesArr, function(dateRange){
                                    return spaItem.SpaFolioItem.BookStartTime.substr(0,10) >= dateRange.startDate && spaItem.SpaFolioItem.BookStartTime.substr(0,10) <= dateRange.endDate;
                                })
                            })
                            spaItemsPerPerson = _.mapObject(spaItemsPerPerson, function(personsSpaItems){
                                return _.filter(personsSpaItems, function(spaItem){
                                    return _.some(dateRangesArr, function(dateRange){
                                        return spaItem.SpaFolioItem.BookStartTime.substr(0,10) >= dateRange.startDate && spaItem.SpaFolioItem.BookStartTime.substr(0,10) <= dateRange.endDate;
                                    })
                                })
                            })
                        }

                        var matchedSpaBookings = [];
                        var tempSpaItems = [];
                        var personPassedCriteriaCount = 0;

                        function countIncludingPackageItems (allSpaItems) {
                            var actualCount = 0;
                            _.each(allSpaItems, function(spaItemPackage) {
                                if(spaItemPackage.spaPackageItems) {
                                    actualCount += spaItemPackage.spaPackageItems.length;
                                } else {
                                    actualCount++;
                                }
                            });
                             return actualCount;
                        };

                        if(!countObj.ruleType){
                            countObj.ruleType = 'all';
                        }

                        switch (countObj.ruleType.toLowerCase()) {
                            case 'pms':
                                _.each(ctx.pmsCartAndFolioItems, function(pmsRes){
                                    var pmsResDates = obj.getAllPmsStayDates({pmsCartAndFolioItems:[pmsRes]});
                                    var personCountHasSpaItemOnPmsDate = 0;
                                    _.each(spaItemsPerPerson, function(personsSpaItems, person){
                                        var personsSpaItemsOnPmsRes = _.filter(spaItemsPerPerson[person], function(spaItem){
                                            return pmsResDates.indexOf(spaItem.SpaFolioItem.BookStartTime.substr(0,10)) != -1;
                                        })

                                        if(personsSpaItemsOnPmsRes.length){
                                            personCountHasSpaItemOnPmsDate++;
                                        }//counting guests

                                        // Collecting all spa folios on the pms days which are bigger than count
                                        if(countIncludingPackageItems(personsSpaItemsOnPmsRes) >= countObj.count){
                                            tempSpaItems = tempSpaItems.concat(personsSpaItemsOnPmsRes);
                                            personPassedCriteriaCount++;
                                        }  
                                    })
                                    if(personCountHasSpaItemOnPmsDate == personPassedCriteriaCount){
                                         matchedSpaBookings = matchedSpaBookings.concat(tempSpaItems);
                                    }
                                })
                                if(matchedSpaBookings.length){
                                    matchedSpaBookings = matchedSpaBookings.concat(spaItemsExclPmsDates);
                                }
                                break;
                            case 'no-pms':
                                // // Check spa item count according to per/person if there is no PMS requirement
                                var personCountHasSpaItemsExcPmsDates = 0;

                                _.each(spaItemsPerPerson, function(personsSpaItems, person){
                                    var personsSpaItemsExclPmsDates = _.intersection(spaItemsPerPerson[person], spaItemsExclPmsDates);

                                    if(personsSpaItemsExclPmsDates.length){
                                        personCountHasSpaItemsExcPmsDates++;
                                    }

                                    if(countIncludingPackageItems(personsSpaItemsExclPmsDates) >= countObj.count){
                                        personPassedCriteriaCount++;
                                        tempSpaItems = tempSpaItems.concat(personsSpaItems);
                                    }
                                }) 
                                
                                if(personCountHasSpaItemsExcPmsDates == personPassedCriteriaCount ){
                                    matchedSpaBookings = matchedSpaBookings.concat(tempSpaItems);
                                }
                                matchedSpaBookings = matchedSpaBookings.concat(_.difference(ctx.spaCartAndFolioItems, spaItemsExclPmsDates));
                                break;
                            case 'all':
                                var personPassedCriteriaCount = 0;
                                _.each(spaItemsPerPerson, function(personsSpaItems, person){
                                    var personsSpaItems = _.intersection(spaItemsPerPerson[person], ctx.spaCartAndFolioItems);

                                    if(countIncludingPackageItems(personsSpaItems) >= countObj.count){
                                        tempSpaItems = tempSpaItems.concat(personsSpaItems);
                                        personPassedCriteriaCount++;
                                    }

                                    if(Object.keys(spaItemsPerPerson).length == personPassedCriteriaCount){
                                        matchedSpaBookings = matchedSpaBookings.concat(tempSpaItems);
                                    }

                                })      
                                break;
                            default:
                                break;
                        }
                        // passes if any one of the days has valid spa bookings
                        return {matches: {spaCartAndFolioItems: matchedSpaBookings}, bool: !!(matchedSpaBookings.length)};       
            
                    },
                    spa_booking_count_min_same_day: function(countObj, ctx){
                        // according to countObj if countObj.ruletype 'pms' all the people has spa booking on pms days must have at least countObj.count spa bookings on the same day
                        // if countObj.ruletype 'no-pms' all the people has spa booking on the days excluding pms days, must have at least countObj.count spa bookings on the same day
                        // if countObj.ruletype 'all' all the people has spa bookings must have at least countObj.count spa bookings on the same day

                        var spaItemsPerPerson = this.getAllSpaItemsPerPerson(ctx);
                        var spaItemsExclPmsDates = this.getAllSpaItemsExclPmsDates(ctx); 
                        var checkDateRangeExist = countObj.dateRange;
                        var dateRangesArr = [];

                        // if date range exist it'll filter spaitems by date range prior to evaluation
                        if(checkDateRangeExist){
                            if(!Array.isArray(checkDateRangeExist)) {
                                dateRangesArr.push(checkDateRangeExist);
                            } else {
                                dateRangesArr = checkDateRangeExist.slice();
                            }      

                            spaItemsExclPmsDates = _.filter(spaItemsExclPmsDates, function(spaItem){
                                return _.some(dateRangesArr, function(dateRange){
                                    return spaItem.SpaFolioItem.BookStartTime.substr(0,10) >= dateRange.startDate && spaItem.SpaFolioItem.BookStartTime.substr(0,10) <= dateRange.endDate;
                                })
                            })
                            spaItemsPerPerson = _.mapObject(spaItemsPerPerson, function(personsSpaItems){
                                return _.filter(personsSpaItems, function(spaItem){
                                    return _.some(dateRangesArr, function(dateRange){
                                        return spaItem.SpaFolioItem.BookStartTime.substr(0,10) >= dateRange.startDate && spaItem.SpaFolioItem.BookStartTime.substr(0,10) <= dateRange.endDate;
                                    })
                                })
                            })
                        }

                        var matchedSpaBookings = [];
                        var personPassedCriteriaCount = 0;
                        
                        function countIncludingPackageItems (allSpaItems) {
                            var actualCount = 0;
                            _.each(allSpaItems, function(spaItemPackage) {
                                if(spaItemPackage.spaPackageItems) {
                                    actualCount += spaItemPackage.spaPackageItems.length;
                                } else {
                                    actualCount++;
                                }
                            });
                             return actualCount;
                        };

                        if(!countObj.ruleType){
                            countObj.ruleType = 'all';
                        }

                        switch (countObj.ruleType.toLowerCase()) {
                            case 'pms':
                                // Check spa items per/person count only on pms dates
                                _.each(ctx.pmsCartAndFolioItems, function(pmsRes){
                                    var pmsResDates = obj.getAllPmsStayDates({pmsCartAndFolioItems:[pmsRes]});
                                    var personCountHasSpaItemOnPmsDate = 0;
                                    var interSectSpaByPerson = [];
                                    _.each(spaItemsPerPerson, function(spaItems, person){
                                        var personsSpaItemsOnPmsDates = _.filter(spaItems, function(spaItem){
                                            return pmsResDates.indexOf(spaItem.SpaFolioItem.BookStartTime.substr(0,10)) > -1;
                                        })
                                        if(personsSpaItemsOnPmsDates.length){
                                            personCountHasSpaItemOnPmsDate++;
                                        }
                                        // Group Person's Spa Items Daily
                                        var groupedSpaItemsEachDay = {};
                                        _.each(personsSpaItemsOnPmsDates, function(spaItem){
                                            if(groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] != undefined){
                                                groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)].push(spaItem);
                                            } else {
                                                groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] = [spaItem];
                                            }
                                        })
                                        var personPassedCriteria = true;
                                        _.each(groupedSpaItemsEachDay, function(spaItems, key){
                                            if(countIncludingPackageItems(spaItems) < countObj.count){
                                                personPassedCriteria = false;
                                            }
                                        })
                                        if(personPassedCriteria && personsSpaItemsOnPmsDates.length){
                                            interSectSpaByPerson = interSectSpaByPerson.concat(personsSpaItemsOnPmsDates);
                                            personPassedCriteriaCount++;
                                        }  
                                    })
                                    if(personCountHasSpaItemOnPmsDate == personPassedCriteriaCount){
                                        matchedSpaBookings = matchedSpaBookings.concat(interSectSpaByPerson);
                                   }
                                })
                                if(matchedSpaBookings.length){
                                    matchedSpaBookings = matchedSpaBookings.concat(spaItemsExclPmsDates);
                                }
                                break;
                            case 'no-pms':
                                // Check spa items per/person count excluding pms dates (no requirements on PMS dates)
                                var spaItemsExcPms = [];
                                var personCountHasSpaItemsExcPmsDates = 0;
                                _.each(spaItemsPerPerson, function(personsSpaItems, person){
                                    var personsSpaItemsExclPmsDates = _.intersection(spaItemsPerPerson[person], spaItemsExclPmsDates);
                                    if(personsSpaItemsExclPmsDates.length){
                                        personCountHasSpaItemsExcPmsDates++;
                                    }
                                    var groupedSpaItemsEachDay = {};
                                    _.each(personsSpaItemsExclPmsDates, function(spaItem){
                                        if(groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] != undefined){
                                            groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)].push(spaItem);
                                        } else {
                                            groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] = [spaItem];
                                        }
                                    })
                                    var personPassedCriteria = true;
                                    _.each(groupedSpaItemsEachDay, function(spaItems, key){
                                        if(countIncludingPackageItems (spaItems) < countObj.count){
                                            personPassedCriteria = false;
                                        }
                                    })
                                    if(personPassedCriteria){
                                        spaItemsExcPms = spaItemsExcPms.concat(spaItems);
                                        personPassedCriteriaCount++;
                                    }   
                                })

                                if(personCountHasSpaItemsExcPmsDates == personPassedCriteriaCount ){
                                    matchedSpaBookings = matchedSpaBookings.concat(spaItemsExcPms);
                                }
                                
                                matchedSpaBookings = matchedSpaBookings.concat(_.difference(ctx.spaCartAndFolioItems, spaItemsExclPmsDates));
                                break;
                            case 'all':
                                // Check spa items per/person count for every other day
                                var tempSpaItems = [];
                                _.each(spaItemsPerPerson, function(personsSpaItems, person){
                                    var personsCommonSpaItems = _.intersection(spaItemsPerPerson[person], ctx.spaCartAndFolioItems);
                                    var groupedSpaItemsEachDay = {};
                                    _.each(personsCommonSpaItems, function(spaItem){
                                        if(groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] != undefined){
                                            groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)].push(spaItem);
                                        } else {
                                            groupedSpaItemsEachDay[spaItem.SpaFolioItem.BookStartTime.substr(0,10)] = [spaItem];
                                        }
                                    })
                                    var personPassedCriteria = true;
                                    _.each(groupedSpaItemsEachDay, function(spaItems, key){
                                        //Cont including spapackageitems
                                        if(countIncludingPackageItems(spaItems) < countObj.count){
                                            personPassedCriteria = false;
                                        }
                                    })   
                                    if(personPassedCriteria){
                                        tempSpaItems = tempSpaItems.concat(personsCommonSpaItems);
                                        personPassedCriteriaCount++;
                                    }
                                })

                                if(Object.keys(spaItemsPerPerson).length == personPassedCriteriaCount){
                                    matchedSpaBookings = matchedSpaBookings.concat(tempSpaItems);
                                }
                                break;
                            default:
                                break;
                        }
                        // passes if any one of the days has valid spa bookings
                        return {matches: {spaCartAndFolioItems: matchedSpaBookings}, bool: !!matchedSpaBookings.length};
                    },
                    spa_booking_day_of_week: function(dayOfWeek, ctx) {
                        // if spaDate is among the specified days of week we accept it
                        var spaCartandFolioItemsOnDays = [];
                        // dayOfWeek = $.wrapArray(dayOfWeek);
                        var daysOfWeekList = [];
              
                        if(!Array.isArray(dayOfWeek)) {
                            daysOfWeekList.push(dayOfWeek);
                        } else {
                            daysOfWeekList = dayOfWeek.slice();
                        }
              
                        _.forEach(ctx.spaCartAndFolioItems, function(spaFolioAndCartItem){
                            var spaDate = spaFolioAndCartItem.SpaFolioItem.BookStartTime.substr(0, 10);
                            if (daysOfWeekList.indexOf(moment(spaDate).isoWeekday()) != -1) {
                                spaCartandFolioItemsOnDays.push(spaFolioAndCartItem);
                            } //pushes cartItem only when spaDate is among the specified days of week
                        })
              
                        return {matches: {spaCartAndFolioItems: spaCartandFolioItemsOnDays}, bool: !!spaCartandFolioItemsOnDays.length};
                    }, 
                    spa_booking_date_ranges: function(dateRanges, ctx){
                        // if spaDate is between the specified dates
                        var spaFolios = [];

                        var dateRangesArr = [];
                        if(!Array.isArray(dateRanges)) {
                            dateRangesArr.push(dateRanges);
                        } else {
                            dateRangesArr = dateRanges.slice();
                        }                      

                        _.forEach(ctx.spaCartAndFolioItems, function(spaF){
                            var spaDate = spaF.SpaFolioItem.BookStartTime.substr(0, 10);
                            _.each(dateRangesArr, function(dateRange){
                                if(moment(spaDate).isBetween(moment(dateRange.startDate),moment(dateRange.endDate),'days','[]')){
                                    spaFolios = spaFolios.concat(spaF);
                                }
                            })

                        })

                          return {matches: {spaCartAndFolioItems: spaFolios}, bool: !!spaFolios.length};
                    },
                    spa_booking_holidays: function(holidays, ctx){
                        // if spaDate is on the specified dates
                        var spaFolios = []; 
                        var holidaysArr = [];

                        if(!Array.isArray(holidays)) {
                            holidaysArr.push(holidays);
                        } else {
                            holidaysArr = holidays.slice();
                        }
              
                        _.forEach(ctx.spaCartAndFolioItems, function(spaF){
                            var spaDate = spaF.SpaFolioItem.BookStartTime.substr(0, 10);
                            if(holidaysArr.indexOf(spaDate) > -1){
                                spaFolios.push(spaF);
                            }
                        })

                        return {matches: {spaCartAndFolioItems: spaFolios}, bool: !!spaFolios.length};
                    },
                    customer_vip_level: function(levelObj, ctx){
                        // gets uniquely common VIP levels
                        if(!app.data.membershipDetails || !app.data.membershipDetails.VIPLevels) return false;
                        var intersectVipLevels = _.intersection(levelObj.levels, app.data.membershipDetails.VIPLevels);

                        // if no module defined evaluate boolean for whole context
                        if(intersectVipLevels.length && levelObj.module == undefined){
                            return true;
                        } else if(!intersectVipLevels.length && levelObj.module == undefined){
                            return false;
                        }

                        //forwarding all folio/cart items if commonViplevels exist
                        switch (levelObj.module.toUpperCase()) {
                            case 'PMS':
                                if(intersectVipLevels.length){
                                    return {matches: {pmsCartAndFolioItems: ctx.pmsCartAndFolioItems}, bool: !!ctx.pmsCartAndFolioItems.length};
                                } else return {matches: {pmsCartAndFolioItems: []}, bool: false};
                            case 'SPA':
                                if(intersectVipLevels.length){
                                    return {matches: {spaCartAndFolioItems: ctx.spaCartAndFolioItems}, bool: !!ctx.spaCartAndFolioItems.length};
                                } else return {matches: {spaCartAndFolioItems: []}, bool: false};
                            case 'GOLF':
                                if(intersectVipLevels.length){
                                    return {matches: {golfCartAndFolioItems: ctx.golfCartAndFolioItems}, bool: !!ctx.golfCartAndFolioItems.length};
                                } else return {matches: {golfCartAndFolioItems: []}, bool: false};                                    
                        } 
                    },
                    customer_membership_item_id: function(memberObj, ctx){
                        // TODO: We're using this code block twice needs to be refactored
                        var intersectMemberIds = [];
                        // Check If multiproperty settings defined, if it's then run regex and identify members according to property
                        if(app.customization.dynamicRestrictions.multiPropertyMemberships != undefined && app.data.membershipDetails){
                            intersectMemberIds = _.intersection(memberObj.memberIds, app.data.membershipDetails.membershipItemIds);
                            _.each(memberObj.memberIds, function(memberId){
                                if(app.customization.dynamicRestrictions.multiPropertyMemberships[memberId] != undefined){
                                    // constructing regex string
                                    var regexString = '';
                                    _.each(app.customization.dynamicRestrictions.multiPropertyMemberships[memberId], function(digit){
                                        regexString += '['+ digit + ']';
                                    })
                                    regexString = '^'+regexString+'.*';
                                    var regex = new RegExp(regexString,'g');
                                    // check each member id from API response if they are matching with property regex
                                    _.each(app.data.membershipDetails.membershipItemIds, function(customerId){
                                        var memberFound = regex.test(parseInt(customerId)); 
                                        if(memberFound){
                                            intersectMemberIds.push(customerId);
                                        }
                                    })
                                }
                            })
                        } else if(app.data.membershipDetails) {
                            intersectMemberIds = _.intersection(memberObj.memberIds, app.data.membershipDetails.membershipItemIds);
                        }
                        
                        // if no module defined evaluate boolean for whole context
                        if(intersectMemberIds.length && memberObj.module == undefined){
                            return true;
                        } else if(!intersectMemberIds.length && memberObj.module == undefined){
                            return false;
                        }

                        switch (memberObj.module && memberObj.module.toUpperCase()) {
                            case 'PMS':
                                if(intersectMemberIds.length){
                                    return {matches: {pmsCartAndFolioItems: ctx.pmsCartAndFolioItems}, bool: !!ctx.pmsCartAndFolioItems.length};
                                } else return {matches: {pmsCartAndFolioItems: []}, bool: false};
                                
                            case 'SPA':
                                if(intersectMemberIds.length){
                                    return {matches: {spaCartAndFolioItems: ctx.spaCartAndFolioItems}, bool: !!ctx.spaCartAndFolioItems.length};
                                } else return {matches: {spaCartAndFolioItems: []}, bool: false};
                            case 'GOLF':
                                if(intersectMemberIds.length){
                                    return {matches: {golfCartAndFolioItems:ctx.golfCartAndFolioItems}, bool: !!ctx.golfCartAndFolioItems.length};
                                } else return {matches: {golfCartAndFolioItems: []}, bool: false};                                    
                        } 
                        
                    },
                    golf_booking_crs: function(courses, ctx){
                        var golfFolioItems = _.filter(ctx.golfCartAndFolioItems,function(item){
                            return courses.indexOf(item.CourseId) != -1 
                        })
                            return {matches:{golfCartAndFolioItems: golfFolioItems}, bool: !!golfFolioItems.length};
                    },
                    golf_booking_ratesname: function(ratesname, ctx){
                        var golfFolioItems = _.filter(ctx.golfCartAndFolioItems,function(item){
                            var matched = false;
                            _.forEach(ratesname, function(name){
                                var nameRegex = new RegExp(name, 'g');
                                matched = nameRegex.test(item.GolfPlayer[0].Details);
                            })
                            return matched;
                        })
                        return {matches:{golfCartAndFolioItems: golfFolioItems}, bool: !!golfFolioItems.length};
                    },
                    golf_course_bookings_exceeded_for_pms:function(golfPmsObj, ctx){
                        var exceedResult = false;
                        var courseArr = [];

                        if(!Array.isArray(golfPmsObj.courseIds)) {
                            courseArr.push(golfPmsObj.courseIds);
                        } else {
                            courseArr = golfPmsObj.courseIds.slice();
                        }
                        if(ctx.golfCartAndFolioItems.length){
                            _.forEach(app.data.pmsResDays, function(pmsFolioItem){
                                var pmsAdultNumber = pmsFolioItem.NumAdults;
                                var lengthOfStay = moment(pmsFolioItem.DepartureDate).diff(moment(pmsFolioItem.ArrivalDate),'days')+1;
                                var calculatedRoundsPerAdult = Math.floor(lengthOfStay / golfPmsObj.roundEveryNights) * pmsAdultNumber;
                                var totalGolfBookingsOnPMSRes = 0;
                                _.forEach(ctx.golfCartAndFolioItems, function(golfFolioItem){
                                    if(moment(golfFolioItem.BookingTime.substr(0,10)).isBetween(moment(pmsFolioItem.ArrivalDate),moment(pmsFolioItem.DepartureDate),'days','[]') && courseArr.indexOf(golfFolioItem.CourseId) > -1 ){
                                        totalGolfBookingsOnPMSRes += parseInt(golfFolioItem.NumPlayers);
                                    }
                                })
                                if(totalGolfBookingsOnPMSRes > calculatedRoundsPerAdult){
                                    exceedResult = true;
                                }
                            })
                            
                            if(app.data.pmsResDays.length == 0){
                                _.forEach(ctx.golfCartAndFolioItems, function(golfFolioItem){
                                    if(courseArr.indexOf(golfFolioItem.CourseId) > -1) {
                                        exceedResult = true;
                                    }
                                })
                            }
                            
                        } 
                        
                        return exceedResult;
                    },
                    golf_bookings_sameDay_exceeded_for_courses: function(golfObj, ctx){
                        var exceedResult = false;
                        var courseArr = [];

                        if(!Array.isArray(golfObj.courseIds)) {
                            courseArr.push(golfObj.courseIds);
                        } else {
                            courseArr = golfObj.courseIds.slice();
                        }

                        if(ctx.golfCartAndFolioItems.length){
                            var totalGolfBookingsPerDay = {};
                            _.forEach(ctx.golfCartAndFolioItems, function(golfFolioItem){
                                if(courseArr.indexOf(golfFolioItem.CourseId) > -1 ){
                                    if(totalGolfBookingsPerDay[golfFolioItem.BookingTime.substr(0,10)]){
                                       console.log(totalGolfBookingsPerDay[golfFolioItem.BookingTime.substr(0,10)])
                                       totalGolfBookingsPerDay[golfFolioItem.BookingTime.substr(0,10)] = totalGolfBookingsPerDay[golfFolioItem.BookingTime.substr(0,10)]+ parseInt(golfFolioItem.NumPlayers);
                                    } else {
                                        totalGolfBookingsPerDay[golfFolioItem.BookingTime.substr(0,10)] = parseInt(golfFolioItem.NumPlayers);
                                    }
                                }
                            })
                            // Check any of the same day bookings exceeded given limit
                            _.forEach(totalGolfBookingsPerDay, function(numberOfPlayers, bookingDay){
                                if(numberOfPlayers > golfObj.maxPlayers){
                                    exceedResult = true;
                                }
                            })
                        }
                        return exceedResult;
                    },
                    golf_bookings_maxPlayers_exceed_for_profile: function(maxValue, ctx){
                        var exceedResult = false;

                        if(ctx.golfCartAndFolioItems.length){
                            var totalPlayers = 0;
                            _.forEach(ctx.golfCartAndFolioItems, function(golfFolioItem){                            
                                    totalPlayers += parseInt(golfFolioItem.NumPlayers);                               
                            })
                            // Check total players exceeded given limit
                            if(totalPlayers > maxValue){
                                exceedResult = true;
                            }                        
                        }
                        return exceedResult;
                    },
                    golf_booking_day_of_week: function(dayOfWeek, ctx){
                        // if golfDate is among the specified days of week we accept it
                        var golfCartandFolioItemsOnDays = [];
                        // dayOfWeek = $.wrapArray(dayOfWeek);
                        var daysOfWeekList = [];
                
                        if(!Array.isArray(dayOfWeek)) {
                            daysOfWeekList.push(dayOfWeek);
                        } else {
                            daysOfWeekList = dayOfWeek.slice();
                        }
                
                        _.forEach(ctx.golfCartAndFolioItems, function(golfFolioAndCartItem){
                            var golfDate = golfFolioAndCartItem.BookingTime.substr(0,10);
                            if (daysOfWeekList.indexOf(moment(golfDate).isoWeekday()) != -1) {
                                golfCartandFolioItemsOnDays.push(golfFolioAndCartItem);
                            } //pushes cartItem only when golfDate is among the specified days of week
                        })
                
                        return {matches: {golfCartAndFolioItems: golfCartandFolioItemsOnDays}, bool: !!golfCartandFolioItemsOnDays.length};
                    },
                    golf_booking_date_ranges: function(dateRanges, ctx){
                        // if golfDate is between the specified dates
                        var golfFolios = [];

                        var dateRangesArr = [];
                        if(!Array.isArray(dateRanges)) {
                            dateRangesArr.push(dateRanges);
                        } else {
                            dateRangesArr = dateRanges.slice();
                        }                      

                        _.forEach(ctx.golfCartAndFolioItems, function(golfF){
                            var golfDate = golfF.BookingTime.substr(0,10);
                            _.each(dateRangesArr, function(dateRange){
                                if(moment(golfDate).isBetween(moment(dateRange.startDate),moment(dateRange.endDate),'days','[]')){
                                    golfFolios = golfFolios.concat(golfF);
                                }
                            })

                        })

                          return {matches: {golfCartAndFolioItems: golfFolios}, bool: !!golfFolios.length};
                    },
                    golf_booking_holidays: function(holidays, ctx){
                        // if golfDate is on the specified dates
                        var golfFolios = []; 
                        var holidaysArr = [];

                        if(!Array.isArray(holidays)) {
                            holidaysArr.push(holidays);
                        } else {
                            holidaysArr = holidays.slice();
                        }
              
                        _.forEach(ctx.golfCartAndFolioItems, function(golfF){
                            var golfDate = golfF.BookingTime.substr(0,10);
                            if(holidaysArr.indexOf(golfDate) > -1){
                                golfFolios.push(golfF);
                            }
                        })

                        return {matches: {golfCartAndFolioItems: golfFolios}, bool: !!golfFolios.length};
                    },
                    $or: function(criterias, ctx){
                        var keys = Object.keys(criterias);
                        var obj = this;

                        var results = [];
                        for(var i = 0; i < keys.length; i++){
                            var preservedctx = JSON.parse(JSON.stringify(ctx));
                            var name = keys[i];
                            var arg = criterias[name];
                            
                            var result = obj[name](arg, preservedctx);
                            if(typeof result == 'boolean') result = {bool: result};

                            results.push(result)
                            
                        }

                        function union(matchedBkgs, localBkgs, type){
                            switch(type) {
                                case 'pmsCartAndFolioItems':
                                    return _.uniq(localBkgs.concat(matchedBkgs), function(folio){return folio.PMSFolioId});
                                case 'spaCartAndFolioItems':
                                    return _.uniq(localBkgs.concat(matchedBkgs), function(folio){return folio.SpaFolioItem.SpaFolioItemId});
                                case 'golfCartAndFolioItems':
                                    return _.uniq(localBkgs.concat(matchedBkgs), function(folio){return folio.GolfBookingId});
                            }
                        }

                        var localctx={};
                        var pmsDates = [];
                        var booleanResultIsTrue = false;

                        _.forEach(results, function(result){
                            if(result.matches){
                                _.each(['pmsCartAndFolioItems','spaCartAndFolioItems','golfCartAndFolioItems'], function(type){

                                    if(result.matches && result.matches[type]){
                                        localctx[type] = localctx[type] ? union(result.matches[type], localctx[type], type) : result.matches[type]
    
                                        //Storing all pms stay dates in array
                                        if(type == 'pmsCartAndFolioItems'){
                                            _.forEach(result.matches[type], function(pmsFolioItem){
                                                pmsDates = pmsDates.concat(_.map(_.pluck(pmsFolioItem.DailyRateDetails.DailyRateDetail, 'PMSDate'),function(pmsDate){return pmsDate?(pmsDate+'').substr(0,10):''}));
                                            })
                                        }
                                    }

                                })
                            }
                            else if(result.bool){
                                booleanResultIsTrue = true;
                            }
                        });

                        //crossing all pms stay dates with other module folios
                        if(pmsDates.length){
                            _.each(['spaCartAndFolioItems','golfCartAndFolioItems'], function(type){
                                if(localctx[type]){
                                    localctx[type] = _.filter(localctx[type], function(bkg){
                                        switch(type) {
                                            case 'spaCartAndFolioItems':
                                                return pmsDates.indexOf(bkg.SpaFolioItem.BookStartTime.substr(0, 10)) > -1;
                                            case 'golfCartAndFolioItems':
                                                return pmsDates.indexOf(bkg.BookingTime.substr(0, 10)) > -1;
                                        }
                                    });
                                }
                            });
                        }

                        return {matches: localctx, bool: booleanResultIsTrue ? booleanResultIsTrue : _.any(localctx, function(ctx_){return ctx_.length > 0}) };

                    },
                    $and: function(criterias, ctx){
                        var keys = Object.keys(criterias);
                        var obj = this;


                        var results = [];
                        for(var i = 0; i < keys.length; i++){
                            var preservedctx = JSON.parse(JSON.stringify(ctx));
                            var name = keys[i];
                            var arg = criterias[name];
                            var result = obj[name](arg, preservedctx);

                            if(typeof result == 'boolean') result = {bool: result};
                            results.push(result);
                        }

                        function intersect(matchedBkgs, localBkgs, type){
                            var survived = [];
                            _.forEach(localBkgs, function(lBkg){
                                var found = _.find(matchedBkgs, function(mBkg){
                                    switch(type) {
                                        case 'pmsCartAndFolioItems':
                                            return mBkg.PMSFolioId == lBkg.PMSFolioId;
                                        case 'spaCartAndFolioItems':
                                            return mBkg.SpaFolioItem.SpaFolioItemId == lBkg.SpaFolioItem.SpaFolioItemId;
                                        case 'golfCartAndFolioItems':
                                            return mBkg.GolfBookingId == lBkg.GolfBookingId;
                                    }
                                });

                                if(found) survived.push(found);
                            })

                            return survived;
                        }

                        var result_booking_context={};
                        var pmsDates = [];
                        var booleanResultIsFalse = false;

                        _.forEach(results, function(result){
                            if(result.matches){
                                _.each(['pmsCartAndFolioItems', 'spaCartAndFolioItems','golfCartAndFolioItems'], function(type){
                                    if(result.matches[type]){
                                        result_booking_context[type] = (result_booking_context[type] 
                                                        ? intersect(result.matches[type], result_booking_context[type], type)
                                                        : result.matches[type])
    
                                        //Stores all pms stay dates in array
                                        if(type == 'pmsCartAndFolioItems'){
                                            _.forEach(result.matches[type], function(pmsFolioItem){
                                                var pmsDailyRateDetails = _.pluck($.wrapArray(pmsFolioItem.DailyRateDetails.DailyRateDetail), 'PMSDate');
                                                pmsDates = pmsDates.concat(_.map(pmsDailyRateDetails, function(pmsDate){ return pmsDate?(pmsDate+'').substr(0,10):''}));
                                            })
                                        } 
                                    }
                                })
                            } else if(!result.bool) {
                                booleanResultIsFalse = true;
                            }
                        });

                        //crossing all pms stay dates with other module folios
                        if(pmsDates.length){
                            _.each(['spaCartAndFolioItems','golfCartAndFolioItems'], function(type){
                                if(result_booking_context[type]){
                                    result_booking_context[type] = _.filter(result_booking_context[type], function(bkg){
                                        switch(type) {
                                            case 'spaCartAndFolioItems':
                                                return pmsDates.indexOf(bkg.SpaFolioItem.BookStartTime.substr(0, 10)) > -1;
                                            case 'golfCartAndFolioItems':
                                                return pmsDates.indexOf(bkg.BookingTime.substr(0, 10)) > -1;
                                        }
                                    });
                                }
                            });
                        }
                
                        return {matches: result_booking_context, bool: booleanResultIsFalse ? false  : _.every(result_booking_context, function(ctx_){return ctx_.length > 0}) };

                    },
                    normalizerHelper: function(ctx){
                        // returns cart items and folios combined as just folio like items extended on active context
                        // extending because of ctx.customer
                        return _.extend({
                            pmsCartAndFolioItems: this.combinePmsCartAndFolios(ctx),
                            spaCartAndFolioItems: this.combineSpaCartAndFolios(ctx),
                            golfCartAndFolioItems: this.combineGolfCartAndFolios(ctx)
                        }, ctx) 
                    },
                    combinePmsCartAndFolios: function(ctx){
                        var pmsCartItems = [];
                        
                        // getting all pmsCart items and converting them to pmsFolios
                        if(ctx.pmsCart) {
                            _.forEach(ctx.pmsCart, function (pmsCartItem) {
                                var pmsCartToPmsFolio = _.extend(
                                    {
                                    PMSFolioId: pmsCartItem.WebFolioId,
                                    ArrivalDate: pmsCartItem.StartDate,
                                    DepartureDate: pmsCartItem.FinishDate,
                                    DailyRateDetails: {DailyRateDetail: pmsCartItem.DailyRates.DailyRateDetails},
                                    // Venue: pmsCartItem.pmsVenue.VenueId
                                    }, 
                                    pmsCartItem
                                    ); 
    
                                pmsCartItems.push(pmsCartToPmsFolio);
                            });
                        }

                        return pmsCartItems.concat(ctx.pmsFolios);
                    },
                    combineSpaCartAndFolios: function(ctx){
                        var spaCartItems = [];
                        
                        // gets all spacart items and converting them to spafolio like objs
                        if(ctx.spaCart) {
                            _.forEach(ctx.spaCart, function (spaCartItem) {
                                var spaCartItemToSpaFolio = _.extend(
                                    {
                                    SpaFolioItem: _.extend(
                                        {
                                        BookStartTime: spaCartItem.StartDate,
                                        SpaFolioItemId: spaCartItem.FolioItemId,
                                        LocationId:spaCartItem.LocationId,
                                        BookingCustomerId: spaCartItem.CustomerId
                                        },
                                        spaCartItem
                                    ),
                                    },
                                    spaCartItem
                                ); 
    
                                spaCartItems.push(spaCartItemToSpaFolio);
                            });
                        }

                        return spaCartItems.concat(ctx.spaFolios);
                    },
                    combineGolfCartAndFolios: function(ctx){
                        var golfCartItemsGroup = {};
                        var golfCartItems = [];
                        // gets all golfcart items and converting them to golffolio like objs
                        if(ctx.golfCart) {
                            _.forEach(ctx.golfCart, function(golfCartItem){
                                if(golfCartItemsGroup[golfCartItem.BookingId]){
                                    golfCartItemsGroup[golfCartItem.BookingId].push(golfCartItem);
                                } else {
                                    golfCartItemsGroup[golfCartItem.BookingId] = [golfCartItem];
                                }
                            })

                            _.forEach(golfCartItemsGroup, function(golfitem, key){
                                var golfCartItemToGolfFolio =   {
                                                                    BookingTime: golfitem[0].StartDate,
                                                                    GolfBookingId: key,
                                                                    CourseId: golfitem[0].CourseId,
                                                                    NumPlayers: golfitem.length,
                                                                    Future:true,
                                                                    cartItem: true,
                                                                    GolfPlayer: golfitem
                                                                };
                                
                                golfCartItems.push(golfCartItemToGolfFolio);
                            })
                        }

                        return golfCartItems.concat(ctx.golfFolios);
                    },
                    getAllPmsStayDates: function(ctx) {
                        // Gets all PMS dates including BOTH cart and folios
                        var pmsStayDates = [];
                        _.forEach(ctx.pmsCartAndFolioItems, function(pmsCartAndFolioItem){
                            var startDate = Date.parseExact(pmsCartAndFolioItem.ArrivalDate, "yyyy-MM-ddHHmmss"),
                            endDate = Date.parseExact(pmsCartAndFolioItem.DepartureDate, "yyyy-MM-ddHHmmss");
                            for (var theDate = startDate.clone(); theDate <= endDate; theDate.add(1).day()) {
                                pmsStayDates.push(theDate.toString("yyyy-MM-dd"));
                            }                            
                        })
                        
                        return pmsStayDates;
                    },
                    getAllSpaItemsOnPmsDates: function(ctx) {
                        // Gets all spaItems on pms dates incl. pms cart and pms folio dates
                        var spaItemsByDates = {};
                        var pmsStayDates = obj.getAllPmsStayDates(ctx);

                        //collects all spa items on a given date
                        _.forEach(ctx.spaCartAndFolioItems, function(spaCartAndFolioItem){
                            var spaDate = spaCartAndFolioItem.SpaFolioItem.BookStartTime.substr(0, 10);
              
                            if(pmsStayDates.indexOf(spaDate) != -1 && !spaItemsByDates[spaDate]){
                                spaItemsByDates[spaDate] = _.filter(ctx.spaCartAndFolioItems, function(spaCartAndFolioItem){
                                    return spaCartAndFolioItem.SpaFolioItem.BookStartTime.substr(0, 10) == spaDate
                                });
                            }
                        }) 

                        return spaItemsByDates;
                    },
                    getAllSpaItemsExclPmsDates: function(ctx) {
                        var spaItemsExclPmsDates = [];

                        var pmsStayDates = obj.getAllPmsStayDates(ctx);

                        _.forEach(ctx.spaCartAndFolioItems, function(spaCartAndFolioItem){
                            var spaDate = spaCartAndFolioItem.SpaFolioItem.BookStartTime.substr(0, 10);
                            if(!(pmsStayDates.indexOf(spaDate) != -1) ){
                                spaItemsExclPmsDates.push(spaCartAndFolioItem);
                            }
                        }) 

                        return spaItemsExclPmsDates;
                    },
                    getAllSpaItemsPerPerson: function(ctx) {
                        // Gets all spaItems on pms dates incl. pms cart and pms folio dates
                        var spaItemsByPerson = {};
                        var spaCustomers = [];
                        var allPmsDates = obj.getAllPmsStayDates(ctx);
                        //collects all spa items on a given date
                        _.forEach(ctx.spaCartAndFolioItems, function(spaCartAndFolioItem){
                            spaCustomers.push(spaCartAndFolioItem.SpaFolioItem.BookingCustomerId);               
                        })
                        
                        _.each(spaCustomers, function(spaCustomerId){
                            spaItemsByPerson[spaCustomerId] = _.filter(ctx.spaCartAndFolioItems, function(spaItem){  
                                return spaItem.SpaFolioItem.BookingCustomerId == spaCustomerId;
                            })
                        })

                        return spaItemsByPerson;
                    },                   
                }                              
                
                var self = this; 
                self.activeEffects = {};

                _.forEach(Customization.dynamicRestrictions.rules, function(currentRule){
                    obj.activeContext.pmsFolios = _.filter(app.data.pmsBookings, function(item){
                        return app.data.pmsBookingFuture.indexOf(item.PMSFolioId) != -1
                    }) || [];
                    obj.activeContext.spaFolios = _.filter(app.data.spaBookings, function(item){
                        return app.data.spaBookingFuture.indexOf(item.SpaFolioId) != -1
                    }) || [];
                    obj.activeContext.golfFolios = _.filter(app.data.golfBookings, function(item){
                        return app.data.golfBookingFuture.indexOf(item.GolfBookingId) != -1
                    }) || [];
                    

                    var webFolioResponse = app.models.systemModel.dataModel.folioBookings.data 
                        && app.models.systemModel.dataModel.folioBookings.data[
                                app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBookings,{})
                            ]
                    if (webFolioResponse && webFolioResponse.WebFolioItem) {
                        obj.activeContext.spaCart = _.filter(webFolioResponse.WebFolioItem,function(item){return item.Category=='Spa'});
                        obj.activeContext.pmsCart = _.filter(webFolioResponse.WebFolioItem,function(item){return item.Category=='Hotel'});
                        obj.activeContext.golfCart = _.filter(webFolioResponse.WebFolioItem,function(item){return item.Category=='Golf'});
                    } else {
                        obj.activeContext.spaCart = [];
                        obj.activeContext.pmsCart = [];
                        obj.activeContext.golfCart = [];
                    }
                    // Populating normalized context
                    obj.activeContext = obj.normalizerHelper(obj.activeContext);

                    // Creating PMS Datelist for tryingToBook_golfMaxAdultsChancePerPMSNightExceed function
                    app.data.pmsResDays = [];
                    // Populating pms res days with their folio id and adult number in the reservation
                    _.each(obj.activeContext.pmsCartAndFolioItems, function(pmsItem){
                        var cartPmsFolioIdWithAdultNum = app.datal('pmsFolioIdWithAdultNum');
                        var numAdults = pmsItem.NumAdults;
                        if(!numAdults){
                            _.forEach(cartPmsFolioIdWithAdultNum, function(cartItem){
                                if( cartItem.PMSFolioId == pmsItem.FolioId 
                                    && cartItem.ArrivalDate == pmsItem.ArrivalDate.substr(0,10) 
                                    && cartItem.DepartureDate == pmsItem.DepartureDate.substr(0,10) 
                                    && cartItem.PMSRoomType == pmsItem.RoomType
                                    && cartItem.PMSRateType == pmsItem.RateType)
                                {
                                    numAdults = cartItem.NumAdults;
                                }
                            })
                        }
                        app.data.pmsResDays.push({ArrivalDate:pmsItem.ArrivalDate.substr(0,10), DepartureDate: pmsItem.DepartureDate.substr(0,10), FolioId:pmsItem.FolioId, NumAdults:numAdults});
                    })
                        

                    var andOr = Object.keys(currentRule.criteria)[0]; //root OR / AND

                    var result = obj[andOr](currentRule.criteria[andOr], obj.activeContext);
                    //effect registration    
                    if(result && result.bool) {
                        _.each(currentRule.effects, function(effect_fn, effect_type){
                            var tempResult = effect_fn(result.matches);

                            if(tempResult && !tempResult.uniqueName){
                                tempResult.uniqueName = '_default';
                            }
                            if(tempResult && !tempResult.value && typeof tempResult.value != 'string'){
                                if(effect_type == 'tryingToBook'){
                                    tempResult = {uniqueName:tempResult.uniqueName, value:{criteria:tempResult.criteria,effects:tempResult.effects}}
                                } else {
                                    tempResult = {value:tempResult};
                                }
                            }   

                            if(tempResult && !tempResult.effect_type){
                                tempResult.effect_type = effect_type
                            }

                            if (tempResult && tempResult.isActive == undefined) {
                                tempResult.isActive = true
                            }

                            if(!self.activeEffects[effect_type]){
                                self.activeEffects[effect_type] = [tempResult];
                            } else{
                                self.activeEffects[effect_type].push(tempResult);
                            }
                        })                          

                    }        
                });

            },
            eval_ttb: function(ctx){
                console.log('eval_ttb',ctx)
                var obj = {
                    tryingToBook_module: function(module, ctx){
                        console.log(module,'module and ctx', ctx);
                        return _.any(module,function(mod){return ctx && mod==ctx.module});
                    },
                    tryingToBook_day: function(days, ctx){
                        return ctx.date ? days.indexOf(moment(ctx.date).isoWeekday()) > -1 : ctx.item && days.indexOf(moment(ctx.item.preferedDate).isoWeekday()) > -1;
                    },
                    tryingToBook_booking_holidays : function(holidays,ctx){
                        var holidaysArr = [];
                        if(!Array.isArray(holidays)) {
                            holidaysArr.push(holidays);
                        } else {
                            holidaysArr = holidays.slice();
                        }                          
                        // if spaDate / golfDate is on the specified dates
                        return holidaysArr.indexOf(ctx.date) != -1;
                    },
                    tryingToBook_booking_date_ranges : function(dateRanges, ctx){
                        var dateRangesArr = [];
                        if(!Array.isArray(dateRanges)) {
                            dateRangesArr.push(dateRanges);
                        } else {
                            dateRangesArr = dateRanges.slice();
                        }                        

                        return _.any(dateRangesArr, function(dateRange){ return moment(ctx.date).isBetween(moment(dateRange.startDate),moment(dateRange.endDate),'days','[]') })
                    },
                    tryingToBook_membership_item_ids: function (membershipIds, ctx) {
                        var membershipIdsArr = [];
                        if (!Array.isArray(membershipIds)) {
                            membershipIdsArr.push(membershipIds);
                        } else {
                            membershipIdsArr = membershipIds.slice();
                        }
                        var result = false;
                        // in case if ctx.membershipId is an array
                        if (Array.isArray(ctx.membershipIds)) {
                            _.each(ctx.membershipIds, function (membershipId) {
                            if (membershipIdsArr.indexOf(membershipId) > -1) {
                                result = true;
                            }
                            });
                        } else {
                            result = membershipIdsArr.indexOf(ctx.membershipIds) > -1;
                        }
                        return result;
                    },
                    tryingToBook_vip_levels: function (vipLevels, ctx) {
                        var vipLevelsArr = [];
                        if (!Array.isArray(vipLevels)) {
                            vipLevelsArr.push(vipLevels);
                        } else {
                            vipLevelsArr = vipLevels.slice();
                        }
                        var result = false; // in case if ctx.vipLevel is an array
                        if (Array.isArray(ctx.vipLevel)) {
                            _.each(ctx.vipLevel, function (vipLevel) {
                            if (vipLevelsArr.indexOf(vipLevel) > -1) {
                                result = true;
                            }
                            });
                        } else {
                            result = vipLevelsArr.indexOf(ctx.vipLevel) > -1;
                        }
                        return result;
                    },
                    tryingToBook_spaService_location: function(location, ctx){
                        console.log('tryingToBook_spaService_location ozan',location,ctx);
                        return _.any(location,function(loc){return ctx && ctx.item && ctx.item.service && loc==ctx.item.service.Location || loc==ctx.location});
                    },
                    tryingToBook_spaService_serviceItem: function(serviceItems, ctx){
                        return _.any(serviceItems,function(serviceId){return (ctx && ctx.item && ctx.item.service && ctx.item.service.SpaItemId == serviceId) || ctx.item == serviceId });
                    },
                    tryingToBook_golfLocation: function(golfLocations, ctx){
                        return golfLocations.indexOf(ctx.locationId) > -1;
                    },
                    tryingToBook_golfCourse: function(golfCourses, ctx){
                        return golfCourses.indexOf(ctx.courseId) > -1;
                    },
                    tryingToBook_golfRateNames: function(golfRates, ctx){
                        var foundRateIds = $('[data-rateid='+ctx.itemId+']');
                        var foundRateName = foundRateIds.length ? $(foundRateIds[0]).attr('data-ratename') : '';
                        var matched = false;
                        _.forEach(golfRates, function(rateName){
                            var nameRegex = new RegExp(rateName, 'g');
                            matched = nameRegex.test(foundRateName) || rateName == foundRateName;                        
                        })
                        return matched;
                    },
                    tryingToBook_golfMaxNumberOfPlayers: function(numberOfPeople, ctx){
                        return parseInt(ctx.numberOfPlayers) > numberOfPeople;
                    },
                    tryingToBook_golfPrevenBookingTimeRange: function(timeRanges, ctx){
                        if(!ctx.time) return false;
                        var formattedTime = ctx.time.replace(/^(\d{2})(\d{2})/, '$1:$2:');
                        var timeFormat = 'HH:mm:ss';
                        var timeRangesArr = [];
                        if(!Array.isArray(timeRanges)) {
                            timeRangesArr.push(timeRanges);
                        } else {
                            timeRangesArr = timeRanges.slice();
                        }  
                        return _.any(timeRangesArr, function(timeRange){ return moment(formattedTime, timeFormat).isBetween(moment(timeRange.startTime, timeFormat),moment(timeRange.endTime, timeFormat)) })
                    },
                    tryingToBook_golfMaxAdultsChancePerPMSNightExceed: function(value, ctx){
                        var conditionResult = false;
                        var pmsAdultNumber;
                        var lengthOfStay;
                        var calculatedRoundsPerAdult;
                        if(app.data.pmsResDays.length){
                            _.forEach(app.data.pmsResDays, function(pmsItemDays){
                                if(moment(ctx.date).isBetween(moment(pmsItemDays.ArrivalDate),moment(pmsItemDays.DepartureDate),'days','[]')){
                                    pmsAdultNumber = pmsItemDays.NumAdults;
                                    lengthOfStay = moment(pmsItemDays.DepartureDate).diff(moment(pmsItemDays.ArrivalDate),'days')+1;
                                    calculatedRoundsPerAdult = Math.floor(lengthOfStay / value) * pmsAdultNumber; 
                                    if(calculatedRoundsPerAdult < parseInt(ctx.numberOfPlayers)){
                                        conditionResult = true;
                                    }
                                }
                            })
                        }  
                        return conditionResult;
                    },
                    tryingToBook_preventGolfBookTeeTimesApart: function(teeTimesApart, ctx){
                        if(!ctx.time) return false;
                        var conditionResult = true;
                        var minApartTeeTimesRanges = [];
                        var maxApartTeeTimesRanges = [];
                        var dateExistBookedTeeTimeDays = _.find(app.data.groupedBookedGolfTeeTimes, function(teeTimes){
                            return teeTimes[ctx.date];
                        })

                        var formattedTime = ctx.time.replace(/^(\d{2})(\d{2})/, '$1:$2:');
                        var tryingToBookDate = new Date(ctx.date + ' ' +formattedTime);
                        var minApart = teeTimesApart.minApart;
                        var maxApart = teeTimesApart.maxApart;

                        if(dateExistBookedTeeTimeDays){
                            // populate minApartTeeTimeRanges & maxApartTeeTimeRanges
                            if(minApart){
                                _.forEach(dateExistBookedTeeTimeDays[ctx.date], function(teeTime){
                                    var minApartStartDate = new Date(ctx.date + ' ' +teeTime[0]);
                                    var minApartEndDate = new Date(ctx.date + ' ' +teeTime[teeTime.length-1]);
                                    var totalMins = 60 * minApart;
                                    console.log(minApartStartDate, 'minstart time', minApartEndDate);
                                    minApartEndDate.setMinutes( minApartEndDate.getMinutes() + totalMins );
                                    minApartStartDate.setMinutes( minApartStartDate.getMinutes() - totalMins );
                                    var minApartObj = {'startTime':minApartStartDate, 'endTime':minApartEndDate};
                                    minApartTeeTimesRanges.push(minApartObj);
                                })
                            }

                            if(maxApart){
                                _.forEach(dateExistBookedTeeTimeDays[ctx.date], function(teeTime){
                                    var maxApartStartDate = new Date(ctx.date + ' ' +teeTime[0]);
                                    var maxApartEndDate = new Date(ctx.date + ' ' +teeTime[teeTime.length-1]);
                                    var totalMins = 60 * maxApart;
                                    console.log(maxApartStartDate, 'minstart time', maxApartEndDate);
                                    maxApartEndDate.setMinutes( maxApartEndDate.getMinutes() + totalMins );
                                    maxApartStartDate.setMinutes( maxApartStartDate.getMinutes() - totalMins );
                                    var maxApartObj = {'startTime':maxApartStartDate, 'endTime':maxApartEndDate};
                                    maxApartTeeTimesRanges.push(maxApartObj);
                                })
                            }

                            if(minApartTeeTimesRanges){
                                _.forEach(minApartTeeTimesRanges, function(minApartTeeRange){
                                    if(minApartTeeRange.startTime <= tryingToBookDate && tryingToBookDate <= minApartTeeRange.endTime){
                                        conditionResult = false;
                                    }
                                })
                            }

                            if(maxApartTeeTimesRanges){
                                _.forEach(maxApartTeeTimesRanges, function(maxApartTeeRange){
                                    if(maxApartTeeRange.startTime >= tryingToBookDate || tryingToBookDate >= maxApartTeeRange.endTime){
                                        conditionResult = false;
                                    }
                                })
                            }


                        } else conditionResult = false;                    
                        
                        return conditionResult;
                    },
                    tryingToBook_isTeeTimeEarlierThanDayCount: function(dayCount, ctx){
                        var conditionResult = false;
                        if(!ctx.date) return false;
                        var todaysDate = new Date();
                        // format the todays date YYYY-MM-DD
                        var formattedTodaysDate = todaysDate.getFullYear() + '-' + (todaysDate.getMonth() + 1) + '-' + todaysDate.getDate();
                        // get the day difference between the trying to book date and today
                        var dayDiff = moment(ctx.date).diff(moment(formattedTodaysDate),'days');
                        dayDiff = Math.abs(dayDiff);
                        if(dayDiff <= dayCount){
                            conditionResult = true;
                        }
                        return conditionResult;                        
                    },
                    tryingToBook_isTeeTimeLaterThanDayCount: function(dayCount, ctx){
                        var conditionResult = false;
                        if(!ctx.date) return false;
                        var todaysDate = new Date();
                        // format the todays date YYYY-MM-DD
                        var formattedTodaysDate = todaysDate.getFullYear() + '-' + (todaysDate.getMonth() + 1) + '-' + todaysDate.getDate();
                        // get the day difference between the trying to book date and today
                        var dayDiff = moment(formattedTodaysDate).diff(moment(ctx.date),'days');
                        dayDiff = Math.abs(dayDiff);
                        if(dayCount < dayDiff){
                            conditionResult = true;
                        }
                        return conditionResult;
                    },
                    tryingToBook_dining_venue: function(venues, ctx){
                        return venues.indexOf(ctx.diningVenue) > -1;
                    },
                    tryingToBook_pms_venue: function(venues, ctx){
                        return venues.indexOf(ctx.pmsVenue) > -1;
                    },
                    tryingToBook_pms_dayguestmode: function(dayguest, ctx){
                        return dayguest ? ctx.dayGuest : !ctx.dayGuest;
                    },
                    tryingToBook_pms_booking_date_ranges: function(dateRanges, ctx){
                        var formattedArrivalDate = ctx.pmsArrivalDate && ctx.pmsArrivalDate.substring(0,10);
                        var formattedDepartureDate = ctx.pmsDepartureDate && ctx.pmsDepartureDate.substring(0,10);
                        // Check date ranges overlap with pms dates
                        // create array has pms dates
                        var pmsDates = [];
                        var dateRangesArr = [];
                        if(!Array.isArray(dateRanges)) {
                            dateRangesArr.push(dateRanges);
                        } else {
                            dateRangesArr = dateRanges.slice();
                        }      

                        if(formattedArrivalDate && formattedDepartureDate && dateRangesArr.length){
                            // generate every pms date and add to array
                            var pmsDate = moment(formattedArrivalDate);
                            while(pmsDate.isSameOrBefore(formattedDepartureDate)){
                                pmsDates.push(pmsDate.format('YYYY-MM-DD'));
                                pmsDate.add(1, 'days');
                            }
                            // check date ranges overlap with pms dates
                            var checkOverlap = false;
                            _.each(dateRangesArr, function(dateRange){
                                _.each(pmsDates, function(pmsDate){
                                    if(moment(dateRange.startDate).isSameOrBefore(moment(pmsDate)) && moment(dateRange.endDate).isSameOrAfter(moment(pmsDate))){
                                        checkOverlap = true;
                                    }
                                })
                            })
                            return checkOverlap;

                        } else {
                            return false;
                        }
                    },
                    tryingToBook_pms_booking_dates: function(dates, ctx){
                        var formattedArrivalDate = ctx.pmsArrivalDate && ctx.pmsArrivalDate.substring(0,10);
                        var formattedDepartureDate = ctx.pmsDepartureDate && ctx.pmsDepartureDate.substring(0,10);
                        var pmsDates = [];
                        // short circut if dayGuest is true since there is no departure date
                        if(ctx.dayGuest && dates.length){
                            return _.some(dates, function(date){ return date == formattedArrivalDate; });
                        } else if(ctx.dayGuest && !dates.length){
                            return false;
                        }

                        if(formattedArrivalDate && formattedDepartureDate && dates.length){
                            // generate every pms date and add to array
                            var pmsDate = moment(formattedArrivalDate);
                            while(pmsDate.isSameOrBefore(formattedDepartureDate)){
                                pmsDates.push(pmsDate.format('YYYY-MM-DD'));
                                pmsDate.add(1, 'days');
                            }
                            // check date ranges overlap with pms dates
                            var checkOverlap = false;
                            _.each(dates, function(date){
                                _.each(pmsDates, function(pmsDate){
                                    if(moment(date).isSameOrBefore(moment(pmsDate)) && moment(date).isSameOrAfter(moment(pmsDate))){
                                        checkOverlap = true;
                                    }
                                })
                            })
                            return checkOverlap;

                        } else {
                            return false;
                        }
                    },
                    tryingToBook_pms_max_occupany_exceeded: function(maxOccupancy, ctx){
                        var totalOccupancy = parseInt(ctx.pmsNumAdults) + parseInt(ctx.pmsNumYouth) + parseInt(ctx.pmsNumChildren) + parseInt(ctx.pmsNumJrChildren);
                        return totalOccupancy >= maxOccupancy;
                    },
                    $or: function(criterias, ctx){
                        var keys = Object.keys(criterias);
                        for(var i = 0; i < keys.length; i++){
                            var name = keys[i];
                            var arg = criterias[name];
                            
                            var result = obj[name](arg, ctx);

                            if(result) return true;
                            
                        }

                        return false;
                    },
                    $and: function(criterias, ctx){
                        var keys = Object.keys(criterias);
                        for(var i = 0; i < keys.length; i++){
                            var name = keys[i];
                            var arg = criterias[name];

                            var result = obj[name](arg, ctx);

                            if(!result) return false;
                        }
                
                        return true;
                    }
                }

                var self = this;
                app.commonViewHelper.active_ttb_effects={};

                if (app.commonViewHelper.activeEffects.tryingToBook) { 
                    var evaluatetryingToBook = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.tryingToBook);
                    _.forEach(evaluatetryingToBook.value, function(ttbRule){
                        if (ttbRule && ttbRule.criteria && ttbRule.effects) { 
                            var andOr = Object.keys(ttbRule.criteria)[0]; //root OR / AND
                            result = obj[andOr](ttbRule.criteria[andOr], ctx);
                            
                            //effect registration
                            if(result) {
                                _.each(ttbRule.effects, function(effect_fn, effect_type){
                                    var tempResult = effect_fn(result);
                                    if(tempResult && !tempResult.uniqueName){
                                        tempResult.uniqueName = '_default';
                                    }
                                    if(tempResult && !tempResult.value && typeof tempResult.value != 'string'){
                                        tempResult = {value:tempResult};
                                    }         
                                    if(tempResult && !tempResult.effect_type){
                                        tempResult.effect_type = effect_type
                                    }
                                    if (tempResult && tempResult.isActive == undefined) {
                                        tempResult.isActive = true
                                    }

                                    if(!self.active_ttb_effects[effect_type]){
                                        app.commonViewHelper.active_ttb_effects[effect_type] = [tempResult];
                                    } else{
                                        app.commonViewHelper.active_ttb_effects[effect_type].push(tempResult);
                                    }

                                })
                            }
                        }

                    })

                } 
            },
            active_ttb_effects: {},
            activeEffects: {},
            filteredContext: {},
            lastEffect: function(effects) {
                var lastEffect = effects.slice(-1)[0];
                    return lastEffect;
            },
            reduceEffects: function(effects) {
                var isActiveTrueEffects = _.filter(effects, function(effect){
                    return effect.isActive;
                });
                var valueCombined = '';
                var ttBookValue = [];
                var boolExists = false;
                var valueIsString = false;
                var boolCombined = false;
                var isActiveTemp = true;
                var arrayCombined = [];
                var functionsCombined = [];


                if(isActiveTrueEffects && isActiveTrueEffects.length){
                    _.each(isActiveTrueEffects, function(effect){
                        if(effect.effect_type == 'tryingToBook'){
                            ttBookValue.push(effect.value);
                        } else {
                            if(typeof effect.value === 'boolean') {
                                boolCombined = boolCombined || effect.value;
                                boolExists = true;
                            } else if(typeof effect.value === 'string') {
                                valueCombined += effect.value;
                                valueIsString = true;
                            } else if(typeof effect.value === 'object'){
                                arrayCombined = arrayCombined.concat(effect.value);                                
                            } else if(typeof effect.value === 'function'){
                                functionsCombined.push(effect.value);
                            }
                        }                 
                    })
                } else {
                    isActiveTemp = false;
                    _.each(effects, function(effect){
                        valueCombined += effect.value;
                    })
                    valueIsString = true;
                }
                    return {
                            value: boolExists ?  boolCombined : (valueIsString ? valueCombined : (ttBookValue.length ? ttBookValue : (arrayCombined.length ? arrayCombined : functionsCombined))),
                            isActive:isActiveTemp
                        } //TODO: no isActive for boolen
            },
            groupEffects: function(effects){
               var groupedEffects =  _.groupBy(effects, 'uniqueName' );
               var tempReduceEffect = [];
               _.each(groupedEffects, function(value, key){
                    tempReduceEffect.push(app.commonViewHelper.lastEffect(value));
               })
               return app.commonViewHelper.reduceEffects(tempReduceEffect);
            },
            memberVipLevelsHelper: function(){  
                // Getting customers membership itemid and VIP Level and creating customer context in active context
                var defer = $.Deferred(),
                    deferreds = [],
                    apiCalls = []


                var memberships = {},
                    membershipItemIdsAr = [],
                    vipLevels = [];     

                var fetchAccountResponse = app.models.clubModel.dataModel.fetchAccounts.data 
                && app.models.clubModel.dataModel.fetchAccounts.data[
                        app.models.clubModel.makeStandardName(app.models.clubModel.dataModel.fetchAccounts,{CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID})
                    ]
                
                var fetchCustomerProResponse = app.models.userModel.dataModel.fetchCustomerProfile.data 
                && app.models.userModel.dataModel.fetchCustomerProfile.data[
                        app.models.userModel.makeStandardName(app.models.userModel.dataModel.fetchCustomerProfile,{CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID})
                    ]


                if(!fetchCustomerProResponse){
                    apiCalls.push({model:'userModel' ,call:'fetchCustomerProfile'});
                } else {
                    fetchCustomerProResponse.Customer && fetchCustomerProResponse.Customer[0] && fetchCustomerProResponse.Customer[0].VIPLevel && fetchCustomerProResponse.Customer[0].VIPLevel.length && vipLevels.push(fetchCustomerProResponse.Customer[0].VIPLevel); 
                }
                
                if(!fetchAccountResponse){
                    apiCalls.push({model:'clubModel' ,call:'fetchAccounts'});
                } else if(fetchAccountResponse.Account) {
                    _.each($.wrapArray(fetchAccountResponse.Account),function(account){
                        if (account.Memberships) {
                            _.each($.wrapArray(account.Memberships.Membership),function(membership){
                                if (membership.Status == "ACTIVE") {
                                    membershipItemIdsAr.push( membership.ItemId );
                                    memberships[membership.ItemId] = membership;
                                }
                            })
                        }
                    })
                }
        
                if(!app.data.userLoggedIn){
                    vipLevels.push('Public');
                    membershipItemIdsAr.push('Public');
                    app.data.membershipDetails =  { CustomerId:app.data.CustomerId, FirstName: app.data.FirstName, VIPLevels:vipLevels, memberships:memberships, membershipItemIds:membershipItemIdsAr };
                } else {
                    if(!apiCalls.length){
                        app.data.membershipDetails =  { CustomerId:app.data.CustomerId, FirstName: app.data.FirstName, VIPLevels:vipLevels, memberships:memberships, membershipItemIds:membershipItemIdsAr };
                    } else {
                        $.each(apiCalls, function(i,apiCall){
                            var semaphore = $.Deferred();
                            deferreds.push(semaphore.promise());
        
                            $.when(app.models[apiCall.model].getData(apiCall.call,{CustomerId:app.data.CustomerId,CustomerGUID:app.data.CustomerGUID}))
                                .done(function(response){
        
                                    if (response && response.Account) {
                                        _.each($.wrapArray(response.Account),function(account){
                                            if (account.Memberships) {
                                                _.each($.wrapArray(account.Memberships.Membership),function(membership){
                                                    if (membership.Status == "ACTIVE") {
                                                        membershipItemIdsAr.push( membership.ItemId );
                                                        memberships[membership.ItemId] = membership;       
                                                        membershipItemIdsAr = _.filter(membershipItemIdsAr, function(memberId){
                                                            return memberId != 'Public';
                                                        })                                                 
                                                    }
                                                })
                                            }
                                        })
                                    } 
                                    
                                    if (response && response.Customer && response.Customer[0] && response.Customer[0].VIPLevel && response.Customer[0].VIPLevel.length) {          
                                        vipLevels.push(response.Customer[0].VIPLevel); 
                                        vipLevels = _.filter(vipLevels, function(level){
                                            return level != 'Public';
                                        })
                                    } 
        
                                    app.data.membershipDetails =  { CustomerId:app.data.CustomerId, FirstName: app.data.FirstName, VIPLevels:vipLevels, memberships:memberships, membershipItemIds:membershipItemIdsAr };
        
                                    console.log(response,'each member vip level func resolving')
                                    semaphore.resolve();
        
                                })  
                                .fail(function(r){
                                    if(!vipLevels.length){
                                        vipLevels.push('Public');
                                    }
                                    if(!membershipItemIdsAr.length){
                                        membershipItemIdsAr.push('Public');
                                    }
                                    app.data.membershipDetails =  { CustomerId:app.data.CustomerId, FirstName: app.data.FirstName, VIPLevels:vipLevels, memberships:memberships, membershipItemIds:membershipItemIdsAr };
                                    console.log('member vip level promise failed semaphore',semaphore);
                                    semaphore.resolve();
                                });
        
                        })
                    }
                }

                $.when.apply(this,deferreds).done(function(){
                    console.log('memberviphelper all pushed semaphore resolving');

                    defer.resolve(deferreds.length);

                })
                .fail(function(){
                    console.log('memberviphelper response failed');
                    defer.reject()
                });
                
                return defer.promise();            
        
            },    
            enableModuleHelper: function(){
                if(app.commonViewHelper.activeEffects.enableModules){
                    var enableModulesResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableModules);
                    if(enableModulesResult.isActive && enableModulesResult.value && enableModulesResult.value.length){
                        _.each(Customization.features, function(feature,serviceType){
                            if(serviceType != 'updatedSummaryPage'){
                                app.customization.features[serviceType] = false;
                                if(typeof enableModulesResult.value == 'object' && enableModulesResult.value.indexOf(serviceType) != -1){
                                    app.customization.features[serviceType] = true;
                                } else if(typeof enableModulesResult.value == 'object' && enableModulesResult.value.length && typeof enableModulesResult.value[0] == 'function') {
                                    _.each(enableModulesResult.value, function(func){
                                        if(func(serviceType)){
                                            app.customization.features[serviceType] = true;
                                        }
                                    })
                                }
                            }                            
                        });

                        app.controllers.initController.loadServiceTypes();
                    }
                }
            },

            // Dynamic Access Restrictions Finishes Here
        }

        enquire.register("screen and (max-width: 481px)", function () {
            $('head meta[name=viewport]').attr('content', 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0, user-scalable=no')
        });
        enquire.register("screen and (min-width: 482px)", function () {
            $('head meta[name=viewport]').attr('content', 'width=device-width, minimum-scale=1.0, initial-scale=1.0')
        });

        return app.commonViewHelper
    });

